
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("OCz5m", function(module, exports) {
/* editorSSRExtensionHandlers.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3xuv0 = parcelRequire("3xuv0");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $5kjCz = parcelRequire("5kjCz");


var $dwS6P = parcelRequire("dwS6P");


var $kuTjv = parcelRequire("kuTjv");


var $8pcS0 = parcelRequire("8pcS0");


var $2E7zk = parcelRequire("2E7zk");


var $4EIU1 = parcelRequire("4EIU1");


var $ceVeI = parcelRequire("ceVeI");


var $9m03g = parcelRequire("9m03g");


var $5a4cC = parcelRequire("5a4cC");


var $n9ft3 = parcelRequire("n9ft3");


var $bBRJy = parcelRequire("bBRJy");


var $aG1nm = parcelRequire("aG1nm");


var $lJs0a = parcelRequire("lJs0a");


var $jaHkh = parcelRequire("jaHkh");


var $1UHWj = parcelRequire("1UHWj");


var $3bvCJ = parcelRequire("3bvCJ");


var $bJaqz = parcelRequire("bJaqz");


var $cTOQy = parcelRequire("cTOQy");


var $lE7FD = parcelRequire("lE7FD");


var $hEeUR = parcelRequire("hEeUR");


var $CbxlN = parcelRequire("CbxlN");

const $e673ff442c42ddbb$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers = ({ contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId })=>{
    return {
        'com.atlassian.confluence.macro.core': (extension, doc)=>{
            const { extensionKey: extensionKey } = extension;
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                mode: (0, $5kjCz.EDITOR),
                node: extension,
                extensionKey: extensionKey,
                attributes: attributes,
                references: [],
                contentId: contentId,
                spaceKey: spaceKey
            };
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS && (0, $2E7zk.hasConfiguredTeamCalendar)(extension?.parameters?.macroParams) && (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kuTjv.TeamCalendarMacroLoader), {
                extensionNode: extension,
                macroDefaultProps: macroDefaultProps
            });
            if (extensionKey === 'toc') {
                const editorTransformer = new (0, $3xuv0.JSONTransformer)();
                const adf = editorTransformer.encode(doc);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e673ff442c42ddbb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.TableOfContentsLoader), {
                    isInEditMode: true,
                    adf: adf,
                    userId: userId || '',
                    cloudId: cloudId,
                    macroDefaultProps: macroDefaultProps
                }));
            }
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CONTRIBUTORS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTRIBUTORS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4EIU1.ContributorsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).RECENTLY_UPDATED && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).RECENTLY_UPDATED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n9ft3.RecentlyUpdatedMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).POPULAR_LABELS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).POPULAR_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBRJy.PopularLabelsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).PROFILE_PICTURE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lE7FD.DetailsSummaryExtensionHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).PROFILE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).PROFILE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).WIDGET && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).WIDGET)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aG1nm.WidgetMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CONTENT_BY_LABEL && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTENT_BY_LABEL)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lJs0a.ContentByLabelSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INCLUDE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).INCLUDE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bvCJ.PageIncludeSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).BLOG_POSTS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).BLOG_POSTS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTOQy.BlogPostsSSRExtensionHandler), {
                ...macroDefaultProps,
                Renderer: (0, $hEeUR.ADFRenderer),
                getExtensionHandlers: $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CONTENT_REPORT_TABLE && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CONTENT_REPORT_TABLE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jaHkh.ContentReportTableMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: {
                    ...extension?.parameters?.macroParams,
                    currentSpaceKey: spaceKey
                }
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).CHANGE_HISTORY && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).CHANGE_HISTORY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $CbxlN.ChangeHistoryMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ATTACHMENTS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).ATTACHMENTS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJaqz.AttachmentsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
            if (extensionKey === (0, $8pcS0.EXTENSION_KEY).VIEWXLS && (0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).VIEWXLS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1UHWj.ViewXlsMacroHandler), {
                macroDefaultProps: macroDefaultProps,
                macroParams: extension?.parameters?.macroParams
            });
             // Unsupported (yet) extensions should default to existing provider-based handling
            // and rendering on a client side only.
            return null;
        }
    };
};
const $e673ff442c42ddbb$export$206691819bb24df7 = (contentId, spaceKey, extensionProviders)=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [providersReady, setProvidersReady] = (0, $cozmU.useState)(false);
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $cozmU.useEffect)(()=>{
        const providerPromises = extensionProviders?.map((provider)=>{
            return typeof provider.manifestsPromise !== 'undefined' ? provider.manifestsPromise : provider;
        });
        Promise.all(providerPromises).then(()=>setProvidersReady(true)).catch((_error)=>{
            // NOOP: Here, if any of the provider promises fail, the best we can do is to
            // fall back the original experience where macros are resolved and rendered on
            // the client only, although in this case the extensions experience would likely
            // be hosed anyway.
            setProvidersReady(true);
        });
    }, [
        extensionProviders
    ]);
    const extensionHandlers = (0, $cozmU.useMemo)(()=>$e673ff442c42ddbb$var$createEditorSSRExtensionHandlers({
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId
        }), [
        contentId,
        spaceKey,
        cloudId,
        userId
    ]);
    return isTransition || providersReady ? undefined : extensionHandlers;
};
module.exports["useEditorSSRExtensionHandlers"] = $e673ff442c42ddbb$export$206691819bb24df7;

});

parcelRegister("jFkNO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $1ITQ3 = parcelRequire("1ITQ3");

const $bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
const $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
/**
 * Currently, very few legacy (connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be mirrored in content-renderer-legacy-macros/src/useConnectExtensionViewportSize.ts
 * and getCalculatedHeightFromNode.ts
 */ const $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT = 570;
const $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $bbc19db46e52068c$var$getForgeExtensionHeight = (extensionId, extensionViewportSizes)=>{
    if (!extensionViewportSizes || !extensionId || !Array.isArray(extensionViewportSizes)) return;
    const viewportSize = extensionViewportSizes.find((ext)=>ext.extensionId === extensionId)?.viewportSize;
    if (!viewportSize) return undefined;
    if ($bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES.includes(viewportSize)) return $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS[viewportSize];
    return undefined;
};
const $bbc19db46e52068c$var$getHeightFromNode = (node)=>{
    if (!node) return;
    const extensionKey = node.attrs.extensionKey;
    const params = node.attrs.parameters?.macroParams;
    /**
	 * DrawIo will resize diagrams based on the viewport they are rendered in
	 * if the diagram's width is greater than 530px. This means that the natural dimensions
	 * provided in macro parameters could be the incorrect height to reserve so we will
	 * conservatively exclude them.
	 */ if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $bbc19db46e52068c$export$bdad5f6d3f57f201 = ()=>{
    /**
	 * To attribute impact to each ecosystem, we plan to rollout Forge improvements separately
	 * via (confluence_preload_forge_viewport_heights_editor) with Connect improvements after
	 * via (confluence_connect_macro_preset_height). Thus we'll isolate Forge functionality first with
	 * the long term plan to merge both into a single function after successful rollout.
	 */ const extensionViewportSizes = (0, $1ITQ3.useExtensionViewportSizes)(!(0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor'));
    const getForgeViewportHeight = (node)=>{
        // Forge in-content macros contain an ARI/environment/appKey extensionId value
        const extensionId = node.attrs.parameters?.extensionId;
        const forgeExtensionHeight = $bbc19db46e52068c$var$getForgeExtensionHeight(extensionId, extensionViewportSizes);
        if (forgeExtensionHeight) return forgeExtensionHeight;
    };
    const getCalculatedHeightFromNode = (0, $cozmU.useCallback)((node)=>{
        // Check if it's a Connect extension with macro parameters
        const extensionKey = node.attrs.extensionKey;
        const nodeHeight = $bbc19db46e52068c$var$getHeightFromNode(node);
        let height = Number(nodeHeight);
        if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
        switch(extensionKey){
            case 'drawio':
            case 'inc-drawio':
            case 'drawio-sketch':
                height += $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET;
                break;
            case 'lref-gdrive-embedded-file':
                height += $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
                break;
            case 'plantumlcloud':
                height += $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT;
                break;
            default:
                break;
        }
        else // for extensions that don't resize based on their content, we can set a default height
        switch(extensionKey){
            case 'gliffy':
                height = $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT;
                break;
            case 'aura-divider':
                height = $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT;
                break;
            case 'aura-cards':
                height = $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT;
                break;
            case 'miro-macro-resizing':
                height = $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT;
                break;
            case 'easy-math-block':
                height = $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'mathblock':
                height = $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'page-signatures':
                height = $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
                break;
            case 'questionslist-macro':
                height = $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
                break;
            case 'jiraroadmap':
                height = $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
                break;
            case 'lucidchart':
                height = $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT;
                break;
            default:
                height = undefined;
                break;
        }
        return height?.toString();
    }, []);
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) return getForgeViewportHeight;
    if ((0, $9wGTI.fg)('confluence_connect_macro_preset_height')) return getCalculatedHeightFromNode;
};
module.exports["useExtensionNodeParams"] = $bbc19db46e52068c$export$bdad5f6d3f57f201;

});

parcelRegister("bn20W", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $98tu2 = parcelRequire("98tu2");

const $49650e01e06d4e76$export$a15423dd96de66f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FullPageEditor(props) {
    const $ = (0, $bDgLe.c)(3);
    const t0 = props.appearance ?? "full-page";
    let t1;
    if ($[0] !== props || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: t0,
            AppearanceComponent: (0, $98tu2.FullPageEditor),
            __livePage: props.__livePage
        });
        $[0] = props;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function FullPageEditor(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: props.appearance ?? 'full-page',
        AppearanceComponent: (0, $98tu2.FullPageEditor),
        __livePage: props.__livePage
    });
};
module.exports["FullPageEditor"] = $49650e01e06d4e76$export$a15423dd96de66f2;

});

parcelRegister("ijGoX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kYmM6 = parcelRequire("kYmM6");

/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $3oEyF = parcelRequire("3oEyF");


var $7W1a8 = parcelRequire("7W1a8");


var $SW3sR = parcelRequire("SW3sR");


var $az1Tm = parcelRequire("az1Tm");


var $kTn88 = parcelRequire("kTn88");

function $1ad7c7af2c2b07f9$var$_defineProperty(e, r, t) {
    return (r = $1ad7c7af2c2b07f9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1ad7c7af2c2b07f9$var$_toPropertyKey(t) {
    var i = $1ad7c7af2c2b07f9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1ad7c7af2c2b07f9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $1ad7c7af2c2b07f9$var$baselineUnit = "var(--ds-space-050, 4px)";
const $1ad7c7af2c2b07f9$var$COLOR_N900 = '#091E42';
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $1ad7c7af2c2b07f9$var$ContentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $1ad7c7af2c2b07f9$var$Image = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $1ad7c7af2c2b07f9$var$ButtonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
const $1ad7c7af2c2b07f9$var$BodyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0q1b66 _n3td1b66 _syazi7uo",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1ad7c7af2c2b07f9$export$c7313f750e9cbc9d extends (0, $cozmU.Component) {
    getPrimaryButton() {
        const { primaryAction: primaryAction, primaryText: primaryText } = this.props;
        return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
    getSecondaryButton() {
        const { secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
    getActionButton(appearance, onClick, action, text) {
        const type = action ? action.type : (0, $7W1a8.buttonActionTypes).DISMISS;
        switch(type){
            case (0, $7W1a8.buttonActionTypes).LINK:
                {
                    const actionData = action.data;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                        href: actionData.url,
                        target: actionData.target,
                        appearance: appearance,
                        onClick: onClick
                    }, text);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    appearance: appearance,
                    onClick: onClick
                }, text);
        }
    }
    render() {
        const { children: children, title: title, imageSrc: imageSrc, imageAlt: imageAlt, body: body, position: position, order: order, secondaryText: secondaryText } = this.props;
        const messageContent = {
            image: null,
            title: null,
            body: null
        };
        if (title) // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h4", {
            key: "title"
        }, title);
        if (imageSrc) messageContent.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1ad7c7af2c2b07f9$var$Image, {
            key: "img",
            src: imageSrc,
            alt: imageAlt
        });
        messageContent.body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1ad7c7af2c2b07f9$var$BodyContainer, {
            key: "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kTn88.default), {
            html: body
        }));
        const orderedContent = order.map((c)=>messageContent[c]);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1ad7c7af2c2b07f9$var$ContentContainer, null, orderedContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1ad7c7af2c2b07f9$var$ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oEyF.default), {
            content: content,
            placement: position,
            isOpen: true
        }, children);
    }
    constructor(...args){
        super(...args);
        $1ad7c7af2c2b07f9$var$_defineProperty(this, "onPrimaryClick", ()=>{
            this.props.fireClickEvent('primary');
        });
        $1ad7c7af2c2b07f9$var$_defineProperty(this, "onSecondaryClick", ()=>{
            this.props.fireClickEvent('secondary');
        });
    }
}
$1ad7c7af2c2b07f9$var$_defineProperty($1ad7c7af2c2b07f9$export$c7313f750e9cbc9d, "defaultProps", {
    children: null,
    order: [
        'title',
        'image',
        'body'
    ],
    position: 'bottom left'
});
const $1ad7c7af2c2b07f9$export$3660ec843fc5ef1b = (0, $SW3sR.default)($1ad7c7af2c2b07f9$export$c7313f750e9cbc9d);
const $1ad7c7af2c2b07f9$var$_default_1 = (0, $az1Tm.default)($1ad7c7af2c2b07f9$export$3660ec843fc5ef1b, 'inlineDialog'); // eslint-disable-next-line camelcase
var $1ad7c7af2c2b07f9$export$2e2bcd8739ae039 = $1ad7c7af2c2b07f9$var$_default_1;





const $0cc702d7151ce2f5$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $cozmU.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};





class $067857b69cc0ee8d$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$067857b69cc0ee8d$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};



var $lwNi3 = parcelRequire("lwNi3");

const $e86ccba267113370$export$4d97def4de07dcc1 = ()=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/engagementPlatformPluginOptions.ts
    return (0, $cozmU.useMemo)(()=>{
        const config = {
            epComponents: {
                EngagementSpotlight: $kYmM6.EngagementSpotlight,
                EngagementInlineDialog: $1ad7c7af2c2b07f9$export$2e2bcd8739ae039,
                Coordination: $067857b69cc0ee8d$export$2e2bcd8739ae039
            },
            epHooks: {
                useCoordination: $0cc702d7151ce2f5$export$3c29cca421979b0e
            },
            coordinationClient: coordinationClient
        };
        return {
            config: config
        };
    }, [
        coordinationClient
    ]);
};
module.exports["useEditorEngagementPlatform"] = $e86ccba267113370$export$4d97def4de07dcc1;

});

parcelRegister("bDgLc", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $c0rhi = parcelRequire("c0rhi");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");

/**
 * @generated SignedSource<<312647498233a7b45d0a0262adb9e32d>>
 * @relayHash d3f124aab91672208e07302d03b07351
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b
const $60d3698972303f3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageARI"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ], v1 = [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "pageARI"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "keyPhrases",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "keyPhrase"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        }
                                    ]
                                }
                            ],
                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HighlightKeywordsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HighlightKeywordsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d3f124aab91672208e07302d03b07351",
            "id": "c184940bfc597924791e760a99e4cec505eb44de79daa104a6aa46e6adac4b2b",
            "metadata": {},
            "name": "HighlightKeywordsQuery",
            "operationKind": "query",
            "text": "query HighlightKeywordsQuery($pageARI:String,$workspaceId:String){knowledgeDiscovery{keyPhrases(entityAri:$pageARI,workspaceId:$workspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
        }
    };
}();
$60d3698972303f3d$var$node.hash = "2eaa54e2c6daee5ed7b85802235eee06";
var $60d3698972303f3d$export$2e2bcd8739ae039 = $60d3698972303f3d$var$node;


const $770d1260eccad933$export$b855f1e1a990429f = (0, $60d3698972303f3d$export$2e2bcd8739ae039);



var $7rLBD = parcelRequire("7rLBD");

const $70f493264a46a679$var$cachedAcronymRegex = {
    pageARI: '',
    regex: new RegExp('(?!)')
};
const $70f493264a46a679$var$getAcronymRegex = (acronyms, pageARI = '', ignoreCase = false)=>{
    if (pageARI === $70f493264a46a679$var$cachedAcronymRegex.pageARI) return $70f493264a46a679$var$cachedAcronymRegex.regex;
    let regex;
    try {
        regex = new RegExp(acronyms.map((node)=>`\\b${node.phrase}\\b`).join('|'), ignoreCase ? 'gi' : 'g');
    } catch  {
        regex = new RegExp('(?!)');
    }
    $70f493264a46a679$var$cachedAcronymRegex.pageARI = pageARI;
    $70f493264a46a679$var$cachedAcronymRegex.regex = regex;
    return regex;
};
const $70f493264a46a679$export$ce57c3ee398efaad = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const pageARI = contentId ? (0, $7rLBD.generatePageARI)(contentId, cloudId, contentType) : undefined;
    const workspaceId = (0, $7rLBD.generateWorkspaceId)(activationId, cloudId);
    const queryHighlightAcronyms = (0, $cozmU.useCallback)(async ({ cacheKey: cacheKey = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() } = {})=>{
        if (!workspaceId || !pageARI) return {
            acronyms: []
        };
        try {
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $770d1260eccad933$export$b855f1e1a990429f),
                fetchPolicy: 'network-only',
                errorPolicy: 'ignore',
                variables: {
                    cacheKey: // comment from confluence/next/packages/content-appearance/src/contentAppearance.ts
                    // This is dummy variable is used to force "network-only" requests to only be run as network calls.
                    // A bug in Apollo sometimes makes this query return data from the cache even if the policy is "network-only"
                    // See for more details: https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
                    // @ts-expect-error
                    cacheKey,
                    pageARI: pageARI,
                    workspaceId: workspaceId
                },
                interopApolloAggClient: true,
                __callerPackage__: "contextual-reading-aids"
            });
            const keyPhrasesData = data?.knowledgeDiscovery?.keyPhrases;
            const keyPhrases = keyPhrasesData && keyPhrasesData.__typename === 'KnowledgeDiscoveryKeyPhraseConnection' && keyPhrasesData.nodes ? // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            keyPhrasesData.nodes.filter((phrase)=>phrase != null).map((phrase)=>({
                    phrase: phrase.keyPhrase,
                    category: phrase.category
                })) : [];
            // getAcronymRegex use pageARI to cache the regex for the page
            // but for live edit pages we should be careful with the cache
            // because the page content is changing constantly
            const pageARIWithCacheKey = `${pageARI}-${cacheKey}`;
            let acronymRegex = undefined;
            if (keyPhrases.length) acronymRegex = $70f493264a46a679$var$getAcronymRegex(keyPhrases, pageARIWithCacheKey, true);
            return {
                acronyms: keyPhrases,
                acronymRegex: acronymRegex
            };
        } catch  {
            return {
                acronyms: []
            };
        }
    }, [
        pageARI,
        workspaceId
    ]);
    return {
        queryHighlightAcronyms: queryHighlightAcronyms
    };
};






var $2Jxlo = parcelRequire("2Jxlo");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7mpOv = parcelRequire("7mpOv");

const $5ea2be36e6b2ae4f$export$718b2890e94c1d28 = ()=>{
    /**
	 * see comments in `AIDefinitionsPluginConfig` for more details about why not checking `isLivePage` here
	 * const isLivePage = useIsCurrentPageLive();
	 */ const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const featureEnabled = isAIEnabledForContent || isRovoEnabledForContent;
    return isAIFeatureEnabled && featureEnabled;
};
const $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e = ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    return (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""');
};
const $5ea2be36e6b2ae4f$export$538319b84b3e9de0 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const enabled = $5ea2be36e6b2ae4f$export$718b2890e94c1d28();
    const autoHighlightEnabled = $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e();
    const { queryHighlightAcronyms: queryHighlightAcronyms } = (0, $70f493264a46a679$export$ce57c3ee398efaad)();
    const { isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const enablementSource = isRovoEnabledForContent ? 'rovo' : 'general-ai';
    return {
        enabled: enabled,
        contentId: contentId,
        autoHighlightEnabled: autoHighlightEnabled,
        queryHighlightAcronyms: queryHighlightAcronyms,
        ReadingAidsPopup: $2Jxlo.ReadingAidsPopup,
        enablementSource: enablementSource,
        readingAidsMaxWordCount: (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT)
    };
};
module.exports["useEditorPluginAIDefinitionsEnabled"] = $5ea2be36e6b2ae4f$export$718b2890e94c1d28;
module.exports["useEditorPluginAIDefinitionsConfig"] = $5ea2be36e6b2ae4f$export$538319b84b3e9de0;

});

parcelRegister("diJQD", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $eYg5X = parcelRequire("eYg5X");


var $llOMF = parcelRequire("llOMF");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");

const $5e5e3ebbb9249924$export$92a1a3b7554e9387 = {
    SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
    HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR'
};



var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


const $799fc02b434f47a4$export$f00c49e7bdf6721d = new (0, $kCECX.PluginKey)('mediaEditingPlugin');
const $799fc02b434f47a4$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $799fc02b434f47a4$export$f00c49e7bdf6721d,
        state: {
            init () {
                return {};
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($799fc02b434f47a4$export$f00c49e7bdf6721d);
                switch(meta?.type){
                    case (0, $5e5e3ebbb9249924$export$92a1a3b7554e9387).SHOW_IMAGE_EDITOR:
                        return {
                            ...currentPluginState,
                            imageEditorSelectedMedia: meta.imageEditorSelectedMedia,
                            isImageEditorVisible: meta.isImageEditorVisible
                        };
                    case (0, $5e5e3ebbb9249924$export$92a1a3b7554e9387).HIDE_IMAGE_EDITOR:
                        return {
                            ...currentPluginState,
                            imageEditorSelectedMedia: undefined,
                            isImageEditorVisible: meta.isImageEditorVisible
                        };
                    default:
                        return currentPluginState;
                }
            }
        }
    });
};


const $e65a45f8fbe96755$export$a0f8e5c5401083f8 = (media)=>({ tr: tr })=>{
        tr.setMeta((0, $799fc02b434f47a4$export$f00c49e7bdf6721d), {
            type: (0, $5e5e3ebbb9249924$export$92a1a3b7554e9387).SHOW_IMAGE_EDITOR,
            imageEditorSelectedMedia: media,
            isImageEditorVisible: true
        });
        tr.setMeta('addToHistory', false);
        return tr;
    };
const $e65a45f8fbe96755$export$ac53b7b0b56dbebd = ({ tr: tr })=>{
    tr.setMeta((0, $799fc02b434f47a4$export$f00c49e7bdf6721d), {
        type: (0, $5e5e3ebbb9249924$export$92a1a3b7554e9387).HIDE_IMAGE_EDITOR,
        imageEditorSelectedMedia: null,
        isImageEditorVisible: false
    });
    tr.setMeta('addToHistory', false);
    return tr;
};







var $204vt = parcelRequire("204vt");

const $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};


/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $ad7Ou = parcelRequire("ad7Ou");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $7BkLi = parcelRequire("7BkLi");


var $eh6Ml = parcelRequire("eh6Ml");


var $7sJoX = parcelRequire("7sJoX");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");

/* Cropper.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $cbY7C = parcelRequire("cbY7C");

const $1832a0c4f5a4235c$var$isSSRRender = ()=>typeof document === 'undefined' || false; /**
                                                                                                         * Props for the Cropper component
                                                                                                         */ 
const $1832a0c4f5a4235c$var$CropperCanvas = 'cropper-canvas';
const $1832a0c4f5a4235c$var$CropperImage = 'cropper-image';
const $1832a0c4f5a4235c$var$CropperSelection = 'cropper-selection';
const $1832a0c4f5a4235c$var$CropperShade = 'cropper-shade';
const $1832a0c4f5a4235c$var$CropperGrid = 'cropper-grid';
const $1832a0c4f5a4235c$var$CropperCrosshair = 'cropper-crosshair';
const $1832a0c4f5a4235c$var$CropperHandle = 'cropper-handle'; /**
                                                                                                             * Options for getting the cropped canvas
                                                                                                             */ 

const $1832a0c4f5a4235c$export$71ed2b85d4ca43d3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ src: src, alt: alt = '', crossOrigin: crossOrigin, aspectRatio: aspectRatio, initialAspectRatio: initialAspectRatio, initialCoverage: initialCoverage = 1, background: background = true, rotatable: rotatable = true, scalable: scalable = true, translatable: translatable = true, movable: movable = true, resizable: resizable = true, zoomable: zoomable = true, multiple: multiple = false, outlined: outlined = true, className: className, onImageReady: onImageReady, isCircle: isCircle = false }, ref)=>{
    const canvasRef = (0, $cozmU.useRef)(null);
    const selectionRef = (0, $cozmU.useRef)(null);
    const imageRef = (0, $cozmU.useRef)(null);
    const previousSelectionRef = (0, $cozmU.useRef)(null);
    const [isImageReady, setIsImageReady] = (0, $cozmU.useState)(false);
    const [isCropperLoaded, setIsCropperLoaded] = (0, $cozmU.useState)(false);
    const getCanvas = (0, $cozmU.useCallback)(()=>canvasRef.current, []);
    const getImage = (0, $cozmU.useCallback)(()=>imageRef.current, []);
    const getSelection = (0, $cozmU.useCallback)(()=>selectionRef.current, []);
    const getCroppedCanvas = (0, $cozmU.useCallback)((options)=>{
        const selection = selectionRef.current;
        if (!selection) return Promise.resolve(null);
         // Check if the $toCanvas method exists (web component might not be fully initialized)
        if (typeof selection.$toCanvas !== 'function') return Promise.resolve(null);
         // If circular crop, we need to apply a circular mask
        if (isCircle) {
            // For circular crops, force square dimensions to maintain perfect circle
            const squareOptions = {
                ...options,
                height: options?.width // Make height equal to width for a perfect circle
            };
            return selection.$toCanvas({
                ...squareOptions,
                beforeDraw: (context, canvas)=>{
                    // For circles, ensure we have a square canvas
                    const size = Math.min(canvas.width, canvas.height);
                    const radius = size / 2;
                    const centerX = size / 2;
                    const centerY = size / 2; // Enable high-quality image rendering
                    context.imageSmoothingEnabled = true;
                    context.imageSmoothingQuality = 'high'; // Create a circular clipping path with anti-aliasing
                    context.beginPath();
                    context.arc(centerX, centerY, radius, 0, Math.PI * 2);
                    context.clip();
                }
            });
        }
        return selection.$toCanvas(options);
    }, [
        isCircle
    ]);
    const fitStencilToImage = (0, $cozmU.useCallback)(()=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        const selection = selectionRef.current;
        if (canvas && image && selection) {
            // Get the real time positions
            const canvasRect = canvas.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect(); // Calculate coordinates relative to the canvas
            requestAnimationFrame(()=>{
                const x = imageRect.left - canvasRect.left;
                const y = imageRect.top - canvasRect.top;
                const width = imageRect.width;
                const height = imageRect.height; // Apply these to the selection (the stencil)
                if (typeof selection.$change === 'function') selection.$change(Math.floor(x), Math.floor(y), Math.floor(width), Math.floor(height));
            });
        }
    }, []); // Clamp position to keep crop area within image boundaries
    const clampPosition = (0, $cozmU.useCallback)((current)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        if (!canvas || !image) return null;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        let clampedX = current.x;
        let clampedY = current.y; // Clamp left/right
        if (clampedX < imageX) clampedX = imageX;
        else if (clampedX + current.width > imageX + imageWidth) clampedX = imageX + imageWidth - current.width;
         // Clamp top/bottom
        if (clampedY < imageY) clampedY = imageY;
        else if (clampedY + current.height > imageY + imageHeight) clampedY = imageY + imageHeight - current.height;
        return {
            x: clampedX,
            y: clampedY
        };
    }, []); // Correct dimensions when resizing with aspect ratio constraints
    const correctResizeDimensions = (0, $cozmU.useCallback)((current, selection)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        if (!canvas || !image) return null;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        const maxWidthAvailable = imageX + imageWidth - current.x;
        const maxHeightAvailable = imageY + imageHeight - current.y;
        let correctedWidth = current.width;
        let correctedHeight = current.height;
        const hasAspectRatio = selection.aspectRatio && selection.aspectRatio > 0;
        if (hasAspectRatio) {
            const aspectRatio = selection.aspectRatio;
            const heightIfMaxWidth = maxWidthAvailable / aspectRatio;
            const widthIfMaxHeight = maxHeightAvailable * aspectRatio; // Determine which axis is the limiting factor
            if (heightIfMaxWidth <= maxHeightAvailable) {
                correctedWidth = maxWidthAvailable;
                correctedHeight = heightIfMaxWidth;
            } else {
                correctedHeight = maxHeightAvailable;
                correctedWidth = widthIfMaxHeight;
            }
        } else {
            correctedWidth = Math.min(correctedWidth, maxWidthAvailable);
            correctedHeight = Math.min(correctedHeight, maxHeightAvailable);
        } // Ensure positive dimensions
        correctedWidth = Math.max(1, correctedWidth);
        correctedHeight = Math.max(1, correctedHeight);
        return {
            width: correctedWidth,
            height: correctedHeight
        };
    }, []); // Handle move operation (position changed but size stayed same)
    const handleMove = (0, $cozmU.useCallback)(()=>{
        requestAnimationFrame(()=>{
            const selection = selectionRef.current;
            if (!selection) return;
            const current = {
                x: selection.x || 0,
                y: selection.y || 0,
                width: selection.width || 0,
                height: selection.height || 0
            };
            const clamped = clampPosition(current);
            if (!clamped) return;
            if (typeof selection.$change === 'function') selection.$change(Math.floor(clamped.x), Math.floor(clamped.y), Math.floor(current.width), Math.floor(current.height));
            previousSelectionRef.current = {
                width: current.width,
                height: current.height
            };
        });
    }, [
        clampPosition
    ]); // Handle resize operation (size changed, may need aspect ratio correction)
    const handleResize = (0, $cozmU.useCallback)(()=>{
        requestAnimationFrame(()=>{
            const selection = selectionRef.current;
            if (!selection) return;
            const current = {
                x: selection.x || 0,
                y: selection.y || 0,
                width: selection.width || 0,
                height: selection.height || 0
            };
            const corrected = correctResizeDimensions(current, selection);
            if (!corrected) return;
            const canvas = canvasRef.current;
            const image = imageRef.current;
            if (!canvas || !image) return;
            const canvasRect = canvas.getBoundingClientRect();
            const imageRect = image.getBoundingClientRect();
            const imageX = imageRect.left - canvasRect.left;
            const imageY = imageRect.top - canvasRect.top;
            const correctedX = Math.max(imageX, current.x);
            const correctedY = Math.max(imageY, current.y);
            if (typeof selection.$change === 'function') selection.$change(Math.floor(correctedX), Math.floor(correctedY), Math.floor(corrected.width), Math.floor(corrected.height));
            previousSelectionRef.current = {
                width: corrected.width,
                height: corrected.height
            };
        });
    }, [
        correctResizeDimensions
    ]); // Check if selection is within image boundaries
    const isSelectionOutOfBounds = (0, $cozmU.useCallback)((imageX, imageY, imageWidth, imageHeight, selection)=>{
        const tolerance = 1;
        return selection.x < imageX - tolerance || selection.y < imageY - tolerance || selection.x + selection.width > imageX + imageWidth + tolerance || selection.y + selection.height > imageY + imageHeight + tolerance;
    }, []); // Detect if operation is a move or resize based on dimension change
    const isMovingSelection = (0, $cozmU.useCallback)(()=>{
        const prev = previousSelectionRef.current;
        const curr = selectionRef.current;
        if (!prev || !curr) return false;
        return prev.width === curr.width && prev.height === curr.height;
    }, []);
    const handleSelectionChange = (0, $cozmU.useCallback)((event)=>{
        const canvas = canvasRef.current;
        const image = imageRef.current;
        const customEvent = event;
        const selection = customEvent.detail;
        if (!canvas || !image || !selection) return;
        const canvasRect = canvas.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const imageX = imageRect.left - canvasRect.left;
        const imageY = imageRect.top - canvasRect.top;
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        if (!isSelectionOutOfBounds(imageX, imageY, imageWidth, imageHeight, selection)) {
            previousSelectionRef.current = {
                width: selection.width,
                height: selection.height
            };
            return;
        }
        if (isMovingSelection()) handleMove();
        else handleResize();
    }, [
        isSelectionOutOfBounds,
        isMovingSelection,
        handleMove,
        handleResize
    ]); // Lazy load cropperjs only on the client to avoid SSR side effects
    (0, $cozmU.useEffect)(()=>{
        if (!$1832a0c4f5a4235c$var$isSSRRender()) (parcelRequire("3BXGS")).then(()=>setIsCropperLoaded(true)).catch(()=>{
            setIsCropperLoaded(false);
        });
    }, []); // Auto-fit stencil to image on mount and when src changes
    // Only run after cropperjs has loaded (client-side only, post-hydration)
    (0, $cozmU.useEffect)(()=>{
        if (!isCropperLoaded) return;
         // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setIsImageReady(false); // Hide canvas while repositioning
        const image = imageRef.current;
        if (!image) return;
         // Wait for the image to be fully loaded
        if (typeof image.$ready === 'function') image.$ready(()=>{
            const timer = setTimeout(()=>{
                fitStencilToImage();
                setIsImageReady(true);
                onImageReady?.(true);
            }, 500); // Adding a small timeout as there is a rendering issue with webkit
            return ()=>clearTimeout(timer);
        });
        else {
            // Fallback to timeout if $ready is not available
            const timer = setTimeout(()=>{
                fitStencilToImage();
                setIsImageReady(true);
                onImageReady?.(true);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        src,
        isCropperLoaded,
        onImageReady,
        fitStencilToImage
    ]); // Attach selection change listener to enforce boundaries (only after image is ready)
    (0, $cozmU.useEffect)(()=>{
        if (!isImageReady) return;
        const selection = selectionRef.current;
        if (!selection) return;
        return (0, $cbY7C.bind)(selection, {
            type: 'change',
            listener: handleSelectionChange
        });
    }, [
        isImageReady,
        handleSelectionChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!canvasRef.current || !imageRef.current) return;
        const observer = new ResizeObserver(()=>{
            // This forces the image to recalculate its "contain" logic
            // whenever the canvas wrapper changes size
            if (typeof imageRef.current?.$center === 'function') imageRef.current?.$center('contain');
        });
        observer.observe(canvasRef.current);
        return ()=>observer.disconnect();
    }, [
        canvasRef,
        imageRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!canvasRef.current) return;
        const observer = new ResizeObserver(()=>{
            selectionRef.current?.removeAttribute('aspect-ratio');
            fitStencilToImage();
        });
        observer.observe(canvasRef.current);
        return ()=>observer.disconnect();
    }, [
        fitStencilToImage
    ]);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            fitStencilToImage: fitStencilToImage,
            getCanvas: getCanvas,
            getCroppedCanvas: getCroppedCanvas,
            getImage: getImage,
            isImageReady: isImageReady,
            getSelection: getSelection
        }), [
        getCanvas,
        getCroppedCanvas,
        getImage,
        isImageReady,
        fitStencilToImage,
        getSelection
    ]); // Inject global styles for cropper handles
    (0, $cozmU.useEffect)(()=>{
        const style = document.createElement('style');
        const circularStyle = isCircle ? `
			cropper-selection {
				outline: none;
				border-top: 1px solid #0052CC;
				border-right: 1px solid #0052CC;
				border-bottom: 1px solid #0052CC;
				border-left: 1px solid #0052CC;
				box-sizing: border-box;
				border-radius: 50%;
				box-shadow: 0 0 0 9999px rgba(255, 255, 255, 0.6);
			}
		` : `
			cropper-selection {
				outline: none;
				border-top: 1px solid #0052CC;
				border-right: 1px solid #0052CC;
				border-bottom: 1px solid #0052CC;
				border-left: 1px solid #0052CC;
				box-sizing: border-box; 
			}
		`;
        style.textContent = `
				cropper-canvas {
					background-color: #F8F8F8;
					background-image: none;
				}
				cropper-shade {
					outline-color: rgba(255,255,255,0.5);
				}
				cropper-handle[action="move"] {
					opacity: 0;
				}
				cropper-handle[action="ne-resize"] {
					border-radius: 7px 4px 4px 4px;
					border-right: 7px solid rgba(255,255,255,0.6);
					border-top: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-4px, 4px); 
				}
				cropper-handle[action="ne-resize"]::after {
					border-radius: 5px 4px 4px 4px;
					border-right: 5px solid #0052CC;
					border-top: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-7px, -14px); 
				}
				cropper-handle[action="nw-resize"] {
					border-radius: 4px 7px 4px 4px;
					border-left: 7px solid rgba(255,255,255,0.6);
					border-top: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(4px, 4px); 
				}
				cropper-handle[action="nw-resize"]::after {
					border-radius: 4px 5px 4px 4px;
					border-left: 5px solid #0052CC;
					border-top: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-14px, -14px); 
				}
				cropper-handle[action="se-resize"] {
					border-radius: 4px 4px 7px 4px;
					border-right: 7px solid rgba(255,255,255,0.6);
					border-bottom: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-4px, -4px); 
				}
				cropper-handle[action="se-resize"]::after {
					border-radius: 4px 4px 5px 4px;
					border-right: 5px solid #0052CC;
					border-bottom: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-7px, -7px); 
				}
				cropper-handle[action="sw-resize"] {
					border-radius: 4px 4px 4px 7px;
					border-left: 7px solid rgba(255,255,255,0.6);
					border-bottom: 7px solid rgba(255,255,255,0.6);
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(4px, -4px); 
				}
				cropper-handle[action="sw-resize"]::after {
					border-radius: 4px 4px 4px 5px;
					border-left: 5px solid #0052CC;
					border-bottom: 5px solid #0052CC;
					height: 15px;
					width: 15px;
					background-color: transparent;
					transform: translate(-14px, -7px); 
				}
				${circularStyle}
			`;
        document.head.appendChild(style);
        return ()=>style.remove();
    }, [
        isCircle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperCanvas, {
        ref: canvasRef,
        class: className,
        background: background,
        style: {
            opacity: isImageReady ? 1 : 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperImage, {
        ref: imageRef,
        src: src,
        alt: alt,
        crossorigin: crossOrigin,
        rotatable: rotatable,
        scalable: scalable,
        translatable: translatable,
        "initial-center-size": "contain"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperShade, {
        x: 240,
        y: 5,
        width: 160,
        height: 90
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperSelection, {
        ref: selectionRef,
        "initial-coverage": initialCoverage,
        "aspect-ratio": aspectRatio,
        "initial-aspect-ratio": initialAspectRatio,
        movable: movable,
        resizable: resizable,
        zoomable: zoomable,
        multiple: multiple,
        outlined: outlined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperGrid, {
        role: "grid",
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperCrosshair, {
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperHandle, {
        action: "move"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperHandle, {
        action: "ne-resize"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperHandle, {
        action: "nw-resize"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperHandle, {
        action: "se-resize"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1832a0c4f5a4235c$var$CropperHandle, {
        action: "sw-resize"
    })));
});
$1832a0c4f5a4235c$export$71ed2b85d4ca43d3.displayName = 'Cropper';


/* FlipHorizontalIcon.tsx generated by @compiled/babel-plugin v0.40.0 */ 





const $0b9ace0794dccf83$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $0b9ace0794dccf83$var$svgStyles = null;
const $0b9ace0794dccf83$export$19f53ac153fdf5c1 = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $0b9ace0794dccf83$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M8.75 16H7.25V0H8.75V16ZM1.97559 3.99609C2.56238 3.77737 3.22379 3.94656 3.63379 4.41992L5.88379 7.01855L5.92773 7.07129C6.37112 7.63335 6.3567 8.43636 5.88379 8.98242L3.63379 11.5801C3.22379 12.0535 2.56239 12.2226 1.97559 12.0039C1.38909 11.7851 1.00022 11.2246 1 10.5986V5.40234C1.00003 4.77617 1.38894 4.21497 1.97559 3.99609ZM12.3662 4.41992C12.7762 3.94656 13.4376 3.77737 14.0244 3.99609C14.6111 4.21497 15 4.77617 15 5.40234V10.5986C14.9998 11.2246 14.6109 11.7851 14.0244 12.0039C13.4376 12.2226 12.7762 12.0535 12.3662 11.5801L10.1162 8.98242C9.6433 8.43636 9.62888 7.63335 10.0723 7.07129L10.1162 7.01855L12.3662 4.41992ZM2.5 10.5986L4.75 8L2.5 5.40234V10.5986ZM11.25 8L13.5 10.5986V5.40234L11.25 8Z",
        fill: primaryColor
    }));


/* FlipVerticalIcon.tsx generated by @compiled/babel-plugin v0.40.0 */ 





const $a0df28d607359cd7$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $a0df28d607359cd7$var$svgStyles = null;
const $a0df28d607359cd7$export$e97029447c2d07bf = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $a0df28d607359cd7$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M1.492e-05 8.75L1.49856e-05 7.25L16 7.25L16 8.75L1.492e-05 8.75ZM12.0039 1.97656C12.2224 2.56323 12.0533 3.2239 11.5801 3.63379L8.98146 5.88379L8.92873 5.92871C8.36667 6.37206 7.56364 6.35668 7.01759 5.88379L4.41994 3.63379C3.94669 3.2239 3.77765 2.56325 3.99611 1.97656C4.21484 1.38987 4.77528 1.00022 5.40138 1L10.5977 1C11.224 1.00003 11.7851 1.38973 12.0039 1.97656ZM11.5801 12.3662C12.0533 12.7761 12.2224 13.4368 12.0039 14.0234C11.7851 14.6103 11.224 15 10.5977 15L5.40138 15C4.77528 14.9998 4.21484 14.6101 3.99611 14.0234C3.77765 13.4368 3.94669 12.7761 4.41994 12.3662L7.01759 10.1162C7.56364 9.64332 8.36667 9.62794 8.92873 10.0713L8.98146 10.1162L11.5801 12.3662ZM5.40138 2.5L8.00002 4.75L10.5977 2.5L5.40138 2.5ZM8.00001 11.25L5.40138 13.5L10.5977 13.5L8.00001 11.25Z",
        fill: primaryColor
    }));


/* RatioIcon.tsx generated by @compiled/babel-plugin v0.40.0 */ 





const $68a5f1678a50687d$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $68a5f1678a50687d$var$svgStyles = null;
const $68a5f1678a50687d$export$8dcfa0333e5b427e = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $68a5f1678a50687d$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M3 10V13H6V14.5H2.875C2.11561 14.5 1.5 13.8844 1.5 13.125V10H3ZM14.5 13.125C14.5 13.8844 13.8844 14.5 13.125 14.5H10V13H13V10H14.5V13.125ZM13.125 1.5C13.8844 1.5 14.5 2.11561 14.5 2.875V6H13V3H10V1.5H13.125ZM6 3H3V6H1.5V2.875C1.5 2.11561 2.11561 1.5 2.875 1.5H6V3Z",
        fill: primaryColor
    }));


/* RotateIcon.tsx generated by @compiled/babel-plugin v0.40.0 */ 





const $ec1c7a0b4b8f32c9$var$sizeStyles = {
    small: "_1bsbgktf _4t3igktf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $ec1c7a0b4b8f32c9$var$svgStyles = null;
const $ec1c7a0b4b8f32c9$export$f48a22e8beb69262 = ({ label: label, size: size = 'small', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, isDisabled: isDisabled })=>/*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: primaryColor,
            fill: secondaryColor,
            opacity: isDisabled ? 0.5 : 1
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $ec1c7a0b4b8f32c9$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.93459 6.72227C7.47156 6.1853 8.34216 6.1853 8.87913 6.72227L12.0914 9.93458C12.6284 10.4716 12.6284 11.3422 12.0914 11.8791L8.87913 15.0914C8.34216 15.6284 7.47156 15.6284 6.93459 15.0914L3.72228 11.8791C3.18531 11.3422 3.18531 10.4716 3.72228 9.93458L6.93459 6.72227ZM7.90686 7.87132L4.87133 10.9069L7.90686 13.9424L10.9424 10.9069L7.90686 7.87132Z",
        fill: primaryColor
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5C10.6789 0.5 13.0485 1.81718 14.5 3.83691V0.75H16V5.5C16 5.91421 15.6642 6.25 15.25 6.25H10.5V4.75H13.3086C12.1308 3.08578 10.192 2 8 2C4.41015 2 1.5 4.91015 1.5 8.5V9.25H0V8.5Z",
        fill: primaryColor
    }));









var $kSwu1 = parcelRequire("kSwu1");

const $f8db3e284214e4cc$var$ASPECT_RATIOS = {
    original: null,
    custom: null,
    square: {
        x: 1,
        y: 1
    },
    circle: {
        x: 1,
        y: 1
    },
    landscape: {
        x: 4,
        y: 3
    },
    portrait: {
        x: 3,
        y: 4
    },
    wide: {
        x: 16,
        y: 9
    }
};
const $f8db3e284214e4cc$export$873aefdf6f4e5566 = ()=>{
    // no ratio = undefined = custom cropping selection
    const getAspectRatioValue = (ratio)=>{
        const aspectRatioValue = $f8db3e284214e4cc$var$ASPECT_RATIOS[ratio];
        if (aspectRatioValue) return aspectRatioValue.x / aspectRatioValue.y;
        return undefined;
    };
    return {
        getAspectRatioValue: getAspectRatioValue
    };
};
const $f8db3e284214e4cc$export$b331ea965923cd1f = (cropperRef)=>{
    const flipHorizontal = ()=>{
        const image = cropperRef.current?.getImage();
        if (image?.$scale) image.$scale(-1, 1);
    };
    const flipVertical = ()=>{
        const image = cropperRef.current?.getImage();
        if (image?.$scale) image.$scale(1, -1);
    };
    return {
        flipHorizontal: flipHorizontal,
        flipVertical: flipVertical
    };
};
const $f8db3e284214e4cc$export$9202d595fd82f22e = (cropperRef)=>{
    const rotateRight = ()=>{
        const canvas = cropperRef.current?.getCanvas();
        const image = cropperRef.current?.getImage();
        if (!canvas || !image) return;
        const selectionEl = canvas.querySelector('cropper-selection');
        if (selectionEl instanceof HTMLElement) selectionEl.style.opacity = '0';
        image.$rotate('90deg');
        image.$center('contain');
        cropperRef.current?.fitStencilToImage();
        if (selectionEl instanceof HTMLElement) selectionEl.style.opacity = '1';
    };
    return {
        rotateRight: rotateRight
    };
};


const $7c84ebddd77bf93c$export$c9acda86a2363b01 = ()=>{
    const cropperRef = (0, $cozmU.useRef)(null);
    const doneButtonRef = (0, $cozmU.useRef)(null);
    const aspectRatioResolverRef = (0, $cozmU.useRef)(null);
    const isInitialSetupRef = (0, $cozmU.useRef)(true);
    const [isImageReady, setIsImageReady] = (0, $cozmU.useState)(false);
    const [currentAspectRatio, setCurrentAspectRatio] = (0, $cozmU.useState)(undefined);
    const [aspectRatioSelection, setAspectRatioSelection] = (0, $cozmU.useState)('custom');
    const { flipHorizontal: flipHorizontal, flipVertical: flipVertical } = (0, $f8db3e284214e4cc$export$b331ea965923cd1f)(cropperRef);
    const { rotateRight: rotateRight } = (0, $f8db3e284214e4cc$export$9202d595fd82f22e)(cropperRef);
    const { getAspectRatioValue: getAspectRatioValue } = (0, $f8db3e284214e4cc$export$873aefdf6f4e5566)();
    const intl = (0, $kSwu1.useIntl)();
    // Initialize editor state and track canvas size changes
    (0, $cozmU.useEffect)(()=>{
        if (!isImageReady) return;
        // Get the canvas element to observe for size changes
        const canvas = cropperRef.current?.getCanvas();
        if (!canvas) return;
        // Track initial canvas dimensions before any state updates
        let lastWidth = canvas.clientWidth;
        let lastHeight = canvas.clientHeight;
        // Canvas size will change when the viewport size changes
        // Monitor canvas resizing to detect when user manually adjusts the crop area
        const observer = new ResizeObserver((entries)=>{
            // Skip the first observation during setup
            if (isInitialSetupRef.current) {
                isInitialSetupRef.current = false;
                return;
            }
            const entry = entries[0];
            const { width: width, height: height } = entry.contentRect;
            // If canvas size changes, switch to custom aspect ratio mode
            if (width !== lastWidth || height !== lastHeight) {
                lastWidth = width;
                lastHeight = height;
                setAspectRatioSelection('custom');
            }
        });
        observer.observe(canvas);
        // Calculate and set the original aspect ratio based on the image dimensions
        setAspectRatioSelection('custom');
        // Focus on the done button as soon as image loads
        if (doneButtonRef.current) doneButtonRef.current.focus();
        return ()=>observer.disconnect();
    }, [
        isImageReady
    ]);
    // Listen for aspect ratio selection changes and update current aspect ratio
    // This effect monitors the cropper's selection element for any changes
    // and updates the currentAspectRatio state accordingly
    (0, $cozmU.useEffect)(()=>{
        if (isImageReady && aspectRatioSelection !== '') {
            const selection = cropperRef.current?.getSelection();
            if (!selection) return;
            // Update aspect ratio whenever aspect ratio selection changes
            const handleSelectionChange = ()=>{
                const selectionAspectRatio = selection.aspectRatio ? selection.aspectRatio : undefined;
                setCurrentAspectRatio(selectionAspectRatio);
            };
            // Call once to set initial value
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            handleSelectionChange();
            // Attach change listener to selection element
            return (0, $cbY7C.bind)(selection, {
                type: 'change',
                listener: handleSelectionChange
            });
        }
    }, [
        isImageReady,
        aspectRatioSelection
    ]);
    // Resolve pending aspect ratio changes
    // This effect watches for when the aspect ratio reaches its target value
    // and resolves the corresponding promise to allow animations to proceed
    (0, $cozmU.useEffect)(()=>{
        const pending = aspectRatioResolverRef.current;
        if (pending && currentAspectRatio === pending.target) {
            // Resolve the promise stored in the ref when target is reached
            pending.resolve();
            aspectRatioResolverRef.current = null;
        }
    }, [
        currentAspectRatio
    ]);
    // Calculate the original aspect ratio of the image
    // Gets the image element's dimensions and computes width/height ratio
    const calculateOriginalRatio = ()=>{
        const image = cropperRef.current?.getImage();
        if (image) {
            const img = image.getBoundingClientRect();
            const ratio = img.width / img.height;
            setCurrentAspectRatio(ratio);
        }
    };
    // Wait for the aspect ratio to reach a target value
    // Used to coordinate aspect ratio changes with animation frames
    // Returns a promise that resolves when the target ratio is reached
    const waitForCurrentAspectRatio = (target)=>new Promise((resolve)=>{
            // If already at target, resolve on next animation frame
            if (currentAspectRatio === target) {
                requestAnimationFrame(()=>resolve());
                return;
            }
            // Otherwise, store resolve callback to be called when target is reached
            aspectRatioResolverRef.current = {
                resolve: resolve,
                target: target
            };
        });
    // Change the aspect ratio selection and animate the transition
    // This function handles smooth transitions between different aspect ratios
    const setSelectionArea = async (selectedRatio)=>{
        // Custom ratio mode: free-form selection without constraints
        if (selectedRatio === 'custom') {
            setAspectRatioSelection(selectedRatio);
            setCurrentAspectRatio(undefined);
            await waitForCurrentAspectRatio(undefined);
            return;
        }
        const selection = cropperRef.current?.getSelection();
        const canvas = cropperRef.current?.getCanvas();
        const shade = canvas?.querySelector('cropper-shade');
        // Fade out selection and shade during transition for smooth animation
        if (selection) selection.style.opacity = '0';
        if (shade) shade.style.opacity = '0';
        // Reset aspect ratio and wait for the crop area to clear
        setCurrentAspectRatio(undefined);
        await waitForCurrentAspectRatio(undefined);
        cropperRef.current?.fitStencilToImage();
        // Wait for DOM to update
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        // Set the new aspect ratio
        if (selectedRatio === 'original') calculateOriginalRatio();
        else {
            const ratioVal = getAspectRatioValue(selectedRatio);
            setCurrentAspectRatio(ratioVal);
            await waitForCurrentAspectRatio(ratioVal);
        }
        setAspectRatioSelection(selectedRatio);
        // Allow time for the new crop area to be positioned and rendered
        await new Promise((resolve)=>setTimeout(resolve, 300));
        // Center the selection and fade back in
        if (selection) {
            selection.$center();
            selection.style.opacity = '1';
        }
        if (shade) shade.style.opacity = '1';
    };
    // Extract the cropped image and save it
    // Converts the cropped canvas to a blob and calls the onSave callback
    const handleSave = async (onSave, onClose, errorReporter)=>{
        try {
            // Get the selection to determine the crop size relative to original image
            const selection = cropperRef.current?.getSelection();
            const image = cropperRef.current?.getImage();
            let canvasWidth;
            if (selection && image) {
                // Try to get the actual <img> from shadow DOM
                const actualImg = image.shadowRoot?.querySelector('img') || null;
                if (actualImg) {
                    // Get the natural (original) image dimensions
                    const naturalWidth = actualImg.naturalWidth;
                    // Get the displayed image dimensions
                    const displayedRect = image.getBoundingClientRect();
                    const displayedWidth = displayedRect.width;
                    // Calculate the scale factor between displayed and original image
                    const scaleX = naturalWidth / displayedWidth;
                    // Get selection dimensions in displayed coordinates
                    const selectionWidth = selection.width || 0;
                    // Calculate the crop width in original image coordinates
                    const cropWidthInOriginal = selectionWidth * scaleX;
                    // Use the crop width from original image, capped at a reasonable maximum
                    canvasWidth = Math.min(cropWidthInOriginal, 1500);
                }
            }
            // Get the cropped canvas with calculated width
            // Fallback to width = 1500 (a reasonable size for keeping high quality images relatively high quality)
            const canvas = await cropperRef.current?.getCroppedCanvas(canvasWidth ? {
                width: canvasWidth
            } : {
                width: 1500
            });
            if (canvas) {
                const outWidth = canvas.width;
                const outHeight = canvas.height;
                // Convert canvas to blob (defaults to png)
                canvas.toBlob((blob)=>{
                    if (blob) onSave?.(blob, outWidth, outHeight);
                });
            }
        } catch (error) {
            // Report any errors to the error reporter
            if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
        }
    };
    return {
        cropperRef: cropperRef,
        doneButtonRef: doneButtonRef,
        isImageReady: isImageReady,
        setIsImageReady: setIsImageReady,
        currentAspectRatio: currentAspectRatio,
        aspectRatioSelection: aspectRatioSelection,
        flipHorizontal: flipHorizontal,
        flipVertical: flipVertical,
        rotateRight: rotateRight,
        setSelectionArea: setSelectionArea,
        handleSave: handleSave,
        formatMessage: intl.formatMessage
    };
};


const $8a9dece58e2849aa$var$imageWrapper = null;
const $8a9dece58e2849aa$var$cropper = null;
const $8a9dece58e2849aa$var$modalFooter = null;
const $8a9dece58e2849aa$var$ratioBtn = null;
const $8a9dece58e2849aa$var$ratioSelect = null;
const $8a9dece58e2849aa$var$loadingImageStyle = null;
const $8a9dece58e2849aa$var$dropdownItemGroup = null;
const $8a9dece58e2849aa$var$btnGroupStyle = {
    box: "_zulpu2gc _1e0c1txw"
};
const $8a9dece58e2849aa$var$aspectRatioLabelMap = {
    original: 'aspectRatioSelectionOriginal',
    custom: 'aspectRatioSelectionCustom',
    square: 'aspectRatioSelectionSquare',
    circle: 'aspectRatioSelectionCircle',
    landscape: 'aspectRatioSelectionLandscape',
    portrait: 'aspectRatioSelectionPortrait',
    wide: 'aspectRatioSelectionWide'
};
const $8a9dece58e2849aa$export$d0486c7a5136628 = ({ imageUrl: imageUrl, isOpen: isOpen, isSaving: isSaving = false, onClose: onClose, onSave: onSave, errorReporter: errorReporter })=>{
    const { cropperRef: cropperRef, doneButtonRef: doneButtonRef, isImageReady: isImageReady, setIsImageReady: setIsImageReady, currentAspectRatio: currentAspectRatio, aspectRatioSelection: aspectRatioSelection, flipHorizontal: flipHorizontal, flipVertical: flipVertical, handleSave: handleSave, setSelectionArea: setSelectionArea, formatMessage: formatMessage, rotateRight: rotateRight } = (0, $7c84ebddd77bf93c$export$c9acda86a2363b01)();
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: isSaving ? ()=>{} : onClose,
        height: 800,
        width: "x-large",
        testId: "image-editor-modal",
        label: "Image editor modal"
    }, /*#__PURE__*/ $cozmU.createElement("br", null), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _4t3i1osq _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ])
    }, !isImageReady && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        testId: "spinner",
        interactionName: "load",
        label: "Loading"
    })), imageUrl && /*#__PURE__*/ $cozmU.createElement((0, $1832a0c4f5a4235c$export$71ed2b85d4ca43d3), {
        ref: cropperRef,
        src: imageUrl,
        alt: "Crop me",
        crossOrigin: "anonymous",
        initialCoverage: 1,
        aspectRatio: currentAspectRatio,
        isCircle: aspectRatioSelection === 'circle',
        onImageReady: setIsImageReady,
        className: (0, $hekY6.default)([
            "_p12f1osq _1bsb1osq _4t3i1osq"
        ])
    }))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        appearance: "default",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: !isImageReady || isSaving,
                isSelected: props.isSelected,
                onClick: props.onClick,
                onFocus: props.onFocus,
                onBlur: props.onBlur,
                "aria-expanded": props['aria-expanded'],
                "aria-haspopup": props['aria-haspopup'],
                "aria-controls": props['aria-controls'],
                testId: props.testId
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    "_zulpu2gc _1e0c1txw _4cvr1h6o"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $68a5f1678a50687d$export$8dcfa0333e5b427e), {
                label: "change aspect ratio button",
                isDisabled: !isImageReady || isSaving
            }), aspectRatioSelection && formatMessage((0, $7BkLi.mediaEditingMessages)[$8a9dece58e2849aa$var$aspectRatioLabelMap[aspectRatioSelection]]), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                size: "small"
            })))
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1ul9uuw1"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, [
        'original',
        'custom'
    ].map((item)=>/*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
            key: item,
            onClick: ()=>{
                setSelectionArea(item);
            }
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o"
            ])
        }, formatMessage((0, $7BkLi.mediaEditingMessages)[$8a9dece58e2849aa$var$aspectRatioLabelMap[item]]), aspectRatioSelection === item && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "selected"
        }))))), /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), {
        hasSeparator: true
    }, [
        'square',
        'circle',
        'landscape',
        'portrait',
        'wide'
    ].map((item)=>/*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
            key: item,
            onClick: ()=>{
                setSelectionArea(item);
            }
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o"
            ])
        }, formatMessage((0, $7BkLi.mediaEditingMessages)[`${item}Button`]), aspectRatioSelection === item && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "selected"
        }))))))), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        onClick: async ()=>{
            rotateRight();
            await setSelectionArea('custom');
            cropperRef.current?.fitStencilToImage();
        },
        isDisabled: !isImageReady || isSaving,
        testId: "image-editor-rotate-right-btn",
        appearance: "subtle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ec1c7a0b4b8f32c9$export$f48a22e8beb69262), {
        label: "rotate right button",
        isDisabled: !isImageReady || isSaving
    })), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: flipVertical,
        isDisabled: !isImageReady || isSaving,
        testId: "image-editor-flip-vertical-btn",
        appearance: "subtle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $a0df28d607359cd7$export$e97029447c2d07bf), {
        label: "flip vertical button",
        isDisabled: !isImageReady || isSaving
    })), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: flipHorizontal,
        isDisabled: !isImageReady || isSaving,
        testId: "image-editor-flip-horizontal-btn",
        appearance: "subtle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $0b9ace0794dccf83$export$19f53ac153fdf5c1), {
        label: "flip horizontal button",
        isDisabled: !isImageReady || isSaving
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $8a9dece58e2849aa$var$btnGroupStyle.box
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose,
        isDisabled: isSaving
    }, formatMessage((0, $7BkLi.mediaEditingMessages).cancelButton)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>handleSave(onSave, onClose, errorReporter),
        isDisabled: !isImageReady || isSaving,
        isLoading: isSaving,
        ref: doneButtonRef
    }, isSaving ? formatMessage((0, $7BkLi.mediaEditingMessages).savingButton) : formatMessage((0, $7BkLi.mediaEditingMessages).doneButton)))))));
};


const $1eb7b645251d495f$export$8ac4c72242e73a4e = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs, errorReporter: errorReporter, editorView: editorView })=>{
    const [imageUrl, setImageUrl] = (0, $cozmU.useState)('');
    const [isSaving, setIsSaving] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const getImageUrl = ()=>{
            if ((0, $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb)(selectedNodeAttrs)) {
                // Fall back in case editing button shows by mistake
                onClose();
                errorReporter?.captureException(new Error('Cannot edit external media due to CORS restrictions'));
            } else {
                // File media - use MediaClient to get the image URL
                const { id: id, collection: collection = '' } = selectedNodeAttrs;
                try {
                    const mediaClient = new (0, $204vt.MediaClient)(mediaClientConfig);
                    // Subscribe to file state to get file information
                    const subscription = mediaClient.file.getFileState(id, {
                        collectionName: collection
                    }).subscribe((fileState)=>{
                        if (fileState.status === 'processed' || fileState.status === 'processing') // Get the image URL from the processed file
                        mediaClient.file.getFileBinaryURL(id, collection).then((url)=>{
                            setImageUrl(url);
                        });
                    });
                    // Cleanup subscription on unmount
                    return ()=>subscription.unsubscribe();
                } catch (error) {
                    if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
                    setImageUrl('');
                }
            }
        };
        getImageUrl();
    }, [
        selectedNodeAttrs,
        mediaClientConfig,
        errorReporter,
        onClose
    ]);
    const handleSave = (blob, width, height)=>{
        const mediaClient = new (0, $204vt.MediaClient)(mediaClientConfig);
        const collection = 'collection' in selectedNodeAttrs ? selectedNodeAttrs.collection || '' : '';
        // Ensure blob has MIME type
        const typedBlob = blob.type ? blob : new Blob([
            blob
        ], {
            type: 'image/png'
        });
        const localId = !(0, $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.localId : undefined;
        // Upload the edited image as a new file with a different filename
        const originalFileName = !(0, $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.__fileName : undefined;
        let editedFileName = 'edited-image.png'; // fallback if the filename doesn't exist
        if (originalFileName) {
            const lastDotIndex = originalFileName.lastIndexOf('.');
            if (lastDotIndex > 0) {
                const baseName = originalFileName.substring(0, lastDotIndex);
                editedFileName = `${baseName}-edited-${localId}`;
            } else editedFileName = `${originalFileName}-edited-${localId}`;
        }
        const uploadableFile = {
            content: typedBlob,
            collection: collection,
            mimeType: typedBlob.type,
            name: editedFileName,
            size: typedBlob.size
        };
        // Show saving state in modal
        setIsSaving(true);
        const uploadSubscription = mediaClient.file.upload(uploadableFile).subscribe({
            next: (fileState)=>{
                if (fileState.status === 'error') {
                    setIsSaving(false);
                    onClose();
                    uploadSubscription.unsubscribe();
                    return;
                }
                // Only update document when upload is complete
                if (fileState.status !== 'uploading' && fileState.status !== 'processing') {
                    const updatedAttrs = (0, $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs : {
                        ...selectedNodeAttrs,
                        id: fileState.id,
                        __fileName: fileState.name,
                        __fileMimeType: fileState.mimeType,
                        __fileSize: fileState.size,
                        width: width,
                        height: height
                    };
                    // Find the media node position and update it
                    const { state: state, dispatch: dispatch } = editorView;
                    const { doc: doc } = state;
                    let nodePos = null;
                    const selectedLocalId = !(0, $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb)(selectedNodeAttrs) ? selectedNodeAttrs.localId : undefined;
                    doc.descendants((node, pos)=>{
                        if ((0, $7d0bd631cb8b5bb4$export$c8d0f9dbb5a183eb)(selectedNodeAttrs)) return true;
                        // Find by localId (unique per node instance)
                        if (selectedLocalId && node.attrs.localId === selectedLocalId) {
                            nodePos = pos;
                            return false;
                        }
                        return true;
                    });
                    if (nodePos !== null) {
                        const node = doc.nodeAt(nodePos);
                        if (node) {
                            const tr = state.tr.setNodeMarkup(nodePos, undefined, updatedAttrs);
                            dispatch(tr);
                        }
                    }
                    uploadSubscription.unsubscribe();
                    setIsSaving(false);
                    onClose();
                }
            },
            error: (error)=>{
                if (errorReporter) errorReporter.captureException(error instanceof Error ? error : new Error(String(error)));
                uploadSubscription.unsubscribe();
                setIsSaving(false);
                onClose();
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a9dece58e2849aa$export$d0486c7a5136628), {
        isOpen: true,
        onClose: onClose,
        imageUrl: imageUrl,
        onSave: handleSave,
        errorReporter: errorReporter,
        isSaving: isSaving
    });
};


const $15d963889bca129e$var$imageEditorStateSelector = (states)=>{
    return {
        isImageEditorVisible: states.mediaEditingState?.isImageEditorVisible,
        imageEditorSelectedMedia: states.mediaEditingState?.imageEditorSelectedMedia,
        uploadMediaClientConfig: states.mediaState?.uploadMediaClientConfig
    };
};
const $15d963889bca129e$var$ImageEditorFunctionalComponent = ({ api: api, editorView: editorView })=>{
    const { isImageEditorVisible: isImageEditorVisible, imageEditorSelectedMedia: imageEditorSelectedMedia, uploadMediaClientConfig: uploadMediaClientConfig } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'mediaEditing',
        'media'
    ], $15d963889bca129e$var$imageEditorStateSelector);
    if (!isImageEditorVisible || !imageEditorSelectedMedia || !uploadMediaClientConfig) return null;
    const handleOnClose = ()=>{
        api?.core.actions.execute(api?.mediaEditing.commands.hideImageEditor);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eb7b645251d495f$export$8ac4c72242e73a4e), {
        mediaClientConfig: uploadMediaClientConfig,
        onClose: handleOnClose,
        selectedNodeAttrs: imageEditorSelectedMedia,
        editorView: editorView
    });
};
const $15d963889bca129e$export$c84116e7ea204952 = ({ api: api })=>({
        name: 'mediaEditing',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $799fc02b434f47a4$export$f00c49e7bdf6721d).getState(editorState) || null;
        },
        commands: {
            showImageEditor: $e65a45f8fbe96755$export$a0f8e5c5401083f8,
            hideImageEditor: $e65a45f8fbe96755$export$ac53b7b0b56dbebd
        },
        pmPlugins () {
            return [
                {
                    name: 'mediaEditingPlugin',
                    plugin: (0, $799fc02b434f47a4$export$ae829ec7b2625219)
                }
            ];
        },
        contentComponent ({ editorView: editorView }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($15d963889bca129e$var$ImageEditorFunctionalComponent, {
                api: api,
                editorView: editorView
            });
        }
    });



var $a31lS = parcelRequire("a31lS");


var $7eCZG = parcelRequire("7eCZG");


var $dYbu7 = parcelRequire("dYbu7");


var $1CaNG = parcelRequire("1CaNG");


var $gLxaI = parcelRequire("gLxaI");


var $60Pfj = parcelRequire("60Pfj");


var $7Upsh = parcelRequire("7Upsh");


var $cX2jD = parcelRequire("cX2jD");


var $lK9Pz = parcelRequire("lK9Pz");


var $dHFAY = parcelRequire("dHFAY");


var $jLogi = parcelRequire("jLogi");


var $fKdaf = parcelRequire("fKdaf");


var $9ki8I = parcelRequire("9ki8I");


var $fLS6B = parcelRequire("fLS6B");


var $cud1R = parcelRequire("cud1R");


var $40ukF = parcelRequire("40ukF");


var $5VZEy = parcelRequire("5VZEy");


var $ifkCZ = parcelRequire("ifkCZ");


var $kaUwk = parcelRequire("kaUwk");


var $bkj40 = parcelRequire("bkj40");


var $51qBv = parcelRequire("51qBv");


var $gh55E = parcelRequire("gh55E");


var $e6Dq9 = parcelRequire("e6Dq9");


var $e4SgJ = parcelRequire("e4SgJ");


var $82I6D = parcelRequire("82I6D");


var $8PVlW = parcelRequire("8PVlW");


var $lDJPY = parcelRequire("lDJPY");


var $l5MIu = parcelRequire("l5MIu");


var $1ZhW4 = parcelRequire("1ZhW4");


var $f2WDp = parcelRequire("f2WDp");


var $7gk7g = parcelRequire("7gk7g");


var $4y9hw = parcelRequire("4y9hw");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $iFdOW = parcelRequire("iFdOW");


var $gXOst = parcelRequire("gXOst");


var $k7vUa = parcelRequire("k7vUa");


var $47YIB = parcelRequire("47YIB");


var $k8SUN = parcelRequire("k8SUN");


var $3gmKQ = parcelRequire("3gmKQ");


var $h0KOi = parcelRequire("h0KOi");


var $dGnqc = parcelRequire("dGnqc");


var $5tMpU = parcelRequire("5tMpU");


var $4Kyof = parcelRequire("4Kyof");


var $7iL2d = parcelRequire("7iL2d");


var $iVGec = parcelRequire("iVGec");


var $eHllO = parcelRequire("eHllO");


var $laiso = parcelRequire("laiso");


var $1U7Jq = parcelRequire("1U7Jq");


var $6WRJZ = parcelRequire("6WRJZ");


var $3HCXM = parcelRequire("3HCXM");


var $HGu9Y = parcelRequire("HGu9Y");


var $5HQgD = parcelRequire("5HQgD");


var $jT02V = parcelRequire("jT02V");


var $4exuQ = parcelRequire("4exuQ");


var $e1OCV = parcelRequire("e1OCV");


var $hFvHs = parcelRequire("hFvHs");


var $eEseG = parcelRequire("eEseG");


var $jdplc = parcelRequire("jdplc");


var $5bzSg = parcelRequire("5bzSg");


var $7gEjc = parcelRequire("7gEjc");


var $2ZvWx = parcelRequire("2ZvWx");


var $4OMM6 = parcelRequire("4OMM6");


var $jeuMk = parcelRequire("jeuMk");


var $hYOOW = parcelRequire("hYOOW");


var $4Bdub = parcelRequire("4Bdub");


var $f3DNZ = parcelRequire("f3DNZ");


var $1K7sQ = parcelRequire("1K7sQ");


var $hBGxo = parcelRequire("hBGxo");


var $hHtwA = parcelRequire("hHtwA");


var $2hEu6 = parcelRequire("2hEu6");


var $3VDvd = parcelRequire("3VDvd");


var $fb3SZ = parcelRequire("fb3SZ");


var $dvcAA = parcelRequire("dvcAA");


var $3RHCI = parcelRequire("3RHCI");


var $dxDD9 = parcelRequire("dxDD9");


var $5JZoZ = parcelRequire("5JZoZ");


var $drevR = parcelRequire("drevR");


var $ljXAk = parcelRequire("ljXAk");


var $fxjEF = parcelRequire("fxjEF");


var $gUZEQ = parcelRequire("gUZEQ");


var $jIG3b = parcelRequire("jIG3b");


var $gkbos = parcelRequire("gkbos");


var $grjTL = parcelRequire("grjTL");


var $4gNvG = parcelRequire("4gNvG");


var $1171P = parcelRequire("1171P");


var $3Q36X = parcelRequire("3Q36X");


var $d1HsG = parcelRequire("d1HsG");


var $ctVsO = parcelRequire("ctVsO");


var $ftAOO = parcelRequire("ftAOO");


var $abOD2 = parcelRequire("abOD2");


var $cjuKO = parcelRequire("cjuKO");


var $4lpx1 = parcelRequire("4lpx1");


var $5C5Mq = parcelRequire("5C5Mq");


var $lfQQe = parcelRequire("lfQQe");




























































































































































































































































































var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");





var $eYo03 = parcelRequire("eYo03");


var $jHZ78 = parcelRequire("jHZ78");


var $5lo82 = parcelRequire("5lo82");


var $1tIRv = parcelRequire("1tIRv");














var $dM4cY = parcelRequire("dM4cY");








var $jqItm = parcelRequire("jqItm");











var $4X6m9 = parcelRequire("4X6m9");




let $e65a16941efd8768$var$executionRequestSequence = 0;
const $e65a16941efd8768$var$createExecutionRequestId = ()=>`execution-${++$e65a16941efd8768$var$executionRequestSequence}`;
const $e65a16941efd8768$var$getFinishExecutionMeta = ({ localId: localId, requestId: requestId })=>localId ? {
        localId: localId,
        requestId: requestId,
        type: 'FINISH_EXECUTION'
    } : undefined;
const $e65a16941efd8768$var$startExecution = ({ editorView: editorView, lifecycleState: lifecycleState, localId: localId, requestId: requestId })=>{
    if (!localId) return;
    (0, $4X6m9.dispatchAgentManagedExtensionMeta)(editorView, {
        lifecycleState: lifecycleState,
        localId: localId,
        requestId: requestId,
        type: 'START_EXECUTION'
    });
};
const $e65a16941efd8768$var$getCurrentLifecycleState = (editorView, localId)=>{
    const found = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, localId) ?? (0, $5lo82.findAgentManagedExtension)(editorView.state);
    return found ? (0, $jHZ78.getExecutionLifecycleState)(found.node) : 'no-body-executing';
};
const $e65a16941efd8768$var$isLatestExecutionRequest = ({ editorView: editorView, localId: localId, requestId: requestId })=>{
    const pluginState = (0, $eYo03.pluginKey).getState(editorView.state);
    if (!pluginState) return true;
    return pluginState.executionLifecycleByLocalId[localId]?.requestId === requestId;
};
const $e65a16941efd8768$export$8235b51c7030883b = async ({ aimoId: aimoId, editorView: editorView, localId: localId })=>{
    const requestId = $e65a16941efd8768$var$createExecutionRequestId();
    const lifecycleState = $e65a16941efd8768$var$getCurrentLifecycleState(editorView, localId);
    $e65a16941efd8768$var$startExecution({
        editorView: editorView,
        lifecycleState: lifecycleState,
        localId: localId,
        requestId: requestId
    });
    try {
        const executionResult = await (0, $jqItm.executeAiManagedObject)(aimoId);
        if (editorView.isDestroyed || !localId) return null;
        if (!$e65a16941efd8768$var$isLatestExecutionRequest({
            editorView: editorView,
            localId: localId,
            requestId: requestId
        })) return null;
        const executeTr = editorView.state.tr;
        (0, $4X6m9.replaceNodeBodyContent)(editorView.state, executeTr, executionResult.output.blockContent, localId);
        const cacheAiManagedObjectMeta = (0, $1tIRv.getCacheAiManagedObjectMeta)(executionResult.aiManagedObject, localId);
        const finishExecutionMeta = $e65a16941efd8768$var$getFinishExecutionMeta({
            localId: localId,
            requestId: requestId
        });
        (0, $4X6m9.setAgentManagedExtensionMeta)(executeTr, finishExecutionMeta ? [
            cacheAiManagedObjectMeta,
            finishExecutionMeta
        ] : cacheAiManagedObjectMeta);
        editorView.dispatch(executeTr);
        return executionResult.aiManagedObject;
    } catch  {
        if (editorView.isDestroyed) return null;
        if (localId && $e65a16941efd8768$var$isLatestExecutionRequest({
            editorView: editorView,
            localId: localId,
            requestId: requestId
        })) {
            const failureTr = editorView.state.tr;
            (0, $4X6m9.setAgentManagedExtensionMeta)(failureTr, [
                {
                    localId: localId,
                    requestId: requestId,
                    type: 'FAIL_EXECUTION'
                },
                {
                    localId: localId,
                    requestId: requestId,
                    type: 'FINISH_EXECUTION'
                }
            ]);
            editorView.dispatch(failureTr);
        }
        return null;
    }
};








const $6db51b6644db656c$var$NO_SELECT_ATTR_SELECTOR = '[data-no-extension-select]';
const $6db51b6644db656c$export$5da0612d8cab41d7 = 'agent-managed-extension';
const $6db51b6644db656c$export$b9bf3748f3ac8521 = 'bodiedExtension-content-dom-wrapper';
const $6db51b6644db656c$export$4e60d7c587e4fea7 = 'data-agent-managed-extension-content-dom';
const $6db51b6644db656c$export$79fd7963490e64c = (doc, node, options = {})=>{
    const root = doc.createElement('div');
    root.classList.add($6db51b6644db656c$export$5da0612d8cab41d7);
    root.setAttribute('data-node-type', 'bodied-extension');
    root.setAttribute('data-extension-type', node.attrs.extensionType);
    root.setAttribute('data-extension-key', node.attrs.extensionKey);
    root.setAttribute('data-local-id', node.attrs.localId ?? '');
    const mountPoint = doc.createElement('div');
    mountPoint.classList.add('extension-container');
    root.appendChild(mountPoint);
    if (!options.includeContentDOM) return {
        root: root,
        mountPoint: mountPoint
    };
    const contentDOM = doc.createElement('div');
    contentDOM.classList.add($6db51b6644db656c$export$b9bf3748f3ac8521);
    contentDOM.setAttribute($6db51b6644db656c$export$4e60d7c587e4fea7, 'true');
    // ProseMirror expects contentDOM to start inside the node view DOM. The
    // React view moves this same node into its body wrapper on first layout so
    // editor-managed body content sits inside the custom chrome.
    root.appendChild(contentDOM);
    return {
        root: root,
        mountPoint: mountPoint,
        contentDOM: contentDOM
    };
};
const $6db51b6644db656c$export$1f8619c80fdc0e01 = (view, dom, getPos)=>{
    const handle = (e)=>{
        const pos = getPos();
        if (typeof pos !== 'number') return;
        const target = e.target;
        if (target?.closest(`${$6db51b6644db656c$var$NO_SELECT_ATTR_SELECTOR}, [${$6db51b6644db656c$export$4e60d7c587e4fea7}]`)) return;
        e.preventDefault();
        view.dispatch(view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos)));
    };
    return (0, $cbY7C.bind)(dom, {
        type: 'mousedown',
        listener: handle
    });
};


const $7705f643ae0490ee$var$buildPortalKey = (node)=>`agent-managed-extension-${node.attrs.localId ?? Math.random().toString(36)}`;
/**
 * Registry of active agent-managed-extension node views.
 * Used by the plugin's `view.update()` to trigger re-renders when plugin
 * state changes (e.g. config open/close), since ProseMirror only calls
 * `NodeView.update()` when the underlying node itself changes.
 */ const $7705f643ae0490ee$var$activeNodeViews = new Set();
const $7705f643ae0490ee$export$924a307d8482cd9d = ()=>{
    for (const nodeView of $7705f643ae0490ee$var$activeNodeViews)nodeView.renderReact();
};
const $7705f643ae0490ee$export$85c8b8e715aadfd8 = (view)=>{
    for (const nodeView of $7705f643ae0490ee$var$activeNodeViews)if (nodeView.belongsToEditorView(view)) nodeView.renderReact();
};
const $7705f643ae0490ee$export$db77a51a8cbfff28 = (localId, selected)=>{
    for (const nv of $7705f643ae0490ee$var$activeNodeViews)if (nv.getLocalId() === localId) {
        nv.setSelected(selected);
        nv.renderReact();
        return true;
    }
    return false;
};
/**
 * Custom nodeView for bespoke agent-managed chrome. It exposes `contentDOM`,
 * matching regular bodied extensions so the body ADF is editable whenever the
 * host editor itself is editable.
 */ class $7705f643ae0490ee$var$AgentManagedExtensionNodeView {
    getLocalId() {
        return this.node.attrs.localId ?? '';
    }
    belongsToEditorView(view) {
        return this.view === view;
    }
    setSelected(selected) {
        this.selected = selected;
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        // Refuse to re-use this nodeView for a non-agent-managed block;
        // ProseMirror will then ask the factory for a fresh nodeView.
        if (!(0, $5lo82.isAgentManagedExtension)(node)) return false;
        // Force a remount when the localId changes — prevents stale
        // React state from leaking across instances.
        if (node.attrs.localId !== this.node.attrs.localId) return false;
        if (node === this.node) return true;
        this.dom.setAttribute('data-local-id', node.attrs.localId ?? '');
        this.node = node;
        this.renderReact();
        return true;
    }
    selectNode() {
        this.selected = true;
        this.renderReact();
    }
    deselectNode() {
        this.selected = false;
        this.renderReact();
    }
    destroy() {
        $7705f643ae0490ee$var$activeNodeViews.delete(this);
        this.detachBodyClick();
        this.nodeViewPortalProviderAPI.remove(this.portalKey);
    }
    stopEvent(event) {
        // Let ProseMirror own selected-node copy/cut so it serializes the extension ADF
        // instead of browser DOM, which includes visual chrome like the block label.
        if (event.type === 'copy' || event.type === 'cut') return false;
        if (this.contentDOM?.contains(event.target)) return false;
        return true;
    }
    ignoreMutation(mutation) {
        if (mutation.type === 'selection') return false;
        return !this.contentDOM?.contains(mutation.target);
    }
    constructor(node, view, getPos, args){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.mountPoint = void 0;
        this.portalKey = void 0;
        this.detachBodyClick = void 0;
        this.selected = false;
        this.renderReact = ()=>{
            const localId = this.getLocalId();
            const pluginState = (0, $eYo03.pluginKey).getState(this.view.state);
            const aimoId = (0, $5lo82.getNodeAiManagedObject)(this.node.attrs)?.id;
            const transientLifecycleState = localId ? pluginState?.executionLifecycleByLocalId?.[localId]?.state : undefined;
            const lifecycleState = (0, $jHZ78.getAgentManagedBlockLifecycleState)({
                hasLocalExecutionError: Boolean(localId && pluginState?.executionErrorLocalIds?.[localId]),
                node: this.node,
                transientLifecycleState: transientLifecycleState
            });
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dM4cY.AgentManagedExtensionView), {
                contentDOM: this.contentDOM,
                hasGeneratedBodyContent: (0, $jHZ78.hasGeneratedBodyContent)(this.node),
                isSelected: this.selected,
                lifecycleState: lifecycleState,
                onRetry: this.view.editable && aimoId ? ()=>{
                    (0, $e65a16941efd8768$export$8235b51c7030883b)({
                        aimoId: aimoId,
                        editorView: this.view,
                        localId: localId || undefined
                    });
                } : undefined,
                readOnly: !this.view.editable
            });
            this.nodeViewPortalProviderAPI.render(()=>element, this.mountPoint, this.portalKey);
        };
        this.node = node;
        this.view = view;
        this.nodeViewPortalProviderAPI = args.nodeViewPortalProviderAPI;
        const { root: root, mountPoint: mountPoint, contentDOM: contentDOM } = (0, $6db51b6644db656c$export$79fd7963490e64c)(view.dom.ownerDocument, node, {
            includeContentDOM: true
        });
        this.dom = root;
        this.mountPoint = mountPoint;
        this.contentDOM = contentDOM;
        this.portalKey = $7705f643ae0490ee$var$buildPortalKey(node);
        this.detachBodyClick = (0, $6db51b6644db656c$export$1f8619c80fdc0e01)(view, this.dom, getPos);
        $7705f643ae0490ee$var$activeNodeViews.add(this);
        this.renderReact();
    }
}
const $7705f643ae0490ee$export$981fde09308f7c44 = (args)=>(node, view, getPos)=>{
        // Only handle agent-managed bodied extensions; let the framework's
        // default `bodiedExtension` nodeView render every other one.
        if (!(0, $5lo82.isAgentManagedExtension)(node)) return null;
        return new $7705f643ae0490ee$var$AgentManagedExtensionNodeView(node, view, getPos, args);
    };









var $4HMJH = parcelRequire("4HMJH");

const $49ade6317a36668c$var$MAX_AUTO_OPEN_ATTEMPTS = 5;
const $49ade6317a36668c$var$getPendingAutoOpenLocalId = (editorView)=>(0, $eYo03.pluginKey).getState(editorView.state)?.pendingAutoOpenLocalId;
const $49ade6317a36668c$var$hasRenderedBlockDom = (editorView, localId)=>{
    const found = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    return found?.node.attrs.localId === localId && editorView.nodeDOM(found.pos) instanceof HTMLElement;
};
const $49ade6317a36668c$var$openConfigForBlock = (editorView, localId)=>{
    editorView.dispatch((0, $4HMJH.setMeta)(editorView.state.tr, {
        localId: localId,
        type: 'OPEN_CONFIG'
    }));
};
const $49ade6317a36668c$export$961bee066c4d0379 = (editorView)=>{
    const handledLocalIds = new Set();
    let scheduledLocalId;
    let animationFrameId;
    let remainingAttempts = 0;
    const clearScheduledOpen = ()=>{
        if (animationFrameId !== undefined) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = undefined;
        }
        scheduledLocalId = undefined;
        remainingAttempts = 0;
    };
    const getActiveScheduledLocalId = ()=>{
        if (!scheduledLocalId || handledLocalIds.has(scheduledLocalId)) return undefined;
        const pendingLocalId = $49ade6317a36668c$var$getPendingAutoOpenLocalId(editorView);
        return pendingLocalId === scheduledLocalId ? scheduledLocalId : undefined;
    };
    const attemptOpenConfig = ()=>{
        animationFrameId = undefined;
        const localId = getActiveScheduledLocalId();
        if (!localId) {
            clearScheduledOpen();
            return;
        }
        if ($49ade6317a36668c$var$hasRenderedBlockDom(editorView, localId)) {
            handledLocalIds.add(localId);
            $49ade6317a36668c$var$openConfigForBlock(editorView, localId);
            clearScheduledOpen();
            return;
        }
        remainingAttempts -= 1;
        if (remainingAttempts <= 0) {
            clearScheduledOpen();
            return;
        }
        animationFrameId = requestAnimationFrame(attemptOpenConfig);
    };
    const scheduleOpenConfig = (pendingLocalId)=>{
        if (scheduledLocalId === pendingLocalId && animationFrameId !== undefined) return;
        scheduledLocalId = pendingLocalId;
        remainingAttempts = $49ade6317a36668c$var$MAX_AUTO_OPEN_ATTEMPTS;
        animationFrameId = requestAnimationFrame(attemptOpenConfig);
    };
    return {
        destroy () {
            clearScheduledOpen();
        },
        update () {
            const pendingLocalId = $49ade6317a36668c$var$getPendingAutoOpenLocalId(editorView);
            if (!pendingLocalId || handledLocalIds.has(pendingLocalId)) return;
            scheduleOpenConfig(pendingLocalId);
        }
    };
};



var $fud2r = parcelRequire("fud2r");





var $1hQ0e = parcelRequire("1hQ0e");

function $2f2ffb98bbc84b84$export$895a298bdabf4d43() {
    try {
        const { origin: origin, pathname: pathname } = window.location;
        const isLocal = origin.includes('localhost') || origin.includes('127.0.0.1') || origin.includes('0.0.0.0');
        if (isLocal) {
            const baseUrlMeta = (0, $1hQ0e.getDocument)()?.querySelector('meta[name="ajs-base-url"]');
            if (baseUrlMeta?.content) return baseUrlMeta.content + pathname;
            const canonical = (0, $1hQ0e.getDocument)()?.querySelector('link[rel="canonical"]');
            if (canonical?.href) return canonical.href;
            const siteUrl = window.__SITE_URL__;
            if (siteUrl) return siteUrl + pathname;
        }
        return origin + pathname;
    } catch  {
        return undefined;
    }
}



var $89DwQ = parcelRequire("89DwQ");


var $aPdNQ = parcelRequire("aPdNQ");













const $9bce5dc968766c07$export$aeee8a234ebb282 = 'aiManagedObjectCopyPaste';


const $97cf16489c54499e$var$isRecord = (value)=>Boolean(value) && typeof value === 'object' && !Array.isArray(value);
const $97cf16489c54499e$var$getStringValue = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
const $97cf16489c54499e$export$957229695d10ea4a = (attrs)=>$97cf16489c54499e$var$getStringValue(attrs?.localId);
const $97cf16489c54499e$var$parseCopyPasteMarker = (value)=>{
    const rawValue = $97cf16489c54499e$var$isRecord(value) && 'value' in value ? value.value : value;
    if (typeof rawValue !== 'string') return undefined;
    try {
        const parsed = JSON.parse(rawValue);
        if (!$97cf16489c54499e$var$isRecord(parsed)) return undefined;
        const operation = parsed.operation;
        const sourceAiManagedObjectId = parsed.sourceAiManagedObjectId;
        if (operation !== 'copy' && operation !== 'cut' || typeof sourceAiManagedObjectId !== 'string') return undefined;
        const marker = {
            operation: operation,
            sourceAiManagedObjectId: sourceAiManagedObjectId
        };
        if (typeof parsed.sourcePageUrl === 'string') marker.sourcePageUrl = parsed.sourcePageUrl;
        if (typeof parsed.sourceReferenceObjectAri === 'string') marker.sourceReferenceObjectAri = parsed.sourceReferenceObjectAri;
        return marker;
    } catch  {
        return undefined;
    }
};
const $97cf16489c54499e$export$3480fc2ad376a68c = (attrs)=>$97cf16489c54499e$var$parseCopyPasteMarker(attrs?.parameters?.macroParams?.[0, $9bce5dc968766c07$export$aeee8a234ebb282]);
const $97cf16489c54499e$export$c0cb508f5f9e8218 = (macroParams = {})=>{
    const { [(0, $9bce5dc968766c07$export$aeee8a234ebb282)]: _marker, ...rest } = macroParams;
    return rest;
};
const $97cf16489c54499e$export$b90593cf7b1dd29d = ({ attrs: attrs, clearAiManagedObject: clearAiManagedObject, marker: marker, regenerateLocalId: regenerateLocalId })=>{
    const parameters = attrs.parameters ?? {};
    const macroParams = {
        ...parameters.macroParams,
        [(0, $9bce5dc968766c07$export$aeee8a234ebb282)]: {
            value: JSON.stringify(marker)
        }
    };
    if (clearAiManagedObject) delete macroParams.aiManagedObject;
    return {
        ...attrs,
        localId: regenerateLocalId ? (0, $5lo82.generateLocalId)() : attrs.localId,
        parameters: {
            ...parameters,
            macroParams: macroParams
        }
    };
};
const $97cf16489c54499e$export$c285bda75d8ebbf5 = ({ attrs: attrs, clearAiManagedObject: clearAiManagedObject, localId: localId })=>{
    const parameters = attrs.parameters ?? {};
    const macroParams = $97cf16489c54499e$export$c0cb508f5f9e8218(parameters.macroParams);
    if (clearAiManagedObject) delete macroParams.aiManagedObject;
    return {
        ...attrs,
        localId: localId,
        parameters: {
            ...parameters,
            macroParams: macroParams
        }
    };
};
const $97cf16489c54499e$export$74b8d6deba872536 = ({ aimo: aimo, attrs: attrs })=>{
    const parameters = attrs.parameters ?? {};
    const macroParams = $97cf16489c54499e$export$c0cb508f5f9e8218(parameters.macroParams);
    return {
        ...attrs,
        parameters: {
            ...parameters,
            macroParams: {
                ...macroParams,
                aiManagedObject: {
                    value: JSON.stringify((0, $4X6m9.getAiManagedObjectParameter)(aimo))
                }
            }
        }
    };
};


const $446fd74f705de547$export$4296014ca990d071 = (slice, node)=>{
    const attrs = node.attrs;
    const localId = (0, $97cf16489c54499e$export$957229695d10ea4a)(attrs);
    if (!localId) return node;
    const firstChildAttrs = slice.content.firstChild?.attrs;
    const lastChildAttrs = slice.content.lastChild?.attrs;
    const isFirstChild = (0, $97cf16489c54499e$export$957229695d10ea4a)(firstChildAttrs) === localId;
    const isLastChild = (0, $97cf16489c54499e$export$957229695d10ea4a)(lastChildAttrs) === localId;
    // Open slices mean ProseMirror only copied part of the node. Keeping identity on that
    // fragment could make a partial body look like a complete managed block.
    return isFirstChild && slice.openStart > 0 || isLastChild && slice.openEnd > 0 ? node.content : node;
};
const $446fd74f705de547$export$dd0d390420a2370a = (slice)=>{
    const found = [];
    slice.content.descendants((node)=>{
        if (!(0, $5lo82.isAgentManagedExtension)(node)) return true;
        const completeNode = $446fd74f705de547$export$4296014ca990d071(slice, node);
        if (completeNode !== node) return false;
        const attrs = node.attrs;
        const localId = (0, $97cf16489c54499e$export$957229695d10ea4a)(attrs);
        if (localId) {
            const aiManagedObjectId = (0, $5lo82.getNodeAiManagedObject)(attrs)?.id;
            found.push({
                ...aiManagedObjectId ? {
                    aiManagedObjectId: aiManagedObjectId
                } : {},
                localId: localId
            });
        }
        return false;
    });
    return found;
};
const $446fd74f705de547$export$b7a4a6ee1e5b49e7 = (state)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !(0, $5lo82.isAgentManagedExtension)(selection.node)) return undefined;
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(selection.node), 0, 0);
};
const $446fd74f705de547$var$collectAgentManagedNodes = (state)=>{
    const found = new Map();
    state.doc.descendants((node)=>{
        if (!(0, $5lo82.isAgentManagedExtension)(node)) return true;
        const attrs = node.attrs;
        const localId = (0, $97cf16489c54499e$export$957229695d10ea4a)(attrs);
        if (localId) {
            const aiManagedObjectId = (0, $5lo82.getNodeAiManagedObject)(attrs)?.id;
            found.set(localId, {
                ...aiManagedObjectId ? {
                    aiManagedObjectId: aiManagedObjectId
                } : {},
                localId: localId
            });
        }
        return false;
    });
    return found;
};
const $446fd74f705de547$export$92f9ab68b0f810 = (oldState, newState)=>{
    const oldNodes = $446fd74f705de547$var$collectAgentManagedNodes(oldState);
    const newNodes = $446fd74f705de547$var$collectAgentManagedNodes(newState);
    return {
        added: [
            ...newNodes.values()
        ].filter(({ localId: localId })=>!oldNodes.has(localId)),
        removed: [
            ...oldNodes.values()
        ].filter(({ localId: localId })=>!newNodes.has(localId))
    };
};


















const $e456ffe9b1dc36c6$var$CONFLUENCE_CONTENT_ARI_PATTERN = /^ari:cloud:confluence:([^:]+):(blogpost|page)\/([^/]+)$/;
const $e456ffe9b1dc36c6$var$isSupportedContentType = (contentType)=>contentType === 'blogpost' || contentType === 'page';
const $e456ffe9b1dc36c6$export$4d80ff8879a0429d = ({ cloudId: cloudId, contentType: contentType = 'page', contextIdentifierProvider: contextIdentifierProvider, objectId: objectId = contextIdentifierProvider?.objectId, product: product = contextIdentifierProvider?.product })=>{
    if (!objectId) return undefined;
    const match = $e456ffe9b1dc36c6$var$CONFLUENCE_CONTENT_ARI_PATTERN.exec(objectId);
    if (!match) {
        if (!cloudId || product !== 'confluence' || !$e456ffe9b1dc36c6$var$isSupportedContentType(contentType)) return undefined;
        return {
            cloudId: cloudId,
            referenceObjectAri: `ari:cloud:confluence:${cloudId}:${contentType}/${objectId}`
        };
    }
    return {
        cloudId: match[1],
        referenceObjectAri: objectId
    };
};





const $8593b28083a2a47c$export$b5a4ee270806b39a = ({ cloudId: cloudId, contentType: contentType, getContextIdentifierProvider: getContextIdentifierProvider })=>{
    const contextIdentifierProvider = getContextIdentifierProvider?.();
    return (0, $e456ffe9b1dc36c6$export$4d80ff8879a0429d)({
        cloudId: cloudId,
        contentType: contentType,
        contextIdentifierProvider: contextIdentifierProvider,
        product: contextIdentifierProvider?.product
    });
};
const $8593b28083a2a47c$export$4ea142194dd56f81 = (args)=>$8593b28083a2a47c$export$b5a4ee270806b39a(args)?.referenceObjectAri;
const $8593b28083a2a47c$export$7830dd0e613d59d9 = async (editorView, marker, localId)=>{
    if (marker.sourceReferenceObjectAri) return marker.sourceReferenceObjectAri;
    const sourceAimo = await (0, $89DwQ.getAiManagedObjectWithCache)({
        aimoId: marker.sourceAiManagedObjectId,
        editorView: editorView,
        localId: localId
    });
    return sourceAimo?.referenceObjectAri;
};


const $3a39d9ddff7eb1e5$var$toConfigCreateInput = (config)=>({
        desiredUpdateFrequency: config.desiredUpdateFrequency ?? undefined,
        goal: config.goal ?? undefined,
        goalOperations: config.goalOperations ?? undefined,
        prompt: config.prompt ?? null,
        sources: config.sources?.map((source)=>({
                app: source.app,
                url: source.url
            })) ?? undefined
    });
const $3a39d9ddff7eb1e5$var$rebindCurrentPageSources = ({ config: config, destinationPageUrl: destinationPageUrl, sourcePageUrl: sourcePageUrl })=>{
    if (!sourcePageUrl || !destinationPageUrl || sourcePageUrl === destinationPageUrl) return {
        config: config,
        didRebind: false
    };
    // Current-page sources should follow the destination page when a block is copied.
    let didRebind = false;
    const sources = config.sources?.map((source)=>{
        if (source.url !== sourcePageUrl) return source;
        didRebind = true;
        return {
            ...source,
            app: 'CONFLUENCE',
            url: destinationPageUrl
        };
    });
    return {
        config: didRebind ? {
            ...config,
            sources: sources
        } : config,
        didRebind: didRebind
    };
};
const $3a39d9ddff7eb1e5$var$setCopiedAiManagedObject = (editorView, localId, aimo)=>{
    const found = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    if (!found) return;
    const tr = editorView.state.tr;
    tr.setNodeMarkup(found.pos, undefined, {
        ...found.node.attrs,
        ...(0, $97cf16489c54499e$export$74b8d6deba872536)({
            aimo: aimo,
            attrs: found.node.attrs
        })
    });
    (0, $4X6m9.setAgentManagedExtensionMeta)(tr, (0, $1tIRv.getCacheAiManagedObjectMeta)(aimo, localId));
    editorView.dispatch(tr);
};
const $3a39d9ddff7eb1e5$var$createCopiedAiManagedObject = async ({ args: args, editorView: editorView, localId: localId, marker: marker })=>{
    const referenceObject = (0, $8593b28083a2a47c$export$b5a4ee270806b39a)(args);
    if (!referenceObject) return null;
    const sourceAimo = await (0, $89DwQ.getAiManagedObjectWithCache)({
        aimoId: marker.sourceAiManagedObjectId,
        editorView: editorView,
        localId: localId
    });
    if (!sourceAimo) return null;
    const { config: config, didRebind: didRebind } = $3a39d9ddff7eb1e5$var$rebindCurrentPageSources({
        config: $3a39d9ddff7eb1e5$var$toConfigCreateInput(sourceAimo.config),
        destinationPageUrl: (0, $2f2ffb98bbc84b84$export$895a298bdabf4d43)(),
        sourcePageUrl: marker.sourcePageUrl
    });
    const aimo = await (0, $89DwQ.createAiManagedObjectWithCache)(editorView, {
        cloudId: referenceObject.cloudId,
        config: config,
        referenceObjectAri: referenceObject.referenceObjectAri,
        referenceProduct: 'CONFLUENCE',
        status: 'ACTIVE',
        type: 'BLOCK'
    }, localId);
    return {
        aimo: aimo,
        shouldExecute: marker.operation === 'cut' || didRebind
    };
};
const $3a39d9ddff7eb1e5$export$dee490768d86cce8 = async ({ args: args, editorView: editorView, localId: localId, marker: marker, pendingArchivedRemovalsByLocalId: pendingArchivedRemovalsByLocalId })=>{
    const currentReferenceObjectAri = (0, $8593b28083a2a47c$export$4ea142194dd56f81)(args);
    const sourceReferenceObjectAri = await (0, $8593b28083a2a47c$export$7830dd0e613d59d9)(editorView, marker, localId);
    const isSameReferenceObject = Boolean(currentReferenceObjectAri) && currentReferenceObjectAri === sourceReferenceObjectAri;
    const isTrackedSameEditorCut = marker.operation === 'cut' && pendingArchivedRemovalsByLocalId.has(localId);
    // Same-reference cuts preserve the existing object id. We wait for any archive request
    // started by the removal transaction so reactivation cannot race the backend state change.
    if (marker.operation === 'cut' && (isTrackedSameEditorCut || isSameReferenceObject)) {
        const pendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
        await pendingRemoval?.archivePromise;
        const latestPendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
        if (latestPendingRemoval?.archiveFailed) return;
        await (0, $89DwQ.reactivateAiManagedObjectWithCache)(editorView, marker.sourceAiManagedObjectId, localId);
        pendingArchivedRemovalsByLocalId.delete(localId);
        return;
    }
    const created = await $3a39d9ddff7eb1e5$var$createCopiedAiManagedObject({
        args: args,
        editorView: editorView,
        localId: localId,
        marker: marker
    });
    if (!created) return;
    if (marker.operation === 'cut') pendingArchivedRemovalsByLocalId.delete(localId);
    $3a39d9ddff7eb1e5$var$setCopiedAiManagedObject(editorView, localId, created.aimo);
    // A cut into a different page, or a copy whose current-page source was rebound,
    // should refresh immediately so the visible block matches its new context.
    if (created.shouldExecute) await (0, $e65a16941efd8768$export$8235b51c7030883b)({
        aimoId: created.aimo.id,
        editorView: editorView,
        localId: localId
    });
};
const $3a39d9ddff7eb1e5$export$e6e56a9d778d0808 = async ({ editorView: editorView, localId: localId, pendingArchivedRemovalsByLocalId: pendingArchivedRemovalsByLocalId })=>{
    const pendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
    if (!pendingRemoval) return;
    const found = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    const attrs = found?.node.attrs;
    const currentAimo = (0, $5lo82.getNodeAiManagedObject)(attrs);
    if (!found || currentAimo?.id !== pendingRemoval.aiManagedObjectId) return;
    // Undo can restore a cut block after the backend archive was requested; only
    // reactivate after a successful archive so backend lifecycle state stays aligned.
    await pendingRemoval.archivePromise;
    const latestPendingRemoval = pendingArchivedRemovalsByLocalId.get(localId);
    if (latestPendingRemoval?.archiveFailed) return;
    pendingArchivedRemovalsByLocalId.delete(localId);
    await (0, $89DwQ.reactivateAiManagedObjectWithCache)(editorView, pendingRemoval.aiManagedObjectId, localId);
};



const $c148cfc5bba1cb43$export$2c63de875cb788c8 = (args)=>{
    let clipboardOperation;
    let selectedAgentManagedNodeSlice;
    let clipboardContextId = 0;
    const pendingCutRemovalByLocalId = new Map();
    const pendingArchivedRemovalsByLocalId = new Map();
    const pendingPasteByLocalId = new Map();
    const readyArchiveLocalIds = new Set();
    const readyPasteLocalIds = new Set();
    const readyReactivationLocalIds = new Set();
    const markClipboardOperation = (operation, view)=>{
        clipboardContextId += 1;
        const currentClipboardContextId = clipboardContextId;
        clipboardOperation = operation;
        selectedAgentManagedNodeSlice = (0, $446fd74f705de547$export$b7a4a6ee1e5b49e7)(view.state);
        // Keep transformCopied free of shared-state writes. ProseMirror serializes
        // clipboard content synchronously after the DOM event, then this context expires.
        queueMicrotask(()=>{
            if (clipboardContextId === currentClipboardContextId) {
                clipboardOperation = undefined;
                selectedAgentManagedNodeSlice = undefined;
            }
        });
        return selectedAgentManagedNodeSlice;
    };
    return {
        appendTransaction: (transactions, oldState, newState)=>{
            const hasLocalDocumentChange = transactions.some((tr)=>tr.docChanged && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument'));
            if (!hasLocalDocumentChange) return null;
            const { added: added, removed: removed } = (0, $446fd74f705de547$export$92f9ab68b0f810)(oldState, newState);
            removed.forEach(({ aiManagedObjectId: aiManagedObjectId, localId: localId })=>{
                const pendingCutRemoval = pendingCutRemovalByLocalId.get(localId);
                const pendingRemoval = pendingCutRemoval ?? (aiManagedObjectId ? {
                    aiManagedObjectId: aiManagedObjectId
                } : undefined);
                if (!pendingRemoval) return;
                // Cut intent is recorded by the DOM event before serialization, while
                // delete only becomes visible here. Queue the archive until the plugin view runs so
                // the cache can be updated through the live EditorView.
                pendingCutRemovalByLocalId.delete(localId);
                pendingArchivedRemovalsByLocalId.set(localId, pendingRemoval);
                readyArchiveLocalIds.add(localId);
            });
            added.forEach(({ localId: localId })=>{
                if (pendingPasteByLocalId.has(localId)) {
                    readyPasteLocalIds.add(localId);
                    return;
                }
                if (pendingArchivedRemovalsByLocalId.has(localId)) readyReactivationLocalIds.add(localId);
            });
            return null;
        },
        pendingArchivedRemovalsByLocalId: pendingArchivedRemovalsByLocalId,
        pendingPasteByLocalId: pendingPasteByLocalId,
        props: {
            handleDOMEvents: {
                copy: (view)=>{
                    pendingCutRemovalByLocalId.clear();
                    markClipboardOperation('copy', view);
                    return false;
                },
                cut: (view)=>{
                    pendingCutRemovalByLocalId.clear();
                    const selectedSlice = markClipboardOperation('cut', view);
                    const cutSlice = selectedSlice ?? view.state.selection.content();
                    // transformCopied may run multiple times for one cut. Record the cut
                    // identities once, before serialization, and reconcile them after removal.
                    (0, $446fd74f705de547$export$dd0d390420a2370a)(cutSlice).forEach(({ aiManagedObjectId: aiManagedObjectId, localId: localId })=>{
                        if (aiManagedObjectId) pendingCutRemovalByLocalId.set(localId, {
                            aiManagedObjectId: aiManagedObjectId
                        });
                    });
                    return false;
                }
            },
            // The DOM event tells us whether ProseMirror is serializing for copy or cut;
            // transformCopied alone does not carry that intent.
            transformCopied: (slice)=>{
                const operation = clipboardOperation;
                const copiedSlice = selectedAgentManagedNodeSlice ?? slice;
                if (!operation) return slice;
                const sourcePageUrl = (0, $2f2ffb98bbc84b84$export$895a298bdabf4d43)();
                return (0, $fud2r.mapSlice)(copiedSlice, (node)=>{
                    if (!(0, $5lo82.isAgentManagedExtension)(node)) return node;
                    const completeNode = (0, $446fd74f705de547$export$4296014ca990d071)(copiedSlice, node);
                    if (completeNode !== node) return completeNode;
                    const attrs = node.attrs;
                    const aiManagedObject = (0, $5lo82.getNodeAiManagedObject)(attrs);
                    if (!aiManagedObject?.id) return node;
                    const marker = {
                        operation: operation,
                        sourceAiManagedObjectId: aiManagedObject.id
                    };
                    if (sourcePageUrl) marker.sourcePageUrl = sourcePageUrl;
                    const sourceReferenceObjectAri = (0, $8593b28083a2a47c$export$4ea142194dd56f81)(args);
                    if (sourceReferenceObjectAri) marker.sourceReferenceObjectAri = sourceReferenceObjectAri;
                    // The marker exists only on the clipboard slice. Pasted content strips it and
                    // queues async identity work in plugin state instead of storing transient data.
                    return node.type.create((0, $97cf16489c54499e$export$b90593cf7b1dd29d)({
                        attrs: attrs,
                        clearAiManagedObject: operation === 'copy',
                        marker: marker,
                        regenerateLocalId: operation === 'copy'
                    }), node.content, node.marks);
                });
            },
            // Paste strips transient clipboard metadata and queues follow-up AIMO work
            // until appendTransaction confirms which localId actually entered the document.
            transformPasted: (slice)=>{
                const currentReferenceObjectAri = (0, $8593b28083a2a47c$export$4ea142194dd56f81)(args);
                return (0, $fud2r.mapSlice)(slice, (node)=>{
                    if (!(0, $5lo82.isAgentManagedExtension)(node)) return node;
                    const completeNode = (0, $446fd74f705de547$export$4296014ca990d071)(slice, node);
                    if (completeNode !== node) return completeNode;
                    const attrs = node.attrs;
                    const aiManagedObject = (0, $5lo82.getNodeAiManagedObject)(attrs);
                    const marker = (0, $97cf16489c54499e$export$3480fc2ad376a68c)(attrs) ?? (aiManagedObject?.id ? {
                        operation: 'copy',
                        sourceAiManagedObjectId: aiManagedObject.id
                    } : undefined);
                    if (!marker) return node;
                    const preserveCutIdentity = marker.operation === 'cut' && (!marker.sourceReferenceObjectAri || Boolean(currentReferenceObjectAri) && currentReferenceObjectAri === marker.sourceReferenceObjectAri);
                    const nextLocalId = preserveCutIdentity ? (0, $97cf16489c54499e$export$957229695d10ea4a)(attrs) ?? (0, $5lo82.generateLocalId)() : (0, $5lo82.generateLocalId)();
                    pendingPasteByLocalId.set(nextLocalId, marker);
                    return node.type.create((0, $97cf16489c54499e$export$c285bda75d8ebbf5)({
                        attrs: attrs,
                        clearAiManagedObject: !preserveCutIdentity,
                        localId: nextLocalId
                    }), node.content, node.marks);
                });
            }
        },
        readyArchiveLocalIds: readyArchiveLocalIds,
        readyPasteLocalIds: readyPasteLocalIds,
        readyReactivationLocalIds: readyReactivationLocalIds
    };
};
const $c148cfc5bba1cb43$export$ab31f6f79ac952df = (editorView, args)=>{
    const inFlightLocalIds = new Set();
    const processReadyArchives = (view)=>{
        args.readyArchiveLocalIds.forEach((localId)=>{
            const pendingRemoval = args.pendingArchivedRemovalsByLocalId.get(localId);
            if (!pendingRemoval || pendingRemoval.archivePromise) return;
            // Archive after ProseMirror commits the removal, then update the cached AIMO
            // status for toolbar and undo flows that still know this localId. Paste and
            // undo processors await this promise and short-circuit if archiving failed.
            args.readyArchiveLocalIds.delete(localId);
            const archivePromise = (0, $89DwQ.archiveAiManagedObjectWithCache)(view, pendingRemoval.aiManagedObjectId, localId).catch((error)=>{
                const latestPendingRemoval = args.pendingArchivedRemovalsByLocalId.get(localId) ?? pendingRemoval;
                args.pendingArchivedRemovalsByLocalId.set(localId, {
                    ...latestPendingRemoval,
                    archiveError: error,
                    archiveFailed: true
                });
            });
            args.pendingArchivedRemovalsByLocalId.set(localId, {
                ...pendingRemoval,
                archivePromise: archivePromise
            });
        });
    };
    const processReadyPastes = (view)=>{
        args.readyPasteLocalIds.forEach((localId)=>{
            const marker = args.pendingPasteByLocalId.get(localId);
            if (!marker || inFlightLocalIds.has(localId)) return;
            inFlightLocalIds.add(localId);
            args.readyPasteLocalIds.delete(localId);
            (0, $3a39d9ddff7eb1e5$export$dee490768d86cce8)({
                args: args,
                editorView: view,
                localId: localId,
                marker: marker,
                pendingArchivedRemovalsByLocalId: args.pendingArchivedRemovalsByLocalId
            }).catch(()=>undefined).finally(()=>{
                args.pendingPasteByLocalId.delete(localId);
                inFlightLocalIds.delete(localId);
            });
        });
    };
    const processReadyReactivations = (view)=>{
        args.readyReactivationLocalIds.forEach((localId)=>{
            if (args.pendingPasteByLocalId.has(localId) || inFlightLocalIds.has(localId)) return;
            inFlightLocalIds.add(localId);
            args.readyReactivationLocalIds.delete(localId);
            (0, $3a39d9ddff7eb1e5$export$e6e56a9d778d0808)({
                editorView: view,
                localId: localId,
                pendingArchivedRemovalsByLocalId: args.pendingArchivedRemovalsByLocalId
            }).catch(()=>undefined).finally(()=>{
                inFlightLocalIds.delete(localId);
            });
        });
    };
    const update = (view)=>{
        processReadyArchives(view);
        processReadyPastes(view);
        processReadyReactivations(view);
    };
    update(editorView);
    return {
        update: (view)=>{
            update(view);
        }
    };
};









const $b66ec4080e9a0a8c$var$getSelectedAgentManagedLocalId = (editorView)=>(0, $5lo82.findAgentManagedExtension)(editorView.state)?.node.attrs.localId;
const $b66ec4080e9a0a8c$var$getOpenUiLocalId = (editorView)=>{
    const pluginState = (0, $eYo03.pluginKey).getState(editorView.state);
    if (pluginState?.isConfigOpen) return pluginState.configLocalId ?? $b66ec4080e9a0a8c$var$getSelectedAgentManagedLocalId(editorView);
    if (pluginState?.isAutoUpdateIntervalOpen) return pluginState.autoUpdateIntervalLocalId;
    return undefined;
};
const $b66ec4080e9a0a8c$export$7906ccecd478b93e = (editorView)=>{
    let selectedLocalId;
    return {
        update () {
            const nextSelectedLocalId = $b66ec4080e9a0a8c$var$getOpenUiLocalId(editorView);
            if (nextSelectedLocalId === selectedLocalId) return;
            if (selectedLocalId) (0, $7705f643ae0490ee$export$db77a51a8cbfff28)(selectedLocalId, false);
            selectedLocalId = nextSelectedLocalId;
            if (selectedLocalId) (0, $7705f643ae0490ee$export$db77a51a8cbfff28)(selectedLocalId, true);
        }
    };
};





const $506e91053d3165bc$export$ae829ec7b2625219 = (args)=>{
    const copyPasteIdentity = (0, $c148cfc5bba1cb43$export$2c63de875cb788c8)({
        cloudId: args.cloudId,
        contentType: args.contentType,
        getContextIdentifierProvider: args.getContextIdentifierProvider
    });
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $eYo03.pluginKey),
        appendTransaction: copyPasteIdentity.appendTransaction,
        props: {
            ...copyPasteIdentity.props,
            nodeViews: {
                bodiedExtension: (0, $7705f643ae0490ee$export$981fde09308f7c44)({
                    nodeViewPortalProviderAPI: args.nodeViewPortalProviderAPI
                })
            }
        },
        state: {
            init: (0, $4HMJH.initialState),
            apply (tr, prev, oldState, newState) {
                const withMeta = (0, $4HMJH.applyMeta)(prev, (0, $4HMJH.getMeta)(tr), newState);
                const withAutoOpen = (0, $4HMJH.applyAutoOpenOnInsert)(withMeta, tr, oldState, newState);
                return (0, $4HMJH.applyAutoCloseOnSelectionChange)(withAutoOpen, tr, newState);
            }
        },
        view: (editorView)=>{
            const autoOpen = (0, $49ade6317a36668c$export$961bee066c4d0379)(editorView);
            const copyPaste = (0, $c148cfc5bba1cb43$export$ab31f6f79ac952df)(editorView, {
                cloudId: args.cloudId,
                contentType: args.contentType,
                getContextIdentifierProvider: args.getContextIdentifierProvider,
                pendingArchivedRemovalsByLocalId: copyPasteIdentity.pendingArchivedRemovalsByLocalId,
                pendingPasteByLocalId: copyPasteIdentity.pendingPasteByLocalId,
                readyArchiveLocalIds: copyPasteIdentity.readyArchiveLocalIds,
                readyPasteLocalIds: copyPasteIdentity.readyPasteLocalIds,
                readyReactivationLocalIds: copyPasteIdentity.readyReactivationLocalIds
            });
            const selectedWhileConfigOpen = (0, $b66ec4080e9a0a8c$export$7906ccecd478b93e)(editorView);
            let prevEditable = editorView.editable;
            let prevPluginState = (0, $eYo03.pluginKey).getState(editorView.state);
            return {
                destroy: ()=>{
                    autoOpen.destroy();
                },
                update: (view)=>{
                    autoOpen.update();
                    copyPaste.update(view);
                    selectedWhileConfigOpen.update();
                    const currentPluginState = (0, $eYo03.pluginKey).getState(view.state);
                    if (view.editable !== prevEditable || currentPluginState !== prevPluginState) {
                        prevEditable = view.editable;
                        prevPluginState = currentPluginState;
                        (0, $7705f643ae0490ee$export$85c8b8e715aadfd8)(view);
                    }
                }
            };
        }
    });
};












var $7XIuB = parcelRequire("7XIuB");


var $uia0q = parcelRequire("uia0q");




var $cJrqk = parcelRequire("cJrqk");

/* ManagedBlockConfig.tsx generated by @compiled/babel-plugin v0.40.0 */ 












var $24dy7 = parcelRequire("24dy7");


var $4yccB = parcelRequire("4yccB");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");




/**
 * Validation logic for AI-managed object configurations.
 *
 * Validation is intentionally centralised here so that every consumer
 * (editor plugin UI, server-side checks, etc.) uses the same rules.
 * The function is designed to be extended as new config fields are
 * introduced — callers should not hard-code their own checks.
 */ function $b4354e2d9ae7322a$export$f21a0ba102fbd812(config) {
    const errors = [];
    const hasStructuredConfig = Boolean(config.goal);
    if (!hasStructuredConfig && (!config.prompt || config.prompt.trim().length === 0)) errors.push({
        code: 'EMPTY_PROMPT',
        field: 'prompt'
    });
    if (config.desiredUpdateFrequency && (!config.desiredUpdateFrequency.type || config.desiredUpdateFrequency.value.trim().length === 0)) errors.push({
        code: 'INVALID_DESIRED_UPDATE_FREQUENCY',
        field: 'desiredUpdateFrequency'
    });
    if (hasStructuredConfig) {
        if (!config.goal) errors.push({
            code: 'MISSING_GOAL',
            field: 'goal'
        });
        if (!config.goalOperations?.outputFormat) errors.push({
            code: 'MISSING_OUTPUT_FORMAT',
            field: 'goalOperations.outputFormat'
        });
        if (!config.sources?.length) errors.push({
            code: 'MISSING_SOURCES',
            field: 'sources'
        });
    }
    return {
        valid: errors.length === 0,
        errors: errors
    };
}





/* AimoStatusMetadata.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $arQY7 = parcelRequire("arQY7");





var $lRkXe = parcelRequire("lRkXe");


var $22Zs7 = parcelRequire("22Zs7");


var $lpNn5 = parcelRequire("lpNn5");




const $5e2609207061f85f$var$metadataStyles = null;
const $5e2609207061f85f$var$profileTriggerStyles = null;
const $5e2609207061f85f$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
const $5e2609207061f85f$var$profileClient = new (0, $lRkXe.default)({
    url: $5e2609207061f85f$var$DIRECTORY_URL
});
const $5e2609207061f85f$var$getLastSuccessfulExecutionDate = (aimoData)=>{
    if (aimoData?.lastExecutionStatus !== 'SUCCESS' || !aimoData.lastExecutedAt) return null;
    const date = new Date(aimoData.lastExecutedAt);
    return Number.isNaN(date.getTime()) ? null : date;
};
const $5e2609207061f85f$export$b029164683c5c152 = ({ aimoData: aimoData = null, cloudId: cloudId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const ownerId = aimoData?.lastModifiedBy;
    const lastSuccessfulExecutionDate = $5e2609207061f85f$var$getLastSuccessfulExecutionDate(aimoData);
    const [ownerProfile, setOwnerProfile] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!ownerId || !cloudId) {
            setOwnerProfile(null);
            return;
        }
        let cancelled = false;
        setOwnerProfile(null);
        $5e2609207061f85f$var$profileClient.getProfile(cloudId, ownerId).then((profile)=>{
            if (!cancelled) setOwnerProfile(profile ?? null);
        }).catch(()=>{
            if (!cancelled) setOwnerProfile(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        cloudId,
        ownerId
    ]);
    const ownerName = ownerProfile?.fullName ?? ownerProfile?.nickname;
    const hasOwner = Boolean(ownerId && cloudId && ownerName);
    const hasUpdatedDate = Boolean(lastSuccessfulExecutionDate);
    if (!(hasOwner || hasUpdatedDate)) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _4cvr1h6o _1tke1ejb _syazi7uo"
        ])
    }, hasOwner && ownerId && cloudId && ownerName && /*#__PURE__*/ $cozmU.createElement((0, $22Zs7.default), {
        cloudId: cloudId,
        prepopulatedData: ownerProfile ?? undefined,
        resourceClient: $5e2609207061f85f$var$profileClient,
        userId: ownerId
    }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: intl.formatMessage((0, $uia0q.messages).owner)
    }, /*#__PURE__*/ $cozmU.createElement("button", {
        type: "button",
        className: (0, $hekY6.default)([
            "_zulp1b66 _11c8wadc _189eidpf _1rjcidpf _18zridpf _1e0c116y _4cvr1h6o _1tke1ejb _syazi7uo _bfhk1j28 _80omtlke"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
        appearance: "circle",
        label: ownerName,
        size: "xsmall",
        src: ownerProfile?.avatarUrl
    }), ownerName))), hasOwner && hasUpdatedDate && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span",
        color: "color.text.subtlest"
    }, "|"), lastSuccessfulExecutionDate && /*#__PURE__*/ $cozmU.createElement("span", null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span",
        color: "color.text.subtle"
    }, intl.formatMessage((0, $uia0q.messages).lastSuccessfulExecution)), ' ', intl.formatDate(lastSuccessfulExecutionDate, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }), ' ', intl.formatTime(lastSuccessfulExecutionDate, {
        hour: 'numeric',
        minute: '2-digit'
    })));
};


/* config-panel-options.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $erZTy = parcelRequire("erZTy");


var $a1ZzW = parcelRequire("a1ZzW");


var $2hwiA = parcelRequire("2hwiA");


var $1bzO2 = parcelRequire("1bzO2");







const $a3dc0f7194be2166$export$52024dc0d58d35da = (options, value)=>options.find((option)=>option.value === value);
const $a3dc0f7194be2166$export$9860925510add594 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>({
            goalOptions: [
                {
                    label: intl.formatMessage((0, $uia0q.messages).goalExecutiveSummary),
                    value: 'executive-summary'
                },
                {
                    label: intl.formatMessage((0, $uia0q.messages).goalDecisionRegister),
                    value: 'decision-register'
                },
                {
                    label: intl.formatMessage((0, $uia0q.messages).goalMeetingRecap),
                    value: 'meeting-recap'
                },
                // Keep System design ready for later, but do not show it in the goal dropdown yet.
                // {
                // 	label: intl.formatMessage(messages.goalSystemDesign),
                // 	value: 'system-design' as const,
                // },
                {
                    label: intl.formatMessage((0, $uia0q.messages).promptToggleLabel),
                    value: 'prompt'
                }
            ],
            outputFormatOptions: [
                {
                    icon: /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
                        as: "span",
                        size: "large",
                        "aria-hidden": "true"
                    }, intl.formatMessage((0, $uia0q.messages).outputFormatTextIcon)),
                    label: intl.formatMessage((0, $uia0q.messages).outputFormatText),
                    value: 'text'
                },
                {
                    icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hwiA))), {
                        label: "",
                        color: "currentColor"
                    }),
                    label: intl.formatMessage((0, $uia0q.messages).outputFormatList),
                    value: 'list'
                },
                {
                    icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))), {
                        label: "",
                        color: "currentColor"
                    }),
                    label: intl.formatMessage((0, $uia0q.messages).outputFormatTable),
                    value: 'table'
                },
                {
                    icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                        label: "",
                        color: "currentColor"
                    }),
                    label: intl.formatMessage((0, $uia0q.messages).outputFormatPanel),
                    value: 'panel'
                }
            ],
            sourceModeOptions: [
                {
                    label: intl.formatMessage((0, $uia0q.messages).sourcesModeManual),
                    value: 'manual'
                },
                {
                    label: intl.formatMessage((0, $uia0q.messages).sourcesModeCurrentPage),
                    value: 'current-page'
                }
            ],
            systemDesignOutputFormatOptions: [
                {
                    icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($erZTy))), {
                        label: "",
                        color: "currentColor"
                    }),
                    isLocked: true,
                    label: intl.formatMessage((0, $uia0q.messages).outputFormatDiagram),
                    value: 'diagram'
                }
            ]
        }), [
        intl
    ]);
};









/* GoalSelect.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $6wGOF = parcelRequire("6wGOF");





/* config-panel-primitives.tsx generated by @compiled/babel-plugin v0.40.0 */ 





const $e11890fa23152c2b$var$labelStyles = null;
const $e11890fa23152c2b$export$1acdcf5a973a8414 = ({ children: children, htmlFor: htmlFor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: htmlFor,
        className: (0, $hekY6.default)([
            "_1e0c1ule _syazazsu _otyr12x7"
        ])
    }, children);


const $6afbceee21fe1de3$var$goalSelectStyles = {
    root: "_kqswh2mm _1pbyb4wl"
};
const $6afbceee21fe1de3$export$9ec0a8bc422643e4 = ({ contentSelection: contentSelection, isDisabled: isDisabled = false, onContentSelectionChange: onContentSelectionChange, options: options })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $6afbceee21fe1de3$var$goalSelectStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e11890fa23152c2b$export$1acdcf5a973a8414), {
        htmlFor: "agent-managed-extension-goal"
    }, intl.formatMessage((0, $uia0q.messages).contentGoalLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        inputId: "agent-managed-extension-goal",
        options: options,
        value: (0, $a3dc0f7194be2166$export$52024dc0d58d35da)(options, contentSelection),
        onChange: (option)=>{
            if (option) onContentSelectionChange(option.value);
        },
        isDisabled: isDisabled,
        isSearchable: false
    }));
};


/* OutputFormatPicker.tsx generated by @compiled/babel-plugin v0.40.0 */ 











const $7b574f788782fb1d$var$fieldsetStyles = null;
const $7b574f788782fb1d$var$legendStyles = null;
const $7b574f788782fb1d$var$formatGridStyles = null;
const $7b574f788782fb1d$var$formatButtonStyles = null;
const $7b574f788782fb1d$var$formatButtonSelectedStyles = null;
const $7b574f788782fb1d$var$formatIconStyles = null;
const $7b574f788782fb1d$export$61dd55c259b4cf24 = ({ goal: goal, isDisabled: isDisabled = false, onOutputFormatChange: onOutputFormatChange, outputFormat: outputFormat, outputFormatOptions: outputFormatOptions, systemDesignOutputFormatOptions: systemDesignOutputFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const visibleOutputFormatOptions = goal === 'system-design' ? systemDesignOutputFormatOptions : outputFormatOptions;
    return /*#__PURE__*/ $cozmU.createElement("fieldset", {
        className: (0, $hekY6.default)([
            "_189eidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("legend", {
        className: (0, $hekY6.default)([
            "_syazazsu _otyru2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, intl.formatMessage((0, $uia0q.messages).outputFormatLabel)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_zulpu2gc _1e0c11p5 _yv0eorlc"
        ])
    }, visibleOutputFormatOptions.map((option)=>{
        const isSelected = outputFormat === option.value;
        const isLocked = Boolean(option.isLocked);
        return /*#__PURE__*/ $cozmU.createElement("button", {
            key: option.value,
            "aria-disabled": isLocked || undefined,
            "aria-pressed": isSelected,
            disabled: isDisabled,
            onClick: ()=>{
                if (!isLocked) onOutputFormatChange(option.value);
            },
            type: "button",
            className: (0, $hekY6.default)([
                "_2rko12b0 _11c81kw7 _1h6d1l7x _1dqonqa1 _189ee4h9 _r06hglyw _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1ul9idpf _1tket9kd _vchhusvi _bfhkvuon _syazi7uo _80omtlke _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _irr31dpa",
                isSelected && "_1h6dq98m _bfhk15s3"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ejb _4t3i1ejb _otyr1b66 _syaz1q3r"
            ])
        }, option.icon), /*#__PURE__*/ $cozmU.createElement("span", null, option.label));
    })));
};


/* SourcesPanel.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $2uDbg = parcelRequire("2uDbg");










var $1VhsF = parcelRequire("1VhsF");





var $e3Wrf = parcelRequire("e3Wrf");







var $5FjCy = parcelRequire("5FjCy");

const $43fc7685832af4f9$export$ebc817fa2f208b3c = ({ requireSource: requireSource, sourceEntries: sourceEntries })=>{
    if (sourceEntries.length === 0) return requireSource ? 'required' : null;
    if (sourceEntries.some((source)=>source.status === 'resolving')) return 'pending';
    if (sourceEntries.some((source)=>source.status === 'invalid')) return 'invalid';
    if (requireSource && !sourceEntries.some((source)=>source.status === 'resolved')) return 'required';
    return null;
};
const $43fc7685832af4f9$export$64f9064479cbe7b9 = (sourceValidationError)=>{
    switch(sourceValidationError){
        case 'invalid':
            return 'sourceInvalidError';
        case 'pending':
            return 'sourcePendingError';
        case 'required':
            return 'sourceRequiredError';
        default:
            return null;
    }
};


/* SourceList.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $1WMy0 = parcelRequire("1WMy0");





var $5HApy = parcelRequire("5HApy");







var $l8wPz = parcelRequire("l8wPz");







const $c77f20f6cb86684b$export$56f8b797da4bdab7 = (sourceUrl)=>{
    try {
        const url = new URL(sourceUrl);
        const path = url.pathname.replace(/\/$/, '');
        return path ? `${url.hostname}${path}` : url.hostname;
    } catch  {
        return sourceUrl;
    }
};


const $cffd9c45120ecabe$var$sourceChipListStyles = null;
const $cffd9c45120ecabe$var$sourceChipListInputStyles = null;
const $cffd9c45120ecabe$var$sourceChipStyles = null;
const $cffd9c45120ecabe$var$sourceChipInvalidStyles = null;
const $cffd9c45120ecabe$var$sourceChipResolvingStyles = null;
const $cffd9c45120ecabe$var$sourceChipLabelStyles = null;
const $cffd9c45120ecabe$var$sourceInvalidMessageStyles = null;
const $cffd9c45120ecabe$var$sourceResolvedCardStyles = null;
const $cffd9c45120ecabe$var$sourceStatusStyles = null;
const $cffd9c45120ecabe$var$getInvalidSourceMessageKey = (invalidReason)=>{
    switch(invalidReason){
        case 'invalid-url':
            return 'sourceInvalidUrl';
        case 'not-found':
            return 'sourceNotFound';
        case 'unauthenticated':
        case 'unauthorized':
            return 'sourceUnauthorized';
        case 'unavailable':
        default:
            return 'sourceUnavailable';
    }
};
const $cffd9c45120ecabe$var$SourceItem = ({ isDisabled: isDisabled, onRemove: onRemove, onRetry: onRetry, source: source })=>{
    const intl = (0, $kSwu1.useIntl)();
    const sourceLabel = (0, $c77f20f6cb86684b$export$56f8b797da4bdab7)(source.url);
    const invalidMessageKey = $cffd9c45120ecabe$var$getInvalidSourceMessageKey(source.invalidReason);
    return /*#__PURE__*/ $cozmU.createElement("li", {
        className: (0, $hekY6.default)([
            "_zulp1b66 _2rko12b0 _1e0c116y _4cvr1h6o _vchhusvi _p12f1osq _1ul9idpf _bfhki8nm _syazazsu _ca0q1b66 _u5f31b66 _n3td1b66 _19bv12x7",
            source.status === 'invalid' && "_1h6d1bqt _1dqonqa1 _189ee4h9 _bfhk1gly _syaz1tmw",
            source.status === 'resolving' && "_tzy4txnc"
        ])
    }, source.status === 'resolved' && /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1ul9idpf"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $l8wPz.Card), {
        appearance: "inline",
        placeholder: sourceLabel,
        resolvingPlaceholder: sourceLabel,
        url: source.url
    })), source.status === 'resolving' && /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_zulp1b66 _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        label: intl.formatMessage((0, $uia0q.messages).sourceResolving),
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
        ])
    }, sourceLabel)), source.status === 'invalid' && /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_zulp1b66 _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
        ])
    }, sourceLabel), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1o9zidpf _19bv1b66 _o5721q9c"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $uia0q.messages)[invalidMessageKey])))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.025",
        alignBlock: "center"
    }, source.status === 'invalid' && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1WMy0))),
        isDisabled: isDisabled,
        label: intl.formatMessage((0, $uia0q.messages).retrySourceLabel, {
            source: sourceLabel
        }),
        onClick: ()=>onRetry(source.url),
        spacing: "compact"
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        isDisabled: isDisabled,
        label: intl.formatMessage((0, $uia0q.messages).removeSourceLabel, {
            source: sourceLabel
        }),
        onClick: ()=>onRemove(source.url),
        spacing: "compact"
    })));
};
const $cffd9c45120ecabe$export$3748a2f1ceae9e24 = ({ 'aria-label': ariaLabel, cardClient: cardClient, isDisabled: isDisabled = false, onRemove: onRemove, onRetry: onRetry, smartCardProviderProduct: smartCardProviderProduct, spacing: spacing = 'default', sources: sources, testId: testId })=>{
    if (sources.length === 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), {
        client: cardClient,
        product: smartCardProviderProduct
    }, /*#__PURE__*/ $cozmU.createElement("ul", {
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_zulp1b66 _qtt8glyw _1e0c1txw _1n261g80 _19pku2gc _2hwxidpf _otyridpf _18u0idpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            spacing === 'input' && "_19pkidpf _otyru2gc"
        ])
    }, sources.map((source)=>/*#__PURE__*/ $cozmU.createElement($cffd9c45120ecabe$var$SourceItem, {
            key: source.url,
            isDisabled: isDisabled,
            onRemove: onRemove,
            onRetry: onRetry,
            source: source
        }))));
};









var $aeMAI = parcelRequire("aeMAI");




const $41891ca689b915d8$export$5cddb41d9a4259b7 = (currentEntries, rawSourceUrls)=>{
    const candidates = (0, $aeMAI.getSourceUrlCandidatesFromText)(rawSourceUrls);
    const seenUrls = new Set(currentEntries.map((source)=>source.url));
    const entries = [
        ...currentEntries
    ];
    let limitExceeded = false;
    candidates.forEach((candidate)=>{
        if (seenUrls.has(candidate)) return;
        if (entries.length >= (0, $aeMAI.MAX_MANAGED_BLOCK_SOURCES)) {
            limitExceeded = true;
            return;
        }
        seenUrls.add(candidate);
        entries.push((0, $aeMAI.isValidSourceUrl)(candidate) ? {
            app: (0, $aeMAI.getSourceAppFromUrl)(candidate),
            status: 'resolving',
            url: candidate
        } : {
            invalidReason: 'invalid-url',
            status: 'invalid',
            url: candidate
        });
    });
    return {
        entries: entries,
        limitExceeded: limitExceeded
    };
};
const $41891ca689b915d8$export$d2cf2595d48e7504 = (sourceEntries, url, update)=>sourceEntries.map((source)=>source.url === url ? {
            ...source,
            ...update,
            url: url
        } : source);
const $41891ca689b915d8$export$110d8af17cd151ae = (sourceEntries, sourceUrl)=>sourceEntries.filter((source)=>source.url !== sourceUrl);





const $30a150b31acce74f$var$APP_MATCHERS = [
    [
        'BITBUCKET',
        /bitbucket/
    ],
    [
        'CONFLUENCE',
        /confluence/
    ],
    [
        'GITHUB',
        /github/
    ],
    [
        'GOOGLE_DRIVE',
        /google|gdrive|drive|docs/
    ],
    [
        'JIRA',
        /jira/
    ],
    [
        'LOOM',
        /loom/
    ],
    [
        'MICROSOFT_SHAREPOINT',
        /sharepoint|onedrive/
    ],
    [
        'MICROSOFT_TEAMS',
        /microsoft.?teams|ms.?teams/
    ],
    [
        'SALESFORCE',
        /salesforce/
    ],
    [
        'SLACK',
        /slack/
    ]
];
const $30a150b31acce74f$var$getTextValue = (value)=>typeof value === 'string' && value.trim().length > 0 ? value : undefined;
const $30a150b31acce74f$var$getRecord = (value)=>value && typeof value === 'object' ? value : undefined;
const $30a150b31acce74f$export$247794f7c9f9b348 = (url, response)=>{
    const meta = $30a150b31acce74f$var$getRecord(response.meta);
    const data = $30a150b31acce74f$var$getRecord(response.data);
    const metaGenerator = $30a150b31acce74f$var$getRecord(meta?.generator);
    const dataGenerator = $30a150b31acce74f$var$getRecord(data?.generator);
    const candidates = [
        meta?.product,
        meta?.key,
        meta?.definitionId,
        metaGenerator?.name,
        metaGenerator?.['@id'],
        dataGenerator?.name,
        dataGenerator?.['@id'],
        data?.url,
        url
    ].map($30a150b31acce74f$var$getTextValue).filter((candidate)=>Boolean(candidate)).map((candidate)=>candidate.toLowerCase());
    return $30a150b31acce74f$var$APP_MATCHERS.find(([, matcher])=>candidates.some((candidate)=>matcher.test(candidate)))?.[0] ?? (0, $aeMAI.getSourceAppFromUrl)(url);
};
const $30a150b31acce74f$export$598ac52f861a5de9 = (response)=>{
    const meta = $30a150b31acce74f$var$getRecord(response.meta);
    const access = $30a150b31acce74f$var$getTextValue(meta?.access)?.toLowerCase();
    const visibility = $30a150b31acce74f$var$getTextValue(meta?.visibility)?.toLowerCase();
    if (visibility === 'not_found') return 'not-found';
    if (access === 'unauthorized' || access === 'forbidden') return 'unauthorized';
    if (access === 'unauthenticated') return 'unauthenticated';
    if (access && access !== 'granted') return 'unavailable';
    return null;
};
const $30a150b31acce74f$export$fd29b3c31d66ad7a = (error)=>{
    const errorText = error instanceof Error ? `${error.name} ${error.message}`.toLowerCase() : '';
    if (errorText.includes('auth')) return 'unauthenticated';
    if (errorText.includes('forbidden') || errorText.includes('permission')) return 'unauthorized';
    if (errorText.includes('unsupported') || errorText.includes('not found')) return 'not-found';
    return 'unavailable';
};


const $0cfee091019149b9$export$6cb422e489bb93bc = ({ cardClient: cardClient, onChange: onChange, sourceEntries: sourceEntries })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!cardClient) return;
        let cancelled = false;
        sourceEntries.filter((source)=>source.status === 'resolving' && (0, $aeMAI.isValidSourceUrl)(source.url)).forEach((source)=>{
            cardClient.fetchData(source.url, false, 'inline').then((response)=>{
                if (cancelled) return;
                const invalidReason = (0, $30a150b31acce74f$export$598ac52f861a5de9)(response);
                onChange((currentConfiguration)=>{
                    const nextSourceEntries = invalidReason ? (0, $41891ca689b915d8$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, source.url, {
                        app: (0, $aeMAI.getSourceAppFromUrl)(source.url),
                        invalidReason: invalidReason,
                        status: 'invalid'
                    }) : (0, $41891ca689b915d8$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, source.url, {
                        app: (0, $30a150b31acce74f$export$247794f7c9f9b348)(source.url, response),
                        invalidReason: undefined,
                        status: 'resolved'
                    });
                    return {
                        ...currentConfiguration,
                        sourceEntries: nextSourceEntries,
                        sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(nextSourceEntries)
                    };
                });
            }).catch((error)=>{
                if (cancelled) return;
                onChange((currentConfiguration)=>{
                    const nextSourceEntries = (0, $41891ca689b915d8$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, source.url, {
                        app: (0, $aeMAI.getSourceAppFromUrl)(source.url),
                        invalidReason: (0, $30a150b31acce74f$export$fd29b3c31d66ad7a)(error),
                        status: 'invalid'
                    });
                    return {
                        ...currentConfiguration,
                        sourceEntries: nextSourceEntries,
                        sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(nextSourceEntries)
                    };
                });
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        cardClient,
        onChange,
        sourceEntries
    ]);
};









const $fd8963b60ddff2c3$export$ee8283cf036594fb = ({ onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, onSourcesAdded: onSourcesAdded, sourceEntries: sourceEntries, sourceMode: sourceMode, sourceUrls: sourceUrls })=>{
    const [sourceInputValue, setSourceInputValue] = (0, $cozmU.useState)('');
    const [showSourceLimitError, setShowSourceLimitError] = (0, $cozmU.useState)(false);
    const handleSourceModeChange = (0, $cozmU.useCallback)((nextSourceMode)=>{
        onInteraction();
        if (sourceMode !== nextSourceMode || sourceUrls.length > 0 || sourceEntries.length > 0 || sourceInputValue.length > 0) onConfigEdit();
        setSourceInputValue('');
        setShowSourceLimitError(false);
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                sourceEntries: [],
                sourceMode: nextSourceMode,
                sourceUrls: ''
            }));
    }, [
        onChange,
        onConfigEdit,
        onInteraction,
        sourceEntries.length,
        sourceInputValue,
        sourceMode,
        sourceUrls
    ]);
    const handleSourceInputChange = (0, $cozmU.useCallback)((event)=>{
        onInteraction();
        setShowSourceLimitError(false);
        setSourceInputValue(event.currentTarget.value);
    }, [
        onInteraction
    ]);
    const addManualSources = (0, $cozmU.useCallback)((rawSourceUrls)=>{
        onInteraction();
        const { entries: nextSourceEntries, limitExceeded: limitExceeded } = (0, $41891ca689b915d8$export$5cddb41d9a4259b7)(sourceEntries, rawSourceUrls);
        setShowSourceLimitError(limitExceeded);
        if (nextSourceEntries.length === sourceEntries.length) {
            if (!limitExceeded) setSourceInputValue('');
            return;
        }
        onSourcesAdded?.();
        onConfigEdit();
        onChange((currentConfiguration)=>{
            const next = (0, $41891ca689b915d8$export$5cddb41d9a4259b7)(currentConfiguration.sourceEntries, rawSourceUrls).entries;
            return {
                ...currentConfiguration,
                sourceEntries: next,
                sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(next)
            };
        });
        setSourceInputValue('');
    }, [
        onChange,
        onConfigEdit,
        onInteraction,
        onSourcesAdded,
        sourceEntries
    ]);
    const handleSourceInputKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            addManualSources(sourceInputValue);
        }
    }, [
        addManualSources,
        sourceInputValue
    ]);
    const handleSourceInputPaste = (0, $cozmU.useCallback)((event)=>{
        const pastedText = event.clipboardData.getData('text');
        if (pastedText.trim().length === 0) return;
        event.preventDefault();
        addManualSources(pastedText);
    }, [
        addManualSources
    ]);
    const handleRemoveSourceUrl = (0, $cozmU.useCallback)((sourceUrl)=>{
        onInteraction();
        const nextSourceEntries = (0, $41891ca689b915d8$export$110d8af17cd151ae)(sourceEntries, sourceUrl);
        if (sourceEntries.length !== nextSourceEntries.length) onConfigEdit();
        setShowSourceLimitError(false);
        onChange((currentConfiguration)=>{
            const next = (0, $41891ca689b915d8$export$110d8af17cd151ae)(currentConfiguration.sourceEntries, sourceUrl);
            return {
                ...currentConfiguration,
                sourceEntries: next,
                sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(next)
            };
        });
    }, [
        onChange,
        onConfigEdit,
        onInteraction,
        sourceEntries
    ]);
    const handleRetrySourceUrl = (0, $cozmU.useCallback)((sourceUrl)=>{
        onInteraction();
        setShowSourceLimitError(false);
        onChange((currentConfiguration)=>{
            const isValidRetryUrl = (0, $aeMAI.isValidSourceUrl)(sourceUrl);
            const nextSourceEntries = (0, $41891ca689b915d8$export$d2cf2595d48e7504)(currentConfiguration.sourceEntries, sourceUrl, {
                app: (0, $aeMAI.getSourceAppFromUrl)(sourceUrl),
                invalidReason: isValidRetryUrl ? undefined : 'invalid-url',
                status: isValidRetryUrl ? 'resolving' : 'invalid'
            });
            return {
                ...currentConfiguration,
                sourceEntries: nextSourceEntries,
                sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(nextSourceEntries)
            };
        });
    }, [
        onChange,
        onInteraction
    ]);
    return {
        sourceInputValue: sourceInputValue,
        showSourceLimitError: showSourceLimitError,
        handleRemoveSourceUrl: handleRemoveSourceUrl,
        handleRetrySourceUrl: handleRetrySourceUrl,
        handleSourceInputChange: handleSourceInputChange,
        handleSourceInputKeyDown: handleSourceInputKeyDown,
        handleSourceInputPaste: handleSourceInputPaste,
        handleSourceModeChange: handleSourceModeChange
    };
};


const $f584fcd2928459b9$export$5a4a752748eadf59 = ({ cardClient: cardClient, onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, showInitialSourceDisclaimer: showInitialSourceDisclaimer = false, sourceEntries: sourceEntries, sourceMode: sourceMode, sourceUrls: sourceUrls })=>{
    const [isSourceDisclaimerDismissed, setIsSourceDisclaimerDismissed] = (0, $cozmU.useState)(false);
    const [isSourceDisclaimerVisible, setIsSourceDisclaimerVisible] = (0, $cozmU.useState)(()=>showInitialSourceDisclaimer);
    (0, $0cfee091019149b9$export$6cb422e489bb93bc)({
        cardClient: cardClient,
        onChange: onChange,
        sourceEntries: sourceEntries
    });
    const handleSourcesAdded = (0, $cozmU.useCallback)(()=>{
        if (!isSourceDisclaimerDismissed) setIsSourceDisclaimerVisible(true);
    }, [
        isSourceDisclaimerDismissed
    ]);
    const sourceInput = (0, $fd8963b60ddff2c3$export$ee8283cf036594fb)({
        onChange: onChange,
        onConfigEdit: onConfigEdit,
        onInteraction: onInteraction,
        onSourcesAdded: handleSourcesAdded,
        sourceEntries: sourceEntries,
        sourceMode: sourceMode,
        sourceUrls: sourceUrls
    });
    const handleDismissSourceDisclaimer = (0, $cozmU.useCallback)(()=>{
        setIsSourceDisclaimerDismissed(true);
        setIsSourceDisclaimerVisible(false);
    }, []);
    return {
        handleDismissSourceDisclaimer: handleDismissSourceDisclaimer,
        isSourceDisclaimerVisible: isSourceDisclaimerVisible,
        manualSources: sourceEntries,
        ...sourceInput
    };
};


const $d2cfc3e87eee0211$var$sourceInputStyles = null;
const $d2cfc3e87eee0211$var$sourceInputInvalidStyles = null;
const $d2cfc3e87eee0211$var$errorTextStyles = null;
const $d2cfc3e87eee0211$var$additionalContextStyles = {
    sourceDisclaimer: "_19pku2gc",
    root: "_19pku2gc",
    textArea: "_19pk12x7",
    message: "_19pk1b66"
};
const $d2cfc3e87eee0211$export$2c62bf432071778d = ({ additionalContext: additionalContext, additionalContextValidationError: additionalContextValidationError, isDisabled: isDisabled = false, isAdditionalContextSelected: isAdditionalContextSelected, onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, sourceEntries: sourceEntries, sourceMode: sourceMode, sourceModeOptions: sourceModeOptions, showInitialSourceDisclaimer: showInitialSourceDisclaimer, smartCardProviderProduct: smartCardProviderProduct, sourceUrls: sourceUrls, sourceValidationError: sourceValidationError })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cardClient = (0, $cozmU.useMemo)(()=>new (0, $4yccB.default)(), []);
    const { handleDismissSourceDisclaimer: handleDismissSourceDisclaimer, isSourceDisclaimerVisible: isSourceDisclaimerVisible, manualSources: manualSources, sourceInputValue: sourceInputValue, handleRemoveSourceUrl: handleRemoveSourceUrl, handleRetrySourceUrl: handleRetrySourceUrl, handleSourceInputChange: handleSourceInputChange, handleSourceInputKeyDown: handleSourceInputKeyDown, handleSourceInputPaste: handleSourceInputPaste, handleSourceModeChange: handleSourceModeChange, showSourceLimitError: showSourceLimitError } = (0, $f584fcd2928459b9$export$5a4a752748eadf59)({
        cardClient: cardClient,
        onChange: onChange,
        onConfigEdit: onConfigEdit,
        onInteraction: onInteraction,
        showInitialSourceDisclaimer: showInitialSourceDisclaimer,
        sourceEntries: sourceEntries,
        sourceMode: sourceMode,
        sourceUrls: sourceUrls
    });
    const sourceErrorMessageKey = showSourceLimitError ? 'sourceLimitError' : (0, $43fc7685832af4f9$export$64f9064479cbe7b9)(sourceValidationError);
    const sourceErrorId = sourceErrorMessageKey ? 'agent-managed-extension-source-error' : undefined;
    const additionalContextErrorId = additionalContextValidationError ? 'agent-managed-extension-additional-context-error' : undefined;
    const additionalContextCounterId = 'agent-managed-extension-additional-context-counter';
    const additionalContextDescriptionIds = [
        additionalContextErrorId,
        additionalContextCounterId
    ].filter(Boolean).join(' ');
    const additionalContextCharactersRemaining = Math.max(0, (0, $5FjCy.MAX_ADDITIONAL_CONTEXT_LENGTH) - additionalContext.length);
    const handleAdditionalContextChange = (0, $cozmU.useCallback)((event)=>{
        const nextAdditionalContext = event.currentTarget.value.slice(0, (0, $5FjCy.MAX_ADDITIONAL_CONTEXT_LENGTH));
        onInteraction();
        if (additionalContext !== nextAdditionalContext) onConfigEdit();
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                additionalContext: nextAdditionalContext
            }));
    }, [
        additionalContext,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    const handleAdditionalContextSelectedChange = (0, $cozmU.useCallback)((event)=>{
        const nextIsAdditionalContextSelected = event.currentTarget.checked;
        onInteraction();
        if (isAdditionalContextSelected !== nextIsAdditionalContextSelected) onConfigEdit();
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                isAdditionalContextSelected: nextIsAdditionalContextSelected
            }));
    }, [
        isAdditionalContextSelected,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e11890fa23152c2b$export$1acdcf5a973a8414), {
        htmlFor: "agent-managed-extension-source-mode"
    }, intl.formatMessage((0, $uia0q.messages).sourcesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        inputId: "agent-managed-extension-source-mode",
        options: sourceModeOptions,
        value: (0, $a3dc0f7194be2166$export$52024dc0d58d35da)(sourceModeOptions, sourceMode),
        onChange: (option)=>{
            if (option) handleSourceModeChange(option.value);
        },
        isDisabled: isDisabled,
        isSearchable: false
    })), sourceMode === 'manual' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        "aria-describedby": sourceErrorId,
        "aria-invalid": Boolean(sourceErrorMessageKey),
        "data-testid": "agent-managed-extension-source-input",
        disabled: isDisabled,
        onChange: handleSourceInputChange,
        onKeyDown: handleSourceInputKeyDown,
        onPaste: handleSourceInputPaste,
        placeholder: intl.formatMessage((0, $uia0q.messages).sourcesPlaceholder),
        type: "text",
        value: sourceInputValue,
        className: (0, $hekY6.default)([
            "_2rko12b0 _11c81kw7 _1h6drsbi _1dqonqa1 _189ee4h9 _1bsb1osq _vchhusvi _bfhkvuon _syazi7uo _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1idr1rpy _nt751v1w _1bg4v77o _49pcnqa1 _1hvwdkaa",
            sourceErrorMessageKey && "_1h6d1bqt"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cffd9c45120ecabe$export$3748a2f1ceae9e24), {
        "aria-label": intl.formatMessage((0, $uia0q.messages).sourceLinksLabel),
        cardClient: cardClient,
        isDisabled: isDisabled,
        onRemove: handleRemoveSourceUrl,
        onRetry: handleRetrySourceUrl,
        smartCardProviderProduct: smartCardProviderProduct,
        sources: manualSources
    }), sourceErrorMessageKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: sourceErrorId,
        role: "alert",
        className: (0, $hekY6.default)([
            "_syaz1tmw _19pku2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $uia0q.messages)[sourceErrorMessageKey])))), isSourceDisclaimerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $d2cfc3e87eee0211$var$additionalContextStyles.sourceDisclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "information",
        isDismissible: !isDisabled,
        onDismiss: handleDismissSourceDisclaimer,
        testId: "agent-managed-extension-source-disclaimer"
    }, intl.formatMessage((0, $uia0q.messages).sourceDisclaimerCopy))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $d2cfc3e87eee0211$var$additionalContextStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
        id: "agent-managed-extension-additional-context-toggle",
        isChecked: isAdditionalContextSelected,
        isDisabled: isDisabled,
        label: intl.formatMessage((0, $uia0q.messages).additionalContextLabel),
        onChange: handleAdditionalContextSelectedChange
    }), isAdditionalContextSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $d2cfc3e87eee0211$var$additionalContextStyles.textArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        "aria-describedby": additionalContextDescriptionIds,
        "aria-label": intl.formatMessage((0, $uia0q.messages).additionalContextDetailsLabel),
        id: "agent-managed-extension-additional-context",
        isDisabled: isDisabled,
        isInvalid: additionalContextValidationError,
        maxLength: (0, $5FjCy.MAX_ADDITIONAL_CONTEXT_LENGTH),
        minimumRows: 3,
        onChange: handleAdditionalContextChange,
        placeholder: intl.formatMessage((0, $uia0q.messages).additionalContextPlaceholder),
        testId: "agent-managed-extension-additional-context",
        value: additionalContext
    }), additionalContextValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        id: additionalContextErrorId,
        role: "alert",
        xcss: $d2cfc3e87eee0211$var$additionalContextStyles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $uia0q.messages).additionalContextRequiredError))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        id: additionalContextCounterId,
        xcss: $d2cfc3e87eee0211$var$additionalContextStyles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtle"
    }, intl.formatMessage((0, $uia0q.messages).additionalContextCharactersRemaining, {
        remaining: additionalContextCharactersRemaining
    }))))));
};


const $1e266a9340378627$export$aac584ace4a7b830 = ({ additionalContextValidationError: additionalContextValidationError, configuration: configuration, isDisabled: isDisabled = false, onChange: onChange, onConfigEdit: onConfigEdit, onInteraction: onInteraction, onPromptSelect: onPromptSelect, smartCardProviderProduct: smartCardProviderProduct, showInitialSourceDisclaimer: showInitialSourceDisclaimer, sourceValidationError: sourceValidationError })=>{
    const { goalOptions: goalOptions, outputFormatOptions: outputFormatOptions, sourceModeOptions: sourceModeOptions, systemDesignOutputFormatOptions: systemDesignOutputFormatOptions } = (0, $a3dc0f7194be2166$export$9860925510add594)();
    const handleGoalChange = (0, $cozmU.useCallback)((nextGoal)=>{
        const nextOutputFormat = nextGoal === 'system-design' ? 'diagram' : configuration.outputFormat === 'diagram' ? 'text' : configuration.outputFormat;
        onInteraction();
        if (configuration.goal !== nextGoal || configuration.outputFormat !== nextOutputFormat) onConfigEdit();
        onChange((currentConfiguration)=>{
            const currentNextOutputFormat = nextGoal === 'system-design' ? 'diagram' : currentConfiguration.outputFormat === 'diagram' ? 'text' : currentConfiguration.outputFormat;
            return {
                ...currentConfiguration,
                goal: nextGoal,
                outputFormat: currentNextOutputFormat
            };
        });
    }, [
        configuration.goal,
        configuration.outputFormat,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    const handleContentSelectionChange = (0, $cozmU.useCallback)((nextSelection)=>{
        if (nextSelection === 'prompt') {
            onPromptSelect();
            return;
        }
        handleGoalChange(nextSelection);
    }, [
        handleGoalChange,
        onPromptSelect
    ]);
    const handleOutputFormatChange = (0, $cozmU.useCallback)((outputFormat)=>{
        onInteraction();
        if (configuration.outputFormat !== outputFormat) onConfigEdit();
        onChange((currentConfiguration)=>({
                ...currentConfiguration,
                outputFormat: outputFormat
            }));
    }, [
        configuration.outputFormat,
        onChange,
        onConfigEdit,
        onInteraction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6afbceee21fe1de3$export$9ec0a8bc422643e4), {
        contentSelection: configuration.goal,
        isDisabled: isDisabled,
        onContentSelectionChange: handleContentSelectionChange,
        options: goalOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b574f788782fb1d$export$61dd55c259b4cf24), {
        goal: configuration.goal,
        isDisabled: isDisabled,
        onOutputFormatChange: handleOutputFormatChange,
        outputFormat: configuration.outputFormat,
        outputFormatOptions: outputFormatOptions,
        systemDesignOutputFormatOptions: systemDesignOutputFormatOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2cfc3e87eee0211$export$2c62bf432071778d), {
        additionalContext: configuration.additionalContext,
        additionalContextValidationError: additionalContextValidationError,
        isDisabled: isDisabled,
        isAdditionalContextSelected: configuration.isAdditionalContextSelected,
        onChange: onChange,
        onConfigEdit: onConfigEdit,
        onInteraction: onInteraction,
        sourceEntries: configuration.sourceEntries,
        sourceMode: configuration.sourceMode,
        sourceModeOptions: sourceModeOptions,
        showInitialSourceDisclaimer: showInitialSourceDisclaimer,
        smartCardProviderProduct: smartCardProviderProduct,
        sourceValidationError: sourceValidationError,
        sourceUrls: configuration.sourceUrls
    }));
};





var $EWSMm = parcelRequire("EWSMm");


/* ManagedBlockConfigFrame.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $I7hWB = parcelRequire("I7hWB");







const $e1de4b8c5ba7c9b9$var$wrapperStyles = null;
const $e1de4b8c5ba7c9b9$export$9ce5063a680c0a10 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    const headingId = (0, $cozmU.useId)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-labelledby": headingId,
        "data-testid": testId,
        ref: ref,
        role: "group",
        tabIndex: -1,
        className: (0, $hekY6.default)([
            "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsb1osq _vchhusvi _bfhkvuon _ca0qpxbi _u5f3pxbi _n3tdutpp _19bvpxbi _16qs130s"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        id: headingId,
        size: "small"
    }, intl.formatMessage((0, $uia0q.messages).configureBlock)), children));
});
$e1de4b8c5ba7c9b9$export$9ce5063a680c0a10.displayName = 'ManagedBlockConfigFrame';





const $28936f0b1b8e48a5$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $28936f0b1b8e48a5$var$createTextContent = (text)=>text.split('\n').flatMap((line, index)=>[
            ...index > 0 ? [
                {
                    type: 'hardBreak'
                }
            ] : [],
            ...line.length > 0 ? [
                {
                    type: 'text',
                    text: line
                }
            ] : []
        ]);
const $28936f0b1b8e48a5$var$createInlineCardContent = (url)=>({
        type: 'inlineCard',
        attrs: {
            url: url
        }
    });
const $28936f0b1b8e48a5$var$createPromptContent = (prompt, sourceEntries)=>{
    const sourceUrls = Array.from(new Set(sourceEntries.map((source)=>source.url))).sort((left, right)=>right.length - left.length);
    if (sourceUrls.length === 0) return {
        consumedSourceUrls: new Set(),
        content: $28936f0b1b8e48a5$var$createTextContent(prompt)
    };
    const sourceUrlPattern = new RegExp(sourceUrls.map($28936f0b1b8e48a5$var$escapeRegExp).join('|'), 'g');
    const content = [];
    const consumedSourceUrls = new Set();
    let previousIndex = 0;
    for (const match of prompt.matchAll(sourceUrlPattern)){
        const url = match[0];
        const matchIndex = match.index ?? 0;
        content.push(...$28936f0b1b8e48a5$var$createTextContent(prompt.slice(previousIndex, matchIndex)));
        content.push($28936f0b1b8e48a5$var$createInlineCardContent(url));
        consumedSourceUrls.add(url);
        previousIndex = matchIndex + url.length;
    }
    content.push(...$28936f0b1b8e48a5$var$createTextContent(prompt.slice(previousIndex)));
    return {
        consumedSourceUrls: consumedSourceUrls,
        content: content
    };
};
const $28936f0b1b8e48a5$export$3c7a02469d0ba581 = (prompt, sourceEntries)=>{
    const { consumedSourceUrls: consumedSourceUrls, content: paragraphContent } = $28936f0b1b8e48a5$var$createPromptContent(prompt, sourceEntries);
    sourceEntries.forEach((source)=>{
        if (consumedSourceUrls.has(source.url)) return;
        if (paragraphContent.length > 0) paragraphContent.push({
            type: 'text',
            text: ' '
        });
        paragraphContent.push($28936f0b1b8e48a5$var$createInlineCardContent(source.url));
    });
    return {
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                ...paragraphContent.length > 0 ? {
                    content: paragraphContent
                } : {}
            }
        ]
    };
};
const $28936f0b1b8e48a5$export$dbf337e43a5c9c02 = (adf)=>{
    const sourceUrls = [];
    const seenUrls = new Set();
    const visit = (node)=>{
        if (node.type === 'inlineCard' && node.attrs?.url) {
            const [sourceUrl] = (0, $aeMAI.getSourceUrlCandidatesFromPromptText)(node.attrs.url);
            if (sourceUrl && !seenUrls.has(sourceUrl)) {
                seenUrls.add(sourceUrl);
                sourceUrls.push(sourceUrl);
            }
        }
        node.content?.forEach(visit);
    };
    if (adf) visit(adf);
    return sourceUrls;
};


/* PromptPanel.tsx generated by @compiled/babel-plugin v0.40.0 */ 












var $j6vyT = parcelRequire("j6vyT");


var $gC2EJ = parcelRequire("gC2EJ");









/* ManagedBlockPromptEditor.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $6RwwD = parcelRequire("6RwwD");





var $gWBVp = parcelRequire("gWBVp");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dVPAB = parcelRequire("dVPAB");

































































var $at1wf = parcelRequire("at1wf");

const $bd9d11db6762dd1d$var$promptEditorStyles = null;
const $bd9d11db6762dd1d$var$promptEditorInvalidStyles = null;
const $bd9d11db6762dd1d$var$promptEditorDisabledStyles = null;
const $bd9d11db6762dd1d$var$createManagedBlockPromptPreset = ({ cardProvider: cardProvider, placeholder: placeholder })=>{
    const cardPluginData = {
        provider: Promise.resolve(cardProvider),
        disableFloatingToolbar: true,
        showUpgradeDiscoverability: false,
        allowBlockCards: false,
        allowEmbeds: false
    };
    return new (0, $a31lS.EditorPresetBuilder)().add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        {}
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $7Upsh.default),
        {}
    ]).add((0, $2QN3e.decorationsPlugin)).add((0, $d1HsG.typeAheadPlugin)).add((0, $6WRJZ.default)).add((0, $abOD2.undoRedoPlugin)).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $3HCXM.hyperlinkPlugin),
        {
            disableFloatingToolbar: true
        }
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $f3DNZ.placeholderPlugin),
        {
            placeholder: placeholder
        }
    ]).add((0, $e273U.editorDisabledPlugin)).add((0, $1ZhW4.copyButtonPlugin)).add((0, $5tMpU.floatingToolbarPlugin)).add([
        (0, $fb3SZ.selectionPlugin),
        {}
    ]).add([
        (0, $iVGec.gridPlugin),
        {}
    ]).add([
        (0, $40ukF.cardPlugin),
        cardPluginData
    ]).add((0, $4lpx1.userIntentPlugin));
};
const $bd9d11db6762dd1d$var$ManagedBlockPromptEditorInner = ({ ariaDescribedBy: ariaDescribedBy, ariaLabel: ariaLabel, autoFocus: autoFocus, defaultValue: defaultValue, isDisabled: isDisabled = false, isInvalid: isInvalid = false, onADFChange: onADFChange, onInputChange: onInputChange, placeholder: placeholder, setFocusHandler: setFocusHandler })=>{
    const cardProvider = (0, $cozmU.useMemo)(()=>new (0, $6RwwD.EditorCardProvider)(), []);
    const textSerializerRef = (0, $cozmU.useRef)(null);
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(()=>$bd9d11db6762dd1d$var$createManagedBlockPromptPreset({
            cardProvider: cardProvider,
            placeholder: placeholder
        }), [
        cardProvider,
        placeholder
    ]);
    const handleChange = (0, $cozmU.useCallback)((editorView)=>{
        const { schema: schema } = editorView.state;
        if (textSerializerRef.current?.schema !== schema) textSerializerRef.current = {
            schema: schema,
            serializer: (0, $at1wf.default).fromSchema(schema)
        };
        const textSerializer = textSerializerRef.current.serializer;
        const text = textSerializer.serializeFragment(editorView.state.doc.content);
        const adf = (0, $gWBVp.toJSON)(editorView.state.doc);
        onADFChange(adf);
        onInputChange(text);
    }, [
        onADFChange,
        onInputChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        setFocusHandler?.(editorApi?.core?.actions.focus);
    }, [
        editorApi,
        setFocusHandler
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-disabled": isDisabled,
        "data-testid": "agent-managed-extension-prompt-input-field",
        className: (0, $hekY6.default)([
            "_2rko12b0 _1h6drsbi _1dqonqa1 _189ee4h9 _bfhk1j9a _ca0qu2gc _u5f3u2gc _n3td12x7 _19bvu2gc _jyzf1v1w _1u6l5nfi",
            isInvalid && "_1h6d1bqt _jyzf1bqt _1u6l1esi",
            isDisabled && "_1h6dbk0g _bfhk187o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
        appearance: "chromeless",
        assistiveDescribedBy: ariaDescribedBy,
        assistiveLabel: ariaLabel,
        defaultValue: defaultValue,
        disabled: isDisabled,
        minHeight: 100,
        onChange: handleChange,
        preset: preset,
        shouldFocus: autoFocus
    }));
};
const $bd9d11db6762dd1d$export$ac184428b65a12e9 = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement($bd9d11db6762dd1d$var$ManagedBlockPromptEditorInner // Ignored via go/ees005
    , props));


const $bc58fb404129b1e6$var$labelStyles = null;
const $bc58fb404129b1e6$var$promptSectionStyles = null;
const $bc58fb404129b1e6$var$promptToggleStyles = null;
const $bc58fb404129b1e6$var$promptToggleTextStyles = null;
const $bc58fb404129b1e6$var$promptToggleChevronStyles = null;
const $bc58fb404129b1e6$var$promptBodyStyles = {
    root: "_19pku2gc",
    error: "_19pku2gc"
};
const $bc58fb404129b1e6$export$a61c020b7ca91c15 = (props)=>{
    const { isDisabled: isDisabled = false, defaultValue: defaultValue, isExpanded: isExpanded, onPromptADFChange: onPromptADFChange, onPromptChange: onPromptChange, promptEditorKey: promptEditorKey, promptValidationError: promptValidationError } = props;
    const intl = (0, $kSwu1.useIntl)();
    const promptEditorFocusRef = (0, $cozmU.useRef)(undefined);
    const promptErrorId = promptValidationError ? 'agent-managed-extension-prompt-error' : undefined;
    const promptLabel = intl.formatMessage((0, $uia0q.messages).customInstructionsLabel);
    (0, $cozmU.useEffect)(()=>{
        if (isExpanded) promptEditorFocusRef.current?.();
    }, [
        isExpanded
    ]);
    const promptBody = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $bc58fb404129b1e6$var$promptBodyStyles.root
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1e0c1ule _syazazsu _otyr12x7"
        ])
    }, promptLabel), /*#__PURE__*/ $cozmU.createElement((0, $bd9d11db6762dd1d$export$ac184428b65a12e9), {
        key: promptEditorKey,
        ariaDescribedBy: promptErrorId,
        ariaLabel: promptLabel,
        autoFocus: isExpanded,
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isInvalid: promptValidationError,
        onADFChange: (inputValue)=>{
            if (!isDisabled) onPromptADFChange(inputValue);
        },
        onInputChange: (inputValue)=>{
            if (!isDisabled) onPromptChange(inputValue);
        },
        placeholder: intl.formatMessage((0, $uia0q.messages).customInstructionsPlaceholder),
        setFocusHandler: (focus)=>{
            promptEditorFocusRef.current = focus;
        }
    }), promptValidationError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        id: promptErrorId,
        role: "alert",
        xcss: $bc58fb404129b1e6$var$promptBodyStyles.error
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $uia0q.messages).emptyPrompt))));
    if (props.showToggle === false) return promptBody;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1i531l7x _15a5nqa1 _uwhke4h9 _ca0qutpp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("button", {
        "aria-expanded": isExpanded,
        disabled: isDisabled,
        onClick: props.onToggle,
        type: "button",
        className: (0, $hekY6.default)([
            "_11c81kw7 _189eidpf _r06hglyw _1e0c1txw _4cvr1h6o _1bsb1osq _bfhk1j28 _syazazsu _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1e5h _mizu1v1w _1ah31b66 _ra3xnqa1 _128mdkaa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_18u012x7"
        ])
    }, intl.formatMessage((0, $uia0q.messages).promptToggleLabel)), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_18u01wug"
        ])
    }, isExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "currentColor"
    }))), isExpanded && promptBody);
};








const $48777841143a27f5$var$saveErrorStyles = null;
const $48777841143a27f5$var$footerStyles = null;
const $48777841143a27f5$var$actionsStyles = null;
const $48777841143a27f5$var$promptSourceErrorStyles = null;
const $48777841143a27f5$var$applyStateAction = (currentValue, action)=>typeof action === 'function' ? action(currentValue) : action;
const $48777841143a27f5$var$getPromptSourceEntries = (configuration)=>configuration.mode === 'prompt' ? configuration.sourceEntries : [];
const $48777841143a27f5$var$getStructuredSourceState = (configuration)=>configuration.mode === 'configuration' ? {
        sourceEntries: configuration.sourceEntries,
        sourceMode: configuration.sourceMode,
        sourceUrls: configuration.sourceUrls
    } : {
        sourceEntries: [],
        sourceMode: configuration.sourceMode,
        sourceUrls: ''
    };
const $48777841143a27f5$var$TEXT_ENTRY_INPUT_TYPES = new Set([
    'email',
    'number',
    'password',
    'search',
    'tel',
    'text',
    'url'
]);
const $48777841143a27f5$var$isElementInWindow = (target, ownerWindow)=>target instanceof ownerWindow.HTMLElement;
const $48777841143a27f5$var$isTextEntryTarget = (target, panelElement, ownerWindow)=>{
    if (!$48777841143a27f5$var$isElementInWindow(target, ownerWindow)) return false;
    const element = target.closest('input, textarea, [contenteditable="true"], [role="textbox"]');
    if (!$48777841143a27f5$var$isElementInWindow(element, ownerWindow) || !panelElement.contains(element)) return false;
    if (element instanceof ownerWindow.HTMLTextAreaElement) return true;
    if (element instanceof ownerWindow.HTMLInputElement) return $48777841143a27f5$var$TEXT_ENTRY_INPUT_TYPES.has(element.type);
    return element.isContentEditable || element.getAttribute('role') === 'textbox';
};
function $48777841143a27f5$export$ece65817fe850722({ aimoData: aimoData = null, cloudId: cloudId, currentPageSourceUrl: currentPageSourceUrl, initialConfiguration: initialConfiguration, isVisible: isVisible = true, onSave: onSave, onCancel: onCancel, onClearError: onClearError, isSaving: isSaving = false, error: error = null, persistedConfig: persistedConfig = null, smartCardProviderProduct: smartCardProviderProduct, showInitialSourceDisclaimer: showInitialSourceDisclaimer = false }) {
    const intl = (0, $kSwu1.useIntl)();
    const { goalOptions: promptGoalOptions } = (0, $a3dc0f7194be2166$export$9860925510add594)();
    const [configState, setConfigState] = (0, $cozmU.useState)({
        configuration: initialConfiguration,
        showPromptSourceLimitError: false
    });
    const { configuration: configuration, showPromptSourceLimitError: showPromptSourceLimitError } = configState;
    const [hasAttemptedSave, setHasAttemptedSave] = (0, $cozmU.useState)(false);
    const [promptEditorInstanceKey, setPromptEditorInstanceKey] = (0, $cozmU.useState)(0);
    const hasEditedConfigurationRef = (0, $cozmU.useRef)(false);
    const hasEditedPromptRef = (0, $cozmU.useRef)(false);
    const lastHydratedConfigurationRef = (0, $cozmU.useRef)(initialConfiguration);
    const panelRef = (0, $cozmU.useRef)(null);
    const hadFocusWithinPanelRef = (0, $cozmU.useRef)(false);
    const hasFocusedPanelRef = (0, $cozmU.useRef)(false);
    const configurationRef = (0, $cozmU.useRef)(configuration);
    const promptSourceEntriesRef = (0, $cozmU.useRef)($48777841143a27f5$var$getPromptSourceEntries(initialConfiguration));
    const structuredSourceStateRef = (0, $cozmU.useRef)($48777841143a27f5$var$getStructuredSourceState(initialConfiguration));
    const updateConfiguration = (0, $cozmU.useCallback)((update)=>{
        setConfigState((currentState)=>({
                ...currentState,
                configuration: $48777841143a27f5$var$applyStateAction(currentState.configuration, update)
            }));
    }, []);
    (0, $cozmU.useEffect)(()=>{
        configurationRef.current = configuration;
    }, [
        configuration
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (configuration.mode === 'prompt') {
            promptSourceEntriesRef.current = configuration.sourceEntries;
            return;
        }
        structuredSourceStateRef.current = $48777841143a27f5$var$getStructuredSourceState(configuration);
    }, [
        configuration
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentConfiguration = configurationRef.current;
        const lastHydratedConfiguration = lastHydratedConfigurationRef.current;
        lastHydratedConfigurationRef.current = initialConfiguration;
        if ((0, $5FjCy.arePanelConfigurationsEqual)(currentConfiguration, lastHydratedConfiguration, currentPageSourceUrl)) {
            hasEditedConfigurationRef.current = false;
            hasEditedPromptRef.current = false;
            setPromptEditorInstanceKey((currentKey)=>currentKey + 1);
            updateConfiguration(initialConfiguration);
            promptSourceEntriesRef.current = $48777841143a27f5$var$getPromptSourceEntries(initialConfiguration);
            structuredSourceStateRef.current = $48777841143a27f5$var$getStructuredSourceState(initialConfiguration);
        }
    }, [
        currentPageSourceUrl,
        initialConfiguration,
        updateConfiguration
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isVisible) {
            hasFocusedPanelRef.current = false;
            return;
        }
        if (hasFocusedPanelRef.current) return;
        const panelElement = panelRef.current;
        if (!panelElement) return;
        panelElement.focus({
            preventScroll: true
        });
        hadFocusWithinPanelRef.current = true;
        hasFocusedPanelRef.current = true;
    }, [
        isVisible
    ]);
    const clearErrorsOnInteraction = (0, $cozmU.useCallback)(()=>{
        setHasAttemptedSave(false);
        onClearError?.();
    }, [
        onClearError
    ]);
    const markConfigurationEdited = (0, $cozmU.useCallback)(()=>{
        hasEditedConfigurationRef.current = true;
    }, []);
    const handleConfigurationChange = (0, $cozmU.useCallback)((update)=>{
        updateConfiguration(update);
    }, [
        updateConfiguration
    ]);
    const promptCardClient = (0, $cozmU.useMemo)(()=>configuration.mode === 'prompt' ? new (0, $4yccB.default)() : null, [
        configuration.mode
    ]);
    (0, $0cfee091019149b9$export$6cb422e489bb93bc)({
        cardClient: promptCardClient,
        onChange: handleConfigurationChange,
        sourceEntries: configuration.mode === 'prompt' ? configuration.sourceEntries : []
    });
    const handlePromptToggle = (0, $cozmU.useCallback)(()=>{
        const currentMode = configurationRef.current.mode;
        const shouldResetConfiguration = currentMode === 'prompt' && hasEditedPromptRef.current;
        clearErrorsOnInteraction();
        updateConfiguration((currentConfiguration)=>{
            if (currentConfiguration.mode === 'prompt') {
                if (shouldResetConfiguration) {
                    setPromptEditorInstanceKey((currentKey)=>currentKey + 1);
                    return (0, $5FjCy.getDefaultStructuredPanelConfiguration)(currentConfiguration);
                }
                return {
                    ...currentConfiguration,
                    ...structuredSourceStateRef.current,
                    mode: 'configuration'
                };
            }
            return {
                ...currentConfiguration,
                mode: 'prompt',
                sourceEntries: promptSourceEntriesRef.current,
                sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(promptSourceEntriesRef.current)
            };
        });
        if (shouldResetConfiguration) {
            hasEditedConfigurationRef.current = false;
            hasEditedPromptRef.current = false;
        }
    }, [
        clearErrorsOnInteraction,
        updateConfiguration
    ]);
    const handlePromptChange = (0, $cozmU.useCallback)((nextPrompt)=>{
        clearErrorsOnInteraction();
        if (configurationRef.current.prompt !== nextPrompt) hasEditedPromptRef.current = true;
        updateConfiguration((currentConfiguration)=>({
                ...currentConfiguration,
                prompt: nextPrompt
            }));
    }, [
        clearErrorsOnInteraction,
        updateConfiguration
    ]);
    const handlePromptAdfChange = (0, $cozmU.useCallback)((nextPromptAdf)=>{
        const sourceUrls = (0, $28936f0b1b8e48a5$export$dbf337e43a5c9c02)(nextPromptAdf);
        const sourceUrlSet = new Set(sourceUrls);
        clearErrorsOnInteraction();
        hasEditedPromptRef.current = true;
        setConfigState((currentState)=>{
            const currentConfiguration = currentState.configuration;
            const nextRetainedSourceEntries = currentConfiguration.sourceEntries.filter((source)=>sourceUrlSet.has(source.url));
            const { entries: nextSourceEntries, limitExceeded: limitExceeded } = (0, $41891ca689b915d8$export$5cddb41d9a4259b7)(nextRetainedSourceEntries, sourceUrls.join('\n'));
            return {
                ...currentState,
                configuration: {
                    ...currentConfiguration,
                    sourceEntries: nextSourceEntries,
                    sourceMode: 'manual',
                    sourceUrls: (0, $aeMAI.getSourceUrlsFromEntries)(nextSourceEntries)
                },
                showPromptSourceLimitError: limitExceeded
            };
        });
    }, [
        clearErrorsOnInteraction
    ]);
    const handlePromptContentSelectionChange = (0, $cozmU.useCallback)((nextSelection)=>{
        if (nextSelection === 'prompt') return;
        const shouldResetConfiguration = configurationRef.current.mode === 'prompt' && hasEditedPromptRef.current;
        clearErrorsOnInteraction();
        updateConfiguration((currentConfiguration)=>{
            const baseConfiguration = shouldResetConfiguration ? (0, $5FjCy.getDefaultStructuredPanelConfiguration)(currentConfiguration) : {
                ...currentConfiguration,
                ...structuredSourceStateRef.current,
                mode: 'configuration'
            };
            const nextOutputFormat = (0, $EWSMm.getOutputFormatForGoal)(nextSelection, baseConfiguration.outputFormat);
            if (baseConfiguration.goal !== nextSelection || baseConfiguration.outputFormat !== nextOutputFormat) hasEditedConfigurationRef.current = true;
            return {
                ...baseConfiguration,
                goal: nextSelection,
                outputFormat: nextOutputFormat
            };
        });
        if (shouldResetConfiguration) hasEditedPromptRef.current = false;
    }, [
        clearErrorsOnInteraction,
        updateConfiguration
    ]);
    const configInput = (0, $cozmU.useMemo)(()=>(0, $5FjCy.toAiManagedObjectConfigInput)(configuration, currentPageSourceUrl), [
        configuration,
        currentPageSourceUrl
    ]);
    const validation = (0, $cozmU.useMemo)(()=>(0, $b4354e2d9ae7322a$export$f21a0ba102fbd812)(configInput), [
        configInput
    ]);
    const manualSourceValidationError = (0, $cozmU.useMemo)(()=>configuration.mode === 'configuration' && configuration.sourceMode === 'manual' ? (0, $43fc7685832af4f9$export$ebc817fa2f208b3c)({
            requireSource: true,
            sourceEntries: configuration.sourceEntries
        }) : null, [
        configuration.mode,
        configuration.sourceEntries,
        configuration.sourceMode
    ]);
    const promptSourceValidationError = (0, $cozmU.useMemo)(()=>configuration.mode === 'prompt' ? (0, $43fc7685832af4f9$export$ebc817fa2f208b3c)({
            requireSource: false,
            sourceEntries: configuration.sourceEntries
        }) : null, [
        configuration.mode,
        configuration.sourceEntries
    ]);
    const sourceValidationError = hasAttemptedSave && configuration.mode === 'configuration' && configuration.sourceMode === 'manual' ? manualSourceValidationError : null;
    const promptSourceError = hasAttemptedSave && configuration.mode === 'prompt' ? promptSourceValidationError : null;
    const promptSourceErrorMessageKey = showPromptSourceLimitError ? 'sourceLimitError' : (0, $43fc7685832af4f9$export$64f9064479cbe7b9)(promptSourceError);
    const isAdditionalContextInvalid = configuration.mode === 'configuration' && configuration.isAdditionalContextSelected && configuration.additionalContext.trim().length === 0;
    const additionalContextValidationError = hasAttemptedSave && isAdditionalContextInvalid;
    const promptValidationError = hasAttemptedSave && configuration.mode === 'prompt' && configuration.prompt.trim().length === 0;
    const promptDefaultValue = (0, $cozmU.useMemo)(()=>configuration.mode === 'prompt' ? (0, $28936f0b1b8e48a5$export$3c7a02469d0ba581)(configuration.prompt, configuration.sourceEntries) : undefined, [
        configuration.mode,
        configuration.prompt,
        configuration.sourceEntries
    ]);
    const hasConfigurationChanged = (0, $5FjCy.hasPersistedConfigurationChanged)(persistedConfig, configInput);
    const isSaveDisabled = isSaving || !hasConfigurationChanged;
    const handleSave = (0, $cozmU.useCallback)(()=>{
        if (isSaveDisabled) return;
        setHasAttemptedSave(true);
        if (manualSourceValidationError || promptSourceValidationError || isAdditionalContextInvalid || !validation.valid) return;
        onSave(configInput);
    }, [
        configInput,
        isAdditionalContextInvalid,
        isSaveDisabled,
        manualSourceValidationError,
        onSave,
        promptSourceValidationError,
        validation
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        onCancel?.();
    }, [
        onCancel
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isVisible) return;
        const panelElement = panelRef.current;
        const ownerWindow = panelElement?.ownerDocument.defaultView;
        if (!panelElement || !ownerWindow) return;
        const stopShortcutPropagation = (event, shouldPreventDefault = false)=>{
            if (shouldPreventDefault) event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        };
        const isTargetInsidePanel = (target)=>target instanceof ownerWindow.Node && panelElement.contains(target);
        const handleFocusIn = (event)=>{
            hadFocusWithinPanelRef.current = isTargetInsidePanel(event.target);
        };
        const handlePointerDown = (event)=>{
            hadFocusWithinPanelRef.current = isTargetInsidePanel(event.target);
        };
        const handleKeyDown = (event)=>{
            const eventTarget = event.target;
            const isInsidePanel = isTargetInsidePanel(eventTarget);
            const isDocumentFocusFallback = hadFocusWithinPanelRef.current && ownerWindow.document.activeElement === ownerWindow.document.body && (eventTarget === ownerWindow.document.body || eventTarget === ownerWindow.document);
            if (!isInsidePanel && !isDocumentFocusFallback) return;
            const isCloseShortcut = event.key === 'Escape' || event.key === 'Esc';
            const isTextEntry = isInsidePanel && $48777841143a27f5$var$isTextEntryTarget(eventTarget, panelElement, ownerWindow);
            const isModifiedEnter = event.key === 'Enter' && (event.metaKey || event.ctrlKey);
            const isPlainEnter = event.key === 'Enter' && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
            const isSaveShortcut = isTextEntry ? isModifiedEnter : isPlainEnter;
            const shouldSuppressModifiedEnter = !isTextEntry && isModifiedEnter;
            if (!isSaveShortcut && !isCloseShortcut && !shouldSuppressModifiedEnter) return;
            if (isCloseShortcut) {
                stopShortcutPropagation(event);
                if (!isSaving) handleCancel();
                return;
            }
            if (shouldSuppressModifiedEnter) {
                stopShortcutPropagation(event);
                return;
            }
            stopShortcutPropagation(event, true);
            handleSave();
        };
        ownerWindow.addEventListener('focusin', handleFocusIn, true);
        ownerWindow.addEventListener('pointerdown', handlePointerDown, true);
        ownerWindow.addEventListener('keydown', handleKeyDown, true);
        return ()=>{
            ownerWindow.removeEventListener('focusin', handleFocusIn, true);
            ownerWindow.removeEventListener('pointerdown', handlePointerDown, true);
            ownerWindow.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [
        handleCancel,
        handleSave,
        isSaving,
        isVisible
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $e1de4b8c5ba7c9b9$export$9ce5063a680c0a10), {
        ref: panelRef,
        testId: "agent-managed-extension-configure-panel"
    }, configuration.mode === 'configuration' ? /*#__PURE__*/ $cozmU.createElement((0, $1e266a9340378627$export$aac584ace4a7b830), {
        additionalContextValidationError: additionalContextValidationError,
        configuration: configuration,
        isDisabled: isSaving,
        onChange: handleConfigurationChange,
        onConfigEdit: markConfigurationEdited,
        onInteraction: clearErrorsOnInteraction,
        onPromptSelect: handlePromptToggle,
        showInitialSourceDisclaimer: showInitialSourceDisclaimer,
        smartCardProviderProduct: smartCardProviderProduct,
        sourceValidationError: sourceValidationError
    }) : /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $6afbceee21fe1de3$export$9ec0a8bc422643e4), {
        contentSelection: "prompt",
        isDisabled: isSaving,
        onContentSelectionChange: handlePromptContentSelectionChange,
        options: promptGoalOptions
    }), /*#__PURE__*/ $cozmU.createElement((0, $bc58fb404129b1e6$export$a61c020b7ca91c15), {
        defaultValue: promptDefaultValue,
        isDisabled: isSaving,
        isExpanded: true,
        onPromptADFChange: handlePromptAdfChange,
        onPromptChange: handlePromptChange,
        promptEditorKey: `agent-managed-extension-prompt-${promptEditorInstanceKey}`,
        promptValidationError: promptValidationError,
        showToggle: false
    }), promptSourceErrorMessageKey && /*#__PURE__*/ $cozmU.createElement("div", {
        role: "alert",
        className: (0, $hekY6.default)([
            "_syaz1tmw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, intl.formatMessage((0, $uia0q.messages)[promptSourceErrorMessageKey])))), error && /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "agent-managed-extension-error",
        role: "alert",
        className: (0, $hekY6.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1tmw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, error)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $5e2609207061f85f$export$b029164683c5c152), {
        aimoData: aimoData,
        cloudId: cloudId
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_18u01wug"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.100",
        alignInline: "end"
    }, onCancel && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: isSaving
    }, intl.formatMessage((0, $uia0q.messages).cancel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        testId: "agent-managed-extension-save",
        onClick: handleSave,
        isDisabled: isSaveDisabled,
        iconAfter: isSaving ? ()=>/*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: "small"
            }) : undefined
    }, intl.formatMessage((0, $uia0q.messages).save))))));
}



const $f77d5c1ac623e650$var$CONTEXT_PRODUCT_TO_SMART_CARD_PRODUCT = {
    atlas: 'ATLAS',
    bitbucket: 'BITBUCKET',
    confluence: 'CONFLUENCE',
    csm: 'CSM',
    elevate: 'ELEVATE',
    jira: 'JSW',
    'jira-product-discovery': 'JPD',
    'jira-service-management': 'JSM',
    'jira-software': 'JSW',
    'jira-work-management': 'JWM',
    jpd: 'JPD',
    jsm: 'JSM',
    jsw: 'JSW',
    jwm: 'JWM',
    trello: 'TRELLO'
};
const $f77d5c1ac623e650$export$1989f8c06c32742e = (product)=>{
    if (!product) return undefined;
    const normalizedProduct = product.trim().toLowerCase().replace(/[\s_]+/g, '-');
    return $f77d5c1ac623e650$var$CONTEXT_PRODUCT_TO_SMART_CARD_PRODUCT[normalizedProduct];
};





























const $efb488c00d84fa07$export$abcc4eb8db800758 = ({ editorView: editorView })=>{
    const executeAiManagedObjectCallback = (0, $cozmU.useCallback)((args)=>(0, $e65a16941efd8768$export$8235b51c7030883b)({
            ...args,
            editorView: editorView
        }), [
        editorView
    ]);
    return {
        executeAiManagedObject: executeAiManagedObjectCallback
    };
};

















const $16ee3f78bb362198$export$31a6a034849cb700 = ({ aimoId: aimoId, aimoLoadStatus: aimoLoadStatus, cachedAimo: cachedAimo, configLocalId: configLocalId, editorView: editorView, foundPos: foundPos, isOpen: isOpen, templateConfig: templateConfig })=>{
    const intl = (0, $kSwu1.useIntl)();
    const configurationLoadErrorMessage = intl.formatMessage((0, $uia0q.messages).failedToLoadConfiguration);
    const [aimoData, setAimoData] = (0, $cozmU.useState)(cachedAimo ?? null);
    const loadRequestIdRef = (0, $cozmU.useRef)(0);
    const isMountedRef = (0, $cozmU.useRef)(true);
    const isLoadedAimoCurrent = Boolean(aimoId && aimoData?.id === aimoId);
    const isExistingConfigurationPending = isOpen && foundPos !== undefined && Boolean(aimoId) && !cachedAimo && !isLoadedAimoCurrent && aimoLoadStatus !== 'failed';
    const cancelPendingConfigurationLoad = (0, $cozmU.useCallback)(()=>{
        loadRequestIdRef.current += 1;
    }, []);
    const loadAiManagedObject = (0, $cozmU.useCallback)(()=>{
        if (!aimoId) return;
        const requestId = loadRequestIdRef.current + 1;
        loadRequestIdRef.current = requestId;
        (0, $89DwQ.getAiManagedObjectWithCache)({
            aimoId: aimoId,
            cachedAimo: cachedAimo,
            editorView: editorView,
            localId: configLocalId
        }).then((aimo)=>{
            if (!isMountedRef.current || loadRequestIdRef.current !== requestId) return;
            setAimoData(aimo);
        }).catch(()=>{
            if (!isMountedRef.current || loadRequestIdRef.current !== requestId) return;
            setAimoData(null);
        });
    }, [
        aimoId,
        cachedAimo,
        configLocalId,
        editorView
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            isMountedRef.current = false;
            cancelPendingConfigurationLoad();
        }, [
        cancelPendingConfigurationLoad
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || foundPos === undefined) {
            cancelPendingConfigurationLoad();
            setAimoData(null);
            return;
        }
        if (!aimoId) {
            cancelPendingConfigurationLoad();
            setAimoData(null);
            return;
        }
        if (cachedAimo) {
            cancelPendingConfigurationLoad();
            setAimoData(cachedAimo);
            return;
        }
        if (aimoLoadStatus !== 'failed' && aimoLoadStatus !== 'loading') loadAiManagedObject();
    }, [
        aimoId,
        aimoLoadStatus,
        cachedAimo,
        cancelPendingConfigurationLoad,
        foundPos,
        isOpen,
        loadAiManagedObject
    ]);
    return {
        aimoData: aimoData,
        configurationLoadError: aimoLoadStatus === 'failed' ? configurationLoadErrorMessage : null,
        handleRetryConfigurationLoad: loadAiManagedObject,
        initialConfiguration: aimoData?.config ? (0, $5FjCy.getPanelConfigurationFromAimoConfig)(aimoData.config) : (0, $5FjCy.getPanelConfigurationFromTemplateConfig)(templateConfig),
        isLoadingConfiguration: isExistingConfigurationPending || aimoLoadStatus === 'loading',
        setAimoData: setAimoData
    };
};


const $8daf2a0ef6c577a0$var$validationErrorMessageKeys = {
    EMPTY_PROMPT: 'emptyPrompt',
    INVALID_DESIRED_UPDATE_FREQUENCY: 'invalidDesiredUpdateFrequency',
    MISSING_GOAL: 'missingGoal',
    MISSING_OUTPUT_FORMAT: 'missingOutputFormat',
    MISSING_SOURCES: 'missingSources'
};
const $8daf2a0ef6c577a0$var$getSaveTarget = (currentFound)=>{
    const attrs = currentFound.node.attrs;
    return {
        currentId: (0, $5lo82.getNodeAiManagedObject)(attrs)?.id,
        localId: currentFound.node.attrs.localId
    };
};
const $8daf2a0ef6c577a0$var$saveAiManagedObject = async ({ cloudId: cloudId, config: config, contentType: contentType, contextObjectId: contextObjectId, contextProduct: contextProduct, currentId: currentId, editorView: editorView, localId: localId })=>{
    if (currentId) return (0, $89DwQ.updateAiManagedObjectWithCache)(editorView, {
        id: currentId,
        config: config
    }, localId, {
        type: 'CLOSE_CONFIG'
    });
    const referenceObject = (0, $e456ffe9b1dc36c6$export$4d80ff8879a0429d)({
        cloudId: cloudId,
        contentType: contentType,
        objectId: contextObjectId,
        product: contextProduct
    });
    if (!referenceObject) return null;
    return (0, $89DwQ.createAiManagedObjectWithCache)(editorView, {
        cloudId: referenceObject.cloudId,
        referenceObjectAri: referenceObject.referenceObjectAri,
        referenceProduct: 'CONFLUENCE',
        status: 'ACTIVE',
        type: 'BLOCK',
        config: config
    }, localId, {
        type: 'CLOSE_CONFIG'
    });
};
const $8daf2a0ef6c577a0$export$430fb711ca8693b9 = ({ aimoId: aimoId, aimoLoadStatus: aimoLoadStatus, cachedAimo: cachedAimo, cloudId: cloudId, configLocalId: configLocalId, contextIdentifierProvider: contextIdentifierProvider, contentType: contentType, editorView: editorView, foundPos: foundPos, isOpen: isOpen, templateConfig: templateConfig })=>{
    const intl = (0, $kSwu1.useIntl)();
    const saveErrorMessage = intl.formatMessage((0, $uia0q.messages).saveError);
    const [isSaving, setIsSaving] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const { executeAiManagedObject: executeAiManagedObject } = (0, $efb488c00d84fa07$export$abcc4eb8db800758)({
        editorView: editorView
    });
    const contextObjectId = contextIdentifierProvider?.objectId;
    const contextProduct = contextIdentifierProvider?.product;
    const { aimoData: aimoData, configurationLoadError: configurationLoadError, handleRetryConfigurationLoad: handleRetryConfigurationLoad, initialConfiguration: initialConfiguration, isLoadingConfiguration: isLoadingConfiguration, setAimoData: setAimoData } = (0, $16ee3f78bb362198$export$31a6a034849cb700)({
        aimoId: aimoId,
        aimoLoadStatus: aimoLoadStatus,
        cachedAimo: cachedAimo,
        configLocalId: configLocalId,
        editorView: editorView,
        foundPos: foundPos,
        isOpen: isOpen,
        templateConfig: templateConfig
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || foundPos === undefined) {
            setError(null);
            setIsSaving(false);
            return;
        }
        if (!aimoId || cachedAimo) setError(null);
    }, [
        aimoId,
        cachedAimo,
        foundPos,
        isOpen
    ]);
    const handleSave = (0, $cozmU.useCallback)(async (config)=>{
        const validation = (0, $b4354e2d9ae7322a$export$f21a0ba102fbd812)(config);
        if (!validation.valid) {
            const validationMessageKey = validation.errors[0]?.code ? $8daf2a0ef6c577a0$var$validationErrorMessageKeys[validation.errors[0].code] : undefined;
            setError(validationMessageKey ? intl.formatMessage((0, $uia0q.messages)[validationMessageKey]) : saveErrorMessage);
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            const currentFound = (0, $4X6m9.findConfiguredAgentManagedExtension)(editorView, configLocalId);
            if (!currentFound) {
                setError(saveErrorMessage);
                setIsSaving(false);
                return;
            }
            const { currentId: currentId, localId: localId } = $8daf2a0ef6c577a0$var$getSaveTarget(currentFound);
            const shouldExecuteAfterSave = (0, $5FjCy.hasExecutableConfigurationChanged)(aimoData?.config, config);
            const aimo = await $8daf2a0ef6c577a0$var$saveAiManagedObject({
                cloudId: cloudId,
                config: config,
                contentType: contentType,
                contextObjectId: contextObjectId,
                contextProduct: contextProduct,
                currentId: currentId,
                editorView: editorView,
                localId: localId
            });
            if (!aimo) {
                setError(saveErrorMessage);
                setIsSaving(false);
                return;
            }
            setAimoData(aimo);
            setIsSaving(false);
            if (!shouldExecuteAfterSave) return;
            const executedAimo = await executeAiManagedObject({
                aimoId: aimo.id,
                localId: localId
            });
            if (executedAimo) setAimoData(executedAimo);
        } catch  {
            setError(saveErrorMessage);
            setIsSaving(false);
        }
    }, [
        aimoData?.config,
        cloudId,
        configLocalId,
        contentType,
        contextObjectId,
        contextProduct,
        editorView,
        executeAiManagedObject,
        intl,
        setAimoData,
        saveErrorMessage
    ]);
    const handleClearError = (0, $cozmU.useCallback)(()=>{
        setError(null);
    }, []);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        setError(null);
        setIsSaving(false);
        (0, $4X6m9.dispatchAgentManagedExtensionMeta)(editorView, {
            type: 'CLOSE_CONFIG'
        });
        editorView.focus();
    }, [
        editorView
    ]);
    return {
        aimoData: aimoData,
        configurationLoadError: configurationLoadError,
        error: error,
        handleCancel: handleCancel,
        handleClearError: handleClearError,
        handleRetryConfigurationLoad: handleRetryConfigurationLoad,
        handleSave: handleSave,
        initialConfiguration: initialConfiguration,
        isLoadingConfiguration: isLoadingConfiguration,
        isSaving: isSaving
    };
};












var $cvhuh = parcelRequire("cvhuh");

const $1daa0ad7b457ca84$export$9ad62d688669e1e4 = ({ api: api, editorView: editorView })=>{
    const agentManagedExtensionState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'agentManagedExtension'
    ], ({ agentManagedExtensionState: agentManagedExtensionState })=>agentManagedExtensionState);
    const isOpen = agentManagedExtensionState?.isConfigOpen ?? false;
    const configLocalId = agentManagedExtensionState?.configLocalId;
    const found = isOpen ? (0, $4X6m9.findConfiguredAgentManagedExtension)(editorView, configLocalId) : null;
    const dom = found ? editorView.nodeDOM(found.pos) : null;
    const blockElement = dom instanceof HTMLElement ? dom : null;
    const foundPos = found?.pos;
    const foundAttrs = found?.node.attrs;
    const aimoId = (0, $5lo82.getNodeAiManagedObject)(foundAttrs)?.id;
    const templateConfig = (0, $5lo82.getNodeTemplateConfig)(foundAttrs);
    const cachedAimo = aimoId ? (0, $cvhuh.getCachedAiManagedObjectFromPluginState)(agentManagedExtensionState, aimoId) : undefined;
    const aimoLoadStatus = (0, $cvhuh.getAiManagedObjectLoadStatusFromPluginState)(agentManagedExtensionState, aimoId);
    return {
        aimoId: aimoId,
        aimoLoadStatus: aimoLoadStatus,
        blockElement: blockElement,
        cachedAimo: cachedAimo,
        configLocalId: configLocalId,
        found: found,
        foundPos: foundPos,
        isOpen: isOpen,
        templateConfig: templateConfig
    };
};








const $4184d9c5bb58980d$var$TOOLBAR_SELECTOR = '[data-testid="editor-floating-toolbar"]';
const $4184d9c5bb58980d$export$73b2aadb6bc56e71 = ({ blockElement: blockElement, isOpen: isOpen })=>{
    const [toolbarElement, setToolbarElement] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            if (toolbarElement) setToolbarElement(null);
            return;
        }
        if (toolbarElement) return;
        const toolbar = (0, $1hQ0e.getDocument)()?.querySelector($4184d9c5bb58980d$var$TOOLBAR_SELECTOR);
        if (toolbar) {
            setToolbarElement(toolbar);
            return;
        }
        const id = requestAnimationFrame(()=>{
            const el = (0, $1hQ0e.getDocument)()?.querySelector($4184d9c5bb58980d$var$TOOLBAR_SELECTOR);
            if (el) setToolbarElement(el);
        });
        return ()=>cancelAnimationFrame(id);
    }, [
        isOpen,
        toolbarElement
    ]);
    return toolbarElement ?? blockElement;
};


const $70d4dc93cc3a85a9$var$POPUP_STYLE = {
    width: 500
};
const $70d4dc93cc3a85a9$var$POPUP_OFFSET = [
    0,
    8
];
const $70d4dc93cc3a85a9$var$selector = (states)=>({
        contextIdentifierProvider: states.contextIdentifierState?.contextIdentifierProvider
    });
const $70d4dc93cc3a85a9$var$ConfigurationPanel = ({ configurationLoadError: configurationLoadError, isLoadingConfiguration: isLoadingConfiguration, onRetryConfigurationLoad: onRetryConfigurationLoad, ...configProps })=>{
    if (isLoadingConfiguration) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1de4b8c5ba7c9b9$export$9ce5063a680c0a10), {
        testId: "agent-managed-extension-configure-panel-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJrqk.AimoConfigurationLoadState), {
        status: "loading",
        testId: "agent-managed-extension-configure-panel-loading-state",
        variant: "panel"
    }));
    if (configurationLoadError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1de4b8c5ba7c9b9$export$9ce5063a680c0a10), {
        testId: "agent-managed-extension-configure-panel-load-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJrqk.AimoConfigurationLoadState), {
        errorMessage: configurationLoadError,
        onRetry: onRetryConfigurationLoad,
        status: "failed",
        testId: "agent-managed-extension-configure-panel-load-error-state",
        variant: "panel"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48777841143a27f5$export$ece65817fe850722), configProps);
};
const $70d4dc93cc3a85a9$export$966c9838aaac668b = ({ api: api, cloudId: cloudId, contentType: contentType, editorView: editorView, mountPoint: mountPoint })=>{
    const intl = (0, $kSwu1.useIntl)();
    const popupContentRef = (0, $cozmU.useRef)(null);
    const configurationAriaLabel = intl.formatMessage((0, $uia0q.messages).configurationAriaLabel);
    const { contextIdentifierProvider: contextIdentifierProvider } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'contextIdentifier'
    ], $70d4dc93cc3a85a9$var$selector);
    const { aimoId: aimoId, aimoLoadStatus: aimoLoadStatus, blockElement: blockElement, cachedAimo: cachedAimo, configLocalId: configLocalId, found: found, foundPos: foundPos, isOpen: isOpen, templateConfig: templateConfig } = (0, $1daa0ad7b457ca84$export$9ad62d688669e1e4)({
        api: api,
        editorView: editorView
    });
    const targetElement = (0, $4184d9c5bb58980d$export$73b2aadb6bc56e71)({
        blockElement: blockElement,
        isOpen: isOpen
    });
    const referenceObject = (0, $e456ffe9b1dc36c6$export$4d80ff8879a0429d)({
        cloudId: cloudId,
        contentType: contentType,
        contextIdentifierProvider: contextIdentifierProvider
    });
    const currentPageSourceUrl = (0, $cozmU.useMemo)(()=>(0, $2f2ffb98bbc84b84$export$895a298bdabf4d43)(), []);
    const smartCardProviderProduct = (0, $f77d5c1ac623e650$export$1989f8c06c32742e)(contextIdentifierProvider?.product);
    const { aimoData: aimoData, configurationLoadError: configurationLoadError, error: error, handleCancel: handleCancel, handleClearError: handleClearError, handleRetryConfigurationLoad: handleRetryConfigurationLoad, handleSave: handleSave, initialConfiguration: initialConfiguration, isLoadingConfiguration: isLoadingConfiguration, isSaving: isSaving } = (0, $8daf2a0ef6c577a0$export$430fb711ca8693b9)({
        aimoId: aimoId,
        aimoLoadStatus: aimoLoadStatus,
        cachedAimo: cachedAimo,
        cloudId: cloudId,
        configLocalId: configLocalId,
        contextIdentifierProvider: contextIdentifierProvider,
        contentType: contentType,
        editorView: editorView,
        foundPos: foundPos,
        isOpen: isOpen,
        templateConfig: templateConfig
    });
    const panelInitialConfiguration = (0, $cozmU.useMemo)(()=>{
        const [source] = aimoData?.config?.sources ?? [];
        const isCurrentPageSource = Boolean(currentPageSourceUrl) && aimoData?.config?.sources?.length === 1 && source?.url === currentPageSourceUrl;
        return isCurrentPageSource ? {
            ...initialConfiguration,
            sourceMode: 'current-page'
        } : initialConfiguration;
    }, [
        aimoData?.config?.sources,
        currentPageSourceUrl,
        initialConfiguration
    ]);
    const showInitialSourceDisclaimer = !aimoId && panelInitialConfiguration.mode === 'configuration' && panelInitialConfiguration.sourceMode === 'current-page' && Boolean(currentPageSourceUrl);
    const shouldUsePopupShortcutGuard = isLoadingConfiguration || Boolean(configurationLoadError);
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || !shouldUsePopupShortcutGuard) return;
        const popupContentElement = popupContentRef.current;
        const ownerWindow = popupContentElement?.ownerDocument.defaultView;
        if (!popupContentElement || !ownerWindow) return;
        const stopShortcutPropagation = (event, shouldPreventDefault = false)=>{
            if (shouldPreventDefault) event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        };
        const handleKeyDown = (event)=>{
            if (!(event.target instanceof ownerWindow.Node) || !popupContentElement.contains(event.target)) return;
            const isCloseShortcut = event.key === 'Escape' || event.key === 'Esc';
            const isSaveShortcut = event.key === 'Enter' && (event.metaKey || event.ctrlKey);
            if (isCloseShortcut) {
                stopShortcutPropagation(event);
                if (!isSaving) handleCancel();
                return;
            }
            if (isSaveShortcut) stopShortcutPropagation(event, true);
        };
        ownerWindow.addEventListener('keydown', handleKeyDown, true);
        return ()=>{
            ownerWindow.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [
        handleCancel,
        isOpen,
        isSaving,
        shouldUsePopupShortcutGuard
    ]);
    if (!isOpen || !found || !targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
        alignX: "center",
        alignY: "bottom",
        target: targetElement,
        mountTo: mountPoint,
        zIndex: 100,
        fitWidth: 500,
        fitHeight: 250,
        preventOverflow: true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- `Popup` accepts only an inline style prop for its outer wrapper
        style: $70d4dc93cc3a85a9$var$POPUP_STYLE,
        offset: $70d4dc93cc3a85a9$var$POPUP_OFFSET,
        ariaLabel: configurationAriaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-no-extension-select": "true",
        ref: popupContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($70d4dc93cc3a85a9$var$ConfigurationPanel, {
        currentPageSourceUrl: currentPageSourceUrl,
        initialConfiguration: panelInitialConfiguration,
        isVisible: isOpen,
        persistedConfig: aimoData?.config,
        onSave: handleSave,
        onCancel: handleCancel,
        onClearError: handleClearError,
        onRetryConfigurationLoad: handleRetryConfigurationLoad,
        configurationLoadError: configurationLoadError,
        isLoadingConfiguration: isLoadingConfiguration,
        isSaving: isSaving,
        error: error,
        aimoData: aimoData,
        cloudId: referenceObject?.cloudId,
        smartCardProviderProduct: smartCardProviderProduct,
        showInitialSourceDisclaimer: showInitialSourceDisclaimer
    })));
};



const $251945f6a0186bdf$export$29e21093a2799ca6 = ({ api: api, config: config })=>{
    const { cloudId: cloudId, contentType: contentType } = config ?? {};
    let currentEditorView;
    return {
        name: 'agentManagedExtension',
        pmPlugins () {
            return [
                {
                    name: 'agentManagedExtension',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $506e91053d3165bc$export$ae829ec7b2625219)({
                            cloudId: cloudId,
                            contentType: contentType,
                            getContextIdentifierProvider: ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        })
                }
            ];
        },
        actions: {
            cacheAiManagedObject: (aiManagedObject, localId)=>{
                api?.core?.actions.execute((0, $1tIRv.cacheAiManagedObject)(aiManagedObject, localId));
            },
            hasAiManagedObject: (localId)=>{
                const found = currentEditorView ? (0, $5lo82.findAgentManagedExtensionByLocalId)(currentEditorView.state, localId) : undefined;
                const attrs = found?.node.attrs;
                return Boolean((0, $5lo82.getNodeAiManagedObject)(attrs));
            },
            openConfig: ()=>{
                api?.core?.actions.execute((0, $1tIRv.openConfig)());
            },
            closeConfig: ()=>{
                api?.core?.actions.execute((0, $1tIRv.closeConfig)());
            },
            regenerate: ({ aimoId: fallbackAimoId, localId: localId })=>{
                const editorView = currentEditorView;
                if (!editorView?.editable) return;
                const found = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, localId) ?? (0, $5lo82.findAgentManagedExtension)(editorView.state);
                if (!found) return;
                const blockLocalId = found.node.attrs.localId || localId;
                const pluginState = (0, $eYo03.pluginKey).getState(editorView.state);
                const executionLifecycleState = blockLocalId ? pluginState?.executionLifecycleByLocalId[blockLocalId]?.state : undefined;
                if ((0, $jHZ78.isExecutingLifecycleState)(executionLifecycleState)) return;
                const aimoId = (0, $5lo82.getNodeAiManagedObject)(found.node.attrs)?.id ?? fallbackAimoId;
                if (!aimoId) return;
                (0, $e65a16941efd8768$export$8235b51c7030883b)({
                    aimoId: aimoId,
                    editorView: editorView,
                    localId: blockLocalId
                });
            },
            toggleConfig: ()=>{
                api?.core?.actions.execute((0, $1tIRv.toggleConfig)());
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint }) {
            if (!editorView) return null;
            currentEditorView = editorView;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70d4dc93cc3a85a9$export$966c9838aaac668b), {
                api: api,
                cloudId: cloudId,
                contentType: contentType,
                editorView: editorView,
                mountPoint: popupsMountPoint
            });
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $eYo03.pluginKey).getState(editorState) ?? undefined;
        }
    };
};


function $5c43a7d481df502f$export$afe0ba724a7b4a9b({ options: options }) {
    return {
        cloudId: options?.cloudId,
        contentType: options?.contentType,
        extensionType: options?.extensionType
    };
}


function $0a6203cde126a92a$export$bfd53895e8497571({}) {
    return {};
}


function $664c41fdd7ad4714$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}


function $d791c4fa106cbed0$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}


function $c1e9c1cdc57d6607$export$a23b3fa66082f163() {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}


function $4048513cd792a4c3$export$af3ae864625d0aa8({ options: options }) {
    return {
        getLinkPath: options.getLinkPath,
        blockLinkHashPrefix: options.blockLinkHashPrefix
    };
}


function $bbb5c0071fd0d2c3$export$817c0e398e6ff750({}) {
    return {
        // rolling out under platform_editor_small_font_size experiment
        allowFontSize: true,
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}


function $8e152632dbd63e07$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}



var $4iudd = parcelRequire("4iudd");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $47a905a618590c5b$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $47a905a618590c5b$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        smartCardContext: options.smartCardContext,
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $47a905a618590c5b$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $4iudd.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}


function $88c029abeda3fcad$export$3f0ff0bcf72f4d98({ options: options }) {
    return {
        appearance: options.editorAppearance
    };
}





function $2b56873a36679f60$export$6e32a592ec823802({}) {
    return {
        allowCodeFolding: (0, $ieeJu.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)
    };
}


function $313d7181ce7b0193$export$74cc43e84bb9c20({ providers: providers }) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false,
        formatCodeProvider: providers.formatCodeProvider
    };
}



var $jj5K7 = parcelRequire("jj5K7");




function $671c4620694faf2e$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: options.__livePage || (0, $ieeJu.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $jj5K7.shouldForceTracking)()
    };
}


function $0b662a7ef413004e$export$8a4106078b67336e({ options: options }) {
    return {
        initialContentMode: options?.initialContentMode ?? 'standard'
    };
}


function $b2170257c320d9ed$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}





function $1d78259b15a5905f$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}


function $5fde522c1f21165b$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}


function $700ff69e56430ded$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}


function $6db45a58f6630574$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}


function $db67c03693a6e77c$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}


function $b7043621d63dbced$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider,
        emojiNodeDataProvider: providers.emojiNodeDataProvider
    };
}


function $27d98ce9e9601a00$export$ed53f0c49fce09d6({ options: options }) {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        allowInteractiveExpand: true,
        __livePage: options.__livePage
    };
}


function $a2d496913e5c42d2$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: options.editorAppearance === 'full-page',
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight,
        getUnsupportedContent: options.getUnsupportedContent
    };
}





function $395b357d0773576f$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $fqVYq.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}


function $332b02334501e969$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}


function $cd12a24f1e639a40$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}


function $664cf89eb1b386cc$export$2a67100cd9c61f05({ options: options }) {
    return options;
}


function $d7249f8d963d1b76$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}





function $62a15d13b773a75f$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $fqVYq.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        toolbarButtons: options.toolbarButtons
    };
}


function $eaf0b74ef5c4c525$export$33fb6c6592b2cd5f({ options: options }) {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: options.editorAppearance
    };
}


function $b4f4f3297fd373d7$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId,
        killSwitchEnabled: options.killSwitchEnabled
    };
}


function $4b10be7247a975ce$export$feaee25faac0c640({ options: options }) {
    return {
        // SECTION: From confluence/next/packages/loom-editor-utils/src/hooks/useLoomPluginOptions.tsx
        renderButton: options.renderButton,
        shouldShowToolbarButton: false
    };
}


// oxlint-disable-next-line @atlassian/no-restricted-imports



const $8e8814d2b5f0a9b3$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


// @ts-ignore - TS1501 Typescript 5.9.2 upgrade
const $06d4fec1f7bc28d7$var$STORAGE_SUPPORTS_REGEX = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
function $06d4fec1f7bc28d7$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            if (!$06d4fec1f7bc28d7$var$STORAGE_SUPPORTS_REGEX.test(text)) return [
                intl.formatMessage((0, $8e8814d2b5f0a9b3$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        createCommentExperience: options.createCommentExperience,
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        allowImageEditing: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true,
        // END SECTION
        mediaViewerExtensions: options.mediaViewerExtensions
    };
}


function $225822b86cf0131d$export$e15342409979aa19({ options: options, providers: providers }) {
    return {
        sanitizePrivateContent: true,
        insertDisplayName: true,
        allowZeroWidthSpaceAfter: true,
        profilecardProvider: providers.profilecardProvider,
        handleMentionsChanged: options.handleMentionsChanged,
        mentionProvider: providers.mentionProvider,
        currentUserId: options.currentUserId,
        enableAgentSectioning: options.enableAgentSectioning,
        showAgentMentionsLabsLozenge: options.showAgentMentionsLabsLozenge,
        getIsRovoPanelOpen: options.getIsRovoPanelOpen,
        onAgentMentionChatClick: options.onAgentMentionChatClick
    };
}


function $d626e708d3bcfbed$export$4677177d82484aef({ options: options }) {
    return options;
}


function $72f855fbf9d3588d$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}


// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $aab17a0cfb66b321$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $aab17a0cfb66b321$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $aab17a0cfb66b321$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}



var $aBPpS = parcelRequire("aBPpS");







// oxlint-disable-next-line @atlassian/no-restricted-imports



const $aa3bf1d9d2c8b4f5$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    placeholderADF: {
        id: "editor-presets-confluence.placeholderADF",
        defaultMessage: "Press <code>space</code> to Ask Rovo or <code>/</code> to insert elements"
    }
});


function $9410fc9bbcb1ad9b$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming');
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        if (shouldShowSpaceShortcut) return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (!options.isAIEnabled) return intl.formatMessage((0, $aa3bf1d9d2c8b4f5$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $aa3bf1d9d2c8b4f5$export$a7357cdd1f0b0168).defaultPlaceholder);
        return intl.formatMessage((0, $aa3bf1d9d2c8b4f5$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (shouldShowSpaceShortcut) return (0, $aBPpS.createADFFromHTML)(intl.formatMessage((0, $aa3bf1d9d2c8b4f5$export$a7357cdd1f0b0168).placeholderADF, {
            code: (parts)=>`<code>${parts}</code>`
        }));
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        isPlaceholderHidden: options.isPlaceholderHidden,
        withEmptyParagraph: (0, $iDrrr.fg)('platform_editor_ai_aifc_streaming'),
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        enableLoadingSpinner: options.enableLoadingSpinner ?? true
    };
}


function $9abf78b29d0e8274$export$8b53e6ddc7cf96b4({}) {
    return {};
}


function $b54201709728ab61$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $cd26f95ed02dae47$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}


function $62c3924b801d068d$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}





function $0b6a84a6fb3f6820$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: options.__livePage || (0, $ieeJu.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
// END SECTION
}


function $bd21fa536fead465$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}


function $eba592b39dcbc632$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider,
        disablePin: options.disablePin
    };
}


function $015f0f51659a521e$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colorScheme: options.colorScheme
    };
}


function $a5e830e2b581039f$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}


function $ab3cdd052a87802a$export$3612ff8a6b94af71({}) {
    return undefined;
}


function $8ce193c5619bba18$export$b4fe80869e994c19({ options: options }) {
    if (!options) return undefined;
    const { enableSourceCreation: enableSourceCreation, syncedBlockRenderer: syncedBlockRenderer, syncBlockDataProvider: syncBlockDataProvider } = options;
    return {
        enableSourceCreation: enableSourceCreation,
        syncedBlockRenderer: syncedBlockRenderer,
        syncBlockDataProvider: syncBlockDataProvider
    };
}








function $eaa930f4c47ddcec$export$9868b594778cf535({ options: options }) {
    return {
        __livePage: (0, $iDrrr.fg)('platform_editor_table_auto_convert_fix') ? options.__livePage : undefined,
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
                tableWithFixedColumnWidthsOption: (0, $iDrrr.fg)('platform_editor_table_fixed_column_width_prop') ? undefined : true,
                // END SECTION
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $fqVYq.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false,
        allowFixedColumnWidthOption: (0, $iDrrr.fg)('platform_editor_table_fixed_column_width_prop') ? true : undefined
    };
}


function $74c766b6ca7229a5$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}


function $4d4318fd3173e767$export$a4eedeb4455295f2({}) {
    return true;
}


function $09e6818cd7daa634$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}


function $1e637ecbadbf99d5$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}


function $2120d7fa990d798f$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $bf9aeef666b631ab$export$f8fa1184f7aaa2b3({ options: options }) {
    return {
        ButtonWrapper: options?.ButtonWrapper,
        showOnToolbar: true
    };
}


function $278f5befe3e0e44e$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}


function $68c53a55a3b4e7fc$export$abdb0d09187eec69({ providers: providers, options: options }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        // If initialToolbarDockingPosition is set, use it to override any saved user preference
        initialUserPreferences: options.initialToolbarDockingPosition ? {
            toolbarDockingPosition: options.initialToolbarDockingPosition
        } : undefined
    };
}


function $0c7bf4d42379e519$export$e26bb6e41a7de602(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the ConfluenceFullPageBasePresetOptions.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    // @ts-ignore - Preset builder cannot infer mutually exclusive registry insertion points.
    return new (0, $a31lS.EditorPresetBuilder)().maybeAdd([
        (0, $e1OCV.limitedModePlugin),
        (0, $b4f4f3297fd373d7$export$d384a797e800fdbe)({
            options: pluginOptions.limitedMode
        })
    ], !pluginOptions.limitedMode.killSwitchEnabled).add([
        (0, $h0KOi.featureFlagsPlugin),
        (0, $395b357d0773576f$export$3bff061e5229a7)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $1CaNG.analyticsPlugin),
        (0, $0a6203cde126a92a$export$bfd53895e8497571)({
            options: pluginOptions.analytics
        })
    ]).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        (0, $aab17a0cfb66b321$export$6b1ad42d09c74964)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $lDJPY.contextIdentifierPlugin),
        (0, $b2170257c320d9ed$export$2c26eb5ff90afcfd)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $7Upsh.default),
        (0, $c1e9c1cdc57d6607$export$a23b3fa66082f163)()
    ]).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        (0, $68c53a55a3b4e7fc$export$abdb0d09187eec69)({
            providers: providers,
            options: pluginOptions.userPreferencesPlugin
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        (0, $278f5befe3e0e44e$export$612ea2d32c3e4c96)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $6WRJZ.default)).add([
        (0, $hBGxo.primaryToolbarPlugin),
        (0, $b54201709728ab61$export$44901d053a58e418)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd((0, $ftAOO.uiControlRegistryPlugin), (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)).maybeAdd([
        (0, $4gNvG.toolbarPlugin),
        (0, $2120d7fa990d798f$export$2d206ce8fa0c3d37)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).maybeAdd([
        (0, $jLogi.blockMenuPlugin),
        (0, $4048513cd792a4c3$export$af3ae864625d0aa8)({
            options: pluginOptions.blockMenu
        })
    ], (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)).add((0, $abOD2.undoRedoPlugin)).add([
        (0, $fKdaf.blockTypePlugin),
        (0, $bbb5c0071fd0d2c3$export$817c0e398e6ff750)({
            options: pluginOptions.blockType
        })
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        (0, $eba592b39dcbc632$export$bc6dcb3c2a6112e1)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $3HCXM.hyperlinkPlugin),
        (0, $d7249f8d963d1b76$export$ab9ae3984d5aef33)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        (0, $09e6818cd7daa634$export$cb883a3a9320698e)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        (0, $cd26f95ed02dae47$export$26cff1f2fe9f781b)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        (0, $9410fc9bbcb1ad9b$export$c6841f879d4c8aef)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add([
        (0, $e273U.editorDisabledPlugin),
        (0, $6db45a58f6630574$export$de47eee62065048e)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $ljXAk.submitEditorPlugin),
        (0, $ab3cdd052a87802a$export$3612ff8a6b94af71)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $1ZhW4.copyButtonPlugin)).maybeAdd((0, $5tMpU.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $jT02V.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $fb3SZ.selectionPlugin),
        (0, $bd21fa536fead465$export$ddc2936355c1da67)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $bkj40.default),
        (0, $313d7181ce7b0193$export$74cc43e84bb9c20)({
            providers: providers
        })
    ]).add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).add([
        (0, $fLS6B.breakoutPlugin),
        (0, $8e152632dbd63e07$export$3be6b735d5cbc3e6)({
            options: pluginOptions.breakout
        })
    ]).add((0, $dYbu7.alignmentPlugin)).add([
        (0, $gkbos.textColorPlugin),
        (0, $4d4318fd3173e767$export$a4eedeb4455295f2)({
            options: pluginOptions.textColor
        })
    ]).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin)).add([
        (0, $k8SUN.expandPlugin),
        (0, $27d98ce9e9601a00$export$ed53f0c49fce09d6)({
            options: pluginOptions.expand
        })
    ]).add((0, $eHllO.guidelinePlugin)).add([
        (0, $iVGec.gridPlugin),
        (0, $cd12a24f1e639a40$export$c66d0d1462a05bd)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $gLxaI.annotationPlugin),
        (0, $664c41fdd7ad4714$export$b3e029fd31f94f55)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $5bzSg.mediaPlugin),
        (0, $06d4fec1f7bc28d7$export$484123ae56f6fbd9)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $7gEjc.mediaInsertPlugin)).add((0, $cud1R.default)).add([
        (0, $2ZvWx.mentionsPlugin),
        (0, $225822b86cf0131d$export$e15342409979aa19)({
            options: pluginOptions.mentions,
            providers: providers
        })
    ]).add([
        (0, $k7vUa.emojiPlugin),
        (0, $b7043621d63dbced$export$7adcaf18ca5c72c4)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $gUZEQ.default),
        (0, $eaa930f4c47ddcec$export$9868b594778cf535)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        (0, $74c766b6ca7229a5$export$1d23e03c42bfc1ac)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $laiso.helpDialogPlugin),
        (0, $664cf89eb1b386cc$export$2a67100cd9c61f05)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: false
            }
        })
    ]).add([
        (0, $gh55E.collabEditPlugin),
        (0, $671c4620694faf2e$export$c1ebe19806bc53b1)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ]).add([
        (0, $jeuMk.default),
        (0, $72f855fbf9d3588d$export$c18e432f323b002e)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $l5MIu.contextPanelPlugin),
        (0, $1d78259b15a5905f$export$48a60d81b6bb28e3)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $3gmKQ.extensionPlugin),
        (0, $a2d496913e5c42d2$export$c18b9102cd0790c9)({
            options: pluginOptions.extension
        })
    ]).maybeAdd([
        (0, $251945f6a0186bdf$export$29e21093a2799ca6),
        (0, $5c43a7d481df502f$export$afe0ba724a7b4a9b)({
            options: pluginOptions.agentManagedExtension
        })
    ], (0, $anBbz.expValEqualsNoExposure)('agent-managed_blocks_mvp', 'isEnabled', true)).add([
        (0, $4y9hw.default),
        (0, $700ff69e56430ded$export$5598bb2314a53fa8)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $1K7sQ.default),
        (0, $9abf78b29d0e8274$export$8b53e6ddc7cf96b4)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $4exuQ.layoutPlugin),
        (0, $eaf0b74ef5c4c525$export$33fb6c6592b2cd5f)({
            options: pluginOptions.layout
        })
    ]).maybeAdd(// Register uiControlRegistry before cardPlugin so card can register paste menu components at init.
    // @ts-expect-error - Preserve paste registry order; mutually exclusive with layout insertion.
    (0, $ftAOO.uiControlRegistryPlugin), (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) && !((0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true))).add([
        (0, $40ukF.cardPlugin),
        (0, $47a905a618590c5b$export$514131654bb897e2)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $f2WDp.customAutoformatPlugin),
        (0, $5fde522c1f21165b$export$f18d68682e981a91)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $drevR.statusPlugin),
        (0, $a5e830e2b581039f$export$9d286ea8d36eb908)({
            options: pluginOptions.status
        })
    ]).maybeAdd([
        (0, $fxjEF.syncedBlockPlugin),
        (0, $8ce193c5619bba18$export$b4fe80869e994c19)({
            options: pluginOptions.syncedBlock
        })
    ], !!pluginOptions.syncedBlock && (0, $fqVYq.editorExperiment)('platform_synced_block', true)).add((0, $HGu9Y.indentationPlugin)).add((0, $3VDvd.scrollIntoViewPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        (0, $1e637ecbadbf99d5$export$bd221c449644c740)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $5HQgD.insertBlockPlugin),
        (0, $62a15d13b773a75f$export$1e11b615e9dc119e)({
            options: pluginOptions.insertBlock
        })
    ]).add([
        (0, $60Pfj.avatarGroupPlugin),
        (0, $d791c4fa106cbed0$export$eeaea850bc5c5797)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dGnqc.findReplacePlugin),
        (0, $332b02334501e969$export$d9e183f0607e1b5d)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $9ki8I.borderPlugin)).add((0, $7iL2d.fragmentPlugin)).add([
        (0, $4Bdub.pasteOptionsToolbarPlugin),
        {
            usePopupBasedPasteActionsMenu: false
        }
    ]).maybeAdd([
        (0, $kaUwk.codeBidiWarningPlugin),
        (0, $88c029abeda3fcad$export$3f0ff0bcf72f4d98)({
            options: pluginOptions.codeBidiWarning
        })
    ], !(0, $ieeJu.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)).maybeAdd([
        (0, $jdplc.loomPlugin),
        (0, $4b10be7247a975ce$export$feaee25faac0c640)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $iFdOW.editorViewModePlugin),
        (0, $db67c03693a6e77c$export$36a79e2b5698697a)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $gXOst.editorViewModeEffectsPlugin)).add([
        (0, $3RHCI.selectionMarkerPlugin),
        (0, $0b6a84a6fb3f6820$export$197b78e13e8987d2)({
            options: pluginOptions.selectionMarker
        })
    ]).add([
        (0, $dHFAY.blockControlsPlugin),
        {
            rightSideControlsEnabled: (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg') && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)
        }
    ]).add((0, $1U7Jq.highlightPlugin)).maybeAdd((0, $e4SgJ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $4OMM6.metricsPlugin),
        (0, $d626e708d3bcfbed$export$4677177d82484aef)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).add([
        (0, $82I6D.contentFormatPlugin),
        (0, $0b662a7ef413004e$export$8a4106078b67336e)({
            options: pluginOptions.contentFormat
        })
    ]).maybeAdd([
        (0, $51qBv.codeBlockAdvancedPlugin),
        (0, $2b56873a36679f60$export$6e32a592ec823802)({
            options: pluginOptions.codeBlockAdvanced
        })
    ], enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $dvcAA.selectionExtensionPlugin),
        (0, $62c3924b801d068d$export$222c5aa4c9fb0805)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).add((0, $4lpx1.userIntentPlugin)).maybeAdd([
        (0, $5JZoZ.showDiffPlugin),
        (0, $015f0f51659a521e$export$5c1f265f89d46b24)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd([
        (0, $3Q36X.trackChangesPlugin),
        (0, $bf9aeef666b631ab$export$f8fa1184f7aaa2b3)({
            options: pluginOptions.trackChanges
        })
    ], enabledOptionalPlugins.trackChanges).maybeAdd((0, $eEseG.localIdPlugin), enabledOptionalPlugins.localId);
}















var $93ZX6 = parcelRequire("93ZX6");



var $irqyl = parcelRequire("irqyl");


var $7Krw2 = parcelRequire("7Krw2");


var $1sOYw = parcelRequire("1sOYw");


var $7pyfy = parcelRequire("7pyfy");


var $axCbT = parcelRequire("axCbT");


var $bw7eK = parcelRequire("bw7eK");

function $7f2918938761da72$export$afe0ba724a7b4a9b({ options: options }) {
    return {
        cloudId: options?.cloudId,
        contentType: options?.contentType,
        extensionType: options?.extensionType
    };
}



var $83dR4 = parcelRequire("83dR4");


var $2H7bJ = parcelRequire("2H7bJ");


var $b0PJa = parcelRequire("b0PJa");


var $emOXs = parcelRequire("emOXs");


var $b11Eg = parcelRequire("b11Eg");


var $hYVYG = parcelRequire("hYVYG");


var $458fo = parcelRequire("458fo");


var $gGfnN = parcelRequire("gGfnN");


var $2j2nv = parcelRequire("2j2nv");


var $37pZs = parcelRequire("37pZs");


var $ccSax = parcelRequire("ccSax");


var $21YtE = parcelRequire("21YtE");


var $j9XhP = parcelRequire("j9XhP");




function $707a36a11edfd222$export$6e32a592ec823802({}) {
    return {
        allowCodeFolding: (0, $ieeJu.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)
    };
}



var $1aAo1 = parcelRequire("1aAo1");


var $6HTz8 = parcelRequire("6HTz8");


var $UzlxI = parcelRequire("UzlxI");

function $890834bce2354317$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}



var $lMcW5 = parcelRequire("lMcW5");

function $f5b5e9d171a860b2$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}


function $6855fb35daf4763d$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}



var $5gRoW = parcelRequire("5gRoW");


var $dUIcZ = parcelRequire("dUIcZ");

function $5ad97d995a77aeaf$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider,
        emojiNodeDataProvider: providers.emojiNodeDataProvider
    };
}



var $n7lIn = parcelRequire("n7lIn");

function $c57e288d197596a1$export$ed53f0c49fce09d6({ options: options }) {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        allowInteractiveExpand: true,
        __livePage: options.__livePage
    };
}



var $1oaTe = parcelRequire("1oaTe");


var $k1Nk4 = parcelRequire("k1Nk4");

function $b2fffa8b496b4174$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}


function $792aff8d44843c51$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}



var $6fxhr = parcelRequire("6fxhr");


var $3psuc = parcelRequire("3psuc");


var $fqvyt = parcelRequire("fqvyt");

function $60ee4daa107e5247$export$33fb6c6592b2cd5f({ options: options }) {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: options.editorAppearance
    };
}



var $19EZx = parcelRequire("19EZx");

function $27b84a2be7eeda5a$export$feaee25faac0c640({ options: options }) {
    return {
        // SECTION: From confluence/next/packages/loom-editor-utils/src/hooks/useLoomPluginOptions.tsx
        renderButton: options.renderButton,
        shouldShowToolbarButton: false
    };
}



var $7OeAC = parcelRequire("7OeAC");

function $2e21c853d1d9522a$export$e15342409979aa19({ options: options, providers: providers }) {
    return {
        sanitizePrivateContent: true,
        insertDisplayName: true,
        allowZeroWidthSpaceAfter: true,
        profilecardProvider: providers.profilecardProvider,
        handleMentionsChanged: options.handleMentionsChanged,
        mentionProvider: providers.mentionProvider,
        currentUserId: options.currentUserId,
        enableAgentSectioning: options.enableAgentSectioning,
        showAgentMentionsLabsLozenge: options.showAgentMentionsLabsLozenge,
        getIsRovoPanelOpen: options.getIsRovoPanelOpen,
        onAgentMentionChatClick: options.onAgentMentionChatClick
    };
}



var $18rHt = parcelRequire("18rHt");

function $66bc09b9522b61c7$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}


function $53a3fbd3b1d928c8$export$b45c01eec1548cb5({ options: options, usePopupBasedPasteActionsMenuDefault: usePopupBasedPasteActionsMenuDefault }) {
    return {
        pasteMenuButtonsFactory: options?.pasteMenuButtonsFactory,
        usePopupBasedPasteActionsMenu: options?.usePopupBasedPasteActionsMenu ?? usePopupBasedPasteActionsMenuDefault
    };
}



var $aMwfi = parcelRequire("aMwfi");


var $bslVh = parcelRequire("bslVh");

function $736a97513041350f$export$8b53e6ddc7cf96b4({}) {
    return {};
}



var $78oCu = parcelRequire("78oCu");


var $3rW2U = parcelRequire("3rW2U");


var $8o1oU = parcelRequire("8o1oU");


var $1JkrY = parcelRequire("1JkrY");


var $gLRz8 = parcelRequire("gLRz8");


var $5S8Qw = parcelRequire("5S8Qw");


var $1cNjj = parcelRequire("1cNjj");


var $9ph8N = parcelRequire("9ph8N");

function $70ac0d47d17259dc$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}



var $4C8JA = parcelRequire("4C8JA");

function $060059217b830d59$export$b4fe80869e994c19({ options: options }) {
    if (!options) return undefined;
    const { __livePage: __livePage, enableSourceCreation: enableSourceCreation, syncedBlockRenderer: syncedBlockRenderer, syncBlockDataProvider: syncBlockDataProvider } = options;
    return {
        __livePage: __livePage,
        enableSourceCreation: enableSourceCreation,
        syncedBlockRenderer: syncedBlockRenderer,
        syncBlockDataProvider: syncBlockDataProvider
    };
}



var $cySgy = parcelRequire("cySgy");


var $crhNi = parcelRequire("crhNi");

function $5aa6de6893b84f02$export$a4eedeb4455295f2({}) {
    return true;
}



var $h9jUa = parcelRequire("h9jUa");

function $f1f5314b39093111$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}



var $a5Ohw = parcelRequire("a5Ohw");

function $d5c7d864e0b53e75$export$f8fa1184f7aaa2b3({ options: options }) {
    return {
        ButtonWrapper: options?.ButtonWrapper,
        showOnToolbar: true
    };
}



var $7cvtX = parcelRequire("7cvtX");


var $d1OC7 = parcelRequire("d1OC7");

function $cf703a3a6f52deb9$var$fullPagePresetLegacy(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    // @ts-ignore - Preset builder cannot infer mutually exclusive registry insertion points.
    return new (0, $a31lS.EditorPresetBuilder)().maybeAdd([
        (0, $e1OCV.limitedModePlugin),
        (0, $19EZx.limitedModePluginOptions)({
            options: pluginOptions.limitedMode
        })
    ], !pluginOptions.limitedMode.killSwitchEnabled).add([
        (0, $h0KOi.featureFlagsPlugin),
        (0, $k1Nk4.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $1CaNG.analyticsPlugin),
        (0, $hYVYG.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        (0, $aMwfi.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $lDJPY.contextIdentifierPlugin),
        (0, $890834bce2354317$export$2c26eb5ff90afcfd)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $7Upsh.default),
        (0, $2j2nv.basePluginOptions)()
    ]).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        (0, $d1OC7.userPreferencesPluginOptions)({
            providers: providers,
            options: pluginOptions.userPreferencesPlugin
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        (0, $7cvtX.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $6WRJZ.default)).add([
        (0, $hBGxo.primaryToolbarPlugin),
        (0, $78oCu.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd((0, $ftAOO.uiControlRegistryPlugin), (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)).maybeAdd((0, $4lpx1.userIntentPlugin), (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)).maybeAdd([
        (0, $4gNvG.toolbarPlugin),
        (0, $a5Ohw.toolbarPluginOptions)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).maybeAdd([
        (0, $jLogi.blockMenuPlugin),
        {
            getLinkPath: pluginOptions.blockMenu?.getLinkPath,
            blockLinkHashPrefix: pluginOptions.blockMenu?.blockLinkHashPrefix
        }
    ], (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)).add((0, $abOD2.undoRedoPlugin)).add([
        (0, $fKdaf.blockTypePlugin),
        (0, $37pZs.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        (0, $1cNjj.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $3HCXM.hyperlinkPlugin),
        (0, $3psuc.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        (0, $h9jUa.textFormattingPluginOptions)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        (0, $3rW2U.quickInsertPluginOptions)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        (0, $bslVh.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add([
        (0, $e273U.editorDisabledPlugin),
        (0, $5gRoW.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $ljXAk.submitEditorPlugin),
        (0, $4C8JA.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $1ZhW4.copyButtonPlugin)).maybeAdd((0, $5tMpU.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $jT02V.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $fb3SZ.selectionPlugin),
        (0, $5S8Qw.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $bkj40.default),
        (0, $1aAo1.codeBlockPluginOptions)({
            providers: providers
        })
    ]).add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).add([
        (0, $fLS6B.breakoutPlugin),
        (0, $ccSax.breakoutPluginOptions)({
            options: pluginOptions.breakout
        })
    ]).add((0, $dYbu7.alignmentPlugin)).add([
        (0, $gkbos.textColorPlugin),
        (0, $5aa6de6893b84f02$export$a4eedeb4455295f2)({
            options: pluginOptions.textColor
        })
    ]).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin)).add([
        (0, $k8SUN.expandPlugin),
        (0, $c57e288d197596a1$export$ed53f0c49fce09d6)({
            options: pluginOptions.expand
        })
    ]).add((0, $eHllO.guidelinePlugin)).add([
        (0, $iVGec.gridPlugin),
        (0, $792aff8d44843c51$export$c66d0d1462a05bd)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $gLxaI.annotationPlugin),
        (0, $458fo.annotationPluginOptions)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $5bzSg.mediaPlugin),
        (0, $7OeAC.mediaPluginOptions)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $7gEjc.mediaInsertPlugin)).maybeAdd([
        (0, $1sOYw.aiImageGenerationPlugin),
        (0, $2H7bJ.aiImageGenerationPluginOptions)({
            options: pluginOptions.aiImageGeneration
        })
    ], enabledOptionalPlugins.aiImageGeneration).add((0, $cud1R.default)).add([
        (0, $2ZvWx.mentionsPlugin),
        (0, $2e21c853d1d9522a$export$e15342409979aa19)({
            options: pluginOptions.mentions,
            providers: providers
        })
    ]).add([
        (0, $k7vUa.emojiPlugin),
        (0, $5ad97d995a77aeaf$export$7adcaf18ca5c72c4)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $gUZEQ.default),
        (0, $cySgy.tablePluginOptions)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        (0, $crhNi.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $laiso.helpDialogPlugin),
        (0, $6fxhr.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: enabledOptionalPlugins.aiExperience
            }
        })
    ]).maybeAdd([
        (0, $gh55E.collabEditPlugin),
        (0, $6HTz8.collabEditPluginOptions)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ], Boolean(pluginOptions.collabEdit.collabEdit)).add([
        (0, $jeuMk.default),
        (0, $66bc09b9522b61c7$export$c18e432f323b002e)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $l5MIu.contextPanelPlugin),
        (0, $lMcW5.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $3gmKQ.extensionPlugin),
        (0, $1oaTe.extensionPluginOptions)({
            options: pluginOptions.extension
        })
    ]).maybeAdd([
        (0, $251945f6a0186bdf$export$29e21093a2799ca6),
        (0, $7f2918938761da72$export$afe0ba724a7b4a9b)({
            options: pluginOptions.agentManagedExtension
        })
    ], (0, $anBbz.expValEqualsNoExposure)('agent-managed_blocks_mvp', 'isEnabled', true)).add([
        (0, $4y9hw.default),
        (0, $6855fb35daf4763d$export$5598bb2314a53fa8)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $1K7sQ.default),
        (0, $736a97513041350f$export$8b53e6ddc7cf96b4)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $4exuQ.layoutPlugin),
        (0, $60ee4daa107e5247$export$33fb6c6592b2cd5f)({
            options: pluginOptions.layout
        })
    ]).maybeAdd(// Register uiControlRegistry before cardPlugin so card can register paste menu components at init.
    // @ts-expect-error - Mutually exclusive with the earlier layout experiment insertion.
    (0, $ftAOO.uiControlRegistryPlugin), (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) && !((0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true))).add([
        (0, $40ukF.cardPlugin),
        (0, $21YtE.cardPluginOptions)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $f2WDp.customAutoformatPlugin),
        (0, $f5b5e9d171a860b2$export$f18d68682e981a91)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $drevR.statusPlugin),
        (0, $70ac0d47d17259dc$export$9d286ea8d36eb908)({
            options: pluginOptions.status
        })
    ]).maybeAdd([
        (0, $fxjEF.syncedBlockPlugin),
        (0, $060059217b830d59$export$b4fe80869e994c19)({
            options: pluginOptions.syncedBlock
        })
    ], !!pluginOptions.syncedBlock && (0, $fqVYq.editorExperiment)('platform_synced_block', true)).add((0, $HGu9Y.indentationPlugin)).add((0, $3VDvd.scrollIntoViewPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        (0, $f1f5314b39093111$export$bd221c449644c740)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $5HQgD.insertBlockPlugin),
        (0, $fqvyt.insertBlockPluginOptions)({
            options: pluginOptions.insertBlock
        })
    ]).add([
        (0, $60Pfj.avatarGroupPlugin),
        (0, $gGfnN.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dGnqc.findReplacePlugin),
        (0, $b2fffa8b496b4174$export$d9e183f0607e1b5d)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $9ki8I.borderPlugin)).add((0, $7iL2d.fragmentPlugin)).add([
        (0, $4Bdub.pasteOptionsToolbarPlugin),
        (0, $53a3fbd3b1d928c8$export$b45c01eec1548cb5)({
            options: pluginOptions.pasteOptionsToolbar,
            usePopupBasedPasteActionsMenuDefault: enabledOptionalPlugins.aiExperience && pluginOptions.ai?.isInDocumentStreamingEnabled
        })
    ]).maybeAdd([
        (0, $kaUwk.codeBidiWarningPlugin),
        (0, $j9XhP.codeBidiWarningPluginOptions)({
            options: pluginOptions.codeBidiWarning
        })
    ], !(0, $ieeJu.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true))// below plugins moved from legacy preset
    .maybeAdd([
        (0, $bw7eK.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $8o1oU.referentialityPluginOptions)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality).maybeAdd([
        (0, $jdplc.loomPlugin),
        (0, $27b84a2be7eeda5a$export$feaee25faac0c640)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $iFdOW.editorViewModePlugin),
        (0, $dUIcZ.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $gXOst.editorViewModeEffectsPlugin))// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $7Krw2.aiDefinitionsPlugin),
        (0, $83dR4.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $irqyl.aiPlugin),
        (0, $b0PJa.aiPluginOptions)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience).add([
        (0, $3RHCI.selectionMarkerPlugin),
        (0, $gLRz8.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).add([
        (0, $dHFAY.blockControlsPlugin),
        {
            rightSideControlsEnabled: (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg') && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)
        }
    ]).add((0, $1U7Jq.highlightPlugin)).add([
        (0, $47YIB.engagementPlatformPlugin),
        (0, $n7lIn.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $e4SgJ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $4OMM6.metricsPlugin),
        (0, $18rHt.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).add([
        (0, $82I6D.contentFormatPlugin),
        (0, $UzlxI.contentFormatPluginOptions)({
            options: pluginOptions.contentFormat
        })
    ]).maybeAdd([
        (0, $51qBv.codeBlockAdvancedPlugin),
        (0, $707a36a11edfd222$export$6e32a592ec823802)({
            options: pluginOptions.codeBlockAdvanced
        })
    ], enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $dvcAA.selectionExtensionPlugin),
        (0, $1JkrY.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).maybeAdd(// @ts-expect-error - Mutually exclusive with the earlier table menu updates experiment insertion.
    (0, $4lpx1.userIntentPlugin), !((0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true))).maybeAdd([
        (0, $5JZoZ.showDiffPlugin),
        (0, $9ph8N.showDiffPluginOptions)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd([
        (0, $3Q36X.trackChangesPlugin),
        (0, $d5c7d864e0b53e75$export$f8fa1184f7aaa2b3)({
            options: pluginOptions.trackChanges
        })
    ], enabledOptionalPlugins.trackChanges).maybeAdd((0, $eEseG.localIdPlugin), enabledOptionalPlugins.localId).maybeAdd([
        (0, $7pyfy.aiStreamingOrchestratorPlugin),
        (0, $emOXs.aiStreamingOrchestratorPluginOptions)({
            options: pluginOptions.aiStreamingOrchestrator
        })
    ], enabledOptionalPlugins.aiStreamingOrchestrator).maybeAdd((0, $93ZX6.aiSpeechToTextPlugin), enabledOptionalPlugins.aiSpeechToText).maybeAdd([
        (0, $axCbT.aiSuggestionsPlugin),
        (0, $b11Eg.aiSuggestionsOptions)({
            options: pluginOptions.aiSuggestions
        })
    ], enabledOptionalPlugins.aiSuggestions);
}
const $cf703a3a6f52deb9$var$fullPagePresetNext = (props)=>{
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return (0, $0c7bf4d42379e519$export$e26bb6e41a7de602)({
        intl: intl,
        providers: providers,
        enabledOptionalPlugins: enabledOptionalPlugins,
        pluginOptions: pluginOptions
    }).maybeAdd([
        (0, $1sOYw.aiImageGenerationPlugin),
        (0, $2H7bJ.aiImageGenerationPluginOptions)({
            options: pluginOptions.aiImageGeneration
        })
    ], enabledOptionalPlugins.aiImageGeneration)// below plugins moved from legacy preset
    .maybeAdd([
        (0, $bw7eK.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $8o1oU.referentialityPluginOptions)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality)// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $7Krw2.aiDefinitionsPlugin),
        (0, $83dR4.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $irqyl.aiPlugin),
        (0, $b0PJa.aiPluginOptions)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience).add([
        (0, $47YIB.engagementPlatformPlugin),
        (0, $n7lIn.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd([
        (0, $7pyfy.aiStreamingOrchestratorPlugin),
        (0, $emOXs.aiStreamingOrchestratorPluginOptions)({
            options: pluginOptions.aiStreamingOrchestrator
        })
    ], enabledOptionalPlugins.aiStreamingOrchestrator).maybeAdd((0, $93ZX6.aiSpeechToTextPlugin), enabledOptionalPlugins.aiSpeechToText).maybeAdd([
        (0, $axCbT.aiSuggestionsPlugin),
        (0, $b11Eg.aiSuggestionsOptions)({
            options: pluginOptions.aiSuggestions
        })
    ], enabledOptionalPlugins.aiSuggestions);
};
function $cf703a3a6f52deb9$export$9f1bd789d5e1fd40(props) {
    return (0, $ieeJu.expValEquals)('platform_editor_confluence_base_preset', 'isEnabled', true) ? $cf703a3a6f52deb9$var$fullPagePresetNext(props) : $cf703a3a6f52deb9$var$fullPagePresetLegacy(props);
}



var $bveWD = parcelRequire("bveWD");


var $9ta51 = parcelRequire("9ta51");

/**
 * EDITOR-6558: Denylist of toolbar component `key` strings that should be
 * hidden when the editor is in Markdown Mode.
 *
 * The strings here come from `@atlaskit/editor-common/toolbar/keys`, where
 * each plugin's toolbar registration uses a stable key constant. Anything
 * matching one of these keys is filtered out by `toolbarPlugin`'s
 * `componentFilter` before it reaches the registry, so the buttons never
 * appear (regardless of whether the toolbar is pinned or floating).
 *
 * The list is the toolbar-component-flavoured equivalent of
 * `MARKDOWN_COMPATIBLE_TOOLBAR_ITEM_NAMES` (which targets the `+` insert
 * block specifically). Entries are conservative — only marks/nodes with no
 * GFM round-trip are excluded. Marks like `bold` / `italic` / `code` /
 * `strike` are intentionally NOT in the list because they have a clean GFM
 * representation.
 *
 * This is a denylist (not an allowlist) because toolbar components are
 * registered by ~17 different plugins with hundreds of stable keys; an
 * allowlist would silently break unrelated functionality (selection
 * toolbar, table toolbar, AI floating toolbar, etc.) the moment we miss
 * a key.
 */ const $9524c0a1023ddde6$export$a49253e1b6a4f67a = [
    // --- Visual marks with no GFM equivalent ---
    // Text colour & highlight (lossy on round-trip)
    'text-color-highlight-group',
    'text-color-highlight-menu',
    'text-color-highlight-menu-section',
    'text-color-menu-item',
    'highlight-menu-item',
    // Underline / sub / super (GFM strict mode doesn't include these)
    'underline-button-group',
    'underline-button',
    'underline-menu-item',
    'subscript-menu-item',
    'superscript-menu-item',
    // Alignment (GFM has no inline alignment marker)
    'alignment-group',
    'alignment-menu',
    'alignment-menu-section',
    // Indentation as a mark (lists themselves are still supported)
    // Note: list buttons themselves remain — only the indentation-as-mark
    // menu item is removed. We keep the broader lists-indentation group
    // because it carries the bulk of list functionality.
    // --- Inline / block nodes with no GFM equivalent ---
    'mention-group',
    'mention-button',
    'emoji-group',
    'emoji-button',
    'layout-group',
    'layout-button',
    // Note: `media-group` and `media-button` were previously blocked because
    // `mediaSingle`/`media` didn't survive the markdown round-trip. EDITOR-6636
    // fixed this: external media serialises to `![alt](url)` and file media
    // serialises to a Confluence tenant proxy URL, both losslessly parseable
    // back to `mediaSingle > media`. These keys are intentionally NOT in the
    // denylist any more so the media toolbar button is visible in markdown mode.
    // Synced blocks — Atlassian-cloud-only block reuse mechanism with no
    // representation in markdown.
    'synced-block-group',
    'synced-block-button',
    'synced-block-section'
];
const $9524c0a1023ddde6$export$35401f2d7ef9b34b = new Set($9524c0a1023ddde6$export$a49253e1b6a4f67a);
const $9524c0a1023ddde6$export$567bd3c3a1a1ead7 = (component)=>{
    return !$9524c0a1023ddde6$export$35401f2d7ef9b34b.has(component.key);
};

/**
 * EDITOR-6558: Allowlist of `MenuItem.value.name` strings that the main
 * editor toolbar should expose when the editor is in Markdown Mode.
 *
 * The strings here come from `editor-plugin-insert-block`'s
 * `ui/ToolbarInsertBlock/item.tsx`, where each item factory hard-codes a
 * `name`. Anything not on this allowlist is hidden from the toolbar
 * (button row + overflow dropdown) while Markdown Mode is active.
 *
 * The list is the toolbar-flavoured equivalent of
 * `MARKDOWN_COMPATIBLE_QUICK_INSERT_ITEM_IDS`. Entries are intentionally
 * kept minimal — only nodes/marks that survive a clean GFM round-trip via
 * `@atlassian/mdast-util-from-pm` are included.
 *
 * If you add a new mdast handler that lets a previously-excluded node
 * round-trip cleanly, add the matching name here so the toolbar surfaces it.
 */ const $f48f2b9f287ca9dc$export$3d509a43eb16227c = [
    // Inline marks / nodes with a clean GFM equivalent:
    'link',
    'image upload',
    // EDITOR-6636: full media insert also now round-trips cleanly.
    // `'media'` opens the Atlassian media picker (file/URL insert), which
    // produces `mediaSingle > media` — now serialised to a CommonMark image
    // via the proxy-URL pipeline. Keep both so users have both entry points.
    'media',
    'codeblock',
    'blockquote',
    'horizontalrule',
    'table',
    'table selector',
    'action'
];
const $f48f2b9f287ca9dc$export$5edd677c06a37e6a = new Set($f48f2b9f287ca9dc$export$3d509a43eb16227c);
const $f48f2b9f287ca9dc$export$d51800a5a6fed7d2 = (item)=>{
    if (!item.value?.name) return true;
    return $f48f2b9f287ca9dc$export$5edd677c06a37e6a.has(item.value.name);
};



var $3Cz3M = parcelRequire("3Cz3M");





var $44cyU = parcelRequire("44cyU");




const $4ca58e1e52d9f1a0$export$56937bf89365f70d = new (0, $kCECX.PluginKey)('aiAutocompletePlugin');


const $7883f6d5386d0dd1$export$92a1a3b7554e9387 = {
    TRIGGER_MANUAL: 'TRIGGER_MANUAL',
    TRIGGER_AUTO: 'TRIGGER_AUTO',
    SET_SUGGESTION: 'SET_SUGGESTION',
    REVEAL_SUGGESTION: 'REVEAL_SUGGESTION',
    ENTER_DURING_LOADING: 'ENTER_DURING_LOADING',
    DISMISS: 'DISMISS'
};


function $18b24afdc152ba14$export$75827d0f82a08bf5(state) {
    const { $from: $from } = state.selection;
    if ($from.depth === 1) {
        const name = $from.parent.type.name;
        return name === 'paragraph' || name === 'heading';
    }
    if ($from.depth === 2 && $from.node(1).type.name === 'panel') {
        const name = $from.parent.type.name;
        return name === 'paragraph' || name === 'heading';
    }
    return false;
}



var $krYZG = parcelRequire("krYZG");

const $852de9c4b9275260$export$37798a7ff6f20cd2 = (editorAnalyticsAPI)=>(transaction, triggerType)=>{
        const payload = {
            action: (0, $krYZG.ACTION).INVOKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                triggerType: triggerType
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $852de9c4b9275260$export$edd7849651b2a74a = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $krYZG.ACTION).SUGGESTION_VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $852de9c4b9275260$export$c26e1e4a084cdc9e = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $krYZG.ACTION).SUGGESTION_INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $852de9c4b9275260$export$61436ea80e595f1a = (editorAnalyticsAPI)=>(transaction)=>{
        const payload = {
            action: (0, $krYZG.ACTION).SUGGESTION_DISMISSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_AUTOCOMPLETE,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };



var $cXtTj = parcelRequire("cXtTj");

function $39f5ee7aa8d32454$var$isStringList(value) {
    return Array.isArray(value) && value.every((item)=>typeof item === 'string');
}
const $39f5ee7aa8d32454$var$STRING_LIST_CONFIG_KEY = 'value';
function $39f5ee7aa8d32454$export$f1de66450aeccbb6(configName, token) {
    if (!(0, $cXtTj.default).initializeCompleted()) return false;
    try {
        // Dynamic configs are exposed through the same client surface as experiments.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const config = (0, $cXtTj.default).getExperiment(configName);
        const listCandidate = config.value[$39f5ee7aa8d32454$var$STRING_LIST_CONFIG_KEY];
        if (!$39f5ee7aa8d32454$var$isStringList(listCandidate)) return false;
        return listCandidate.includes(token);
    } catch  {
        return false;
    }
}


function $ccaa76974964a0df$export$7e72d5dcc9007fb(state) {
    const { $from: $from } = state.selection;
    const parent = $from.parent;
    if (parent.type !== state.schema.nodes.heading) return {
        cursorInHeading: false,
        headingPos: -1,
        headingText: '',
        headingLevel: 0
    };
    // $from.before($from.depth) gives us the absolute position of the start of
    // the heading node (the opening token position).
    const headingPos = $from.before($from.depth);
    const headingText = parent.textContent.trim();
    const headingLevel = parent.attrs['level'] ?? 1;
    return {
        cursorInHeading: true,
        headingPos: headingPos,
        headingText: headingText,
        headingLevel: headingLevel
    };
}


/** Default minimum words when `platform_editor_ai_autocomplete_ux_config` has no word-count token. */ const $4b09d9cf3dfa205d$var$MIN_DOCUMENT_WORDS = 400;
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $4b09d9cf3dfa205d$var$WHITESPACE_SPLIT_REGEX = /\s+/u;
/** On Enter: dismiss if the cursor block exceeds this length (non-heading). */ const $4b09d9cf3dfa205d$var$AUTO_DISMISS_MAX_CHARS_NON_HEADING = 20;
/** On Enter: dismiss if the cursor block exceeds this length (heading). */ const $4b09d9cf3dfa205d$var$AUTO_DISMISS_MAX_CHARS_HEADING = 50;
const $4b09d9cf3dfa205d$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG = 'platform_editor_ai_autocomplete_ux_config';
/**
 * Minimum words in the whole document before autocomplete trigger may fire.
 * Driven by Statsig dynamic config `platform_editor_ai_autocomplete_ux_config`
 * string list (`value` key); first matching token wins if several are present.
 */ function $4b09d9cf3dfa205d$var$getMinDocumentWords() {
    if ((0, $39f5ee7aa8d32454$export$f1de66450aeccbb6)($4b09d9cf3dfa205d$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-300')) return 300;
    if ((0, $39f5ee7aa8d32454$export$f1de66450aeccbb6)($4b09d9cf3dfa205d$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-200')) return 200;
    if ((0, $39f5ee7aa8d32454$export$f1de66450aeccbb6)($4b09d9cf3dfa205d$var$AI_AUTOCOMPLETE_UX_DYNAMIC_CONFIG, 'word-count-350')) return 350;
    return $4b09d9cf3dfa205d$var$MIN_DOCUMENT_WORDS;
}
function $4b09d9cf3dfa205d$export$6f212eb1ee72d86a(doc) {
    return doc.textBetween(0, doc.content.size, '\n', ' ');
}
/**
 * Word count for the full document, aligned with editor analytics style:
 * normalize whitespace, then `Intl.Segmenter` word + `isWordLike`, else whitespace split.
 */ function $4b09d9cf3dfa205d$var$countWordsInDocument(doc) {
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    const normalized = $4b09d9cf3dfa205d$export$6f212eb1ee72d86a(doc).replace(/\s+/gu, ' ').trim();
    if (!normalized) return 0;
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') try {
        const seg = new Intl.Segmenter('und', {
            granularity: 'word'
        });
        let n = 0;
        for (const part of seg.segment(normalized))if (part.isWordLike) n++;
        return n;
    } catch  {
    // fall through
    }
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return normalized.split($4b09d9cf3dfa205d$var$WHITESPACE_SPLIT_REGEX).length;
}
function $4b09d9cf3dfa205d$export$203aad1d4d95d0de(state) {
    const inHeading = (0, $ccaa76974964a0df$export$7e72d5dcc9007fb)(state).cursorInHeading;
    const len = state.selection.$from.parent.textContent.length;
    const maxChars = inHeading ? $4b09d9cf3dfa205d$var$AUTO_DISMISS_MAX_CHARS_HEADING : $4b09d9cf3dfa205d$var$AUTO_DISMISS_MAX_CHARS_NON_HEADING;
    return len > maxChars;
}
function $4b09d9cf3dfa205d$export$8532deffc62f2372(state) {
    const wordCount = $4b09d9cf3dfa205d$var$countWordsInDocument(state.doc);
    return wordCount >= $4b09d9cf3dfa205d$var$getMinDocumentWords();
}


/** How many lines from the top of the doc still count for Summary auto-trigger (first line = 1). */ const $a91800394ca1f7df$var$MAX_LINES_FROM_DOC_START = 4;
/** How many lines from the end of the doc count for Conclusion auto-trigger. */ const $a91800394ca1f7df$var$MAX_LINES_FROM_DOC_END = 4;
function $a91800394ca1f7df$export$faff1b56818221b9(doc, pos) {
    const maxPos = doc.content.size;
    const clamped = Math.max(1, Math.min(pos, maxPos));
    const slice = doc.textBetween(1, clamped, '\n', ' ');
    if (!slice) return 1;
    return slice.split('\n').length;
}
function $a91800394ca1f7df$export$86e2c649a3fb270b(state) {
    return $a91800394ca1f7df$export$faff1b56818221b9(state.doc, state.selection.from) <= $a91800394ca1f7df$var$MAX_LINES_FROM_DOC_START;
}
function $a91800394ca1f7df$export$a0cc97e2eec5e2c9(state) {
    const { doc: doc } = state;
    const cursorLine = $a91800394ca1f7df$export$faff1b56818221b9(doc, state.selection.from);
    const totalLines = $a91800394ca1f7df$export$faff1b56818221b9(doc, doc.content.size);
    return totalLines - cursorLine < $a91800394ca1f7df$var$MAX_LINES_FROM_DOC_END;
}



function $8fed008a3f2d5c61$export$430bd2456e5b9d09(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return false;
    if (event.key === 'Enter') return true;
    if (event.key.length === 1) return $8fed008a3f2d5c61$var$WORD_TERMINATOR_CHAR_REGEX.test(event.key);
    return false;
}
function $8fed008a3f2d5c61$export$32dfe294464a680b(state) {
    const { $from: $from } = state.selection;
    if (!$from.parent.isTextblock || $from.parentOffset === 0) return null;
    const textBefore = $from.parent.textBetween(0, $from.parentOffset, undefined, '\ufffc');
    const withoutTrailingSeparators = textBefore.replace($8fed008a3f2d5c61$var$TRAILING_SEP_RE, '');
    if (!withoutTrailingSeparators) return null;
    const words = withoutTrailingSeparators.split($8fed008a3f2d5c61$var$WORD_SPLIT_RE);
    const last = words[words.length - 1];
    if (!last || !$8fed008a3f2d5c61$var$WORD_CHAR_RE.test(last)) return null;
    return last;
}
function $8fed008a3f2d5c61$export$38f22e55366a41d0(word, keywordSet) {
    return keywordSet.includes(word.toLowerCase());
}
const $8fed008a3f2d5c61$var$WORD_TERMINATOR_CHAR_REGEX = /[\s.,;:!?)\]}"'»«/\\]/u;
const $8fed008a3f2d5c61$var$TRAILING_SEP_RE = RegExp("[\\s\\p{P}]+$", "u");
const $8fed008a3f2d5c61$var$WORD_SPLIT_RE = RegExp("[\\s\\p{P}]+", "u");
const $8fed008a3f2d5c61$var$WORD_CHAR_RE = RegExp("^[\\p{L}\\p{N}_]+$", "u");
const $8fed008a3f2d5c61$var$BOUNDARY_RE = RegExp("[\\s\\p{P}]", "u");
function $8fed008a3f2d5c61$export$2ba08fd9849922d8(state, keywords) {
    const { $from: $from } = state.selection;
    if (!$from.parent.isTextblock || $from.parentOffset === 0) return false;
    let maxKwLen = 0;
    for(let i = 0; i < keywords.length; i++)if (keywords[i].length > maxKwLen) maxKwLen = keywords[i].length;
    // +1 for the word-boundary char we need to inspect; +20 covers trailing
    // separators stripped before matching.
    const extractFrom = Math.max(0, $from.parentOffset - maxKwLen - 21);
    const tail = $from.parent.textBetween(extractFrom, $from.parentOffset, undefined, '\ufffc');
    const trimmed = tail.replace($8fed008a3f2d5c61$var$TRAILING_SEP_RE, '');
    if (!trimmed) return false;
    const lower = trimmed.toLowerCase();
    for(let i = 0; i < keywords.length; i++){
        const kw = keywords[i];
        if (lower === kw) return true;
        if (lower.length > kw.length && lower.endsWith(kw) && $8fed008a3f2d5c61$var$BOUNDARY_RE.test(lower[lower.length - kw.length - 1])) return true;
    }
    return false;
}





const $4f3c8916cf6997a3$export$ee1116f260b39d9b = (0, $kSwu1.defineMessages)({
    summaryKeywords: {
        id: "fabric.editor.ai.autocomplete.summary.trigger.keywords.non-final",
        defaultMessage: "summary, tldr, tl;dr, tl dr, overview, synopsis, recap, abstract, brief, outline, quick, in short, rundown, review, roundup, highlights, key points, snapshot, at a glance, in essence, takeaways, to summarize, to summarise"
    },
    conclusionKeywords: {
        id: "fabric.editor.ai.autocomplete.conclusion.trigger.keywords.non-final",
        defaultMessage: "conclusion, conclusions, findings, results, outcome, outcomes, final thoughts, takeaway, takeaways, verdict, determination, resolution, final analysis, deduction, judgment, decision, culmination, end result, bottom line, final word, closing, to conclude, final notes, learnings, what we learned, overall"
    },
    nextStepsKeywords: {
        id: "fabric.editor.ai.autocomplete.next.steps.trigger.keywords.non-final",
        defaultMessage: "recommendations, follow-through, implementation, moving forward, going forward, deliverables, path forward, what is next, way forward, what's next, next steps, priorities, whats next, task list, follow-up, follow up, next step, followup, priority, next up, up next, roadmap, actions, action, tasks, todos, to do, to-do, todo, plan"
    }
});


/**
 * Parses the formatted trigger-keywords string (comma-separated phrases) into trimmed tokens.
 */ function $271df1e14fdb5171$var$splitAutocompleteTriggerKeywords(intl, messages) {
    return intl().formatMessage(messages).split(',').map((s)=>s.trim()).filter((s)=>s.length > 0);
}
function $271df1e14fdb5171$export$d5883a29c5e2615e(intl) {
    return $271df1e14fdb5171$var$splitAutocompleteTriggerKeywords(intl, (0, $4f3c8916cf6997a3$export$ee1116f260b39d9b).summaryKeywords);
}
function $271df1e14fdb5171$export$ec1e17d2784ef29d(intl) {
    return $271df1e14fdb5171$var$splitAutocompleteTriggerKeywords(intl, (0, $4f3c8916cf6997a3$export$ee1116f260b39d9b).conclusionKeywords);
}
function $271df1e14fdb5171$export$840323b8f6b537aa(intl) {
    return $271df1e14fdb5171$var$splitAutocompleteTriggerKeywords(intl, (0, $4f3c8916cf6997a3$export$ee1116f260b39d9b).nextStepsKeywords);
}


/**
 * True for keys that typically mutate document text (printable chars,
 * Backspace, Delete, Enter) when not combined with meta/ctrl modifiers.
 */ function $0408af6e24724151$var$isDocMutatingKey(event) {
    if (event.isComposing || event.key === 'Process') return false;
    if (event.key === 'Backspace' || event.key === 'Delete') return true;
    if (event.key === 'Enter' && !event.metaKey && !event.ctrlKey) return true;
    return event.key.length === 1 && !event.metaKey && !event.ctrlKey;
}
function $0408af6e24724151$export$a57bf7fb2aa68075({ api: api, getIntl: getIntl }) {
    const editorAnalyticsAPI = api?.analytics?.actions;
    const createSectionKeywordTrigger = (config)=>{
        let pendingIdleId;
        const cancel = ()=>{
            if (pendingIdleId === undefined) return;
            if (typeof cancelIdleCallback === 'function') cancelIdleCallback(pendingIdleId);
            else cancelAnimationFrame(pendingIdleId);
            pendingIdleId = undefined;
        };
        /**
     * Pattern matching runs in an idle callback (see block-controls / insert-block)
     * so we do not add work on the critical key path; DOM + doc are up to date by then.
     */ const schedule = (view)=>{
            cancel();
            const flush = ()=>{
                pendingIdleId = undefined;
                if (view.isDestroyed) return;
                if ((0, $8fed008a3f2d5c61$export$2ba08fd9849922d8)(view.state, config.keywords) && !(0, $4b09d9cf3dfa205d$export$203aad1d4d95d0de)(view.state)) {
                    const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                    if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                    const { from: resolvedCursorPos } = view.state.selection;
                    const invokeTr = view.state.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                        type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).TRIGGER_AUTO,
                        cursorPos: resolvedCursorPos,
                        triggerType: config.sectionType
                    });
                    const triggerType = (0, $ccaa76974964a0df$export$7e72d5dcc9007fb)(view.state).cursorInHeading ? config.headingTriggerType : config.nonHeadingTriggerType;
                    (0, $852de9c4b9275260$export$37798a7ff6f20cd2)(editorAnalyticsAPI)(invokeTr, triggerType);
                    view.dispatch(invokeTr);
                }
            };
            if (typeof requestIdleCallback === 'function') pendingIdleId = requestIdleCallback(flush, {
                timeout: 2000
            });
            else pendingIdleId = requestAnimationFrame(flush);
        };
        return {
            cancel: cancel,
            schedule: schedule
        };
    };
    const summaryTrigger = createSectionKeywordTrigger({
        keywords: (0, $271df1e14fdb5171$export$d5883a29c5e2615e)(getIntl),
        sectionType: 'summary',
        headingTriggerType: 'summary-heading',
        nonHeadingTriggerType: 'summary-first-lines'
    });
    const conclusionTrigger = createSectionKeywordTrigger({
        keywords: (0, $271df1e14fdb5171$export$ec1e17d2784ef29d)(getIntl),
        sectionType: 'conclusion',
        headingTriggerType: 'conclusion-heading',
        nonHeadingTriggerType: 'conclusion-last-lines'
    });
    const nextStepsTrigger = createSectionKeywordTrigger({
        keywords: (0, $271df1e14fdb5171$export$840323b8f6b537aa)(getIntl),
        sectionType: 'next-steps',
        headingTriggerType: 'next-steps-heading',
        nonHeadingTriggerType: 'next-steps-last-lines'
    });
    const triggerManualInline = (state, dispatch, view)=>{
        if (!dispatch || !view) return false;
        const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(state);
        if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
        const freshState = view.state;
        const resolvedCursorPos = freshState.selection.from;
        const invokeTr = freshState.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
            type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).TRIGGER_MANUAL,
            cursorPos: resolvedCursorPos
        });
        (0, $852de9c4b9275260$export$37798a7ff6f20cd2)(editorAnalyticsAPI)(invokeTr, 'cmd+shift+space');
        view.dispatch(invokeTr);
        return true;
    };
    // ── Enter: auto-trigger Enter-reveal flow ─────────────────────────
    // Returns `false` in every branch so ProseMirror still processes
    // the Enter key (new paragraph / split node).  Side effects (flag
    // set, dismiss, scheduled reveal) happen before that.
    const handleEnter = (state, _dispatch, view)=>{
        const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(state);
        // Active state + exceeds char limit → dismiss, let Enter through
        if (pluginState && pluginState.status !== 'idle' && (0, $4b09d9cf3dfa205d$export$203aad1d4d95d0de)(state)) {
            api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
            return false;
        }
        // Loading + auto: flag that Enter was pressed so the API
        // response handler can show the suggestion immediately
        if (pluginState?.status === 'loading' && pluginState.trigger === 'auto' && view) {
            view.dispatch(view.state.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).ENTER_DURING_LOADING
            }));
            return false;
        }
        // suggestion_pending: reveal ghost at new cursor after Enter creates a new block
        if (pluginState?.status === 'suggestion_pending' && view) {
            setTimeout(()=>{
                if (view.isDestroyed) return;
                const pending = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                if (pending?.status !== 'suggestion_pending') return;
                const cursorPos = view.state.selection.from;
                const revealTr = view.state.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                    type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).REVEAL_SUGGESTION,
                    cursorPos: cursorPos
                });
                (0, $852de9c4b9275260$export$edd7849651b2a74a)(editorAnalyticsAPI)(revealTr);
                view.dispatch(revealTr);
            }, 0);
            return false;
        }
        return false;
    };
    const bindings = {
        ['Mod-Shift-Space']: triggerManualInline,
        ['Meta-Shift-Space']: triggerManualInline,
        ['Enter']: handleEnter,
        ['Tab']: (state, dispatch)=>{
            const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(state);
            if (pluginState?.status !== 'suggestion') return false;
            if (!dispatch) return false;
            return api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.acceptSuggestion?.({
                cursorPos: pluginState.cursorPos,
                suggestion: pluginState.suggestion
            })) ?? false;
        },
        ['Escape']: (state, dispatch)=>{
            const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(state);
            if (!pluginState || pluginState.status === 'idle') return false;
            if (!dispatch) return false;
            return api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.()) ?? false;
        }
    };
    return new (0, $kpCD8.SafePlugin)({
        view () {
            return {
                destroy () {
                    summaryTrigger.cancel();
                    conclusionTrigger.cancel();
                    nextStepsTrigger.cancel();
                }
            };
        },
        props: {
            handleKeyDown (view, event) {
                if ((0, $44cyU.keydownHandler)(bindings)(view, event)) return true;
                // Re-read state: the Enter binding may have dispatched a
                // dismiss (char-limit case), making the state idle already.
                const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                // The Enter binding returns false (to let the default Enter
                // through) but already set flags / scheduled reveal for these
                // states — don't let the generic dismiss undo that work.
                if (event.key === 'Enter' && !event.shiftKey && pluginState && (pluginState.status === 'loading' || pluginState.status === 'suggestion_pending')) return false;
                // ── Auto loading / pending: same-line editing tolerance ────────
                // Allow document-mutating keys on the trigger line without
                // dismissing the session; once the cursor moves below the trigger
                // line, further typing dismisses.
                if (pluginState && (pluginState.status === 'loading' || pluginState.status === 'suggestion_pending') && pluginState.trigger === 'auto' && $0408af6e24724151$var$isDocMutatingKey(event)) {
                    const lineNow = (0, $a91800394ca1f7df$export$faff1b56818221b9)(view.state.doc, view.state.selection.from);
                    if (lineNow <= pluginState.triggerLineIndex) return false;
                }
                // ── Generic: dismiss any active state ─────────────────────────
                if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                // ── Schedule keyword checks ───────────────────────────────────
                if ((0, $18b24afdc152ba14$export$75827d0f82a08bf5)(view.state) && (0, $4b09d9cf3dfa205d$export$8532deffc62f2372)(view.state)) {
                    if ((0, $a91800394ca1f7df$export$86e2c649a3fb270b)(view.state)) summaryTrigger.schedule(view);
                    if ((0, $a91800394ca1f7df$export$a0cc97e2eec5e2c9)(view.state)) {
                        conclusionTrigger.schedule(view);
                        nextStepsTrigger.schedule(view);
                    }
                }
                return false;
            }
        }
    });
}






function $25556ddab37edad8$var$isSuggestionVisibleState(state) {
    return state?.status === 'suggestion';
}
const $25556ddab37edad8$export$f87341fc5281ec6c = (options)=>{
    const { api: api } = options;
    return new (0, $kpCD8.SafePlugin)({
        view () {
            let previousSuggestionVisible = false;
            return {
                update (view) {
                    if (!api?.placeholder || !api?.core) return;
                    const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                    const suggestionVisible = $25556ddab37edad8$var$isSuggestionVisibleState(pluginState);
                    if (suggestionVisible !== previousSuggestionVisible) {
                        previousSuggestionVisible = suggestionVisible;
                        api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(suggestionVisible));
                    }
                }
            };
        }
    });
};








const $372021fb6e89cbb4$export$bb9c6e4618c88231 = ({ cursorPos: cursorPos, suggestion: suggestion }, editorAnalyticsAPI)=>({ tr: tr })=>{
        (0, $852de9c4b9275260$export$c26e1e4a084cdc9e)(editorAnalyticsAPI)(tr);
        tr.insert(cursorPos, tr.doc.type.schema.text(suggestion));
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, cursorPos + suggestion.length));
        tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
            type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).DISMISS
        });
        tr.setMeta('addToHistory', true);
        return tr;
    };
const $372021fb6e89cbb4$export$82b68e9b2902c23d = (editorAnalyticsAPI)=>({ tr: tr })=>{
        (0, $852de9c4b9275260$export$61436ea80e595f1a)(editorAnalyticsAPI)(tr);
        return tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
            type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).DISMISS
        });
    };













const $4fd63dc46caf8ab4$var$MAX_TOKENS = 400;
/**
 * Derives the correct API host, matching the pattern used by other editor AI
 * features in editor-plugin-ai/src/ui/prebuilt/utils.ts.
 *
 * On localhost (non-port-8081) and Atlaskit storybook hosts, routes to
 * pug.jira-dev.com so API calls work without a local backend.
 * In all other environments (staging, prod) uses window.location.origin.
 */ function $4fd63dc46caf8ab4$var$deriveHost() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window !== 'undefined' && window.location ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
// Convo-AI path (current source of truth, served by conversational-ai-platform).
const $4fd63dc46caf8ab4$var$CONVO_AI_PATH = '/gateway/api/assist/api/ai/v2/ai-feature/heading-autocomplete';
// cc-smarts path (new home, served by cc-smarts). Reached via the
// cc-smarts-ai-feature stargate route (stargate PR-8755), which strips
// /gateway/api and prepends /api before forwarding to cc-smarts.
const $4fd63dc46caf8ab4$var$CC_SMARTS_PATH = '/gateway/api/ai/v2/ai-feature/heading-autocomplete';
/**
 * Resolves the heading-autocomplete endpoint URL based on the SPRT routing experiment.
 *
 * Routing: the editor experiment `cc_smarts_heading_autocomplete_migration` (param
 * `useCcSmarts`) decides between cc-smarts (new home, test arm) and conversational-ai-platform
 * (current source of truth, control arm). Wire shape is byte-for-byte identical between
 * the two backends; only the URL path differs. Mirrors `cc_smarts_comment_summary_followups_migration`
 * (AFM PR-388153).
 *
 * On any read failure (experiment lookup throws, Statsig unavailable, etc.) callers fail
 * closed to the convo-ai control arm — that's the safer arm because it's the production
 * source of truth today.
 */ function $4fd63dc46caf8ab4$var$getApiEndpoint() {
    // Fail-closed: useCcSmarts stays at its initialised value of `false` if expValEquals throws,
    // landing on the convo-ai control arm — the production source of truth today. Do not move the
    // initialiser out of this declaration or remove the empty catch; both are load-bearing for the
    // fail-closed property (per the convo-ai → cc-smarts migration skill guardrails).
    let useCcSmarts = false;
    try {
        useCcSmarts = (0, $ieeJu.expValEquals)('cc_smarts_heading_autocomplete_migration', 'useCcSmarts', true);
    } catch  {
    // Intentionally empty — see the fail-closed comment on the `let` above.
    }
    const path = useCcSmarts ? $4fd63dc46caf8ab4$var$CC_SMARTS_PATH : $4fd63dc46caf8ab4$var$CONVO_AI_PATH;
    return `${$4fd63dc46caf8ab4$var$deriveHost()}${path}`;
}
async function $4fd63dc46caf8ab4$export$9384628242350716(pageContentMarkdown, sectionType, signal) {
    const response = await fetch($4fd63dc46caf8ab4$var$getApiEndpoint(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Experience-Id': 'editor',
            'X-Product': 'confluence'
        },
        credentials: 'include',
        signal: signal,
        body: JSON.stringify({
            ai_feature_input: {
                page_content_markdown: pageContentMarkdown,
                max_tokens: $4fd63dc46caf8ab4$var$MAX_TOKENS,
                section_type: sectionType
            }
        })
    });
    if (!response.ok) throw new Error(`Heading autocomplete API error: ${response.status} ${response.statusText}`);
    const data = await response.json();
    const generatedParagraph = data?.ai_feature_output?.generated_paragraph;
    if (!generatedParagraph) throw new Error('Heading autocomplete API returned an empty or malformed response');
    return generatedParagraph;
}





var $9DPMp = parcelRequire("9DPMp");

const $ced43b71983f2cbe$var$GENERATE_MARKER = '<!-- GENERATE_HERE -->';
function $ced43b71983f2cbe$export$99167e00e2d4f9dd(view, cursorPos) {
    const doc = view.state.doc;
    // Serialize content before the cursor
    const beforeSlice = doc.slice(0, cursorPos);
    const { markdown: mdBefore } = (0, $9DPMp.convertProsemirrorToMarkdown)({
        editorView: view,
        fragment: beforeSlice.content,
        featureToggles: {}
    });
    // Serialize content after the cursor
    const afterSlice = doc.slice(cursorPos);
    const { markdown: mdAfter } = (0, $9DPMp.convertProsemirrorToMarkdown)({
        editorView: view,
        fragment: afterSlice.content,
        featureToggles: {}
    });
    const before = mdBefore.trimEnd();
    const after = mdAfter.trimStart();
    if (after) return `${before} ${$ced43b71983f2cbe$var$GENERATE_MARKER}\n${after}`;
    return `${before} ${$ced43b71983f2cbe$var$GENERATE_MARKER}`;
}



var $8Dx7s = parcelRequire("8Dx7s");


var $8nvEM = parcelRequire("8nvEM");

const $202a270e621e335b$var$GHOST_INLINE_CLASS = 'heading-autocomplete-ghost-inline';
const $202a270e621e335b$var$GHOST_HINT_CLASS = 'heading-autocomplete-ghost-text-hint';
const $202a270e621e335b$var$ghostInlineStyle = (0, $8Dx7s.convertToInlineCss)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    opacity: '0.95',
    pointerEvents: 'auto',
    userSelect: 'none',
    whiteSpace: 'pre-wrap',
    cursor: 'pointer'
});
const $202a270e621e335b$var$ghostHintStyle = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    borderRadius: "var(--ds-radius-small, 4px)",
    padding: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: "var(--ds-space-050, 4px)",
    verticalAlign: '3px'
});
const $202a270e621e335b$var$ghostHintTabStyle = (0, $8Dx7s.convertToInlineCss)({
    border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`
});
function $202a270e621e335b$export$ec5102320006649a(state, pluginState) {
    return $202a270e621e335b$var$buildInlineGhostDecoration(state, pluginState.cursorPos, pluginState.suggestion);
}
/**
 * Inline ghost text at the cursor position (manual Cmd+Shift+Space trigger).
 * Accepted with Tab or click.
 */ function $202a270e621e335b$var$buildInlineGhostDecoration(state, cursorPos, suggestion) {
    const widget = (0, $8nvEM.Decoration).widget(cursorPos, ()=>{
        const span = document.createElement('span');
        span.className = $202a270e621e335b$var$GHOST_INLINE_CLASS;
        span.setAttribute('aria-hidden', 'true');
        span.setAttribute('contenteditable', 'false');
        span.setAttribute('data-testid', 'heading-autocomplete-ghost-inline');
        span.setAttribute('style', $202a270e621e335b$var$ghostInlineStyle);
        const text = document.createTextNode(suggestion);
        span.appendChild(text);
        const hint = document.createElement('span');
        hint.className = $202a270e621e335b$var$GHOST_HINT_CLASS;
        hint.setAttribute('style', $202a270e621e335b$var$ghostHintStyle);
        span.appendChild(hint);
        const tab = document.createElement('span');
        tab.className = $202a270e621e335b$var$GHOST_HINT_CLASS;
        tab.setAttribute('style', $202a270e621e335b$var$ghostHintTabStyle);
        tab.textContent = 'Tab';
        hint.appendChild(tab);
        const toAcceptText = document.createTextNode(' or click to accept');
        hint.appendChild(toAcceptText);
        return span;
    }, {
        side: 1,
        key: 'heading-autocomplete-ghost-inline'
    });
    return (0, $8nvEM.DecorationSet).create(state.doc, [
        widget
    ]);
}



const $dcc2223de2d8d232$export$ae829ec7b2625219 = ({ api: api })=>{
    let abortController = null;
    const editorAnalyticsAPI = api?.analytics?.actions;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d),
        // -----------------------------------------------------------------------
        // Plugin state — pure synchronous transitions
        // -----------------------------------------------------------------------
        state: {
            init () {
                return {
                    status: 'idle'
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const action = tr.getMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d));
                if (action) switch(action.type){
                    case (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).TRIGGER_MANUAL:
                        return {
                            status: 'loading',
                            trigger: 'manual',
                            cursorPos: action.cursorPos
                        };
                    case (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).TRIGGER_AUTO:
                        return {
                            status: 'loading',
                            trigger: 'auto',
                            cursorPos: action.cursorPos,
                            triggerType: action.triggerType,
                            triggerLineIndex: (0, $a91800394ca1f7df$export$faff1b56818221b9)(tr.doc, action.cursorPos),
                            userPressedEnter: false,
                            postEnterPlainTextBaseline: null
                        };
                    case (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).SET_SUGGESTION:
                        if (pluginState.status === 'loading') {
                            if (pluginState.trigger === 'auto') {
                                if ('displaySuggestionImmediately' in action && action.displaySuggestionImmediately === true) {
                                    const cursorPos = 'suggestionCursorPos' in action && action.suggestionCursorPos !== undefined ? action.suggestionCursorPos : pluginState.cursorPos;
                                    return {
                                        status: 'suggestion',
                                        trigger: 'auto',
                                        cursorPos: cursorPos,
                                        suggestion: action.suggestion
                                    };
                                }
                                return {
                                    status: 'suggestion_pending',
                                    trigger: 'auto',
                                    cursorPos: pluginState.cursorPos,
                                    suggestion: action.suggestion,
                                    triggerLineIndex: pluginState.triggerLineIndex
                                };
                            }
                            return {
                                status: 'suggestion',
                                trigger: 'manual',
                                cursorPos: pluginState.cursorPos,
                                suggestion: action.suggestion
                            };
                        }
                        return pluginState;
                    case (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).REVEAL_SUGGESTION:
                        if (pluginState.status === 'suggestion_pending') {
                            const revealCursorPos = 'cursorPos' in action && action.cursorPos !== undefined ? action.cursorPos : pluginState.cursorPos;
                            return {
                                status: 'suggestion',
                                trigger: 'auto',
                                cursorPos: revealCursorPos,
                                suggestion: pluginState.suggestion
                            };
                        }
                        return pluginState;
                    case (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).ENTER_DURING_LOADING:
                        if (pluginState.status === 'loading' && pluginState.trigger === 'auto') return {
                            ...pluginState,
                            userPressedEnter: true
                        };
                        return pluginState;
                    case (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).DISMISS:
                        return {
                            status: 'idle'
                        };
                    default:
                        return pluginState;
                }
                // Structural doc change during auto-loading with Enter pressed:
                // capture a plain-text baseline so the API response handler can
                // verify the doc hasn't changed beyond the Enter-induced split.
                if (pluginState.status === 'loading' && pluginState.trigger === 'auto' && pluginState.userPressedEnter && pluginState.postEnterPlainTextBaseline === null && !tr.before.eq(tr.doc)) return {
                    ...pluginState,
                    postEnterPlainTextBaseline: (0, $4b09d9cf3dfa205d$export$6f212eb1ee72d86a)(newState.doc),
                    cursorPos: tr.mapping.map(pluginState.cursorPos)
                };
                if (tr.docChanged && pluginState.status !== 'idle') {
                    const state = pluginState;
                    return {
                        ...state,
                        ...state.status === 'loading' || state.status === 'suggestion' || state.status === 'suggestion_pending' ? {
                            cursorPos: tr.mapping.map(state.cursorPos)
                        } : {}
                    };
                }
                return pluginState;
            }
        },
        // -----------------------------------------------------------------------
        // Decorations
        // -----------------------------------------------------------------------
        props: {
            decorations (state) {
                const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(state);
                if (pluginState?.status !== 'suggestion') return null;
                return (0, $202a270e621e335b$export$ec5102320006649a)(state, pluginState);
            },
            handleDOMEvents: {
                click: (view, event)=>{
                    const { target: target } = event;
                    if (target instanceof HTMLElement && target.closest('[data-testid="heading-autocomplete-ghost-inline"]')) {
                        event.preventDefault();
                        const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                        if (pluginState?.status === 'suggestion') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.acceptSuggestion?.({
                            cursorPos: pluginState.cursorPos,
                            suggestion: pluginState.suggestion
                        }));
                        return true;
                    }
                    return false;
                },
                blur: (view)=>{
                    const pluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                    if (pluginState && pluginState.status !== 'idle') api?.core?.actions?.execute?.(api?.aiAutocomplete?.commands?.dismissSuggestion?.());
                    return false;
                }
            }
        },
        // -----------------------------------------------------------------------
        // view() — owns all side effects (fetch lifecycle)
        // -----------------------------------------------------------------------
        view () {
            return {
                update (view, prevState) {
                    const newPluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                    const prevPluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(prevState);
                    if (newPluginState === prevPluginState) return;
                    // Leaving 'loading' — cancel in-flight fetch
                    if (prevPluginState?.status === 'loading' && newPluginState?.status !== 'loading') {
                        abortController?.abort();
                        abortController = null;
                    }
                    // Entering 'loading' — fire the API call
                    if (newPluginState?.status === 'loading' && prevPluginState?.status !== 'loading') {
                        abortController = new AbortController();
                        const markdown = (0, $ced43b71983f2cbe$export$99167e00e2d4f9dd)(view, newPluginState.cursorPos);
                        const sectionType = newPluginState.trigger === 'auto' ? newPluginState.triggerType : undefined;
                        (0, $4fd63dc46caf8ab4$export$9384628242350716)(markdown, sectionType, abortController.signal).then((suggestion)=>{
                            const loading = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(view.state);
                            if (loading?.status !== 'loading') return;
                            const showImmediately = loading.trigger === 'auto' && loading.userPressedEnter;
                            if (showImmediately && loading.postEnterPlainTextBaseline !== null) {
                                const currentPlain = (0, $4b09d9cf3dfa205d$export$6f212eb1ee72d86a)(view.state.doc);
                                if (currentPlain !== loading.postEnterPlainTextBaseline) {
                                    view.dispatch(view.state.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                                        type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).DISMISS
                                    }));
                                    return;
                                }
                            }
                            const tr = view.state.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                                type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).SET_SUGGESTION,
                                suggestion: suggestion,
                                ...showImmediately ? {
                                    displaySuggestionImmediately: true,
                                    suggestionCursorPos: view.state.selection.from
                                } : {}
                            });
                            if (loading.trigger === 'manual' || showImmediately) (0, $852de9c4b9275260$export$edd7849651b2a74a)(editorAnalyticsAPI)(tr);
                            view.dispatch(tr);
                        }).catch((err)=>{
                            if (err instanceof Error && err.name === 'AbortError') return;
                            const dismissTr = view.state.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                                type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).DISMISS
                            });
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).ERRORED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_AUTOCOMPLETE,
                                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorMessage: err instanceof Error ? err.message : String(err)
                                }
                            })(dismissTr);
                            view.dispatch(dismissTr);
                        });
                    }
                },
                destroy () {
                    abortController?.abort();
                    abortController = null;
                }
            };
        },
        // -----------------------------------------------------------------------
        // appendTransaction — doc change → dismiss (accept is handled in command)
        // -----------------------------------------------------------------------
        appendTransaction (transactions, _oldState, newState) {
            const currentPluginState = (0, $4ca58e1e52d9f1a0$export$56937bf89365f70d).getState(newState);
            // Visible suggestion or pending auto reveal: don't dismiss on doc
            // change — keydown already dismisses on typing before the doc mutates.
            if (currentPluginState?.status === 'suggestion' || currentPluginState?.status === 'suggestion_pending') return null;
            // Auto loading: allow doc changes (Enter / same-line edits).
            // Baseline capture is now handled in apply().
            if (currentPluginState?.status === 'loading' && currentPluginState.trigger === 'auto') return null;
            // Use structural doc equality, not `tr.docChanged`: the latter is true for any
            // step (including AnalyticsStep from attachAnalyticsEvent on invoke), which would
            // incorrectly dismiss loading state before the API runs.
            const documentChanged = transactions.some((tr)=>!tr.before.eq(tr.doc));
            if (!documentChanged) return null;
            return newState.tr.setMeta((0, $4ca58e1e52d9f1a0$export$56937bf89365f70d), {
                type: (0, $7883f6d5386d0dd1$export$92a1a3b7554e9387).DISMISS
            });
        }
    });
};


const $154c3a44e87556a7$export$52b2e012ce18dd1 = ({ api: api })=>{
    return {
        name: 'aiAutocomplete',
        commands: {
            acceptSuggestion: (params)=>(0, $372021fb6e89cbb4$export$bb9c6e4618c88231)(params, api?.analytics?.actions),
            dismissSuggestion: ()=>(0, $372021fb6e89cbb4$export$82b68e9b2902c23d)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'aiAutocompletePlugin',
                    plugin: ()=>(0, $dcc2223de2d8d232$export$ae829ec7b2625219)({
                            api: api
                        })
                },
                {
                    name: 'ai-autocomplete-keymap',
                    plugin: (params)=>(0, $0408af6e24724151$export$a57bf7fb2aa68075)({
                            api: api,
                            getIntl: params.getIntl
                        })
                },
                {
                    name: 'ai-autocomplete-placeholder-controller',
                    plugin: ()=>(0, $25556ddab37edad8$export$f87341fc5281ec6c)({
                            api: api
                        })
                }
            ];
        }
    };
};



var $8iNtg = parcelRequire("8iNtg");





var $fRQ3t = parcelRequire("fRQ3t");














var $dOBRD = parcelRequire("dOBRD");

const $e83f07559fdac70a$export$2073a24f9367a16f = (0, $dOBRD.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (typeof window !== 'undefined' && window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $e83f07559fdac70a$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll('[data-section-cta-anchor-name]') || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute('data-section-cta-anchor-name');
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $e83f07559fdac70a$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}


/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $w6R6I = parcelRequire("w6R6I");


var $7Y8M5 = parcelRequire("7Y8M5");


var $gFEZF = parcelRequire("gFEZF");




var $hBYtq = parcelRequire("hBYtq");







const $7c38be9dfef5efbb$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    addSection: {
        id: "company-hub-section-cta.plus-button.add-section",
        defaultMessage: "Add section"
    },
    contentHeader: {
        id: "company-hub-section-cta.section-node.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub-section-cta.section-node.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    lozengeTitle: {
        id: "company-hub-section-cta.section-node.lozenge-title",
        defaultMessage: "Section"
    },
    placeHolderTitle: {
        id: "company-hub-section-cta.section-node.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});



const $25ae6494727e09b5$var$styles = {
    containerBaseStyles: "_v5641p41 _18zr1i3y _kqswstnw _1bsb16wv _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _tzy4idpf _1pbyb4wl _16l4kb7n",
    lineStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3iyh40 _bfhk1aqn",
    pressable: "_2rko1rr0 _bfhk1aqn _4t3izwfg _1bsbzwfg _irr31ibz _1di6of27"
};
const $25ae6494727e09b5$var$Line = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($25ae6494727e09b5$var$styles.lineStyles)
    });
const $25ae6494727e09b5$export$e50c8b7ca0cd488e = ({ anchorId: anchorId, onClick: onClick, view: view, prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition, anchorRectCache: anchorRectCache })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [dynamicStyles, setDynamicStyles] = (0, $cozmU.useState)({});
    (0, $cozmU.useEffect)(()=>{
        const calculatePosition = ()=>{
            const isSectionNode = prevNodeTypeName === 'multiBodiedExtension';
            const isParagraphNode = prevNodeTypeName === 'paragraph';
            const isTableNode = prevNodeTypeName === 'table';
            let verticalOffset = '-50%'; // Default for top and after normal nodes
            if (isSectionNode || isTableNode) verticalOffset = '-100%';
            else if (isLastPosition && isParagraphNode) verticalOffset = '0';
            const baseStyles = {
                // Linter errors if we use variables/non-tokens in cssMap so we need to use style prop
                // add 40px to the max width to account for the padding of the editor
                maxWidth: `${(0, $7Y8M5.akEditorFullWidthLayoutWidth) + 40}px`
            };
            if ((0, $e83f07559fdac70a$export$2073a24f9367a16f)()) {
                setDynamicStyles({
                    ...baseStyles,
                    positionAnchor: `--${anchorId}`,
                    top: 'anchor(bottom)',
                    left: '50%',
                    transform: `translate(-50%, ${verticalOffset})`
                });
                return;
            } // Fallback logic
            anchorRectCache?.clear();
            const rect = anchorRectCache?.getRect(anchorId);
            if (!rect) {
                setDynamicStyles({
                    ...baseStyles,
                    display: 'none'
                });
                return;
            }
            const top = rect.top + rect.height;
            setDynamicStyles({
                ...baseStyles,
                top: `${top}px`,
                left: '50%',
                transform: `translate(-50%, ${verticalOffset})`
            });
        };
        // Set position on initial render and whenever dependencies change.
        calculatePosition(); // Observe for layout changes to recalculate position.
        const observer = new ResizeObserver(calculatePosition);
        observer.observe(view.dom);
        return ()=>{
            observer.disconnect();
        };
    }, [
        anchorId,
        prevNodeTypeName,
        isLastPosition,
        anchorRectCache,
        view.dom
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: dynamicStyles,
        "data-testid": "company-hub-plus-button",
        className: (0, $hekY6.default)([
            $25ae6494727e09b5$var$styles.containerBaseStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25ae6494727e09b5$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $7c38be9dfef5efbb$export$a7357cdd1f0b0168).addSection)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            ...tooltipProps,
            onClick: onClick,
            xcss: $25ae6494727e09b5$var$styles.pressable,
            "aria-label": formatMessage((0, $7c38be9dfef5efbb$export$a7357cdd1f0b0168).addSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25ae6494727e09b5$var$Line, null));
};



var $kHija = parcelRequire("kHija");


var $f9c7077dbb229b8d$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $f9c7077dbb229b8d$export$6cccba5fae1d609d = "wide";
const $f9c7077dbb229b8d$export$617cdcc6afaae4f7 = "var(--ds-surface, #FFFFFF)";
const $f9c7077dbb229b8d$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $f9c7077dbb229b8d$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
const $f9c7077dbb229b8d$export$b39442728ee427d = 'hub-section';
const $f9c7077dbb229b8d$export$12ee1d1507d066e8 = 'com.atlassian.confluence.hub-section';


const $8d0d127e1ac72467$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>({
        type: 'extensionFrame',
        content: [
            {
                type: 'heading',
                attrs: {
                    level: 1,
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${header}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${subHeader}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                }
            },
            {
                type: 'extension',
                attrs: {
                    extensionKey: (0, $f9c7077dbb229b8d$export$ca3a94184e0fbd97),
                    extensionType: (0, $f9c7077dbb229b8d$export$c14e692c91462ed4),
                    parameters: {
                        extensionTitle: placeholderTitle
                    },
                    text: null,
                    layout: 'default',
                    localId: null
                }
            }
        ]
    });
const $8d0d127e1ac72467$var$sectionContentNode = (state, initialContentText)=>state.schema.nodeFromJSON($8d0d127e1ac72467$export$993dca3597b448e8(initialContentText));
const $8d0d127e1ac72467$export$3cf963ab3631af75 = (state, intl)=>{
    const initialContentText = {
        header: intl.formatMessage((0, $7c38be9dfef5efbb$export$a7357cdd1f0b0168).contentHeader),
        subHeader: intl.formatMessage((0, $7c38be9dfef5efbb$export$a7357cdd1f0b0168).contentSubHeader),
        placeholderTitle: intl.formatMessage((0, $7c38be9dfef5efbb$export$a7357cdd1f0b0168).placeHolderTitle)
    };
    return state.schema.nodes.multiBodiedExtension.create({
        extensionType: (0, $f9c7077dbb229b8d$export$12ee1d1507d066e8),
        extensionKey: (0, $f9c7077dbb229b8d$export$b39442728ee427d),
        layout: 'full-width',
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))(),
        parameters: {
            extensionTitle: intl.formatMessage((0, $7c38be9dfef5efbb$export$a7357cdd1f0b0168).lozengeTitle),
            backgroundColor: (0, $f9c7077dbb229b8d$export$617cdcc6afaae4f7),
            contentWidth: (0, $f9c7077dbb229b8d$export$6cccba5fae1d609d)
        }
    }, $8d0d127e1ac72467$var$sectionContentNode(state, initialContentText));
};


const $3e185396515e8d7d$export$243f82fe09087876 = new (0, $kCECX.PluginKey)('companyHubSectionCta');
const $3e185396515e8d7d$export$53e55076862e2785 = (state, pos)=>{
    const { schema: schema, doc: doc } = state;
    const $pos = doc.resolve(pos);
    const isParentDoc = $pos.parent.type === schema.nodes.doc;
    if (!isParentDoc) return false;
    const nodeBefore = $pos.nodeBefore;
    // The button should only appear at the start of the document or after section extensions.
    const isAtStart = !nodeBefore;
    const isAfterSectionExtension = nodeBefore?.attrs.extensionKey === 'hub-section' && nodeBefore?.attrs.extensionType === 'com.atlassian.confluence.hub-section';
    // The button should also appear at the very end of the document.
    const isAtEnd = !$pos.nodeAfter;
    return (isAtStart || isAfterSectionExtension || isAtEnd) && $pos.parent.canReplaceWith($pos.index(), $pos.index(), schema.nodes.multiBodiedExtension);
};
const $3e185396515e8d7d$var$createAnchorDecorations = (state)=>{
    const decs = [];
    const { doc: doc } = state;
    // A map of valid insertion positions to node info.
    const insertPositions = new Map();
    // 1. Check for an insertion point at the very start of the document.
    if ($3e185396515e8d7d$export$53e55076862e2785(state, 0)) {
        // It's the last position if the document is empty.
        const isLastPosition = doc.childCount === 0;
        insertPositions.set(0, {
            prevNodeTypeName: undefined,
            isLastPosition: isLastPosition
        });
    }
    // 2. Check for insertion points after each node in the document.
    doc.content.forEach((node, offset, index)=>{
        const insertPos = offset + node.nodeSize;
        if ($3e185396515e8d7d$export$53e55076862e2785(state, insertPos)) {
            const isLastPosition = index === doc.childCount - 1;
            insertPositions.set(insertPos, {
                prevNodeTypeName: node.type.name,
                isLastPosition: isLastPosition
            });
        }
    });
    // 3. Create decorations for all collected valid positions.
    insertPositions.forEach(({ prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition }, insertPos)=>{
        const anchorId = `section-cta-anchor-${insertPos}`;
        decs.push((0, $8nvEM.Decoration).widget(insertPos, ()=>{
            const anchorEl = document.createElement('span');
            anchorEl.style.cssText = `position: absolute; anchor-name: --${anchorId};`;
            anchorEl.setAttribute('data-section-cta-anchor-name', anchorId);
            return anchorEl;
        }, {
            key: anchorId,
            side: -1,
            anchorId: anchorId,
            prevNodeTypeName: prevNodeTypeName,
            isLastPosition: isLastPosition
        }));
    });
    return (0, $8nvEM.DecorationSet).create(doc, decs);
};
class $3e185396515e8d7d$var$SectionCtaPluginView {
    update(view, prevState) {
        this.view = view;
        this.anchorRectCache.setEditorView(this.view);
        // We re-render only if the decorations have changed - i.e. the user has modified top level nodes
        const oldState = $3e185396515e8d7d$export$243f82fe09087876.getState(prevState);
        const newState = $3e185396515e8d7d$export$243f82fe09087876.getState(view.state);
        if (oldState !== newState) {
            this.anchorRectCache.clear();
            this.renderButtons(view.state);
        }
    }
    destroy() {
        this.anchorRectCache.clear();
        this.root.unmount();
        this.container.remove();
    }
    renderButtons(state) {
        const decorationSet = $3e185396515e8d7d$export$243f82fe09087876.getState(state);
        if (!decorationSet) return;
        const handleClick = (insertPos)=>{
            const command = this.api?.companyHubSectionCtaPlugin?.commands?.insertSection(insertPos, this.intl);
            if (command) command(this.view.state, this.view.dispatch, this.view);
        };
        // Find all our anchor decorations
        const anchorDecos = decorationSet.find();
        this.root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
            value: this.intl
        }, anchorDecos.map((deco)=>{
            const anchorId = deco.spec.anchorId;
            const insertPos = deco.from;
            const prevNodeTypeName = deco.spec.prevNodeTypeName;
            const isLastPosition = deco.spec.isLastPosition;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25ae6494727e09b5$export$e50c8b7ca0cd488e), {
                key: anchorId,
                anchorId: anchorId,
                prevNodeTypeName: prevNodeTypeName,
                isLastPosition: isLastPosition,
                onClick: ()=>handleClick(insertPos),
                anchorRectCache: this.anchorRectCache,
                view: this.view
            });
        })));
    }
    constructor(view, api, intl){
        this.view = void 0;
        this.container = void 0;
        this.root = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.anchorRectCache = void 0;
        this.view = view;
        this.api = api;
        this.intl = intl;
        this.anchorRectCache = new (0, $e83f07559fdac70a$export$e1d230f644ff05aa)();
        this.anchorRectCache.setEditorView(this.view);
        this.container = document.createElement('div');
        this.view.dom.parentElement?.appendChild(this.container);
        this.root = (0, (/*@__PURE__*/$parcel$interopDefault($fRQ3t))).createRoot(this.container);
        this.renderButtons(this.view.state);
    }
}
const $3e185396515e8d7d$export$d82c0e619eaaa2c2 = ({ api: api })=>{
    return {
        name: 'companyHubSectionCtaPlugin',
        pmPlugins () {
            return [
                {
                    name: 'companyHubSectionCtaButton',
                    plugin: ({ getIntl: getIntl })=>{
                        const intl = getIntl();
                        return new (0, $kpCD8.SafePlugin)({
                            key: $3e185396515e8d7d$export$243f82fe09087876,
                            state: {
                                init (_, editorState) {
                                    return $3e185396515e8d7d$var$createAnchorDecorations(editorState);
                                },
                                apply (tr, oldDecs, newState) {
                                    return $3e185396515e8d7d$var$createAnchorDecorations(newState);
                                }
                            },
                            props: {
                                decorations (state) {
                                    // This makes the anchor decorations actually appear in the doc.
                                    return $3e185396515e8d7d$export$243f82fe09087876.getState(state);
                                }
                            },
                            view: (editorView)=>new $3e185396515e8d7d$var$SectionCtaPluginView(editorView, api, intl)
                        });
                    }
                }
            ];
        },
        commands: {
            insertSection: (position, intl)=>{
                return (state, dispatch)=>{
                    if (dispatch) {
                        const { tr: tr } = state;
                        const nodeToInsert = (0, $8d0d127e1ac72467$export$3cf963ab3631af75)(state, intl);
                        tr.insert(position, nodeToInsert);
                        const selection = (0, $kCECX.NodeSelection).create(tr.doc, position);
                        tr.setSelection(selection);
                        dispatch(tr);
                    }
                    return true;
                };
            }
        }
    };
};



var $1pL0T = parcelRequire("1pL0T");


var $dXIrr = parcelRequire("dXIrr");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $3YBks = parcelRequire("3YBks");


var $4EKKB = parcelRequire("4EKKB");





var $3nacY = parcelRequire("3nacY");


var $7T88d = parcelRequire("7T88d");


var $5AKbu = parcelRequire("5AKbu");











var $bFSJa = parcelRequire("bFSJa");


var $6t3CY = parcelRequire("6t3CY");


var $lslMH = parcelRequire("lslMH");


var $5bAC0 = parcelRequire("5bAC0");




const $998cc9ceb52ce297$export$a6f5520975c8a85d = (0, $kSwu1.defineMessages)({
    tabs: {
        id: "editor-plugin-native-tabs-toolbar.tabs",
        defaultMessage: "Tabs"
    }
});


const $c491a67421e67e45$var$NATIVE_TABS_QUICK_INSERT_KEY = 'native-tabs:native-tabs';
const $c491a67421e67e45$var$TABS_BUTTON_TEST_ID = 'editor-toolbar-tabs-button';
const $c491a67421e67e45$export$a117598b3d44511f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const cachedTabsItem = (0, $cozmU.useRef)(null);
    if (!api?.quickInsert) return null;
    const onClick = ()=>{
        if (editorView) {
            let tabsItem = cachedTabsItem.current;
            if (!tabsItem) {
                const suggestions = api?.quickInsert?.actions?.getSuggestions({
                    query: '',
                    disableDefaultItems: false
                });
                tabsItem = suggestions?.find((item)=>item.key === $c491a67421e67e45$var$NATIVE_TABS_QUICK_INSERT_KEY) ?? null;
                if (tabsItem) cachedTabsItem.current = tabsItem;
            }
            if (tabsItem) {
                const { state: state, dispatch: dispatch } = editorView;
                api?.quickInsert?.actions?.insertItem(tabsItem, (0, $krYZG.INPUT_METHOD).TOOLBAR)(state, dispatch);
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $998cc9ceb52ce297$export$a6f5520975c8a85d).tabs)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5bAC0))), {
            label: formatMessage((0, $998cc9ceb52ce297$export$a6f5520975c8a85d).tabs),
            size: "small"
        }),
        onClick: onClick,
        testId: $c491a67421e67e45$var$TABS_BUTTON_TEST_ID
    }));
};


/**
 * Hardcoded toolbar constants for the native tabs toolbar button.
 * These are kept within this plugin rather than in editor-common
 * because native tabs is a private Confluence feature.
 */ const $0c12e133eae86678$var$TABS_GROUP = {
    key: 'tabs-group',
    type: 'group'
};
const $0c12e133eae86678$var$TABS_BUTTON = {
    key: 'tabs-button',
    type: 'button'
};
/**
 * Rank of the tabs group within the INSERT_BLOCK_SECTION.
 * Positioned between layout (600) and synced-block (700).
 */ const $0c12e133eae86678$var$TABS_GROUP_SECTION_RANK = 650;
/**
 * Rank of the tabs button within the tabs group.
 */ const $0c12e133eae86678$var$TABS_BUTTON_GROUP_RANK = 100;
const $0c12e133eae86678$var$getToolbarComponents = (api)=>{
    return [
        {
            type: $0c12e133eae86678$var$TABS_GROUP.type,
            key: $0c12e133eae86678$var$TABS_GROUP.key,
            parents: [
                {
                    type: (0, $3nacY.INSERT_BLOCK_SECTION).type,
                    key: (0, $3nacY.INSERT_BLOCK_SECTION).key,
                    rank: $0c12e133eae86678$var$TABS_GROUP_SECTION_RANK
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                    above: "md"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children))
        },
        {
            type: $0c12e133eae86678$var$TABS_BUTTON.type,
            key: $0c12e133eae86678$var$TABS_BUTTON.key,
            parents: [
                {
                    type: $0c12e133eae86678$var$TABS_GROUP.type,
                    key: $0c12e133eae86678$var$TABS_GROUP.key,
                    rank: $0c12e133eae86678$var$TABS_BUTTON_GROUP_RANK
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c491a67421e67e45$export$a117598b3d44511f), {
                    api: api
                })
        }
    ];
};
const $0c12e133eae86678$export$c5dd41c01dfdca7c = ({ api: api })=>{
    api?.toolbar?.actions.registerComponents($0c12e133eae86678$var$getToolbarComponents(api));
    return {
        name: 'nativeTabsToolbar'
    };
};



var $iHrpD = parcelRequire("iHrpD");


var $2x28u = parcelRequire("2x28u");


var $6mKj3 = parcelRequire("6mKj3");


var $8pcS0 = parcelRequire("8pcS0");

function $7cb36df2e500ad5f$export$d4ded51d0f0bd2df(extensionParams) {
    const { extensionKey: extensionKey, extensionType: extensionType, parameters: parameters } = extensionParams;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INVALID && extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION) return parameters?.nestedContent;
}






var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");








var $cqCFf = parcelRequire("cqCFf");

const $4eff3da02bf6b0b9$export$ce9fbb23568613c5 = (_view, event)=>{
    /**
   * We have to use the event.target to indentify that we are dealing with the live search extension
   * instead of the current editor selection because
   *   1. We can’t guarantee the selection won’t change while we are in the extension
   *   2. Often times the selection is not the extension despite currently interacting with the extension
   *
   * As a result, we have to rely on the event.target to identify if the current event is meant for the
   * live search extension.
   */ const isLiveSearchExtensionElement = event.target.classList.contains(`${(0, $cqCFf.LIVE_SEARCH_SELECT_CLASSNAME_PREFIX)}__input`) || event.target.className === (0, $cqCFf.LIVE_SEARCH_BUTTON_CLASSNAME);
    return (event.target instanceof HTMLInputElement || event.target instanceof HTMLButtonElement) && isLiveSearchExtensionElement;
};
const $4eff3da02bf6b0b9$export$c9403d1366bd779d = {
    keydown: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keyup: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keypress: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    beforeinput: $4eff3da02bf6b0b9$export$ce9fbb23568613c5
};



var $kyKWe = parcelRequire("kyKWe");




const $73f6dfc0acf21779$export$14e5c8eb6f32c76 = (slice)=>{
    const updatedContent = [];
    slice.content.forEach((node)=>{
        if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') {
            // Update the value of the macro param used as anchor name (used as html id in UI) to a unique value, UUID.
            const newAttrs = {
                ...node.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    macroParams: {
                        ...node.attrs.parameters.macroParams,
                        '': {
                            value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                        }
                    }
                }
            };
            updatedContent.push(node.type.create(newAttrs, node.content, node.marks));
        } else updatedContent.push(node);
    });
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(updatedContent), slice.openStart, slice.openEnd);
};


// Duplicate of TEXTFIELD_ID from @atlassian/dynamic-cards-search-page
const $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID = 'ch-search-text-query-input';
const $23f33cc0c92651d7$export$eb1b190bb6345745 = (_view, event)=>{
    /**
	 * We have to use the event.target to indentify that we are dealing with the Company Hub search extension
	 * instead of the current editor selection because
	 *   1. We can’t guarantee the selection won’t change while we are in the extension
	 *   2. Often times the selection is not the extension despite currently interacting with the extension
	 *
	 * As a result, we have to rely on the event.target to identify if the current event is meant for the
	 * Company Hub search extension.
	 */ return event.target instanceof HTMLInputElement && event.target.id === $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID;
};
const $23f33cc0c92651d7$export$47b865254c03e3eb = {
    keydown: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keyup: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keypress: $23f33cc0c92651d7$export$eb1b190bb6345745,
    beforeinput: $23f33cc0c92651d7$export$eb1b190bb6345745
};


const $1a6e0310908ffd24$export$234cb421a967be1c = 'extensionManager';
const $1a6e0310908ffd24$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)($1a6e0310908ffd24$export$234cb421a967be1c);
const $1a6e0310908ffd24$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        key: $1a6e0310908ffd24$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({}),
            apply (tr, pluginState) {
                const metadata = tr.getMeta($1a6e0310908ffd24$export$18d4026d1ea86bb1);
                if (metadata) return {
                    ...pluginState,
                    ...metadata
                };
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                ...(0, $4eff3da02bf6b0b9$export$c9403d1366bd779d),
                ...(0, $23f33cc0c92651d7$export$47b865254c03e3eb)
            },
            transformPasted: (0, $73f6dfc0acf21779$export$14e5c8eb6f32c76)
        }
    });









var $jfFbl = parcelRequire("jfFbl");


var $kTb7m = parcelRequire("kTb7m");











var $1NBp8 = parcelRequire("1NBp8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $cEgMD = parcelRequire("cEgMD");













const $999bd16bdfd9c01c$var$i18n = (0, $kSwu1.defineMessages)({
    defaultTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip",
        defaultMessage: "Copy link to anchor"
    },
    erroredTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.disabled",
        defaultMessage: "Edit to create link"
    },
    copySuccessTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.copied",
        defaultMessage: "Copied!"
    }
});
const $999bd16bdfd9c01c$export$baeb5f600fdaf82a = ()=>({ tr: tr })=>tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
            showAnchorLinkCopiedTooltip: undefined
        });
const $999bd16bdfd9c01c$export$94a93fd1fcc43123 = ({ node: node, intl: intl, api: api, updateTooltipPosition: updateTooltipPosition })=>{
    const showAnchorLinkCopiedTooltip = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        (0, $1a6e0310908ffd24$export$234cb421a967be1c)
    ], (states)=>states?.extensionManagerState?.showAnchorLinkCopiedTooltip);
    const isValidAnchorName = (0, $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8)(node);
    (0, $cozmU.useEffect)(()=>{
        // Reset the state of `showAnchorLinkCopiedTooltip` back to default when the component unmounts
        return ()=>{
            api?.core?.actions?.execute?.($999bd16bdfd9c01c$export$baeb5f600fdaf82a());
        };
    }, [
        api
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        // When the content of a visible tooltip changes, its' position isn't recalculated
        // and the tooltip may become misaligned. Since we change the tooltip content when
        // the link is copied, we need to manually recalculate the tooltip position.
        if (showAnchorLinkCopiedTooltip) updateTooltipPosition?.();
    }, [
        showAnchorLinkCopiedTooltip,
        updateTooltipPosition
    ]);
    if (!isValidAnchorName) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, intl.formatMessage($999bd16bdfd9c01c$var$i18n.erroredTooltipContent));
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, !!showAnchorLinkCopiedTooltip ? intl.formatMessage($999bd16bdfd9c01c$var$i18n.copySuccessTooltipContent) : intl.formatMessage($999bd16bdfd9c01c$var$i18n.defaultTooltipContent)));
};


const $a511a7deb986d4c1$var$i18n = (0, $kSwu1.defineMessages)({
    anchorMacroCopyLinkCTALabel: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.label",
        defaultMessage: "Copy link"
    }
});
const $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8 = (node)=>{
    const rawAnchorName = node.attrs.parameters.macroParams['']?.value;
    // Normalize TinyMCE-era anchor names: strip spaces to match legacy URL format.
    let anchorName = rawAnchorName;
    if (typeof rawAnchorName === 'string' && (0, $iDrrr.fg)('platform_editor_anchor_spaces_normalization')) anchorName = rawAnchorName.replaceAll(/\s+/g, '');
    if (!anchorName) return false;
    try {
        decodeURIComponent(anchorName);
        return true;
    } catch  {
        return false;
    }
};
const $a511a7deb986d4c1$var$getPathName = (isLivePage, contentId, spaceKey)=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) return (0, $1NBp8.COMPANY_HUB).toUrl();
    if (isLivePage) return typeof window !== 'undefined' ? window.location.pathname : '';
    return (0, $1NBp8.VIEW_PAGE).toUrl({
        contentId: contentId,
        spaceKey: spaceKey
    });
};
const $a511a7deb986d4c1$var$encodeAnchorNameForUrlFragment = (anchorName)=>{
    // Encode as a fragment value, but keep `/` readable for path-like anchor names.
    return encodeURIComponent(anchorName).replace(/%2F/gi, '/');
};
const $a511a7deb986d4c1$export$548d9151b6657224 = (node, fireAnalyticsEvent)=>(state, dispatch)=>{
        const { tr: tr } = state;
        const { isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey } = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(state)?.pageContext ?? {};
        const rawAnchorName = node.attrs.parameters.macroParams['']?.value;
        // Normalize TinyMCE-era anchor names: strip spaces to match legacy URL format.
        let anchorName = rawAnchorName;
        if (typeof rawAnchorName === 'string' && (0, $iDrrr.fg)('platform_editor_anchor_spaces_normalization')) anchorName = rawAnchorName.replaceAll(/\s+/g, '');
        const pathName = $a511a7deb986d4c1$var$getPathName(isLivePage, contentId, spaceKey);
        const setShowAnchorLinkCopiedTooltip = (showAnchorLinkCopiedTooltip)=>{
            dispatch?.(tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                showAnchorLinkCopiedTooltip: showAnchorLinkCopiedTooltip
            }));
        };
        fireAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).COPY_LINK_TO_ANCHOR,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                extensionKey: node.attrs?.extensionKey,
                extensionType: node.attrs?.extensionType,
                isLivePage: isLivePage
            }
        });
        if (dispatch) try {
            decodeURIComponent(anchorName ?? '');
            const anchorNameForUrlFragment = (0, $iDrrr.fg)('cc_page_experiences_anchor_encode') ? $a511a7deb986d4c1$var$encodeAnchorNameForUrlFragment(anchorName ?? '') : anchorName ?? '';
            (0, $jfFbl.copyToClipboard)(`${typeof window !== 'undefined' ? window.location.origin : ''}${pathName}#${anchorNameForUrlFragment}`).then(()=>{
                setShowAnchorLinkCopiedTooltip(true);
            }).catch((error)=>{
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
                });
                setShowAnchorLinkCopiedTooltip(false);
            });
        } catch  {
            setShowAnchorLinkCopiedTooltip(false);
        }
        return true;
    };
const $a511a7deb986d4c1$export$3178138fc316e9da = (toolbarItems, intl, node, api)=>{
    const updatedToolbarItems = toolbarItems.slice();
    const indexOfFirstSeperator = toolbarItems.map((item)=>item.type).indexOf('separator');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = api?.analytics?.actions ?? {};
    const newItemsToInsert = [
        {
            id: 'editor.anchor.macro.copy-link',
            type: 'button',
            title: intl.formatMessage($a511a7deb986d4c1$var$i18n.anchorMacroCopyLinkCTALabel),
            tooltipContent: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $999bd16bdfd9c01c$export$94a93fd1fcc43123), {
                    node: node,
                    intl: intl,
                    api: api,
                    updateTooltipPosition: update
                }),
            showTitle: true,
            hideTooltipOnClick: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            onClick: $a511a7deb986d4c1$export$548d9151b6657224(node, fireAnalyticsEvent),
            disabled: !$a511a7deb986d4c1$export$f57cb5ad5ec9d3a8(node)
        }
    ];
    /**
   * If there is no separator, 1 group present, add
   * separator before the new items to create a new visual
   */ if (indexOfFirstSeperator === -1) newItemsToInsert.unshift({
        type: 'separator',
        hidden: false
    });
    else if (indexOfFirstSeperator !== 0 && indexOfFirstSeperator !== toolbarItems.length - 1) newItemsToInsert.push({
        type: 'separator',
        hidden: false
    });
    updatedToolbarItems.splice(indexOfFirstSeperator + 1, 0, ...newItemsToInsert);
    return updatedToolbarItems;
};
const $a511a7deb986d4c1$export$1ddc93af5b94ad04 = {
    shouldApplyOverride: (state, config)=>{
        const isCurrentSelectionAnchorMacro = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && state.selection.node.attrs.extensionKey === 'anchor';
        return isCurrentSelectionAnchorMacro && (Array.isArray(config.nodeType) ? config.nodeType.includes(state.schema.nodes.inlineExtension) : config.nodeType === state.schema.nodes.inlineExtension);
    },
    applyOverride: (config, intl, api)=>{
        if (Array.isArray(config.items)) {
            const toolbarItems = config.items;
            config.items = (node)=>{
                if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') return $a511a7deb986d4c1$export$3178138fc316e9da(toolbarItems, intl, node, api);
                return toolbarItems;
            };
        }
    }
};


const $ea140a6e73833f23$export$86ce8f8241c20a3 = (state, intl, _providerFactory, activeConfigs, api)=>{
    if (!activeConfigs?.length) return;
    const overrides = [
        (0, $a511a7deb986d4c1$export$1ddc93af5b94ad04)
    ];
    activeConfigs.forEach((config)=>{
        overrides.forEach(({ shouldApplyOverride: shouldApplyOverride, applyOverride: applyOverride })=>{
            if (shouldApplyOverride(state, config)) applyOverride(config, intl, api);
        });
    });
};


const $b6333eeaeea6365c$export$53933ef6873e4a9f = ({ api: api })=>({
        name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
        pmPlugins () {
            return [
                {
                    name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
                    plugin: ()=>(0, $1a6e0310908ffd24$export$ae829ec7b2625219)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(editorState);
            return {
                showAnchorLinkCopiedTooltip: pluginState?.showAnchorLinkCopiedTooltip
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
            const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
            (0, $cozmU.useEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                    pageContext: {
                        isLivePage: isLivePage,
                        spaceKey: spaceKey,
                        contentId: contentId
                    }
                });
                dispatch(tr);
            }, [
                editorView,
                isLivePage,
                spaceKey,
                contentId
            ]);
        },
        pluginsOptions: {
            floatingToolbar: (...args)=>(0, $ea140a6e73833f23$export$86ce8f8241c20a3)(...args, api)
        }
    });



var $9wGTI = parcelRequire("9wGTI");








var $1KOhB = parcelRequire("1KOhB");


var $6Ixg8 = parcelRequire("6Ixg8");


var $7TcbF = parcelRequire("7TcbF");








var $9dHNS = parcelRequire("9dHNS");


var $5aU9U = parcelRequire("5aU9U");


var $l5rX3 = parcelRequire("l5rX3");


var $73Kv0 = parcelRequire("73Kv0");


var $3xuv0 = parcelRequire("3xuv0");



















const $bcc122a52e0f74cf$export$3b87fd119d006909 = new (0, $kCECX.PluginKey)('editorOfflineStoragePlugin');
const $bcc122a52e0f74cf$export$ae829ec7b2625219 = (stepsDatabase)=>()=>{
        return new (0, $kpCD8.SafePlugin)({
            key: $bcc122a52e0f74cf$export$3b87fd119d006909,
            state: {
                init () {
                    // environment-aware enablement via feature encoding
                    const isEditorFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-editor-offline-storage');
                    return {
                        status: 'pending',
                        disabled: !isEditorFeatureEnabled ? 'disabledEnvironment' : false,
                        inactiveSyncing: false
                    };
                },
                apply: (tr, currentPluginState)=>{
                    const meta = tr.getMeta($bcc122a52e0f74cf$export$3b87fd119d006909);
                    if (meta) return {
                        ...currentPluginState,
                        ...meta
                    };
                    return currentPluginState;
                }
            },
            view: ()=>{
                return {
                    destroy () {
                        return stepsDatabase.closeDB(true);
                    }
                };
            }
        });
    };


class $5c049076093b3a44$export$d15eb9e8bb5d03ea {
    get hasLock() {
        return this._hasLock;
    }
    get lockPurpose() {
        return this._lockPurpose;
    }
    init(dbName) {
        this.dbName = dbName;
    }
    /**
   * Release the lock so it can be used elsewhere
   */ releaseLock() {
        this._releaseLock();
    }
    /**
   * Acquire the lock for the page
   *
   * **Waiting on this function will block until the lock is acquired then released, or the lock request is aborted.**
   * If waitUntilAvailable is set to `true`, the lock request will wait for the lock to become available.
   * If waitUntilAvailable is set to `false`, the lock request will abort if the lock is not available at the time it's requested.
   *
   * @param callback - The callback to run when the lock is acquired or the lock request is aborted
   * @param waitUntilAvailable - When set to true the lock request will wait until the lock is available
   */ async acquireLock(callback, waitUntilAvailable = false, purpose) {
        if (!this.dbName) return Promise.reject(new Error('SynchronisationLock not initialized.'));
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        await navigator.locks?.request(this.dbName, {
            ifAvailable: !waitUntilAvailable
        }, async (lock)=>{
            if (lock === null) {
                await callback?.(false);
                return;
            }
            const promise = this.holdLock();
            this._lockPurpose = purpose;
            await callback?.(true);
            return promise;
        });
    }
    /**
   * If the lock is currently taken and therefore we shouldn't send any data
   */ async isLocked() {
        if (!this.dbName) return false;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const locks = await navigator.locks?.query();
        const relevantLocks = locks?.held ? locks.held.filter((lock)=>lock.name === this.dbName) : [];
        if (relevantLocks && relevantLocks.length > 0) return true;
        else return false;
    }
    constructor(){
        this.dbName = void 0;
        this._hasLock = false;
        this._lockPurpose = void 0;
        this._releaseLock = ()=>{};
        this.holdLock = async ()=>{
            this._hasLock = true;
            let resolve;
            this._releaseLock = ()=>{
                // resolving the promise will release the lock
                resolve({});
                this._hasLock = false;
                this._lockPurpose = undefined;
            };
            return new Promise((res)=>{
                resolve = res;
            });
        };
    }
}





const $1a899df20ad45f18$var$isTrackEvent = (props)=>{
    return props.action === 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION';
};
const $1a899df20ad45f18$export$6bd08bb9f59ca292 = (props)=>{
    const { api: api, action: action, ...otherAttributes } = props;
    if (!api || !api.analytics) return;
    // Get additional context from shared state
    const sharedPluginState = api?.editorOfflineStorage?.sharedState.currentState();
    const { version: version, steps: steps, status: status, disabled: disabled } = sharedPluginState ?? {};
    api.analytics.actions?.fireAnalyticsEvent?.({
        eventType: $1a899df20ad45f18$var$isTrackEvent(props) ? (0, $krYZG.EVENT_TYPE).TRACK : (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        action: action,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).OFFLINE_EDITING,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).OFFLINE_EDITING,
        attributes: {
            version: // Additonal context.
            version,
            stepsCount: steps?.length,
            status: status,
            disabled: disabled,
            // Action specific attributes.
            ...otherAttributes
        }
    });
};
const $1a899df20ad45f18$export$91c32f1b22d29b2d = (error)=>{
    if (!error) return 'Unknown error';
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return String(error);
};
const $1a899df20ad45f18$export$ff269655d7dc6e77 = (errors)=>{
    return errors.map((e)=>$1a899df20ad45f18$export$91c32f1b22d29b2d(e)).join(';');
};


/**
 * Background cleanup logic for expired offline editor databases.
 *
 * This module handles checking all databases from other documents and taking action:
 * - Deletes fully-expired databases
 * - Clears expired data while preserving fresh data
 * - Migrates pre-migration databases by adding timestamps
 */ 



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $awSMG = parcelRequire("awSMG");


const $e9c926f713f211d2$var$THIRTY_DAYS_MS = 2592000000;
const $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS = 86400000;
const $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP = 100; // Cap to prevent performance issues on first load
/**
 * Extract contentId from database name by removing the prefix.
 */ const $e9c926f713f211d2$var$extractContentId = (dbName)=>dbName.replace((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX), '');
function $e9c926f713f211d2$export$365e5e8d6c8a82b3() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return false;
        const lastAttempt = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT);
        if (!lastAttempt) return true;
        const timeSinceLastAttempt = Date.now() - parseInt(lastAttempt, 10);
        return timeSinceLastAttempt > $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        // Storage access failed - return false to skip cleanup (non-critical)
        return false;
    }
}
function $e9c926f713f211d2$export$df49bbb19630c32d() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT, Date.now().toString());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
    // Storage access failed - continue silently (non-critical)
    }
}
/**
 * Delete an entire database.
 */ async function $e9c926f713f211d2$var$deleteDatabase(dbName) {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.deleteDatabase(dbName);
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
        request.onblocked = ()=>resolve();
    });
}
/**
 * Add timestamp to pre-migration data to migrate it.
 */ async function $e9c926f713f211d2$var$addTimestampToMigrateData(database, metaData) {
    const tx = database.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
    const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
    const updatedMetaData = {
        ...metaData || {
            doc: null,
            version: null
        },
        lastUpdated: Date.now()
    };
    await metaStore.put(updatedMetaData, 1);
    await tx.done;
}
async function $e9c926f713f211d2$export$197ab581d971f15a(dbName) {
    try {
        const db = await (0, $9dHNS.openDB)(dbName, (0, $awSMG.OFFLINE_STEPS_DATABASE_VERSION), {
            upgrade (database) {
                // Create stores if they don't exist
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            blocking: (_currentVersion, _blockedVersion, event)=>{
                // Close the database connection if the database is deleted or version changes
                // This is important for Firefox compatibility when deleting databases. See HOT-12395 for more details.
                if (event?.target) event.target.close();
            }
        });
        try {
            // Check if both stores exist - if not, database is invalid
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) {
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'invalid',
                    errorMessage: 'Database missing required object stores'
                };
            }
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_META_STORE_NAME),
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME)
            ], 'readonly');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const metaData = await metaStore.get(1);
            const stepsCount = await stepsStore.count();
            // Empty database: No meta data AND no steps. Safe to delete.
            if (!metaData && stepsCount === 0) {
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'empty'
                };
            }
            // Migration: Missing metadata or missing timestamp. Add timestamp and skip deletion.
            if (!metaData || !metaData.lastUpdated) {
                await $e9c926f713f211d2$var$addTimestampToMigrateData(db, metaData);
                return {
                    dbName: dbName,
                    deleted: false,
                    reason: 'migrated'
                };
            }
            // At this point, metaData.lastUpdated is guaranteed to exist (migrated above)
            const currentTimestamp = Date.now();
            const databaseAge = currentTimestamp - metaData.lastUpdated;
            const isExpired = databaseAge > $e9c926f713f211d2$var$THIRTY_DAYS_MS;
            // Expired: Delete entire database.
            if (isExpired) {
                const daysExpired = Math.floor(databaseAge / 86400000);
                const hasBackup = !!metaData.versionInsertionBackup;
                db.close();
                await $e9c926f713f211d2$var$deleteDatabase(dbName);
                return {
                    dbName: dbName,
                    deleted: true,
                    reason: 'expired',
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                };
            }
            // Not expired: Database is active.
            return {
                dbName: dbName,
                deleted: false,
                reason: 'active'
            };
        } catch (error) {
            return {
                dbName: dbName,
                deleted: false,
                reason: 'error',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
            };
        } finally{
            db.close();
        }
    } catch (error) {
        // Can't open the database - treat as error case
        return {
            dbName: dbName,
            deleted: false,
            reason: 'error',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
        };
    }
}
async function $e9c926f713f211d2$export$1419703707730bf4(currentDbName, api) {
    try {
        if (!window.indexedDB.databases) return;
        const allDatabases = await window.indexedDB.databases();
        const offlineEditorDatabases = allDatabases.filter((dbInfo)=>dbInfo.name?.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)) && dbInfo.name !== currentDbName);
        const totalOfflineDatabases = offlineEditorDatabases.length;
        let databasesProcessed = 0;
        let databasesDeleted = 0;
        const cleanupDetails = [];
        // Early exit if no databases to process
        if (totalOfflineDatabases === 0) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_COMPLETED',
                databasesProcessed: 0,
                databasesDeleted: 0,
                totalOfflineDatabases: 0,
                cleanupDetails: []
            });
            return;
        }
        // We randomise the order to ensure all databases eventually get checked. Otherwise, we'd check the first N databases every time.
        // We also cap the number of databases checked per run to prevent performance issues. For power users with large backlogs, cleanup will happen gradually over multiple days.
        const randomisedDatabases = offlineEditorDatabases.sort(()=>Math.random() - 0.5);
        const databasesToCheck = randomisedDatabases.slice(0, $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP);
        for (const dbInfo of databasesToCheck){
            const dbName = dbInfo.name;
            try {
                const result = await $e9c926f713f211d2$export$197ab581d971f15a(dbName);
                databasesProcessed++;
                // Fire analytics for database deletions (expired, empty, or invalid)
                if (result.reason === 'expired' || result.reason === 'empty' || result.reason === 'invalid') {
                    databasesDeleted++;
                    cleanupDetails.push({
                        contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                        deletionReason: result.reason,
                        daysExpired: result.daysExpired ?? 0,
                        stepsCount: result.stepsCount ?? 0,
                        hasBackup: result.hasBackup ?? false
                    });
                }
                // Fire analytics for database check errors
                if (result.reason === 'error') (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: result.errorMessage ?? 'Unknown error',
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            } catch (error) {
                databasesProcessed++;
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            }
        }
        // Fire completion analytics for every cleanup run
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_COMPLETED',
            databasesProcessed: databasesProcessed,
            databasesDeleted: databasesDeleted,
            totalOfflineDatabases: totalOfflineDatabases,
            cleanupDetails: cleanupDetails
        });
    } catch (error) {
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: 'cleanup_init'
        });
    }
}





const $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS = 20000;
const $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS = 2592000000;
class $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c {
    // Used to cache the result of the IndexedDB validation.
    onError(_id, error, disabledReason) {
        // Indicate the steps database is not healthy.
        this.api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                disabled: disabledReason ?? 'stepsDatabaseError'
            }));
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: this.api,
            action: (0, $krYZG.ACTION).OFFLINE_STORAGE_STEPS_DATABASE_ERROR,
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: _id,
            errorCause: {
                contentIdPresent: !!this.contentId,
                stepsDatabaseInitAttempted: this.initAttempted,
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isSSR: false,
                isIndexedDBAvailable: this.indexedDBAvailable
            }
        });
    }
    /**
   * The name of the database for the current contentId
   */ get dbName() {
        if (!this.contentId) return undefined;
        return `${0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX}${this.contentId}`;
    }
    get hasLock() {
        return this.syncLock.hasLock;
    }
    get lockPurpose() {
        return this.syncLock.lockPurpose;
    }
    isLocked() {
        return this.syncLock.isLocked();
    }
    /**
   * Releases the current sync lock. Returns a promise to check if the lock has been released
   * at this point which can be useful if you want to do other operations (ie. update the DB)
   * based on the lock status and need it to be freed.
   *
   * @returns boolean: The result if the sync is still locked.
   */ async releaseSyncLock() {
        this.syncLock.releaseLock?.();
        return this.syncLock.isLocked();
    }
    /**
   * Attempts to acquire a synchronization lock for the database.
   *
   * @param callback - Optional callback function that is called when the lock is acquired or times out.
   *                  The callback receives a boolean indicating if the lock was granted.
   * @param waitUntilAvailable - If true, waits until the lock becomes available. If false, returns immediately.
   * @param timeoutAfterMS - Optional timeout in milliseconds. If provided and waitUntilAvailable is true,
   *                        the callback will be called with false if the lock isn't acquired within this time.
   *                        When platform_editor_offline_editing_web_ga_fixes is cleaned up, this parameter can be removed.
   * @returns A Promise if waiting for the lock, void if not waiting.
   */ acquireSyncLock(callback, waitUntilAvailable = false, purpose, timeoutAfterMS) {
        const lockPromise = this.syncLock.acquireLock(callback, waitUntilAvailable, purpose).catch((e)=>{
            this.onError('acquireSyncLock()', e);
            // Ensure callback is called with false on error
            return callback?.(false);
        });
        // If we're not waiting for the lock, fire-and-forget
        if (!waitUntilAvailable) return;
        const effectiveTimeout = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS : timeoutAfterMS;
        // If we have a timeout, race the lock acquisition with a timeout. Redundant check when platform_editor_offline_editing_web_ga_fixes is cleaned up.
        if (effectiveTimeout) {
            const timeoutPromise = new Promise((resolve)=>{
                setTimeout(async ()=>{
                    // Callback invoked with granted = false, failed attempt to acquire lock.
                    await callback?.(false);
                    resolve();
                }, effectiveTimeout);
            });
            return Promise.race([
                lockPromise,
                timeoutPromise
            ]);
        }
        return lockPromise;
    }
    /**
   * Initialize the class for the given contentId.
   * Can be re-initialized with a different contentId, which will close an existing connection.
   * Does not open the database connection.
   * @param contentId The unique page contentId
   * @returns true if initialized successfully, false if indexedDB is not supported.
   */ async init(contentId, api) {
        this.initAttempted = true;
        this.api = api;
        if (window?.indexedDB === undefined) {
            this.onError('init()', new Error('indexedDB is not defined'));
            return false;
        }
        if (this.contentId === contentId && this.dbPromise) return true;
        this.contentId = contentId;
        if (this.dbName) this.syncLock.init(this.dbName);
        return true;
    }
    /**
   * Validates IndexedDB access by attempting a test write.
   * @returns Promise<boolean> - true if validation succeeds, false if it fails
   */ async validateIndexedDBAccess() {
        // Check the cached indexedDBAvailable to avoid validating multiple times.
        if (this.indexedDBAvailable !== undefined) return this.indexedDBAvailable ?? true;
        try {
            if (window?.indexedDB === undefined) throw new Error('indexedDB is not defined');
            const testDbName = 'editor:offline-storage-access-test';
            const testDb = await (0, $9dHNS.openDB)(testDbName, 1, {
                upgrade (database) {
                    database.createObjectStore('test', {
                        autoIncrement: true
                    });
                }
            });
            // Try a test write
            const tx = testDb.transaction('test', 'readwrite');
            const store = tx.objectStore('test');
            await store.add({
                test: 'test'
            });
            await tx.done;
            // Clean up
            testDb.close();
            window.indexedDB.deleteDatabase(testDbName);
            this.indexedDBAvailable = true;
            return true;
        } catch (error) {
            this.onError('validateIndexedDBAccess()', error, 'indexedDBAccessError');
            this.indexedDBAvailable = false;
            return false;
        }
    }
    /**
   * Gets or creates a database connection for the current contentId.
   * If a connection exists, validates it is still usable before returning.
   * If validation fails or no connection exists, creates and returns a new connection.
   *
   * @throws {Error} When dbName is undefined (not initialized – missing contentId, init not called, or in SSR mode)
   * @returns A promise that resolves to a valid database connection
   */ async openDB() {
        if (this.dbName === undefined) throw new Error('StepsDatabase not initialized. Possibly missing contentId, init hasnt been called or rendering in SSR mode.');
        // If we have a cached connection, we validate it with a quick read transaction.
        // If this transaction fails, we close the connection and create a new one.
        if (this.dbPromise) try {
            const db = await this.dbPromise;
            await db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly').objectStore((0, $awSMG.OFFLINE_META_STORE_NAME)).count();
            // Returning the valid cached database connection.
            return this.dbPromise;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (_error) {
            // Cleanup before creating a new connection.
            await this.closeDB();
        }
        this.dbPromise = (0, $9dHNS.openDB)(this.dbName, (0, $awSMG.OFFLINE_STEPS_DATABASE_VERSION), {
            upgrade (database) {
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!database.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) database.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            terminated: ()=>{
                this.dbPromise = undefined;
            },
            blocking: (_currentVersion, _blockedVersion, event)=>{
                // Close the database connection when version changes or database is deleted
                // This is important for Firefox compatibility when deleting databases. See HOT-12395 for more details.
                if (event?.target) // event.target is the database object that the versionchange event was fired on
                event.target.close();
            }
        });
        return this.dbPromise;
    }
    sanitizeStep(step) {
        if (step instanceof (0, $l5rX3.AnalyticsStep) || step instanceof (0, $73Kv0.LinkMetaStep)) return undefined;
        return step.toJSON();
    }
    /**
   * Update the steps, doc and version in the database if the stored steps are different.
   * It does a full clear and replace with the new steps.
   * @param version The collab version for creating unique key/value pairs in the db
   * @param steps The steps to store in the database
   * @returns true if the steps were updated, false if the steps were the same as the stored steps
   */ async updateIfChanged(version, baseDocJSON, steps) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = (0, $9dHNS.unwrap)(tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME)));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // We breakout of idb here. The reason is it ensures we have a single promise
            // for `updateSteps` and ensures `fake-indexeddb` works as intended here.
            // This allows us to test as close as possible to real indexeddb
            const updateSteps = async ()=>{
                await new Promise((resolve, reject)=>{
                    const localSteps = steps.map(this.sanitizeStep).filter((step)=>!!step);
                    const request = stepsStore.clear();
                    request.onsuccess = ()=>{
                        // Store serialized steps in the database
                        let index = 0;
                        const addNextStep = ()=>{
                            if (index < localSteps.length) {
                                const serializedStep = localSteps[index];
                                const addRequest = stepsStore.add({
                                    step: serializedStep
                                });
                                addRequest.onsuccess = ()=>{
                                    index++;
                                    addNextStep();
                                };
                                addRequest.onerror = (event)=>{
                                    reject(event.target?.error);
                                };
                            } else resolve(undefined);
                        };
                        addNextStep();
                    };
                    request.onerror = (event)=>{
                        reject(event.target?.error);
                    };
                });
            };
            await Promise.all([
                updateSteps(),
                // Store the doc, version, and lastUpdated timestamp
                docStore.put({
                    doc: baseDocJSON,
                    version: version,
                    lastUpdated: Date.now()
                }, 1)
            ]);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateIfChanged()', e);
            throw e;
        }
    }
    /**
   * Update the stored docJSON and version in the database.
   * This can be called by the leader after applying steps to save the post-apply state for followers.
   * Extracts the confirmed document state and collaboration version from the editor view.
   * @param editorView The editor view to extract document state and version from
   * @returns Promise<boolean> - true if updated successfully, throws on error
   */ async updateDocAndVersion(editorView) {
        try {
            const newVersion = (0, $7TcbF.getCollabState)(editorView.state)?.version;
            if (newVersion === undefined) return false;
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const transformer = new (0, $3xuv0.JSONTransformer)();
            // We use getDocBeforeUnconfirmedSteps to ensure we get the latest _confirmed_ document, as some
            // ... unconfirmed steps may have come through while clearing the offline steps and updating the docJSON.
            const newDocJSON = transformer.encode((0, $7TcbF.getDocBeforeUnconfirmedSteps)(editorView.state));
            // Update doc, version, and lastUpdated timestamp
            const updatedData = {
                doc: newDocJSON,
                version: newVersion,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateDocAndVersion()', e);
            throw e;
        }
    }
    /**
   * Retrieve the steps, doc and version from the database.
   * Will open a new database connection, if one is not already open.
   * @param pmSchema The current ProseMirror schema
   * @returns The steps stored in the database
   */ async getData(pmSchema) {
        try {
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readonly');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // Collect all steps
            const collectSteps = async ()=>{
                const steps = await stepsStore.getAll();
                return steps.map((stepJson)=>(0, $5aU9U.Step).fromJSON(pmSchema, stepJson.step));
            };
            const [storedSteps, data] = await Promise.all([
                collectSteps(),
                docStore.get(1)
            ]);
            await tx.done;
            return data === undefined ? {
                steps: storedSteps,
                docJSON: null,
                version: null
            } : {
                steps: storedSteps,
                docJSON: data.doc,
                version: data.version
            };
        } catch (e) {
            this.onError('getData()', e);
            throw e;
        }
    }
    /**
   * Clear all steps, and stored doc from the database
   * Will open a new database connection, if one is not already open.
   */ async clear(all) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            if (all) await Promise.all([
                stepsStore.clear(),
                docStore.clear()
            ]);
            else await stepsStore.clear();
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clear()', e);
            throw e;
        }
    }
    /**
   * Check and clear expired data from the current document's database.
   * Also triggers background cleanup of other databases (throttled to once per 24 hours).
   * This should be called after init() but before attempting to restore steps.
   */ async checkAndClearExpiredData() {
        // Check and clear current document's expired data
        await this.checkCurrentDocumentExpiry();
        // Run background cleanup of other document's offline databases (non-blocking, throttled)
        if ((0, $e9c926f713f211d2$export$365e5e8d6c8a82b3)()) {
            // Mark attempted immediately to prevent race condition if multiple tabs open simultaneously
            (0, $e9c926f713f211d2$export$df49bbb19630c32d)();
            (0, $e9c926f713f211d2$export$1419703707730bf4)(this.dbName, this.api);
        }
    }
    /**
   * Check if the current document's offline data has expired and clear it if needed.
   * Uses instance methods (this.openDB(), this.clear()) rather than deleting the database entirely.
   * This preserves the database structure and connection since the current document may be
   * actively written to (e.g. user goes offline). Background cleanup of other databases
   * can safely delete them entirely as they have no active StepsDatabase instance.
   *
   * Backwards compatibility: If data exists but no lastUpdated, adds timestamp = now (30-day window starts from today).
   * Expiry: If lastUpdated > 30 days, clears all data via clear(true)
   */ async checkCurrentDocumentExpiry() {
        try {
            const db = await this.openDB();
            // Early exit if the object stores don't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) return;
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const [metaData, stepsCount] = await Promise.all([
                metaStore.get(1),
                stepsStore.count()
            ]);
            if (!metaData) {
                await tx.done;
                return;
            }
            const now = Date.now();
            // Backwards compatibility: If data exists but no lastUpdated timestamp, add current timestamp
            // This starts the 30-day window from today for existing data
            if (!metaData.lastUpdated) {
                const updatedData = {
                    ...metaData,
                    lastUpdated: now
                };
                await metaStore.put(updatedData, 1);
                await tx.done;
                return;
            }
            // Check if data has expired (>30 days old) - single timestamp for all data
            if (now - metaData.lastUpdated > $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS) {
                await tx.done;
                // Gather analytics metadata
                const hasBackup = !!metaData.versionInsertionBackup;
                const daysExpired = Math.floor((now - metaData.lastUpdated) / 86400000);
                if (this.contentId) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: this.api,
                    action: 'OFFLINE_EDITING_DATA_EXPIRY_CLEANUP',
                    contentId: this.contentId,
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                });
                await this.clear(true);
                return;
            }
            await tx.done;
        } catch (e) {
            this.onError('checkCurrentDocumentExpiry()', e);
        }
    }
    async closeDB(releaseSyncLock = false) {
        try {
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = undefined;
                if (releaseSyncLock) this.syncLock.releaseLock?.();
            }
        } catch (e) {
            this.onError('closeDB()', e);
            throw e;
        }
    }
    /**
   * Store a version insertion backup for later retry
   * @param adfContent Stringified ADF content that failed to be inserted
   * @returns Promise<boolean> - true if stored successfully
   */ async storeVersionInsertionBackup(adfContent) {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // Only store backup if meta store already exists with doc and version
            // If it doesn't exist, there's no document to store a backup for
            if (!existingData || !existingData.doc || existingData.version === undefined) {
                await tx.done;
                return false;
            }
            // Create the backup object (no timestamp - uses shared lastUpdated)
            const versionInsertionBackup = {
                adfContent: adfContent
            };
            // Preserve all existing data and update both versionInsertionBackup and lastUpdated
            const updatedData = {
                ...existingData,
                versionInsertionBackup: versionInsertionBackup,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('storeVersionInsertionBackup()', e);
            return false;
        }
    }
    /**
   * Get the stored version insertion backup if one exists
   * @returns Promise<VersionInsertionBackup | null>
   */ async getVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return null;
        try {
            const db = await this.openDB();
            // Early exit if the meta store doesn't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) return null;
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const data = await docStore.get(1);
            await tx.done;
            return data?.versionInsertionBackup ?? null;
        } catch (e) {
            this.onError('getVersionInsertionBackup()', e);
            return null;
        }
    }
    /**
   * Clear the stored version insertion backup and update lastUpdated timestamp
   * @returns Promise<boolean> - true if cleared successfully
   */ async clearVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // If no data exists or no error field exists, nothing to clear
            if (!existingData || !existingData.versionInsertionBackup) {
                await tx.done;
                return true;
            }
            // Remove the versionInsertionBackup field and update timestamp
            const { versionInsertionBackup: _versionInsertionBackup, ...dataWithoutBackup } = existingData;
            await docStore.put({
                ...dataWithoutBackup,
                lastUpdated: Date.now()
            }, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clearVersionInsertionBackup()', e);
            return false;
        }
    }
    constructor(){
        this.dbPromise = void 0;
        this.contentId = void 0;
        this.syncLock = new (0, $5c049076093b3a44$export$d15eb9e8bb5d03ea)();
        this.api = void 0;
        this.initAttempted = false;
        this.indexedDBAvailable = void 0;
    }
}












var $di3bZ = parcelRequire("di3bZ");

const $8755c63771d651df$export$43d640f3b62db5ab = (editorView)=>{
    const { state: state } = editorView;
    const newState = state.reconfigure({
        plugins: state.plugins.filter((p)=>{
            return p.spec.key !== (0, $di3bZ.history)().spec.key;
        })
    });
    editorView.updateState(newState);
    const { state: updatedState } = editorView;
    const newerState = updatedState.reconfigure({
        plugins: updatedState.plugins.concat((0, $di3bZ.history)())
    });
    editorView.updateState(newerState);
};



const $c71be5c341006c26$export$e38c76da774a8077 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase })=>{
    const isBroadcastChannelSupported = window && 'BroadcastChannel' in window;
    const channelRef = (0, $cozmU.useRef)();
    const firstChannelUpdateRef = (0, $cozmU.useRef)(false);
    const broadcast = (0, $cozmU.useCallback)((messageType = 'resync')=>{
        if (channelRef.current) {
            const message = {
                type: messageType
            };
            channelRef.current.postMessage(message);
        }
    }, []);
    const listener = (0, $cozmU.useCallback)(async function(event) {
        const { type: type } = event.data;
        if (type !== 'resync' && type !== 'restore') return;
        const { mode: mode } = api?.connectivity?.sharedState.currentState() ?? {};
        // RESYNC: Only proceed when offline. This happens while syncing tabs when offline.
        // RESTORE: Only proceed when online. We restore on initialisation, when we have a connection.
        if (type === 'resync') {
            if (mode !== 'offline') return;
        } else if (type === 'restore') {
            if (mode !== 'online') return;
        }
        const { steps: steps, docJSON: docJSON, version: cachedVersion } = await stepsDatabase.getData(editorView.state.schema);
        if (!docJSON || cachedVersion === null) return;
        // RESYNC: only proceed when there are steps to sync.
        // RESTORE: only proceed when there are no steps to sync. The docJSON should have the cleared steps already applied.
        if (type === 'resync') {
            if (!steps) return;
        } else if (type === 'restore') {
            if (steps && steps.length > 0) return;
        }
        if (!firstChannelUpdateRef.current) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $krYZG.ACTION).OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE
            });
            firstChannelUpdateRef.current = true;
        }
        const historyState = api?.history?.sharedState?.currentState?.();
        const hasHistory = (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
        if (hasHistory) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
        const tr = (0, $7TcbF.syncFromAnotherSource)(editorView.state, cachedVersion, docJSON, steps);
        if (hasHistory && api?.history?.commands.updatePluginState) api.history.commands.updatePluginState({
            tr: tr
        });
        editorView.dispatch(tr);
    }, [
        api,
        editorView,
        stepsDatabase
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isBroadcastChannelSupported || !stepsDatabase.dbName) return;
        channelRef.current = new BroadcastChannel(stepsDatabase.dbName);
        channelRef.current.addEventListener('message', listener);
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', listener);
                channelRef.current.close();
            }
        };
    }, [
        isBroadcastChannelSupported,
        stepsDatabase.dbName,
        listener
    ]);
    return broadcast;
};












function $85a440c10c4579b2$export$199006561aceceef() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$415f09fb1d3d2a43(steps, api) {
    return ({ tr: tr })=>{
        const failedSteps = [];
        steps.forEach((step)=>{
            try {
                tr.step(step);
            } catch (e) {
                // step failed to apply, ignore it and attempt to apply other steps
                failedSteps.push({
                    step: step,
                    error: e
                });
            }
        });
        if (failedSteps.length > 0) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $krYZG.ACTION).OFFLINE_STORAGE_FAILED_STEPS,
            errorInfo: (0, $1a899df20ad45f18$export$ff269655d7dc6e77)(failedSteps.map((s)=>s.error)),
            stepsCount: failedSteps.length
        });
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$14dd948c471b3773() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'tooManyRetries'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$e62d02f588ae224b(inactiveSyncing) {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            inactiveSyncing: inactiveSyncing
        });
        return tr;
    };
}



const $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS = 3;
const $9ea4175711f7ca12$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'leader_granted' : 'follower_waiting'; // First tab becomes leader
        case 'follower_waiting':
            return granted ? 'follower_granted' : 'follower_waiting';
        case 'leader_granted':
        case 'follower_granted':
            return status;
    }
};
const $9ea4175711f7ca12$var$recreateOfflineDoc = (jsonDoc, steps, pmSchema)=>{
    try {
        let doc = pmSchema.nodeFromJSON(jsonDoc);
        steps.forEach((step)=>{
            const res = step.apply(doc);
            if (!res.failed && res.doc) doc = res.doc;
        });
        return doc;
    } catch  {
        // TODO: Follow-up error handling
        return undefined;
    }
};
async function $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, options) {
    try {
        const { steps: steps, docJSON: docJSON } = await stepsDatabase.getData(pmSchema);
        if (steps.length > 0) {
            if (docJSON) {
                const offlineDoc = $9ea4175711f7ca12$var$recreateOfflineDoc(docJSON, steps, pmSchema);
                if (offlineDoc) options?.createOfflineVersion?.({
                    doc: offlineDoc,
                    steps: steps
                });
            }
            const dispatched = api?.core.actions.execute((0, $85a440c10c4579b2$export$415f09fb1d3d2a43)(steps, api));
            if (!dispatched) return false;
        }
        return true;
    } catch  {
        return false;
    }
}
async function $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase) {
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, {
            createOfflineVersion: options?.createOfflineVersion
        });
        if (hasSyncSucceeded) // The leader tab relies on the usePluginHook to release their lock and clear the steps from the DB.
        // We do not set the leader as "syncing", so we do not need to call setInactiveSyncingCommand(false).
        return;
        else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, leader path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase) {
    // Wait 2 seconds before allowing the follower to complete, as sometimes it can complete too quickly, making the banner flash briefly.
    await new Promise((resolve)=>setTimeout(resolve, 2000));
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema);
        if (hasSyncSucceeded) {
            await $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase);
            return;
        } else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, follower path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, lockCallback) {
    const LOCK_TIMEOUT = 20000; // Wait for the lock, but only up to 20 seconds.
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(true));
    // TODO: Remove the timeoutAfterMS param after cleaning up the platform_editor_offline_editing_web_ga_fixes gate. All sync lock acquisitions have an expiration timer now.
    await stepsDatabase.acquireSyncLock(lockCallback, true, 'restore', LOCK_TIMEOUT);
}
function $9ea4175711f7ca12$export$f0123301da84dec0(api, stepsDatabase, pmSchema, options) {
    let status = 'init';
    let previousStatus = 'init';
    const callback = async (granted)=>{
        previousStatus = status;
        status = $9ea4175711f7ca12$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop. For example, if the follower is stuck in a loop of follower_waiting -> follower_waiting.
        if (status === previousStatus) {
            await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
            return;
        }
        switch(status){
            case 'leader_granted':
                await $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options);
                break;
            case 'follower_waiting':
                await $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, callback);
                break;
            case 'follower_granted':
                await $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema);
                break;
        }
    };
    return callback;
}


const $576038989d33c4bf$var$MAX_RETRIES = 2;
const $576038989d33c4bf$var$RETRY_DELAY = 1000;
async function $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema) {
    // If there's an error, the validateIndexedDBAccess will disable the plugin.
    const isIndexedDBAvailable = await stepsDatabase.validateIndexedDBAccess();
    if (!isIndexedDBAvailable) return false;
    const databases = await window.indexedDB.databases();
    const dbExists = Boolean(databases.find((db)=>db.name === stepsDatabase.dbName));
    if (!dbExists) return false;
    // If there are steps, we need to restore them.
    const { steps: steps } = await stepsDatabase.getData(pmSchema);
    if (steps.length > 0) return true;
    return false;
}
async function $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error) {
    if (retryCount >= $576038989d33c4bf$var$MAX_RETRIES) {
        api?.core.actions.execute((0, $85a440c10c4579b2$export$14dd948c471b3773)());
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $krYZG.ACTION).OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR,
            errorMessage: `Exceeded max retries (${$576038989d33c4bf$var$MAX_RETRIES}) with delay of ${$576038989d33c4bf$var$RETRY_DELAY}ms`,
            errorInfo: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            maxRetries: $576038989d33c4bf$var$MAX_RETRIES,
            retrySource: 'isStepsRestoreRequired'
        });
        return;
    }
    await new Promise((resolve)=>setTimeout(resolve, $576038989d33c4bf$var$RETRY_DELAY));
    $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount + 1)(pmSchema);
}
function $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount = 0, options) {
    return async (pmSchema)=>{
        try {
            const shouldRestore = await $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema);
            if (!shouldRestore) {
                api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
                return;
            }
        } catch (error) {
            await $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error);
            return;
        }
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $krYZG.ACTION).OFFLINE_STORAGE_RESTORE_STEPS_INITIATED,
            retryCount: retryCount
        });
        const lockCallback = (0, $9ea4175711f7ca12$export$f0123301da84dec0)(api, stepsDatabase, pmSchema, options);
        stepsDatabase.acquireSyncLock(lockCallback, false, 'restore');
    };
}



var $kmQhR = parcelRequire("kmQhR");





const $a5de712ae25052da$export$4abb9cd0bdff89ec = async ({ editorView: editorView, stepsDatabase: stepsDatabase, version: version, steps: steps, broadcast: broadcast })=>{
    const baseDocJSON = (0, $7TcbF.getDocBeforeUnconfirmedSteps)(editorView.state).toJSON();
    const hasChanged = await stepsDatabase.updateIfChanged(version, baseDocJSON, steps);
    if (hasChanged) broadcast();
    else editorView.dispatch(editorView.state.tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
        disabled: 'unableToSync'
    }));
};
const $a5de712ae25052da$var$syncWithOfflineStorageImpl = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))($a5de712ae25052da$export$4abb9cd0bdff89ec, 200);
const $a5de712ae25052da$export$fed59d57957883a7 = $a5de712ae25052da$var$syncWithOfflineStorageImpl;


















var $jbOus = parcelRequire("jbOus");













const $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT = 3000;
const $de973e9ead6dfe2c$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'granted_initial' : 'waiting_initial';
        case 'waiting_initial':
        case 'waiting_recovery':
            return granted ? 'granted_recovery' : 'waiting_recovery';
        case 'granted_initial':
        case 'granted_recovery':
        default:
            return status;
    }
};
const $de973e9ead6dfe2c$export$b79afd6d47f11781 = (api)=>{
    const historyState = api?.history?.sharedState?.currentState?.();
    return (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
};
async function $de973e9ead6dfe2c$export$5ac754b16bef384(api, stepsDatabase, editorView, isActiveTab, options) {
    if ((0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode)) return;
    let status = 'init';
    let previousStatus = 'init';
    const lockCallback = async (granted)=>{
        previousStatus = status;
        status = $de973e9ead6dfe2c$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop.
        // This can happen if repeated timeouts occur (e.g., waiting_recovery -> waiting_recovery).
        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
            if (status === previousStatus) {
                // Fallback: enable the editor and give up on syncing
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                return;
            }
        }
        const { steps: steps, docJSON: docJSON, version: version } = await stepsDatabase.getData(editorView?.state?.schema);
        const sendResyncAnalytics = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $krYZG.ACTION).OFFLINE_STORAGE_RESYNC_ONLINE,
                resyncStatus: status,
                isActiveTab: isActiveTab
            });
        };
        const unconfirmedSteps = (0, $7TcbF.getCollabState)(editorView.state)?.unconfirmed ?? [];
        switch(status){
            case 'granted_initial':
                if (steps.length > 0) {
                    sendResyncAnalytics();
                    // Clear offline lock on unconfirmed steps
                    unconfirmedSteps.forEach((s)=>{
                        if (s.origin instanceof (0, $kCECX.Transaction)) {
                            s.origin.setMeta('isOffline', false);
                            s.origin.setMeta('wasOffline', true);
                        }
                    });
                    // Create the offline version based on a snapshot of the doc at the time of returning online
                    options.createOfflineVersion?.({
                        doc: editorView.state.doc,
                        steps: unconfirmedSteps.map((s)=>s.step)
                    });
                    setTimeout(()=>{
                        api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                    }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                } else if (docJSON && version !== null && unconfirmedSteps.length !== 0) {
                    // So we're here because another tab has already synced but the steps in the DB have been deleted
                    // In this case we revert to the document before going offline and allow collab to resync us
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $7TcbF.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') && (0, $jbOus.tintDirtyTransaction)(tr);
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                } else // At this point we've synced and can enable the editor
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_initial':
                // Reset to base document so we don't duplicate the unconfirmed steps, when we come back online we'll sync with the latest changes
                if (docJSON && version !== null && unconfirmedSteps?.length !== 0) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $7TcbF.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                }
                break;
            case 'granted_recovery':
                if (steps.length > 0 && docJSON && version !== null) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    editorView.dispatch((0, $7TcbF.syncFromAnotherSource)(editorView.state, version, docJSON, steps));
                }
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_recovery':
                if (steps.length > 0 && docJSON && version !== null) sendResyncAnalytics();
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                break;
            default:
                break;
        }
    };
    stepsDatabase.acquireSyncLock(lockCallback, false, 'resync');
}




/**
 * @generated SignedSource<<1e58d607e8989b3be87557d0b2d40fdf>>
 * @relayHash 147cfb56caf40781fcb1a06a43b2650f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0
const $80824365c2b7ecec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "adfContent"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionComment"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "adfContent",
                            "variableName": "adfContent"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionComment",
                            "variableName": "versionComment"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceInsertOfflineVersionPayload",
            "kind": "LinkedField",
            "name": "confluence_insertOfflineVersion",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "versionNumber"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "147cfb56caf40781fcb1a06a43b2650f",
            "id": "e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0",
            "metadata": {},
            "name": "useCreateOfflineVersionInsertVersionMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateOfflineVersionInsertVersionMutation($cloudId:ID!,$contentId:ID!,$adfContent:String!,$versionComment:String!){confluence_insertOfflineVersion(cloudId:$cloudId,input:{contentId:$contentId,adfContent:$adfContent,versionComment:$versionComment}){versionNumber,success,errors{message}}}"
        }
    };
}();
$80824365c2b7ecec$var$node.hash = "116628d327fa315abf5c5c89f4dd52a8";
var $80824365c2b7ecec$export$2e2bcd8739ae039 = $80824365c2b7ecec$var$node;












var $eOaGc = parcelRequire("eOaGc");








var $bQm3c = parcelRequire("bQm3c");


var $308Wd = parcelRequire("308Wd");









var $chu6R = parcelRequire("chu6R");


var $i1agE = parcelRequire("i1agE");

const $bf60d5cebe6d196a$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "editor-offline-storage.version-insertion-error-flag.title",
        defaultMessage: "Error saving version history"
    },
    errorTitleRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.title-retry",
        defaultMessage: "Failed to save"
    },
    errorDescription: {
        id: "editor-offline-storage.version-insertion-error-flag.description",
        defaultMessage: "We couldn't save a version history of your offline edits. Your changes are safe, but if you want a backup please try again."
    },
    errorDescriptionRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.description-retry",
        defaultMessage: "We're still having trouble saving a version history of your offline edits. Please try again."
    },
    retryButton: {
        id: "editor-offline-storage.version-insertion-error-flag.retry-button",
        defaultMessage: "Try again"
    },
    successTitle: {
        id: "editor-offline-storage.version-insertion-success-flag.title",
        defaultMessage: "Version history saved"
    },
    successDescription: {
        id: "editor-offline-storage.version-insertion-success-flag.description",
        defaultMessage: "Your offline edits have been saved to version history."
    }
});
const $bf60d5cebe6d196a$var$ERROR_FLAG_ID = 'version-insertion-error-flag';
const $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID = 'version-insertion-success-flag';
const $bf60d5cebe6d196a$export$ac18e6e44f1970de = (flags, intl, onRetry, onClose, manualRetryCount)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$ERROR_FLAG_ID,
        title: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorTitleRetry : $bf60d5cebe6d196a$var$i18n.errorTitle),
        description: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorDescriptionRetry : $bf60d5cebe6d196a$var$i18n.errorDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i1agE))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        actions: [
            {
                content: intl.formatMessage($bf60d5cebe6d196a$var$i18n.retryButton),
                onClick: onRetry
            }
        ],
        onClose: onClose
    });
};
const $bf60d5cebe6d196a$export$fda504c08c17a634 = (flags, intl)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID,
        title: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successTitle),
        description: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            color: "var(--ds-icon-success, #6A9A23)",
            label: ""
        })
    });
};
const $bf60d5cebe6d196a$export$2e84f8b8ade6c591 = (flags)=>{
    if (!flags) return;
    flags.hideFlag($bf60d5cebe6d196a$var$ERROR_FLAG_ID);
};


const $185ed3c8b342a5b9$var$i18n = (0, $kSwu1.defineMessages)({
    VersionComment: {
        id: "editor-offline-storage.offline-version-comment",
        defaultMessage: "Offline edits"
    },
    VersionCommentManualRetry: {
        id: "editor-offline-storage.offline-version-comment-manual-retry",
        defaultMessage: "Offline edits (manual retry)"
    }
});
// Tech-spec:
// https://hello.atlassian.net/wiki/spaces/~712020fa3d29df95e344e18f663fa84c3d65c8/pages/5567284738/Tech+Spec+Version+History+Creation+API+with+Offline+Copy
const $185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation = (0, $80824365c2b7ecec$export$2e2bcd8739ae039);
// Limit how often we can try to create new versions
// P50 disconnection time is ~7 seconds so this tries to minimise new versions
// if someone's connection is flaky.
const $185ed3c8b342a5b9$var$MAX_INTERVAL = 20000;
const $185ed3c8b342a5b9$export$a47b53017b47e379 = ({ contentId: contentId, api: api, stepsDatabase: stepsDatabase, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $kSwu1.useIntl)();
    const manualRetryCountRef = (0, $cozmU.useRef)(0);
    const [createOfflineVersion] = (0, $308Wd.useMutationInterop)($185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation, {
        __callerPackage__: "editor-offline-storage"
    });
    const createVersionUnthrottled = (0, $cozmU.useCallback)(({ cloudId: paramCloudId, contentId: paramContentId, adfContent: adfContent, versionComment: versionComment })=>{
        // Create onRetry callback that will be reused for both error paths
        const onRetry = ()=>{
            if (!flags) return;
            // Increment manual retry count when user clicks retry
            manualRetryCountRef.current += 1;
            (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
            createVersionUnthrottled({
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
            });
        };
        const onClose = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                manualRetryCount: manualRetryCountRef.current
            });
        };
        createOfflineVersion({
            variables: {
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: versionComment
            }
        }).then(async (res)=>{
            const errors = res.data?.confluence_insertOfflineVersion?.errors;
            if (errors && errors.length > 0) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: errors.map((err)=>err.message).join(','),
                    manualRetryCount: manualRetryCountRef.current
                });
                // Store the backup and show flag for later retry
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    await stepsDatabase.storeVersionInsertionBackup(adfContent);
                    if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
                }
                return;
            }
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION',
                success: res.data?.confluence_insertOfflineVersion?.success,
                manualRetryCount: manualRetryCountRef.current
            });
            // Show success flag only after manual retries
            if (manualRetryCountRef.current > 0 && flags) (0, $bf60d5cebe6d196a$export$fda504c08c17a634)(flags, intl);
            // Reset manual retry count on success
            manualRetryCountRef.current = 0;
            // Clear the stored backup on any successful version insertion
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) await stepsDatabase.clearVersionInsertionBackup();
        }).catch(async (e)=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(e),
                manualRetryCount: manualRetryCountRef.current
            });
            // Store the backup and show flag for later retry
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                await stepsDatabase.storeVersionInsertionBackup(adfContent);
                if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
            }
        });
    }, [
        createOfflineVersion,
        api,
        stepsDatabase,
        flags,
        intl
    ]);
    /**
   * Manually retry version insertion with stored backup content
   * Hides the flag and calls the core createVersionUnthrottled function
   */ const manualRetryCreateVersion = (0, $cozmU.useCallback)((storedAdfContent)=>{
        if (!contentId || !flags) return;
        (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
        createVersionUnthrottled({
            cloudId: cloudId,
            contentId: contentId,
            adfContent: storedAdfContent,
            versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
        });
    }, [
        contentId,
        cloudId,
        flags,
        intl,
        createVersionUnthrottled
    ]);
    const throttledCreateVersion = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(createVersionUnthrottled, $185ed3c8b342a5b9$var$MAX_INTERVAL, {
            leading: true,
            trailing: false
        }), [
        createVersionUnthrottled
    ]);
    return {
        createVersion: (0, $cozmU.useCallback)(({ doc: doc, steps: steps })=>{
            // Only create a new version if there are document changes
            // To avoid noisy versions we filter out any non-ReplaceSteps
            // Ignore ReplaceAroundSteps and other steps that aren't as likely to be intended by the user
            // Note: This is a best-effort approach and may not cover all cases
            if (steps.filter((s)=>s instanceof (0, $eOaGc.ReplaceStep)).length === 0) return;
            if (!contentId) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: 'No content id',
                    manualRetryCount: 0
                });
                return;
            }
            const adfContent = new (0, $3xuv0.JSONTransformer)().encode(doc);
            throttledCreateVersion({
                cloudId: cloudId,
                contentId: contentId,
                adfContent: JSON.stringify(adfContent),
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionComment)
            });
        }, [
            api,
            contentId,
            throttledCreateVersion,
            cloudId,
            intl
        ]),
        manualRetryCreateVersion: manualRetryCreateVersion
    };
};


/**
 * `usePluginStateEffect` has a debounce - we avoid that here to ensure we
 * catch all states on a critical piece of code
 *
 * @param api
 * @param cb
 */ const $93f027f3fd7090c3$var$useConnectivityEffect = (api, cb)=>{
    // Get the latest effect similar to `usePluginStateEffect` (no debounce)
    const latestEffect = (0, $cozmU.useRef)(cb);
    (0, $cozmU.useLayoutEffect)(()=>{
        latestEffect.current = cb;
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        cb
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        return api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            latestEffect.current?.({
                prevMode: prevSharedState?.mode,
                nextMode: nextSharedState?.mode
            });
        });
    }, [
        api
    ]);
};
const $93f027f3fd7090c3$export$68f4c8eca02a72d7 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase, broadcastUpdate: broadcastUpdate, contentId: contentId, flags: flags })=>{
    const { createVersion: createOfflineVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
        contentId: contentId,
        api: api,
        stepsDatabase: stepsDatabase,
        flags: flags
    });
    const isActivelySyncing = (0, $cozmU.useRef)(false);
    $93f027f3fd7090c3$var$useConnectivityEffect(api, ({ prevMode: prevMode, nextMode: nextMode })=>{
        const { status: status, disabled: disabled } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(editorView.state) ?? {};
        if (status !== 'ready' || disabled) return;
        // Only allow one sync at a time. This is to avoid flickering of the connection status causing online and offline resyncs to run at the same time.
        if (isActivelySyncing.current) return;
        isActivelySyncing.current = true;
        if ((0, $6Ixg8.isOfflineMode)(prevMode) && nextMode === 'online') {
            // Try to prioritise the "active" tab by delaying the inactive tabs, this is to minimise
            // our chance of disrupting the user by the reset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document && !document?.hasFocus?.()) // Give the active document ~1s to connect
            setTimeout(()=>(0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, false, {
                    createOfflineVersion: createOfflineVersion
                }).finally(()=>{
                    isActivelySyncing.current = false;
                }), // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document?.visibilityState === 'visible' ? 500 : 1000);
            else (0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, true, {
                createOfflineVersion: createOfflineVersion
            }).finally(()=>{
                isActivelySyncing.current = false;
            });
        } else if ((0, $6Ixg8.isOfflineMode)(nextMode)) stepsDatabase.validateIndexedDBAccess().then((isIndexedDBAvailable)=>{
            if (isIndexedDBAvailable) stepsDatabase.clear(true).then(async (cleared)=>{
                if (cleared) await stepsDatabase.releaseSyncLock?.();
            }).finally(()=>{
                // Resync the db with the current state of the unconfirmed steps
                const { version: version, steps: steps } = (0, $7TcbF.sendableSteps)(editorView.state) ?? {};
                if (version !== undefined && steps !== undefined) (0, $a5de712ae25052da$export$4abb9cd0bdff89ec)({
                    editorView: editorView,
                    stepsDatabase: stepsDatabase,
                    version: version,
                    steps: steps,
                    broadcast: broadcastUpdate
                }).finally(()=>{
                    isActivelySyncing.current = false;
                });
                else isActivelySyncing.current = false;
            });
            else isActivelySyncing.current = false;
        });
    });
};









const $1b00d7c59071460d$export$e3acca0d39d792dc = ({ api: api, stepsDatabase: stepsDatabase, disabledRef: disabledRef })=>{
    const queryingSyncLock = (0, $cozmU.useRef)(false);
    (0, $1KOhB.usePluginStateEffect)(api, [
        'editorOfflineStorage',
        'connectivity',
        'collabEdit'
    ], ()=>{
        // Check if we're safe to re-enable the lock
        if (disabledRef.current === 'unableToSync' && !queryingSyncLock.current) {
            queryingSyncLock.current = true;
            stepsDatabase.isLocked().then((locked)=>{
                // If we're not locked (and still unable to sync) we can re-enable
                if (!locked && disabledRef.current === 'unableToSync') api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                        disabled: false
                    }));
            }).catch(()=>{}).finally(()=>{
                queryingSyncLock.current = false;
            });
        }
    });
};





const $1d19c6d3b6d5b560$export$ea606e96c5866df5 = ({ api: api, config: config })=>{
    const stepsDatabase = new (0, $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c)();
    return {
        name: 'editorOfflineStorage',
        pmPlugins () {
            return [
                {
                    name: 'editorOfflineStoragePlugin',
                    plugin: (0, $bcc122a52e0f74cf$export$ae829ec7b2625219)(stepsDatabase)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { status: status, disabled: disabled, inactiveSyncing: inactiveSyncing } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(state) ?? {};
            const { version: version, steps: steps } = (0, $7TcbF.sendableSteps)(state) ?? {};
            return {
                version: version ?? 0,
                steps: steps ?? [],
                status: status ?? 'pending',
                disabled: disabled ?? false,
                inactiveSyncing: inactiveSyncing ?? false
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            const [contentId] = (0, $ep3mz.usePageContentId)();
            const disabledRef = (0, $cozmU.useRef)(false);
            const hasCheckedForVersionInsertionBackupRef = (0, $cozmU.useRef)(false);
            const intl = (0, $kSwu1.useIntl)();
            (0, $1KOhB.usePluginStateEffect)(api, [
                'editorOfflineStorage'
            ], ({ editorOfflineStorageState: editorOfflineStorageState })=>{
                disabledRef.current = editorOfflineStorageState?.disabled ?? false;
            });
            const { createVersion: createOfflineVersion, manualRetryCreateVersion: manualRetryCreateVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
                contentId: contentId,
                api: api,
                stepsDatabase: stepsDatabase,
                flags: config?.flags ?? null
            });
            (0, $cozmU.useEffect)(()=>{
                if (contentId && !stepsDatabase.dbName && !disabledRef.current) stepsDatabase.init(contentId, api).then(async (initialized)=>{
                    if (!initialized) return;
                    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                        // Check and clear expired data before checking for backup
                        await stepsDatabase.checkAndClearExpiredData();
                        // Check for existing version insertion backup
                        if (!hasCheckedForVersionInsertionBackupRef.current) {
                            hasCheckedForVersionInsertionBackupRef.current = true;
                            const versionInsertionBackup = await stepsDatabase.getVersionInsertionBackup();
                            if (versionInsertionBackup) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(config?.flags, intl, // onRetry: Call manual retry with stored content
                            ()=>{
                                manualRetryCreateVersion(versionInsertionBackup.adfContent);
                            }, // onClose: Track when user dismisses the version insertion error flag
                            ()=>{
                                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                                    api: api,
                                    action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                                    manualRetryCount: 0
                                });
                            }, 0);
                        }
                    }
                });
            // We need stepsDatabase in deps to detect when DB is no longer initialised on re-render, e.g. when page goes full-width.
            }, [
                contentId,
                stepsDatabase,
                api,
                intl,
                manualRetryCreateVersion
            ]); // eslint-disable-line react-hooks/exhaustive-deps
            const broadcastUpdate = (0, $c71be5c341006c26$export$e38c76da774a8077)({
                api: api,
                editorView: editorView,
                stepsDatabase: stepsDatabase
            });
            /**
       * This is to resync the document online once we move from offline -> online
       */ (0, $93f027f3fd7090c3$export$68f4c8eca02a72d7)({
                api: api,
                editorView: editorView,
                broadcastUpdate: broadcastUpdate,
                stepsDatabase: stepsDatabase,
                contentId: contentId,
                flags: config?.flags ?? null
            });
            /**
       * See if it's safe to re-enable the plugin if it's been disabled due to the lock being held
       */ (0, $1b00d7c59071460d$export$e3acca0d39d792dc)({
                api: api,
                stepsDatabase: stepsDatabase,
                disabledRef: disabledRef
            });
            // Clean up the sync timeout on unmount
            // Otherwise its possible that it will fire with stale data after unmount
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    (0, $a5de712ae25052da$export$fed59d57957883a7).cancel();
                };
            }, [
                contentId,
                editorView
            ]);
            /**
       * This is to handle the initial load of the editor and syncing it from the indexeddb
       */ (0, $1KOhB.usePluginStateEffect)(api, [
                'editorOfflineStorage',
                'connectivity',
                'collabEdit'
            ], ({ editorOfflineStorageState: editorOfflineStorageState, connectivityState: connectivityState, collabEditState: collabEditState })=>{
                const { status: status, steps: steps, version: version, disabled: disabled } = editorOfflineStorageState ?? {};
                if (disabledRef.current) return;
                if (window?.indexedDB === undefined) {
                    // If indexeddb is not available disable offline editing here
                    if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                            disabled: 'stepsDatabaseError'
                        }));
                    return;
                }
                // Both the restore (init) sync lock and the resync online (online <-> offline) sync lock are released here.
                // We confirm the steps have synced with NCS before clearing the database and releasing the lock.
                if (steps?.length === 0 && stepsDatabase.hasLock) stepsDatabase.clear(false).then(async (cleared)=>{
                    if (cleared) {
                        if (stepsDatabase.lockPurpose === 'restore') // After we've the steps confirmed with NCS, we update the doc and version in the database.
                        await stepsDatabase.updateDocAndVersion(editorView).then((isUpdated)=>{
                            if (isUpdated) // Notify other tabs to sync from the updated doc/version in IndexedDB.
                            broadcastUpdate('restore');
                        });
                        await stepsDatabase.releaseSyncLock?.();
                    }
                });
                switch(status){
                    case 'pending':
                        // Restore steps once collab edit plugin is initialised
                        if (collabEditState?.initialised.collabInitialisedAt) {
                            const tr = editorView.state.tr;
                            tr.setMeta('addToHistory', false);
                            tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                status: 'restoring'
                            });
                            editorView.dispatch(tr);
                            (0, $576038989d33c4bf$export$312d5d76abf7691a)(api, stepsDatabase, editorView, 0, {
                                createOfflineVersion: createOfflineVersion
                            })(editorView.state.schema);
                        }
                        break;
                    case 'restoring':
                        break;
                    case 'ready':
                        const isFocusedAndVisible = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.visibilityState === 'visible' && document.hasFocus();
                        // If we are offline and we have steps to store, update the steps in the database
                        if (isFocusedAndVisible && steps && version !== undefined && (0, $6Ixg8.isOfflineMode)(connectivityState?.mode)) (0, $a5de712ae25052da$export$fed59d57957883a7)({
                            editorView: editorView,
                            stepsDatabase: stepsDatabase,
                            version: version,
                            steps: steps,
                            broadcast: broadcastUpdate
                        });
                        break;
                    case 'tooManyRetries':
                        // Unable to restore steps - ensure we disable the offline editing session to be safe
                        // in case there's something wrong with the DB.
                        if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                disabled: 'tooManyRetries'
                            }));
                        break;
                    default:
                        break;
                }
            });
        }
    };
};



var $4vxk6 = parcelRequire("4vxk6");


var $d4d2J = parcelRequire("d4d2J");


var $3gyyc = parcelRequire("3gyyc");


var $6ZWlg = parcelRequire("6ZWlg");


var $6xiPL = parcelRequire("6xiPL");








var $3u5lg = parcelRequire("3u5lg");













const $402b4b60c57df829$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "editor-presets.conflicts-resolved-flag.title",
        defaultMessage: "All conflicts have been resolved"
    },
    description: {
        id: "editor-presets.conflicts-resolved-flag.description",
        defaultMessage: "Your offline edits have been successfully synced."
    },
    viewHistoryButton: {
        id: "editor-presets.conflicts-resolved-flag.view-history-button",
        defaultMessage: "View version history"
    }
});
const $402b4b60c57df829$var$FLAG_ID = 'conflicts-resolved-flag';
const $402b4b60c57df829$export$f4728fbe8fc5d546 = (flags, intl, contentId, spaceKey)=>{
    if (!flags) return;
    const versionHistoryUrl = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    flags.showSuccessFlag({
        id: $402b4b60c57df829$var$FLAG_ID,
        title: intl.formatMessage($402b4b60c57df829$var$i18n.title),
        description: intl.formatMessage($402b4b60c57df829$var$i18n.description),
        actions: [
            {
                content: intl.formatMessage($402b4b60c57df829$var$i18n.viewHistoryButton),
                href: versionHistoryUrl,
                onClick: ()=>{
                    $402b4b60c57df829$export$d04b5033a065369f(flags);
                }
            }
        ]
    });
};
const $402b4b60c57df829$export$d04b5033a065369f = (flags)=>{
    if (!flags) return;
    flags.hideFlag($402b4b60c57df829$var$FLAG_ID);
};















var $djYcq = parcelRequire("djYcq");


var $cyZvy = parcelRequire("cyZvy");










// Apply strike mark to deleted text
function $33fd45b068629a29$var$applyMarkToFragment(fragment, markType) {
    if (!markType) return fragment;
    // Create a mark of the given type
    const mark = markType.create({});
    const nodes = [];
    fragment.forEach((node)=>{
        if (node.isText) nodes.push(node.mark([
            ...node.marks,
            mark
        ]));
        else nodes.push(node.copy($33fd45b068629a29$var$applyMarkToFragment(node.content, markType)));
    });
    // Map over each node in the fragment and apply the mark
    return (0, $aPdNQ.Fragment).fromArray(nodes);
}
const $33fd45b068629a29$export$f34037fb3390566b = (conflict, tr, selected = false)=>{
    return (0, $8nvEM.Decoration).widget(conflict.from, ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const strikenText = document.createElement('span');
        const style = (0, $8Dx7s.convertToInlineCss)({
            background: selected ? "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)" : "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        });
        strikenText.setAttribute('style', style);
        // Render striken text fragment
        strikenText.appendChild((0, $aPdNQ.DOMSerializer).fromSchema(tr.doc.type.schema).serializeFragment($33fd45b068629a29$var$applyMarkToFragment(conflict?.local.content, tr.doc.type.schema.marks.strike)));
        return strikenText;
    }, {
        side: -1,
        ignoreSelection: false
    });
};





/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $3f8f658555914fb4$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $3f8f658555914fb4$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($3f8f658555914fb4$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $3f8f658555914fb4$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $3f8f658555914fb4$var$measureHeight = (style)=>{
    return $3f8f658555914fb4$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $3f8f658555914fb4$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
function $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $3f8f658555914fb4$var$hyphenate(property) {
    // Ignored via go/ees005
    return property.replace(/[A-Z]/gu, (match)=>`-${match.toLowerCase()}`).replace(/^ms/u, '-ms');
}
const $3f8f658555914fb4$export$dfadf4096b7e8b0c = (node, pos)=>{
    return (0, $8nvEM.Decoration).widget(pos, (view, getPos)=>{
        const nodeStart = getPos();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const element = document.createElement('span');
        element.className = 'conflictmarker';
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        element.appendChild(document.createElement('span'));
        const dom = nodeStart !== undefined ? view.nodeDOM(nodeStart) : null;
        if (dom instanceof HTMLElement && element.firstChild) {
            const style = $3f8f658555914fb4$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
            const conflictmarker = element.firstChild;
            conflictmarker.style.height = `${$3f8f658555914fb4$var$measureHeight(style)}px`;
            const layoutMode = node && $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node);
            if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') conflictmarker.style.marginTop = style.getPropertyValue('margin-top');
            const conflictMarkerCursorStyles = {
                content: "''",
                position: 'absolute',
                background: "var(--ds-background-accent-red-bolder, #C9372C)",
                width: "var(--ds-space-075, 6px)",
                marginLeft: "var(--ds-space-negative-075, -6px)",
                borderRadius: `${"var(--ds-radius-small, 4px)"} 0 0 ${"var(--ds-radius-small, 4px)"}`
            };
            for (const [rule, value] of Object.entries(conflictMarkerCursorStyles))conflictmarker.style.setProperty($3f8f658555914fb4$var$hyphenate(rule), value);
            conflictmarker.className = 'conflictmarker';
            conflictmarker.setAttribute('data-testid', 'conflictmarker');
        }
        return element;
    }, {
        side: -1
    });
};


const $d80773f42a527d1c$var$getBlockNodeAtPos = (pos, tr)=>{
    const $pos = tr.doc.resolve(pos);
    const node = $pos?.node();
    return node && node.isBlock && !node.isTextblock ? node : null;
};
const $d80773f42a527d1c$var$createInsertedDecoration = (conflict, tr, resolutionMode)=>{
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    const styles = {
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
    };
    // Background highlight behavior:
    // - Gate OFF (old behavior): Always show orange background
    // - Gate ON (new behavior): Only show orange background when actively resolving
    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
        if (resolutionMode === 'resolving') styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    } else // Old behavior: always show background
    styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    return (0, $8nvEM.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $8Dx7s.convertToInlineCss)(styles)
    });
};
const $d80773f42a527d1c$var$createSelectedDecoration = (conflict, tr)=>{
    if (conflict.type === 'deleted') return (0, $33fd45b068629a29$export$f34037fb3390566b)(conflict, tr, true);
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    return (0, $8nvEM.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $8Dx7s.convertToInlineCss)({
            background: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        })
    });
};
function $d80773f42a527d1c$var$filterUndefined(c) {
    return c !== undefined;
}
const $d80773f42a527d1c$var$createDecorationsFromConflicts = (conflicts, selectedConflict, tr, resolutionMode)=>{
    if (!conflicts) return [];
    if (selectedConflict) {
        const selectedDecoration = $d80773f42a527d1c$var$createSelectedDecoration(selectedConflict, tr);
        const conflictDecorations = [
            ...conflicts.inserted.filter((c)=>c.id !== selectedConflict.id).map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
            ...conflicts.deleted.filter((c)=>c.id !== selectedConflict.id).map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
        ];
        if (selectedDecoration) return conflictDecorations.concat(selectedDecoration);
        return conflictDecorations;
    } else return [
        ...conflicts.inserted.map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
        ...conflicts.deleted.map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
    ];
};
const $d80773f42a527d1c$var$mapConflict = (change, mapping, type)=>{
    const from = mapping.map(change.from);
    const to = mapping.map(change.to);
    // We've collapsed the change and there's no visible marker to the user this conflict is no longer useful to us
    // These are "orphaned" conflicts similar to orphaned comments and for now we handle by resolving these since there
    // are no appropriate user actions.
    if (type === 'inserted' && from === to) return undefined;
    return {
        ...change,
        from: from,
        to: to
    };
};
const $d80773f42a527d1c$var$findSelectedConflict = (conflict, selection)=>selection.from >= conflict.from && selection.from <= conflict.to || selection.to >= conflict.from && selection.to <= conflict.to;
const $d80773f42a527d1c$var$getSelectedConflict = (conflicts, selection)=>{
    if (!conflicts) return undefined;
    const insertedSelectedConflict = conflicts?.inserted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    const deletedSelectedConflict = conflicts?.deleted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    if (insertedSelectedConflict) return {
        ...insertedSelectedConflict,
        type: 'inserted'
    };
    if (deletedSelectedConflict) return {
        ...deletedSelectedConflict,
        type: 'deleted'
    };
    return undefined;
};
const $d80773f42a527d1c$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $cyZvy.conflictResolutionPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    conflicts: undefined,
                    selected: undefined,
                    isNextEnabled: false,
                    isPreviousEnabled: false,
                    resolutionMode: 'viewing'
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $cyZvy.conflictResolutionPluginKey));
                const navigatedConflict = tr.getMeta('nextConflict');
                // Early escape hatch to avoid running all the code below if not necessary
                if (pluginState.conflicts === undefined && meta === undefined) return pluginState;
                const conflicts = (0, $djYcq.getNewConflicts)(meta, pluginState.conflicts);
                const mappedConflicts = pluginState.conflicts ? {
                    inserted: pluginState.conflicts.inserted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'inserted')).filter($d80773f42a527d1c$var$filterUndefined),
                    deleted: pluginState.conflicts.deleted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'deleted')).filter($d80773f42a527d1c$var$filterUndefined)
                } : undefined;
                const conflictsRemaining = conflicts ?? mappedConflicts;
                // Update resolution mode based on metadata
                let resolutionMode = pluginState.resolutionMode;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (meta?.type === 'startResolving') resolutionMode = 'resolving';
                    else if (meta?.type === 'stopResolving') resolutionMode = 'viewing';
                    else if (conflicts && !pluginState.conflicts) // Reset to viewing mode when new conflicts arrive
                    resolutionMode = 'viewing';
                }
                // Only select conflicts if explicitly navigated to OR if actively resolving with cursor selection
                let selectedConflict;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (navigatedConflict) selectedConflict = navigatedConflict;
                    else if (resolutionMode === 'resolving') selectedConflict = $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                } else selectedConflict = navigatedConflict ?? $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                const decorations = conflicts || selectedConflict || pluginState.selected ? (0, $8nvEM.DecorationSet).create(tr.doc, $d80773f42a527d1c$var$createDecorationsFromConflicts(conflictsRemaining, selectedConflict, tr, resolutionMode)) : pluginState.decorations.map(tr.mapping, tr.doc);
                return {
                    decorations: decorations,
                    conflicts: conflictsRemaining,
                    selected: selectedConflict,
                    isPreviousEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'previous').isAbleToNavigate : false,
                    isNextEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'next').isAbleToNavigate : false,
                    resolutionMode: resolutionMode
                };
            }
        },
        props: {
            decorations: (state)=>(0, $cyZvy.conflictResolutionPluginKey).getState(state)?.decorations
        }
    });
};









const $751b8c45ea51c6cb$var$LazyContentComponent = /*#__PURE__*/ (0, $cozmU.lazy)(async ()=>({
        default: (await (parcelRequire("l0Gyw"))).ContentComponent
    }));
const $751b8c45ea51c6cb$var$ContentComponentWrapper = ({ api: api, config: config, editorView: editorView })=>{
    const intl = (0, $kSwu1.useIntl)();
    const lastConflictCount = (0, $cozmU.useRef)(0);
    // Watch for conflicts being resolved. This is so we can show the success flag.
    (0, $1KOhB.usePluginStateEffect)(api, [
        'conflictResolutionUI'
    ], ({ conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return;
        if (!config?.flags) return;
        if (!config?.contentId || !config?.spaceKey) return;
        const currentConflictCount = (conflictResolutionUIState?.conflicts?.inserted?.length ?? 0) + (conflictResolutionUIState?.conflicts?.deleted?.length ?? 0);
        // If we had conflicts and now we don't, show success flag
        if (lastConflictCount.current > 0 && currentConflictCount === 0) (0, $402b4b60c57df829$export$f4728fbe8fc5d546)(config.flags, intl, config.contentId, config.spaceKey);
        lastConflictCount.current = currentConflictCount;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($751b8c45ea51c6cb$var$LazyContentComponent, {
        api: api,
        editorView: editorView
    }));
};
const $751b8c45ea51c6cb$export$bb9d066eb8005e17 = ({ api: api, config: config })=>{
    return {
        name: 'conflictResolutionUI',
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($751b8c45ea51c6cb$var$ContentComponentWrapper, {
                api: api,
                config: config,
                editorView: editorView
            });
        },
        getSharedState: (state)=>{
            if (!state) return undefined;
            return {
                selected: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.selected,
                isNextEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isNextEnabled ?? true,
                isPreviousEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isPreviousEnabled ?? true,
                conflicts: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.conflicts,
                resolutionMode: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.resolutionMode ?? 'viewing'
            };
        },
        commands: {
            navigateToFirstConflict: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                if (conflicts && (conflicts.inserted.length > 0 || conflicts?.deleted.length > 0)) return (0, $djYcq.navigateToAvailable)(undefined, tr, conflicts);
                return null;
            },
            startResolvingConflicts: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                // Early exit when we've no conflicts to resolve.
                if (!conflicts || conflicts.inserted.length === 0 && conflicts.deleted.length === 0) return null;
                // First, start resolving mode
                const trWithMode = tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), {
                    type: 'startResolving'
                });
                // Then navigate to first conflict
                const trWithNavigation = (0, $djYcq.navigateToAvailable)(undefined, trWithMode, conflicts);
                return trWithNavigation || trWithMode;
            }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'conflictResolutionPlugin',
                    plugin: (0, $d80773f42a527d1c$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            const lastReconnectionConflictMetadataRef = (0, $cozmU.useRef)();
            (0, $1KOhB.usePluginStateEffect)(api, [
                'collabEdit'
            ], ({ collabEditState: collabEditState })=>{
                const { lastReconnectionConflictMetadata: lastReconnectionConflictMetadata } = collabEditState ?? {};
                if (lastReconnectionConflictMetadata && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(lastReconnectionConflictMetadataRef.current, lastReconnectionConflictMetadata)) {
                    (0, $djYcq.setMetadata)(editorView, {
                        type: 'update',
                        data: lastReconnectionConflictMetadata
                    }, {
                        api: api
                    });
                    lastReconnectionConflictMetadataRef.current = lastReconnectionConflictMetadata;
                }
            });
        }
    };
};














const $9347c19eec4676fd$var$pluginName = 'aiPlannerRemoteTextHighlight';
const $9347c19eec4676fd$var$pmPluginName = 'aiPlannerRemoteTextHighlightPmPlugin';
const $9347c19eec4676fd$var$pluginMetaKey = $9347c19eec4676fd$var$pluginName;
const $9347c19eec4676fd$var$HIGHLIGHT_DURATION_MS = 10000;
const $9347c19eec4676fd$export$456d4fef6896493a = new (0, $kCECX.PluginKey)($9347c19eec4676fd$var$pluginName);
const $9347c19eec4676fd$var$aiPlannerBridgeHighlightStyle = (0, $8Dx7s.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textDecoration: 'underline',
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)",
    textDecorationStyle: 'dashed',
    textDecorationThickness: "var(--ds-border-width, 1px)"
});
const $9347c19eec4676fd$var$isExpiryMeta = (meta)=>Boolean(meta && typeof meta === 'object' && meta.type === 'expire' && typeof meta.now === 'number');
const $9347c19eec4676fd$var$getMeta = (tr)=>{
    const meta = tr.getMeta($9347c19eec4676fd$var$pluginMetaKey);
    return $9347c19eec4676fd$var$isExpiryMeta(meta) ? meta : undefined;
};
const $9347c19eec4676fd$export$8769bf7655ee6ddd = (ranges)=>{
    const sortedRanges = [
        ...ranges
    ].sort((left, right)=>left.from - right.from);
    return sortedRanges.reduce((accumulator, range)=>{
        const previousRange = accumulator[accumulator.length - 1];
        if (!previousRange) {
            accumulator.push({
                ...range
            });
            return accumulator;
        }
        if (range.from <= previousRange.to + 1) {
            previousRange.to = Math.max(previousRange.to, range.to);
            return accumulator;
        }
        accumulator.push({
            ...range
        });
        return accumulator;
    }, []);
};
const $9347c19eec4676fd$var$getTextRangesBetween = (doc, from, to)=>{
    const ranges = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isText) return true;
        const textFrom = Math.max(from, pos);
        const textTo = Math.min(to, pos + node.nodeSize);
        if (textTo > textFrom) ranges.push({
            from: textFrom,
            to: textTo
        });
        return false;
    });
    return ranges;
};
const $9347c19eec4676fd$export$788d997d4f1de01 = (tr, doc)=>{
    if (!tr.docChanged || !tr.getMeta('isRemote') || tr.getMeta('replaceDocument')) return [];
    const insertedRanges = [];
    tr.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const oldSize = oldEnd - oldStart;
            const newSize = newEnd - newStart;
            if (newSize <= 0 || newSize <= oldSize) return;
            const remainingMapping = tr.mapping.slice(index + 1);
            const from = remainingMapping.map(newStart, 1);
            const to = remainingMapping.map(newEnd, -1);
            insertedRanges.push(...$9347c19eec4676fd$var$getTextRangesBetween(doc, from, to));
        });
    });
    return $9347c19eec4676fd$export$8769bf7655ee6ddd(insertedRanges);
};
const $9347c19eec4676fd$var$mapHighlightRanges = (ranges, tr)=>$9347c19eec4676fd$export$8769bf7655ee6ddd(ranges.map(({ from: from, to: to })=>({
            from: tr.mapping.map(from, 1),
            to: tr.mapping.map(to, -1)
        })).filter(({ from: from, to: to })=>to > from));
const $9347c19eec4676fd$var$buildDecorations = (state, highlights)=>{
    const decorations = highlights.flatMap((highlight)=>highlight.ranges.map(({ from: from, to: to }, index)=>(0, $8nvEM.Decoration).inline(from, to, {
                class: 'ai-in-editor-ai-content',
                'data-testid': 'ai-in-editor-ai-content',
                style: $9347c19eec4676fd$var$aiPlannerBridgeHighlightStyle
            }, {
                key: `aiPlannerRemoteTextHighlight:${highlight.id}:${index}:${from}:${to}`
            })));
    return decorations.length > 0 ? (0, $8nvEM.DecorationSet).create(state.doc, decorations) : (0, $8nvEM.DecorationSet).empty;
};
const $9347c19eec4676fd$var$removeExpiredHighlights = (highlights, now)=>{
    const filteredHighlights = highlights.filter(({ expiresAt: expiresAt })=>expiresAt > now);
    return filteredHighlights.length === highlights.length ? highlights : filteredHighlights;
};
const $9347c19eec4676fd$var$buildPluginState = (state, highlights)=>({
        decorations: $9347c19eec4676fd$var$buildDecorations(state, highlights),
        highlights: highlights
    });
const $9347c19eec4676fd$var$scheduleNextExpiry = (view, timeoutIdRef)=>{
    if (timeoutIdRef.current !== undefined) {
        window.clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = undefined;
    }
    const pluginState = $9347c19eec4676fd$export$456d4fef6896493a.getState(view.state);
    const nextExpiry = pluginState?.highlights.reduce((earliest, { expiresAt: expiresAt })=>earliest === undefined || expiresAt < earliest ? expiresAt : earliest, undefined);
    if (nextExpiry === undefined) return;
    timeoutIdRef.current = window.setTimeout(()=>{
        timeoutIdRef.current = undefined;
        const now = Date.now();
        view.dispatch(view.state.tr.setMeta($9347c19eec4676fd$var$pluginMetaKey, {
            type: 'expire',
            now: now
        }));
    }, Math.max(0, nextExpiry - Date.now()));
};
const $9347c19eec4676fd$export$f495b46f04d8aa1e = ()=>{
    return {
        name: $9347c19eec4676fd$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $9347c19eec4676fd$var$pmPluginName,
                    plugin () {
                        return new (0, $kpCD8.SafePlugin)({
                            key: $9347c19eec4676fd$export$456d4fef6896493a,
                            state: {
                                init: (_config, state)=>$9347c19eec4676fd$var$buildPluginState(state, []),
                                apply (tr, pluginState, _oldState, newState) {
                                    const meta = $9347c19eec4676fd$var$getMeta(tr);
                                    const now = meta?.now ?? Date.now();
                                    let highlights = $9347c19eec4676fd$var$removeExpiredHighlights(pluginState.highlights, now);
                                    if (tr.docChanged) highlights = highlights.map((highlight)=>({
                                            ...highlight,
                                            ranges: $9347c19eec4676fd$var$mapHighlightRanges(highlight.ranges, tr)
                                        })).filter(({ ranges: ranges })=>ranges.length > 0);
                                    const insertedRanges = $9347c19eec4676fd$export$788d997d4f1de01(tr, newState.doc);
                                    if (insertedRanges.length > 0) highlights = [
                                        ...highlights,
                                        {
                                            id: `${now}:${highlights.length}:${insertedRanges[0].from}`,
                                            ranges: insertedRanges,
                                            expiresAt: now + $9347c19eec4676fd$var$HIGHLIGHT_DURATION_MS
                                        }
                                    ];
                                    if (highlights === pluginState.highlights && !meta && !tr.docChanged) return pluginState;
                                    return $9347c19eec4676fd$var$buildPluginState(newState, highlights);
                                }
                            },
                            props: {
                                decorations (state) {
                                    return $9347c19eec4676fd$export$456d4fef6896493a.getState(state)?.decorations;
                                }
                            },
                            view (view) {
                                const timeoutIdRef = {
                                    current: undefined
                                };
                                $9347c19eec4676fd$var$scheduleNextExpiry(view, timeoutIdRef);
                                return {
                                    update (updatedView) {
                                        $9347c19eec4676fd$var$scheduleNextExpiry(updatedView, timeoutIdRef);
                                    },
                                    destroy () {
                                        if (timeoutIdRef.current !== undefined) window.clearTimeout(timeoutIdRef.current);
                                    }
                                };
                            }
                        });
                    }
                }
            ];
        }
    };
};



var $5wfVt = parcelRequire("5wfVt");


var $eF5Eg = parcelRequire("eF5Eg");


var $iVURp = parcelRequire("iVURp");

const $83c8a91574f9bbb4$export$714213af40919bf6 = (quickInsert, isMarkdownMode)=>{
    if (!isMarkdownMode) return quickInsert;
    // Normalise to an object so we can spread + add the filter.
    const baseOptions = typeof quickInsert === 'object' && quickInsert !== null ? quickInsert : {};
    const callerFilter = baseOptions.itemFilter;
    const itemFilter = callerFilter ? (item)=>(0, $9ta51.isMarkdownCompatibleQuickInsertItem)(item) && callerFilter(item) : (0, $9ta51.isMarkdownCompatibleQuickInsertItem);
    return {
        ...baseOptions,
        itemFilter: itemFilter
    };
};
const $83c8a91574f9bbb4$var$allowOptionalAIPluginOptions = (pluginOptions)=>pluginOptions;
const $83c8a91574f9bbb4$var$allowFormatCodeProvider = (providers)=>providers;
function $83c8a91574f9bbb4$export$7cb04b251abcb35b(options) {
    const { intl: intl, appearance: appearance, prevAppearance: prevAppearance } = options;
    const isNativeEmbeddedLiveDoc = !!options.__livePage && !!options.isEmbeddedConfluence && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isMarkdownMode = options.isMarkdownMode ?? false;
    const isEditorAIPluginEnabled = Boolean(options.editorPluginAIOptions);
    const quickInsertOptions = $83c8a91574f9bbb4$export$714213af40919bf6(options.quickInsert, isMarkdownMode);
    const agentManagedExtensionPluginOption = {
        agentManagedExtension: {
            cloudId: options.cloudId,
            contentType: options.contentType
        }
    };
    // `prettier-ignore` keeps the long fluent chain below on its current
    // `return fullPagePreset(...)` form. Without it Prettier re-indents ~570
    // chained-method lines and explodes the diff for any unrelated change.
    // The chain is purely declarative configuration.
    // prettier-ignore
    return (0, $cf703a3a6f52deb9$export$9f1bd789d5e1fd40)({
        intl: intl,
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        pluginOptions: $83c8a91574f9bbb4$var$allowOptionalAIPluginOptions({
            contentFormat: {
                initialContentMode: options.contentMode ?? 'standard'
            },
            helpDialog: {
                imageUploadProviderExists: false,
                aiEnabled: options.isAIEnabledForContent ?? false
            },
            hyperlink: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback
            },
            quickInsert: {
                emptyStateHandler: options.elementBrowser?.emptyStateHandler,
                quickInsert: quickInsertOptions
            },
            placeholder: {
                viewMode: options.viewMode,
                isAIEnabled: options.isAIEnabledForContent ?? false,
                // hide placeholder when (1) variant1 is enabled (2) not embedded editor & (3) user would see BPQA.
                // match BPQA conditions as defined by shouldRenderBPQA in FullPageEditorComponent
                // in this case, only isCompanyHub is not handled yet by the placeholder plugin
                isPlaceholderHidden: !options.isEmbeddedConfluence && !options.isCompanyHub && options.isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1'),
                enableLoadingSpinner: options.enablePlaceholderLoadingSpinner,
                isRovoLLMEnabled: options.isRovoLLMEnabled
            },
            selection: {
                __livePage: options.__livePage
            },
            ...agentManagedExtensionPluginOption,
            editorDisabled: {
                disabled: options.disabled
            },
            breakout: {
                editorAppearance: appearance
            },
            expand: {
                editorAppearance: appearance,
                __livePage: options.__livePage
            },
            annotation: {
                annotationManager: options.annotationProviders?.annotationManager,
                createCommentExperience: (0, $3YBks.createInlineCommentCompoundExperience),
                selectCommentExperience: (0, $4EKKB.selectInlineCommentCompoundExperience),
                viewInlineCommentTraceUFOPress: ()=>{
                    // Similar to logic in next/packages/annotation-provider-inline-comments/src/renderer/ViewComponent.tsx
                    // but for editor:
                    // Only start this trace if this is not viewing a just-created comment, in
                    // which case an `editor-create-inline-comment` action trace would still be
                    // running. We let it run to cover the entire create UI flow end-to-end.
                    const createExperienceState = (0, $fGzMp.getExperienceTracker)().getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
                    const skipTrace = createExperienceState?.hasStopped === false && (0, $6mKj3.expValEquals)('confluence_fe_create_comment_optimistic', 'isEnabled', true);
                    if (!skipTrace) (0, $eYg5X.default)('view-inline-comment-action');
                }
            },
            media: {
                createCommentExperience: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? (0, $3YBks.createInlineCommentCompoundExperience) : undefined,
                editorAppearance: appearance,
                mediaViewerExtensions: options.media?.mediaViewerExtensions,
                fallbackMediaNameFetcher: options.media?.fallbackMediaNameFetcher
            },
            mentions: {
                enableAgentSectioning: options.enableAgentSectioning,
                showAgentMentionsLabsLozenge: options.enableAgentSectioning,
                handleMentionsChanged: options.handleMentionsChanged,
                currentUserId: options.currentUserId,
                ...(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && {
                    getIsRovoPanelOpen: options.getIsRovoPanelOpen,
                    ...(0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') && {
                        onAgentMentionChatClick: options.onAgentMentionChatClick
                    }
                }
            },
            table: {
                __livePage: options.__livePage,
                editorAppearance: appearance,
                prevEditorAppearance: prevAppearance
            },
            tasksAndDecisions: {
                hasEditPermission: options.hasEditPermission,
                requestToEditContent: options.requestToEditContent,
                hasRequestedEditPermission: options.hasRequestedEditPermission
            },
            collabEdit: {
                collabEdit: options.collabEdit,
                __livePage: options.__livePage
            },
            // Remove the options.contextPanelOptions undefined checking after cleaning `platform_editor_ai_object_sidebar_injection` FG
            // and options.contextPanelOptions will be always defined.
            contextPanel: options.contextPanelOptions ? {
                objectSideBar: options.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: options.extensionHandlers,
                editorAppearance: appearance,
                __rendererExtensionOptions: options.__rendererExtensionOptions,
                getExtensionHeight: options.getExtensionHeight,
                getUnsupportedContent: $7cb36df2e500ad5f$export$d4ded51d0f0bd2df
            },
            layout: {
                editorAppearance: appearance
            },
            card: {
                smartCardContext: (0, $3gyyc.isSSRStreaming)() ? options.smartCardContext : undefined,
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback,
                __livePage: options.__livePage,
                CompetitorPrompt: $dXIrr.PromptPopupContainer,
                enablePasteDisplayAsMenu: true
            },
            insertBlock: {
                editorAppearance: appearance,
                // In Markdown Mode, hide toolbar insert items whose underlying node
                // has no clean GFM round-trip (panels, layouts, dates, status,
                // mentions, emoji, decisions, expand, placeholder text, rich `media`).
                itemFilter: isMarkdownMode ? (0, $f48f2b9f287ca9dc$export$d51800a5a6fed7d2) : undefined,
                toolbarButtons: {
                    emoji: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    insert: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    layout: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    media: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    mention: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    table: {
                        enabled: true,
                        showAt: 'md'
                    },
                    taskList: {
                        enabled: true,
                        showAt: 'lg'
                    }
                }
            },
            avatarGroup: {
                // Avatars are moved to Confluence codebase for Edit in Context
                // When Edit in Context is enabled primaryToolbarComponents is undefined
                // For more details please check
                // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
                collabEdit: options.collabEdit
            },
            codeBidiWarning: {
                editorAppearance: appearance
            },
            referentiality: {
                referentialityContext: options.referentialityContext
            },
            ...options.editorPluginAIOptions ? {
                ai: options.editorPluginAIOptions
            } : {},
            pasteOptionsToolbar: options.pasteOptionsToolbarPluginOptions,
            loom: {
                renderButton: options.loomPluginOptions.renderButton
            },
            editorViewMode: {
                viewMode: options.viewMode
            },
            aiDefinitions: options.editorPluginAIDefinitionsConfig,
            selectionMarker: {
                __livePage: options.__livePage ?? false
            },
            engagementPlatform: {
                coordinationClient: options.editorEngagementPlatformPluginConfig.coordinationClient
            },
            selectionExtension: options.selectionExtensionPluginOptions,
            metrics: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1') ? {
                userPreferencesProvider: options.userPreferencesProvider
            } : undefined,
            primaryToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            selectionToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled,
                // In embedded live doc, the toolbar is always unpinned and the pin option is hidden
                disablePin: isNativeEmbeddedLiveDoc
            },
            userPreferencesPlugin: {
                // In embedded live doc, force the toolbar to start unpinned regardless of any saved user preference
                initialToolbarDockingPosition: isNativeEmbeddedLiveDoc ? 'none' : undefined
            },
            blockMenu: {
                getLinkPath: options.getHeadingLinkPath,
                blockLinkHashPrefix: options.blockLinkHashPrefix
            },
            showDiff: options.showDiffPluginParams,
            syncedBlock: options.syncedBlockProvider && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true) ? {
                __livePage: options.__livePage,
                enableSourceCreation: true,
                syncedBlockRenderer: (0, $llOMF.getSyncedBlockRenderer)({
                    syncBlockRendererOptions: {
                        eventHandlers: options.syncedBlockEventHandlers,
                        stickyHeaders: {
                            show: true,
                            offsetTop: 0
                        }
                    }
                }),
                syncBlockDataProvider: options.syncedBlockProvider
            } : undefined,
            limitedMode: options.limitedModePluginOptions || {},
            toolbar: {
                contextualFormattingEnabled: options.contextualFormattingMode ?? 'controlled',
                // In Markdown Mode, filter the toolbar two ways:
                //
                //   1. In wysiwyg view: hide buttons / menus whose underlying
                //      mark or node has no clean GFM round-trip (text colour,
                //      highlight, alignment, underline, sub/super, mention,
                //      emoji, layout, media, synced block).
                //   2. In source / preview view: hide everything except the
                //      view-mode toggle itself, since the buttons would have
                //      no effect on the source / preview surfaces.
                //
                componentFilter: isMarkdownMode ? (0, $9524c0a1023ddde6$export$567bd3c3a1a1ead7) : undefined
            },
            trackChanges: {
                ButtonWrapper: options.trackChangesPluginOptions?.ButtonWrapper
            },
            aiSuggestions: options.aiSuggestionsPluginOptions,
            aiImageGeneration: {
                isRemixHidden: options.__isRemixHidden || isMarkdownMode,
                isRovoLLMEnabled: options.isRovoLLMEnabled
            }
        }),
        providers: $83c8a91574f9bbb4$var$allowFormatCodeProvider({
            // In embedded live doc, we always want the toolbar to be unpinned regardless of saved preferences.
            // Passing undefined for both providers prevents any shared user preference state from affecting
            // the embedded live doc toolbar docking position.
            userPreferencesProvider: isNativeEmbeddedLiveDoc ? undefined : options.userPreferencesProvider,
            userPreferencesProviderNext: isNativeEmbeddedLiveDoc ? undefined : options.userPreferencesProviderNext,
            cardProvider: options.linking?.smartLinks?.provider,
            contextIdentifierProvider: options.contextIdentifierProvider,
            inlineCommentAnnotationProvider: options.annotationProviders?.inlineComment,
            mediaProvider: options.media?.provider,
            syncMediaProvider: options.media?.syncProvider,
            mentionProvider: options.mentionProvider,
            profilecardProvider: options.mention?.profilecardProvider,
            emojiProvider: options.emojiProvider,
            emojiNodeDataProvider: options.emojiNodeDataProvider,
            formatCodeProvider: (0, $6xiPL.getCodeBlockFormatProvider)(),
            collabEditProvider: options.collabEdit?.provider,
            autoformattingProvider: options.autoformattingProvider,
            taskDecisionProvider: options.taskDecisionProvider
        }),
        enabledOptionalPlugins: {
            agentManagedExtension: options.isRovoLLMEnabled && (0, $6mKj3.expValEquals)('agent-managed_blocks_mvp', 'isEnabled', true),
            limitedMode: false,
            findReplace: Boolean(options.allowFindReplace),
            referentiality: Boolean(options.referentialityContext.plugin),
            loom: options.isLoomPluginEnabled,
            aiDefinitions: isEditorAIPluginEnabled && options.editorPluginAIDefinitionsEnabled,
            aiImageGeneration: isEditorAIPluginEnabled && (0, $6mKj3.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai'),
            connectivity: options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
            metrics: (0, $9wGTI.fg)('platform_editor_ease_of_use_metrics'),
            codeBlockAdvanced: true,
            selectionExtension: (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            aiExperience: Boolean(isEditorAIPluginEnabled && options.editorPluginAIOptions?.aiGlobalOptIn.status !== 'disabled'),
            interaction: Boolean(options?.__livePage) || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            userPreferences: (0, $9wGTI.fg)('platform_editor_use_preferences_plugin'),
            trackChanges: (0, $9wGTI.fg)('aifc_create_enabled'),
            showDiff: Boolean(options?.showDiffPluginParams) || (0, $9wGTI.fg)('aifc_create_enabled'),
            toolbar: !options?.disableToolbar && ((0, $9wGTI.fg)('aifc_create_enabled') || isEditorAIPluginEnabled && options.editorPluginAIOptions?.aiGlobalOptIn.status !== 'enabled' && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)),
            blockMenu: (0, $6mKj3.expValEquals)('platform_editor_block_menu', 'isEnabled', true),
            localId: (0, $9wGTI.fg)('platform_editor_adf_with_localid'),
            aiStreamingOrchestrator: (0, $9wGTI.fg)('aifc_create_enabled'),
            syncedBlock: (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true),
            floatingToolbar: !options?.disableFloatingToolbar,
            codeBidiWarning: !(0, $6mKj3.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true),
            contentFormat: true,
            uiControlRegistry: (0, $6mKj3.expValEquals)('platform_editor_paste_actions_menu', 'isEnabled', true),
            aiSuggestions: isEditorAIPluginEnabled && options.isRovoLLMEnabled && (0, $6mKj3.expVal)('platform_editor_ai_content_suggested_edits', 'isEnabled', false),
            aiSpeechToText: isEditorAIPluginEnabled && (0, $6mKj3.expValEquals)('ai_speech_to_text_in_editor', 'isEnabled', true),
            collabEdit: true
        }
    }).add((0, $eF5Eg.ssrPlugin))// When hiding content titles in URLs, skip the heading anchor links plugin to prevent generating anchor URLs that expose UGC.
    .maybeAdd([
        (0, $4vxk6.EditorHeadingLinksPlugin),
        {
            getHeadingLinkPath: options.getHeadingLinkPath
        }
    ], !options.shouldHideHeadingAnchorLinks).add((0, $iVURp.pageTitleUtilsPlugin)).add((0, $b6333eeaeea6365c$export$53933ef6873e4a9f)).add((0, $1pL0T.forgeEditorPlugin)).maybeAdd([
        (0, $1d19c6d3b6d5b560$export$ea606e96c5866df5),
        {
            flags: options.flags
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).maybeAdd([
        (0, $751b8c45ea51c6cb$export$bb9d066eb8005e17),
        {
            flags: options.flags,
            contentId: options.contentId,
            spaceKey: options.spaceKey
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).maybeAdd((0, $9347c19eec4676fd$export$f495b46f04d8aa1e), Boolean(options.enableAIPlannerRemoteTextHighlight)).add((0, $5wfVt.emptyStatePlugin)).add((0, $iHrpD.legacyContentMacroPlugin)).maybeAdd((0, $0c12e133eae86678$export$c5dd41c01dfdca7c), (0, $6mKj3.expVal)('confluence_native_tabs_experiment', 'isEnabled', false))// `previewComponent` is intentionally omitted: the preview view is
    // disabled in the toggle UI today and not yet implemented in Confluence.
    // When it lands, supply a Confluence renderer here (it needs product
    // providers — SmartCard, Emoji, media feature flags — so it can't live
    // in the platform plugin).
    .maybeAdd([
        (0, $bveWD.markdownModePlugin),
        {
            isMarkdownMode: isMarkdownMode,
            contentId: options.contentId ?? '',
            viewModePersistence: {
                getInitialView: (0, $2x28u.readStoredMarkdownViewMode),
                onViewChange: (0, $2x28u.writeStoredMarkdownViewMode)
            },
            // EDITOR-6636 — pass through the Confluence-supplied
            // `serializeFileMedia`. Builds tenant attachment-proxy URLs
            // (`/wiki/download/attachments/...`) for `media(type:file)`
            // so the markdown text remains credential-free and the
            // renderer auths the bytes via the viewer's session cookie.
            serializeFileMedia: options.serializeFileMediaForMarkdown,
            onSourceWritebackError: options.onSourceWritebackError
        }
    ], isMarkdownMode).maybeAdd((0, $15d963889bca129e$export$c84116e7ea204952), (0, $6mKj3.expVal)('platform_editor_add_image_editing', 'isEnabled', false)).maybeAdd((0, $3e185396515e8d7d$export$d82c0e619eaaa2c2), options.isCompanyHub).maybeAdd([
        (0, $8iNtg.malleableUiPlugin),
        {
            __isRemixHidden: options.__isRemixHidden || isMarkdownMode,
            __isRovoLLMEnabled: options.isRovoLLMEnabled,
            __remixDisabledReason: options.__remixDisabledReason,
            __livePage: options.__livePage,
            shouldHideToolbarWhileRemixing: true,
            createRemixContentComponent: $d4d2J.createRemixContentComponent,
            diagramPaste: options.cloudId && options.spaceKey ? (0, $6ZWlg.createConfluenceMauiDiagramPasteConfig)({
                contentId: options.contentId,
                contentType: options.contentType,
                duplicateMauiApp: options.duplicateMauiApp,
                siteId: options.cloudId,
                spaceKey: options.spaceKey,
                userId: options.currentUserId
            }) : undefined
        }
    ], (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && !options.isEmbeddedConfluence).maybeAdd([
        (0, $3Cz3M.nativeEmbedsPlugin)
    ], (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')).maybeAdd((0, $154c3a44e87556a7$export$52b2e012ce18dd1), (0, $6mKj3.expVal)('platform_editor_ai_headingautocomplete', 'isEnabled', false));
}
module.exports["createFullPageEditorPreset"] = $83c8a91574f9bbb4$export$7cb04b251abcb35b;

});

parcelRegister("3BXGS", function(module, exports) {

let $2a132116ae7fdbd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a132116ae7fdbd2$var$load("3JvLF").then(()=>parcelRequire('8lGAV'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("2x28u", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");

const $46c9e3ceb36a3a8c$export$25ad9f1e249c47eb = 'syntax';
const $46c9e3ceb36a3a8c$var$isMarkdownViewMode = (value)=>value === 'syntax' || value === 'preview';
const $46c9e3ceb36a3a8c$export$6e4435a107f4f22b = ()=>{
    const stored = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).MARKDOWN_VIEW_MODE);
    if ($46c9e3ceb36a3a8c$var$isMarkdownViewMode(stored)) return stored;
    // No valid preference stored — persist the default so the toggle can read it.
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).MARKDOWN_VIEW_MODE, $46c9e3ceb36a3a8c$export$25ad9f1e249c47eb);
    return $46c9e3ceb36a3a8c$export$25ad9f1e249c47eb;
};
const $46c9e3ceb36a3a8c$export$2380bf8e3c6aedc9 = (mode)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).MARKDOWN_VIEW_MODE, mode);
};
module.exports["readStoredMarkdownViewMode"] = $46c9e3ceb36a3a8c$export$6e4435a107f4f22b;
module.exports["writeStoredMarkdownViewMode"] = $46c9e3ceb36a3a8c$export$2380bf8e3c6aedc9;

});

parcelRegister("4vxk6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $8nvEM = parcelRequire("8nvEM");


var $55fM8 = parcelRequire("55fM8");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $d4ec92cbc00adf4b$export$3e69d3882a51f072 = 'heading-links';
const $d4ec92cbc00adf4b$export$2dd355223baa0569 = new (0, $kCECX.PluginKey)($d4ec92cbc00adf4b$export$3e69d3882a51f072);
var $d4ec92cbc00adf4b$export$ad105db915eb8d4a = /*#__PURE__*/ function(EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS) {
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["CONTROL"] = "control";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["VARIANT"] = "variant";
    return EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS;
}({});






var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $krYZG = parcelRequire("krYZG");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $202oG = parcelRequire("202oG");

const $4b64eb8446c0685a$export$9030f1f7cf11a203 = async (node, getHeadingLinkPath)=>{
    try {
        const headingId = (0, $202oG.getHeadingIdForNode)(node);
        if (!headingId) return false;
        const path = getHeadingLinkPath();
        if (!path) return false;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const url = new URL(location.origin + path);
        url.hash = encodeURIComponent(headingId);
        const href = url.toString();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            await navigator.clipboard.writeText(href);
            return true;
        }
        return false;
    } catch  {
        return false;
    }
};


const $a9415ea089d2d14f$var$i18n = (0, $kSwu1.defineMessages)({
    tooltipCopyMessage: {
        id: "editor-heading-links.link-component.tooltip.copy",
        defaultMessage: "Copy link to heading"
    },
    tooltipCopiedMessage: {
        id: "editor-heading-links.link-component.tooltip.copied",
        defaultMessage: "Copied!"
    },
    iconLabel: {
        id: "editor-heading-links.link-component.icon.label",
        defaultMessage: "Link icon"
    }
});
const $a9415ea089d2d14f$export$f356b7f7371242f8 = ({ node: node, intl: intl, analytics: analytics, isRightAligned: isRightAligned, getHeadingLinkPath: getHeadingLinkPath })=>{
    const [didCopy, setDidCopy] = (0, $cozmU.useState)(false);
    const updateTooltip = (0, $cozmU.useRef)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    (0, $cozmU.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        didCopy
    ]);
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        const didCopySucceed = await (0, $4b64eb8446c0685a$export$9030f1f7cf11a203)(node, getHeadingLinkPath);
        if (didCopySucceed) setDidCopy(true);
        // Should match the event fired for heading links on the view page
        // platform/packages/editor/renderer/src/react/nodes/heading.tsx
        analytics?.fireAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    }, [
        node,
        analytics,
        getHeadingLinkPath
    ]);
    const tooltipContentFn = (0, $cozmU.useCallback)(({ update: update })=>{
        updateTooltip.current = update;
        return didCopy ? intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopiedMessage) : intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopyMessage);
    }, [
        didCopy,
        intl
    ]);
    const handleMouseOut = (0, $cozmU.useCallback)(()=>{
        setDidCopy(false);
    }, []);
    const headingLevel = node.attrs['level'];
    const alignmentClass = isRightAligned ? 'link-widget-right' : 'link-widget-left';
    const sizeClass = headingLevel > 3 ? 'link-widget-small' : 'link-widget-medium';
    let colorClass;
    if (didCopy) colorClass = colorMode === 'dark' ? 'link-widget-clicked-dark' : 'link-widget-clicked-light';
    else colorClass = colorMode === 'dark' ? 'link-widget-hovered-dark' : 'link-widget-hovered-light';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        delay: 0,
        position: "top",
        content: tooltipContentFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "heading-link-copy-button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `link-widget ${alignmentClass} ${sizeClass} ${colorClass}`,
        onClick: handleClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: handleMouseOut
    }));
};


const $61a2a9c96b4df241$export$181fa0f15c7f1584 = (position, node, isRightAligned, intl, analytics, getHeadingLinkPath)=>{
    return (0, $8nvEM.Decoration).widget(position, ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const elem = document.createElement('span');
        // Trying to avoid both React and ProseMirror changing the same elements,
        // hence the nested container
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.createElement('span');
        // eslint-disable-next-line react/no-deprecated
        (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9415ea089d2d14f$export$f356b7f7371242f8), {
            node: node,
            intl: intl,
            analytics: analytics,
            isRightAligned: isRightAligned,
            getHeadingLinkPath: getHeadingLinkPath
        }), container);
        elem.appendChild(container);
        return elem;
    }, {
        side: isRightAligned ? -1 : 1,
        key: `heading-link-${position}`,
        ignoreSelection: false
    });
};
const $61a2a9c96b4df241$export$ae829ec7b2625219 = (intl, analytics, getHeadingLinkPath)=>{
    const handleMouseOver = (view, event)=>{
        // Get the position of the cursor
        const result = view.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        const pos = result?.pos;
        if (pos !== undefined) {
            // Resolve the position to a node
            let range = view.state.doc.resolve(pos);
            if (range.parent.type.name !== 'heading') {
                // There was an issue where, if you hovered over a heading from top to bottom,
                // the position would resolve to the document node rather than the heading.
                // Offsetting by 1 seems to fix the issue. However, we need to check both
                // pos and pos+1. If we only check the latter, there's a similar problem when
                // hovering headings from right to left.
                const adjPos = Math.min(pos + 1, view.state.doc.content.size);
                range = view.state.doc.resolve(adjPos);
            }
            // If the node is a heading, dispatch metadata to add a link decoration
            if (range.parent.type.name === 'heading') view.dispatch(view.state.tr.setMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569), {
                applyHoverDecoration: true,
                from: range.start(),
                node: range.parent
            }));
        }
        return false;
    };
    const debouncedHandleMouseOver = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handleMouseOver, 150);
    const plugin = new (0, $kpCD8.SafePlugin)({
        key: (0, $d4ec92cbc00adf4b$export$2dd355223baa0569),
        state: {
            init () {
                return {
                    hoveredHeading: undefined,
                    start: undefined
                };
            },
            apply: (tr, old, _, newState)=>{
                // Get the metadata that was dispatched from the mouseover event
                const hoverDecoration = tr.getMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569));
                // If the metadata `applyHoverDecoration` property is present,
                // add a link decoration to the heading node. Note: Only one
                // decoration will ever exist on the page. When a new heading
                // is hovered, the old decoration will be replaced.
                if (hoverDecoration?.applyHoverDecoration) {
                    const node = hoverDecoration.node;
                    return {
                        hoveredHeading: node,
                        start: hoverDecoration.from
                    };
                }
                if (old.start !== undefined) {
                    const newStart = tr.mapping.map(old.start);
                    const newHeadingNode = newState.doc.resolve(newStart);
                    if (newHeadingNode.parent.content.size === 0 || newHeadingNode.parent.type.name !== 'heading') return {
                        hoveredHeading: undefined,
                        start: undefined
                    };
                    // If the heading is prepended, the start position will be off by 1,
                    // so we need to use the .start() method to get the correct position.
                    return {
                        hoveredHeading: newHeadingNode.parent,
                        start: newHeadingNode.start()
                    };
                }
                return old;
            }
        },
        props: {
            decorations (state) {
                const pluginState = plugin.getState(state);
                const heading = pluginState?.hoveredHeading;
                const start = pluginState?.start;
                if (heading && start !== undefined) {
                    const endMark = heading.marks.find((mark)=>mark.attrs?.align === 'end');
                    const position = endMark ? start : start + heading.content.size;
                    const link = $61a2a9c96b4df241$export$181fa0f15c7f1584(position, heading, endMark !== undefined, intl, analytics, getHeadingLinkPath);
                    return (0, $8nvEM.DecorationSet).create(state.doc, [
                        link
                    ]);
                }
                return (0, $8nvEM.DecorationSet).empty;
            },
            handleDOMEvents: {
                mouseover: debouncedHandleMouseOver
            }
        }
    });
    return plugin;
};
const $61a2a9c96b4df241$export$96df4e1ee1c54b95 = ({ api: api, config: { getHeadingLinkPath: getHeadingLinkPath } })=>({
        name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
        pmPlugins () {
            return [
                {
                    name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
                    plugin: ({ getIntl: getIntl })=>{
                        return $61a2a9c96b4df241$export$ae829ec7b2625219(getIntl(), api?.analytics?.actions, getHeadingLinkPath);
                    }
                }
            ];
        }
    });
module.exports["EditorHeadingLinksPlugin"] = $61a2a9c96b4df241$export$96df4e1ee1c54b95;

});

parcelRegister("djYcq", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $kCECX = parcelRequire("kCECX");


var $krYZG = parcelRequire("krYZG");


var $cyZvy = parcelRequire("cyZvy");

const $ea625f5574c5221d$export$bd9824d426074790 = (api)=>(payload)=>{
        return api?.attachAnalyticsEvent(payload);
    };


const $5899ae1a7b0c1755$export$cb5777189008ecf = (metadata, existingConflicts)=>{
    if (!metadata) return undefined;
    switch(metadata.type){
        // Navigate between conflicts using arrows - doesn't modify conflicts
        case 'navigate':
        // Enter/exit conflict resolution mode - doesn't modify conflicts
        case 'startResolving':
        case 'stopResolving':
            return existingConflicts;
        // Receive new conflicts from server after reconnection
        case 'update':
            return {
                inserted: metadata.data.inserted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    })),
                deleted: metadata.data.deleted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }))
            };
        // User accepts/dismisses a single conflict (removes it from the list)
        case 'resolve':
        // User chooses to keep deleted text (restores it, then removes conflict from the list)
        case 'restore':
            if (!existingConflicts) return existingConflicts;
            return {
                inserted: existingConflicts.inserted.filter((conflict)=>conflict.id !== metadata.data.id),
                deleted: existingConflicts.deleted.filter((conflict)=>conflict.id !== metadata.data.id)
            };
        // User accepts all conflicts at once (clears the entire list)
        case 'resolveAll':
            return {
                inserted: [],
                deleted: []
            };
        default:
            return undefined;
    }
};
const $5899ae1a7b0c1755$export$6804620b9d3be6a7 = (conflicts, selected, direction)=>{
    const allConflicts = [
        ...conflicts?.inserted ?? [],
        ...conflicts?.deleted ?? []
    ].sort((a, b)=>a.from - b.from);
    if (!selected) return {
        isAbleToNavigate: true,
        newConflict: allConflicts.length > 0 ? allConflicts[0] : undefined
    };
    const idx = allConflicts.findIndex((c)=>c.id === selected.id);
    if (direction === 'next') {
        const isAbleToNavigate = idx < allConflicts.length - 1;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx + 1] : undefined
        };
    } else {
        const isAbleToNavigate = idx > 0;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx - 1] : undefined
        };
    }
};
const $5899ae1a7b0c1755$var$addTypeToConflict = (conflict, conflicts)=>{
    const type = conflicts.deleted.find((c)=>c.id === conflict.id) ? 'deleted' : 'inserted';
    return {
        ...conflict,
        type: type
    };
};
const $5899ae1a7b0c1755$var$navigateToSelection = (meta, tr, conflicts)=>{
    const { isAbleToNavigate: isAbleToNavigate, newConflict: newConflict } = $5899ae1a7b0c1755$export$6804620b9d3be6a7(conflicts, meta.data, meta.direction);
    if (isAbleToNavigate && newConflict) return tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, newConflict.from, newConflict.to)).setMeta('nextConflict', $5899ae1a7b0c1755$var$addTypeToConflict(newConflict, conflicts)).scrollIntoView();
    else return null;
};
const $5899ae1a7b0c1755$export$995f88ef5b52af82 = (currentConflict, tr, conflicts)=>{
    return $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'next',
        data: currentConflict
    }, tr, conflicts) ?? $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'previous',
        data: currentConflict
    }, tr, conflicts);
};
const $5899ae1a7b0c1755$export$f8685c902e685023 = (editorView, meta, options)=>{
    const { dispatch: dispatch, state: { tr: tr } } = editorView;
    if (meta.type === 'navigate') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$var$navigateToSelection(meta, tr, pluginState?.conflicts);
    } else if (meta.type === 'restore') tr.replace(meta.data.from, meta.data.to, meta.data.local);
    else if (meta.type === 'update') (0, $ea625f5574c5221d$export$bd9824d426074790)(options?.api?.analytics?.actions)({
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
        attributes: {
            inserted: meta.data.inserted.length,
            deleted: meta.data.deleted.length
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: 'offlineReconnectionConflict'
    })?.(tr);
    else if (meta.type === 'resolve') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$export$995f88ef5b52af82(meta.data, tr, pluginState?.conflicts);
    }
    dispatch(tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), meta));
};
module.exports["getNewConflicts"] = $5899ae1a7b0c1755$export$cb5777189008ecf;
module.exports["getNavigationInfo"] = $5899ae1a7b0c1755$export$6804620b9d3be6a7;
module.exports["navigateToAvailable"] = $5899ae1a7b0c1755$export$995f88ef5b52af82;
module.exports["setMetadata"] = $5899ae1a7b0c1755$export$f8685c902e685023;

});

parcelRegister("l0Gyw", function(module, exports) {

let $f4ba9bc559ffd8e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4ba9bc559ffd8e3$var$load("4LYSa").then(()=>parcelRequire('50nRh'));

});

parcelRegister("eF5Eg", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");

const $fe598058b05d810f$var$pluginName = 'ssr-plugin';
const $fe598058b05d810f$var$pmPluginName = 'ssr-disable-transactions';
const $fe598058b05d810f$export$bfca3f3ccfec3116 = ()=>{
    return {
        name: $fe598058b05d810f$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $fe598058b05d810f$var$pmPluginName,
                    plugin () {
                        return new (0, $kpCD8.SafePlugin)({
                            filterTransaction () {
                                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                                return true;
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["ssrPlugin"] = $fe598058b05d810f$export$bfca3f3ccfec3116;

});

parcelRegister("iVURp", function(module, exports) {

var $88vX6 = parcelRequire("88vX6");


var $4EksL = parcelRequire("4EksL");


var $kCECX = parcelRequire("kCECX");

const $3c910faa900bb0f6$var$selectDocStart = ()=>({ tr: tr })=>{
        const docStartSelection = (0, $88vX6.isValidTargetNode)(tr.doc.firstChild) ? new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(0)) : (0, $kCECX.Selection).atStart(tr.doc);
        tr.setSelection(docStartSelection);
        return tr;
    };
const $3c910faa900bb0f6$var$insertNewLineAtDocStart = ()=>({ tr: tr })=>{
        const { paragraph: paragraph, heading: heading } = tr.doc.type.schema.nodes;
        const firstChild = tr.doc.firstChild;
        if (firstChild && [
            paragraph,
            heading
        ].includes(firstChild.type) && !firstChild.childCount) return $3c910faa900bb0f6$var$selectDocStart()({
            tr: tr
        });
        const emptyParagraph = tr.doc.type.schema.nodes.paragraph.create();
        tr.insert(0, emptyParagraph);
        tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(0)));
        return tr;
    };
const $3c910faa900bb0f6$export$c7c689ff4e6df96c = ()=>{
    return {
        name: 'pageTitleUtils',
        dependencies: [],
        commands: {
            selectDocStart: $3c910faa900bb0f6$var$selectDocStart,
            insertNewLineAtDocStart: $3c910faa900bb0f6$var$insertNewLineAtDocStart
        }
    };
};
module.exports["pageTitleUtilsPlugin"] = $3c910faa900bb0f6$export$c7c689ff4e6df96c;

});

parcelRegister("cyZvy", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670 = new (0, $kCECX.PluginKey)('conflictResolutionPluginKey');
module.exports["conflictResolutionPluginKey"] = $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670;

});


//# sourceMappingURL=FullPageEditorComponent.194bbe53.js.map
